
// ══ CONFIG ══
const SB = 'https://sutnfihpmfsejdlkghjp.supabase.co';
const KEY = 'sb_publishable_5ZJdu4hX49XRH1q0dCFsAQ_0S0Eps95';

// ===== IA (busqueda en lenguaje natural) =====
// La API key de Anthropic YA NO vive en el navegador. Las llamadas van a una
// Edge Function de Supabase (supabase/functions/ia) que guarda la key como
// secreto del servidor, valida el JWT del usuario y limita el uso.
const IA_URL = SB + '/functions/v1/ia';

// Llama al proxy de IA. tarea: 'filtros' | 'reemplazos'. Devuelve el JSON ya parseado.
async function iaLlamar(tarea, texto){
  const r = await fetch(IA_URL, {
    method:'POST',
    headers:{'Content-Type':'application/json','apikey':KEY,'Authorization':'Bearer '+AUTHTOK()},
    body: JSON.stringify({tarea: tarea, texto: texto})
  });
  const d = await r.json().catch(function(){ return null; });
  if(!r.ok){
    var m = (d && d.error) || ('IA ' + r.status);
    if(r.status===401) m = 'Tu sesion expiro. Vuelve a entrar.';
    if(r.status===429) m = 'Demasiadas busquedas con IA. Espera un momento.';
    throw new Error(m);
  }
  if(!d || d.resultado===undefined) throw new Error('Respuesta vacia de la IA');
  return d.resultado;
}

// Fotos vienen de Shopify via campo foto_url en Supabase
// No necesitas configurar nada — se llenan automáticamente cada noche
const FOTO_BASE = SB + '/storage/v1/object/public/fotos-items/'; // fotos en Supabase Storage (bucket publico 'fotos-items'); se le agrega el picturname

// ══ TIPO DE PRODUCTO (campo U_SubG_* de SAP) ══
// Codigo -> nombre (subcategoria). Cargado desde la lista de SAP.
const SUBG_MAP = {"001": "S/P","002": "Jacket","003": "Pantalon","004": "Vestido De Bano","005": "Corbata","006": "Correa","007": "Short","008": "Camisa","009": "T-Shirt","010": "Falda","011": "Calzoncillo","012": "Jeans","013": "Capri","014": "Papel de Aluminio","015": "Polos","016": "Legging","017": "Top","018": "Sweater","019": "Sacos","020": "Medias","021": "Pijama","022": "Panty","023": "Braciere","024": "Blusa","025": "Enterizo","026": "Vestido","027": "Maniqui","028": "Conjunto","030": "Alfombra","031": "Protector de Colchon","032": "Cobertor","033": "Cortina","034": "Accesorios","035": "Individuales","036": "Cojines","037": "Mantel","038": "Toallas","039": "Ganchos","040": "Basurero","041": "Envase","042": "Canasta","043": "Utensilios","044": "Vasos","045": "Tetera","046": "Hielera","047": "Jarras","048": "Ralladores","049": "Organizador","050": "Picadores","051": "Caja Herramientas","052": "Jardineria","053": "Gavetero","054": "Dispensador","055": "Escobas","056": "Capote","057": "Closet","058": "Zapatera","059": "Riel","060": "Flores","061": "Vajillas","062": "Cuadros","063": "Adorno","064": "Relojes","065": "Espejo","066": "Bolsa de Basura","067": "Estante","068": "Escurridor","069": "Organizador de Puerta","070": "Parrilla","071": "Calderos","072": "Persiana","073": "Almohadas","075": "Juego de Duvet","076": "Tabla de Picar","077": "Platos","078": "Termo","079": "Pesas","080": "Cuchillo","081": "Asiento","082": "Macetero","083": "Tazas","084": "Bolsa","085": "Banquito","086": "Corniza","087": "Sabanas","088": "Baul","089": "Florero","090": "Colador","091": "Desechable","092": "Cubiertos","093": "Portarretrato","094": "Album","095": "Guantes","096": "Sarten","097": "Tabla de Planchar","098": "Tendedero","099": "Cepillo","100": "Moldes","101": "Regadera","102": "Botella","103": "Piedras","104": "Cosmetiquera","105": "Cama","106": "Medidores","107": "Manta","108": "Joyero","109": "Abanico","110": "Comforter","111": "Tiradores","112": "Embudo","113": "Atomizador","114": "Zapatilla","115": "Bota","116": "Sandalia","117": "Zapato para vestir","118": "Bailarina","119": "Tacon","120": "Mocasine","121": "Chancleta","122": "Pantunfla","123": "Tejido","125": "Abrelatas","126": "Adaptadores","127": "Aire acondicionado","128": "Aspiradoras","129": "Audifonos","130": "Batidoras","131": "Blower","132": "Bocinas","133": "Cafeteras","134": "Caja de Llaves","135": "Cajas fuertes","136": "Calentadores de agua","137": "Camara","138": "Cerraduras","139": "Cuchillos","140": "Dispensadores","141": "Estufas","142": "Exibicion","143": "Extractores","144": "Freidoras","145": "Hornos","146": "Licuadoras","147": "Maletas","148": "Masaje","149": "Microondas","150": "Monitores","151": "Muebles para tv","152": "Neveras","153": "Ollas","154": "Planchas","155": "Radio","156": "Reproductores","157": "Repuestos","158": "Sandwicheras","159": "Soportes","160": "Telefonos","161": "Televisores","162": "Teteras","163": "Tostadoras","164": "Sofa","165": "Muebles","166": "Frutas Falsas","167": "Bandeja","168": "Pinza para alimento","169": "baldosa","170": "Mesa","171": "Acero Inoxidable","172": "Azulejos","173": "Duchas","174": "Puertas","175": "Ceramica","176": "Acc. P/ Techo de Policarbonato","177": "Lamina de Policarbonato","178": "Pedestal","179": "Grama Artificial","180": "Fregadero","181": "Mueble de Bano","182": "Grifos","183": "Lavamano","184": "Granito 60x100","185": "Inodoro","186": "Sobre de Granito Redondo","187": "Marmol","188": "Chapa D/ Aluminio","189": "Acc. Groove Ceiling","190": "Acc. Lay In Ceiling","191": "Aluminio Hexagonal","192": "Aluminio Triangular","193": "Techo Suspendido de Aluminio","194": "Granito 25.8X40X1.2","195": "Techo con Cliip de Aluminio","196": "Granito","197": "Granito 51X51X1.2","198": "Panel Redondo","199": "Aluminio P/ Techo","200": "Porcelanato Diseno de Madera","201": "Mosaico Decorativo","202": "Azulejo 30x90 cm","203": "Carretilla Cap. 250 Kg","204": "Porcelanato Delgado","205": "Glaceado/Pulido 800x800","206": "Porcelanato Pulido","207": "Pulido 1000x1000","208": "Ceramica Pulida 30x60 cm","209": "Ceramica 30x60 cm","210": "Sujetador de Bolsa","211": "Palitroc de 3000 kgs","212": "Organizador de Zapatos","213": "Lavamano D/Vidrios","214": "Lavamano D/Vidrio","215": "Piso","216": "Grifo P/Lavamano con disco","217": "Grifo P/Fregador","218": "Grifo P/Lavamano","219": "Capacidad 200 Kg","220": "Mueble P/Bano C/Espejo","221": "Espejo P/Bano","222": "Lavamano de Ceramica","223": "Rueda 16x4.00-8","224": "Mueble P/Bano","225": "Capacidad 180 Kgs","226": "Capacidad 150 Kgs","227": "Repisas","228": "Mosaico D/ Vidrio 30X30X4","229": "Mosaico D/ Vidrio 55X8/300X305","230": "Mosaico D/ Vidrio 23X98X8","231": "Mosaico de Acero 300X310MM","232": "Mosaico de Ceramica 300x300MM","233": "ESQUINERA","234": "RECIPIENTE P/ALMACENAR","235": "Grama Artifical","236": "Carretilla","237": "Secador","238": "Micro Cristal","239": "Mosaicos","24": "Alcancia","240": "Panel Decorativo Para Pared","241": "Azulejo","242": "Baldosa Decorativa","243": "Porcelanato","244": "Micro Crystal","245": "Estanteria de Vino","246": "Placas Para Pared","247": "Tela","248": "FRASCO D/VIDRIO","249": "Zapato Escolar","250": "SOBRECAMA","251": "PISO VYNIL","252": "COLADOR DE ALIMENTOS","260": "FORRO","261": "PIEDRA DECORATIVA","280": "PISO DE VYNIL","281": "PALETA PARA PIZZA","282": "Colchon","283": "Consola","284": "Taburete","285": "ARTICULO DE LIMPIEZA","286": "JABONERA","287": "PANERA","288": "ESPONJA PARA BANO","289": "HORQUILLA","290": "GORRA","291": "SINTETICO","292": "NATURAL","294": "Almohada","296": "Caja De Herramienta","301": "Delantal","305": "Frutas","307": "Juguetes","308": "Organizador De Cocina","309": "Organizador De Bano","310": "Porta Caliente","311": "Seccionales","312": "Butaca - Silla","313": "Reclinable","314": "Mesita","315": "Tv Stand","316": "Sofa Cama","317": "Bar","318": "Librero","319": "Respaldo","320": "Peinadora","321": "Mesita De Noche","322": "Juego De Cama","323": "Armario","324": "Colchones","325": "Camarote","326": "Cuna","327": "Perchero","328": "Silla De Bar","329": "Microonda","330": "Cocineta","331": "Carrito Para Servir","332": "Silla De Oficina","333": "Escritorio","334": "Librero De Oficina","335": "Mesa De Oficina","336": "Podio","337": "Recepcion","338": "Chimenea","339": "Cuadro","340": "Plantas","341": "Silla De Comedor","342": "Juego De Comedor","343": "Mesa De Comedor","344": "Bufetera","345": "Mesa De Exterior","346": "Silla De Exterior","347": "Cama De Exterior","348": "Paragua","349": "Tolda","350": "Sofa De Exterior","351": "Camiseta","352": "Saco","353": "Polo","354": "Short De Playa","355": "Sala","356": "Comedor","357": "Dormitorio","358": "Pasillos","359": "Alfombras De Bano","360": "Juegos De Bano","361": "Alfombras De Cocina","362": "Juegos De Cocina","363": "Didactico","364": "Decorativo","365": "Display Box","366": "Arroceras","367": "Grill Y Sandwicheras","368": "Procesadores De Alimentos","369": "Exprimidores","370": "Teteras Y Cafeteras","371": "Wafleras","372": "Ollas Electricas","373": "Abanicos","374": "Refrigeradores","375": "Soporte De Tv","376": "Juegos De Cuchillo","377": "Hornear","378": "Utensilios Y Gadgets","379": "Escurridores","380": "Coladores","381": "Picadores Y Ralladores","382": "Sartenes","383": "Toallas De Cocina","384": "Manteles E Individuales","385": "Porcelana","386": "Cristaleria Vasos Y Copas","387": "Bowl Y Ensaladeras","388": "Bandeja De Servir","389": "Cuberteria","390": "Floreros","391": "Velas Y Difusores","392": "Riel De Cortinas","393": "Porta Retratos","394": "Candelabros","395": "Esculturas Y Art Deco","396": "Espejos Decorativos","397": "Reloj Y Arte De Pared","398": "Flores Artificiales","399": "Cajas Organizadoras","400": "Espejos Con Joyero","401": "Navidad","402": "Toallas De Mano","403": "Toallas De Cuerpo","404": "Toallas De Piso","405": "Toallas De Tocador","406": "Ducha","408": "Pintura","410": "Jardin","411": "Almacenamiento y Organizacion","412": "Instalaciones","413": "Extensiones Electricas y Adaptadores","414": "Herramientas Manuales","415": "Exhibicion","416": "ASAACOADO","417": "BJG","418": "APA","419": "BABCACDSI","420": "CACDSI","421": "ADOBABCACDSI","422": "DSIIDI","423": "ADOBABDSIIDI","424": "BABCACDSIDDB","425": "ADODSI","426": "ADOIDIIDE","427": "BABDSIIDE","428": "ADOBABDSIIDE","429": "ADOIDE","430": "EXA","431": "ADO","432": "ADOBABDSI","433": "ADOAPA","434": "ADOAPADSI","435": "ASAACOADOAEX","436": "CAC","437": "AEXDSI","438": "ASAACOADOAPA","439": "AEXAPADSI","44": "-","440": "BJGDNA","441": "ASAACOADOAEXDSI","442": "ADOBJGCJCDSI","443": "CJC","444": "ADOCACDNA","445": "AEXDNA","446": "DNA","447": "ADOBAB","448": "BABCACDNA","449": "ADOAEXBABDSI","450": "ASAADOAEX","451": "ADOIDI","452": "ADOBABIDE","453": "ADOBJGIDE","454": "ADOAEXAPA","455": "ADOAEXBABCACDSI","456": "ADOBABCACDNA","457": "CACDDB","458": "DSI","459": "ADOCAC","460": "ADOBJGCJC","461": "BABCAC","462": "ADOBABCAC","463": "BAB","464": "ADOBJG","465": "APACAC","466": "ADOAPABABCAC","467": "AEXBABCACDSI","468": "APABABCAC","469": "ADOAPACAC","470": "BJGCJC","471": "AEXBABCACDSIDDB","472": "APABABCACDSI","473": "ADOAPABABCACDSI","474": "BABDNA","475": "AEXCACDSI","476": "AEXAPACACDSI","477": "ADOAEXAPABABCACDSI","478": "AEXAPABABCACDSI","479": "AEXDSIDDB","480": "AEXBABCAC","481": "AEXCAC","482": "ASAADO","483": "AEXBABCACDNA","484": "AEXAPABABCACDNA","485": "ADOAEXBABCACDNA","486": "AEX","487": "BJGIDE","488": "ADOAPADDB","489": "ADOCACDSI","490": "ADOAPACACDSI","491": "Instalaciones accesorios y adhesivos de ferreteria","492": "Extensiones electricas y adaptadores","493": "REPUESTO","494": "ADODSIDDB","495": "AEXAPADNA","496": "AEXDSIDNA","497": "Seguridad","498": "ADOAPABABDDB","499": "BJGDDB","500": "ADOAPABABCACDDB","501": "Bocinas amplificadas","502": "Bocinas bluetooth","503": "Televisores LED","504": "Televisores Smart TV","505": "Bocinas inalambricas","506": "Barras de sonido","507": "Accesorios A/V","508": "Freidoras de aire","509": "Tostahornos","510": "Ollas de coccion lenta","511": "Estufas electricas","512": "Shabbat","513": "Ollas arroceras","514": "Ralladores de vegetal","515": "Refrigeradoras","516": "Congeladores","517": "Dispensadores de agua","518": "Secadoras de pelo","519": "Planchas para pelo","520": "Soporte para TV","521": "Soportes para monitor","522": "Soportes para DVD","523": "Mesitas para monitor","524": "Anaquel","525": "ASAACOADODDB","526": "Otomanos","527": "Bancos","528": "Auxiliares","529": "Sofas Deco","530": "Mesas de Centro","531": "Consolas","532": "Gabinetes","533": "Sillas y Poltronas","534": "Camas Deco","535": "Comida Artificial","536": "Storage","537": "Rieles y Cortinas","538": "Auxiliares de Bano","539": "Servilleteros","540": "Saleros y Pimenteros","541": "Funda para Almohada","542": "AEXAPADSIDDB","543": "ADOAEXAPABABIDI","544": "ADOAPAIDI","545": "BJGCJCDSI","546": "AEXDNADDB","547": "ASAADOAEXIDIDDB","548": "ADOAPABABDSI","549": "Cubetas para Hielo","550": "Mantequillera","551": "Soporte Multiuso","552": "Sacacorcho","553": "Abridor de Botellas","554": "Cacerola","555": "Papel Pergamino","556": "Escobilla de Bano","557": "Portaescobilla","558": "Protector de Almohada","559": "Exhibidor","560": "Protector de Fregadero","561": "Pelador","562": "Cortador de Pizza","563": "Vaporera","564": "Planta Artificial","565": "Barras de Cortina","566": "Porta Pasteles","567": "Trapeador","568": "Mortero","569": "LIMPIADOR INDUSTRIAL","570": "Silla Comedor bebe","571": "Vasos botellas termicas","572": "PORTA ROPA","573": "GORRO TURBANTE DE BANO","574": "BOTELLA VASO TERMICO","575": "ESPUMADOR ELECTRICO DE LECHE","576": "CUBETAS DE HIELO","577": "SALERO PIMENTERO"};
var ALF_MAP={ASA:'SALA',ACO:'COMEDOR',ADO:'DORMITORIO',AEX:'EXTERIORES',APA:'PASILLOS',BAB:'ALF. DE BANO',BJG:'JGO. DE BANO',CAC:'ALF. DE COCINA',CJC:'JGO. DE COCINA',DSI:'SINTETICO',DNA:'NATURAL',IDI:'DIDACTICO',IDE:'DECORATIVO',DDB:'DISPLAY BOX',EXA:'EXHIBIDORES'};
function alfombraLabel(s){
  // Candidato a codigo de alfombra: solo letras y longitud multiplo de 3.
  // Traduce los segmentos conocidos y omite los desconocidos (no oculta la alfombra).
  if(!s||!/^[A-Za-z]+$/.test(s)||s.length%3!==0) return null;
  var partes=[],hits=0;
  for(var i=0;i<s.length;i+=3){
    var seg=s.substr(i,3).toUpperCase();
    if(ALF_MAP[seg]){partes.push(ALF_MAP[seg]);hits++;}
  }
  return hits>0 ? partes.join(', ') : null;
}
function subgLabel(c){
  if(c==null||c==="") return "—";
  var k=String(c).trim();
  var nombre=k;
  if(SUBG_MAP[k]) nombre=SUBG_MAP[k];
  else if(/^[0-9]+$/.test(k)){
    var k3=k.padStart(3,"0");
    var kn=String(parseInt(k,10));
    if(SUBG_MAP[k3]) nombre=SUBG_MAP[k3];
    else if(SUBG_MAP[kn]) nombre=SUBG_MAP[kn];
  }
  return alfombraLabel(nombre)||nombre;
}

// Ya no hay usuarios ni contrasenas en el codigo del navegador.
// TODOS los usuarios (admin, vendedor, gerencia y cliente) viven en Supabase Auth.
// El rol se lee de app_metadata, que solo se puede cambiar con la service_role key
// desde el servidor (user_metadata SI lo puede editar el propio usuario: no sirve
// para permisos).

let CU = null;    // usuario actual (sin contrasena: solo rol, nombre, cardcode)
let SESS = null;  // {access_token, refresh_token, expira_en_ms}

// Token que se manda a PostgREST: el del usuario logueado; si no hay sesion, la
// llave publicable (solo deberia alcanzar para lo que este abierto por RLS).
function AUTHTOK(){ return (SESS && SESS.access_token) || KEY; }
let gsTimer = null, cliTimer = null, pedTimer = null, facTimer = null, invTimer = null;
let pedPage=0, facPage=0, invPage=0, cliPage=0;
var invLoadingMore=false, invHasNext=false, catLoadingMore=false, catHasNext=false, pedLoadingMore=false, pedHasNext=false, cliLoadingMore=false, cliHasNext=false, _infObs={}, _infScrollFb={};
function _infScroll(gridId, sentId, hasNext, onHit){
  var prev=document.getElementById(sentId); if(prev) prev.remove();
  if(_infObs[gridId]){ _infObs[gridId].disconnect(); delete _infObs[gridId]; }
  // Quita el respaldo de scroll anterior si existe
  if(_infScrollFb[gridId]){ window.removeEventListener('scroll', _infScrollFb[gridId]); delete _infScrollFb[gridId]; }
  if(!hasNext) return;
  var grid=document.getElementById(gridId); if(!grid) return;
  var sent=document.createElement('div'); sent.id=sentId; sent.style.cssText='grid-column:1/-1;width:100%;height:20px';
  grid.appendChild(sent);
  var disparado=false;
  var hit=function(){ if(disparado) return; disparado=true; onHit(); };
  // 1) IntersectionObserver (método principal)
  try{
    var ob=new IntersectionObserver(function(ents){ if(ents[0] && ents[0].isIntersecting) hit(); }, {rootMargin:'800px'});
    ob.observe(sent); _infObs[gridId]=ob;
  }catch(e){}
  // 2) Respaldo por evento de scroll (por si el observer no dispara en algún navegador/layout)
  var fb=function(){
    var s=document.getElementById(sentId); if(!s){ window.removeEventListener('scroll', fb); return; }
    var r=s.getBoundingClientRect();
    if(r.top <= (window.innerHeight||document.documentElement.clientHeight) + 800){ hit(); }
  };
  _infScrollFb[gridId]=fb;
  window.addEventListener('scroll', fb, {passive:true});
}
let pedQ='', pedS='', pedConfF='', pedVendF='', facQ='', facDesde='', facHasta='', invQ='', invTextos=[], invCatF='', invAnioF='', invRecienteF='', invColF='', invStockF='todos', ecCatF='', upQ='';
let invPMin='', invPMax='', invSMin='', invSMax='', invBMin='', invBMax='', invDispF='', invImgF='', invOrden='reciente';
let catPMin='', catPMax='', catSMin='', catDispF='', catImgF='', catOrden='reciente';
const PAGE_SIZE = 50, INV_PAGE_SIZE = 40;

// ══ HELPERS ══
const $ = id => document.getElementById(id);
const fmt = n => n==null||isNaN(+n) ? '—' : '$'+Number(n).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
const fmtN = n => n==null||isNaN(+n) ? '—' : Number(n).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0});
const fmtD = d => { if(!d) return '—'; var s=String(d).substring(0,10); var p=s.split('-'); return p.length===3 ? p[2]+'-'+p[1]+'-'+p[0] : s; };
const ini = name => { if(!name) return '?'; const w=name.trim().split(' '); return (w[0][0]+(w[1]?w[1][0]:'')).toUpperCase(); };
const badgeEC = cat => {
  if(!cat) return '<span class="badge b-gray">—</span>';
  if(cat.includes('Al dia')) return `<span class="badge b-blue">Al dia</span>`;
  if(cat.includes('+90')) return `<span class="badge b-red">+90 dias</span>`;
  if(cat.includes('61')) return `<span class="badge b-red">61-90 dias</span>`;
  if(cat.includes('31')) return `<span class="badge b-amber">31-60 dias</span>`;
  return `<span class="badge b-green">1-30 dias</span>`;
};
const loading = () => `<div class="loading"><div class="spinner"></div> Cargando...</div>`;
const empty = msg => `<div class="empty">${msg||'Sin resultados'}</div>`;

// ══ API ══
// Un cliente de NAPA no compra a Kennedy: sus documentos estan en las tablas
// de NAPA. En vez de tocar las veinte pantallas del portal, se redirige aqui,
// que es por donde pasan todas las consultas.
var TABLAS_NAPA = {
  'facturas':       'facturas_napa',
  'vista_facturas': 'facturas_napa',
  'pedidos':        'pedidos_napa',
  'vista_pedidos':  'pedidos_napa',
  'clientes':       'clientes_napa',
  'estado_cuenta':  'estado_cuenta_nappa',
  // 'movimientos' es el mayor de cuentas de Kennedy (JDT1); su equivalente en
  // NAPA es estado_cuenta_nappa, que guarda exactamente lo mismo. La ficha del
  // cliente lee de aqui, no de estado_cuenta: por eso salia vacia aunque la
  // otra consulta si devolviera datos.
  'movimientos':    'estado_cuenta_nappa'
};

// Vistas que NO existen para NAPA. Se calculan a partir de facturas_napa en
// vez de devolver vacio, que es lo que hacia que "Ultimo precio pagado" y
// "Restock sugerido" salieran sin datos.
var VISTAS_NAPA = ['ultimo_precio_cliente', 'frecuencia_compra_cliente', 'restock_cliente'];

// Ultimo precio y cantidad de cada articulo que el cliente ha comprado.
async function _napaUltimoPrecio(cardcode){
  try{
    var f = await qAll('facturas_napa',
      'select=itemcode,dscription,docdate,price,quantity&cardcode=eq.'+encodeURIComponent(cardcode));
    var m = {};
    (f||[]).forEach(function(x){
      if(!x.itemcode) return;
      var a = m[x.itemcode];
      var d = String(x.docdate||'').substring(0,10);
      if(!a || d > a.fechaultima_compra){
        m[x.itemcode] = {
          itemcode: x.itemcode,
          dscription: x.dscription || x.itemcode,
          fechaultima_compra: d,
          ultimoprecio: Number(x.price)||0,
          ultimacantidad: Number(x.quantity)||0,
          cardcode: cardcode,
          veces: (a ? a.veces : 0) + 1
        };
      } else {
        a.veces = (a.veces||0) + 1;   // cuantas veces lo ha comprado
      }
    });
    var hoy = Date.now();
    return Object.keys(m).map(function(k){
      var r = m[k];
      // Dias desde la ultima compra: es lo que usa "Restock sugerido" para
      // marcar en rojo lo que lleva tiempo sin reponerse.
      if(r.fechaultima_compra){
        var t = new Date(r.fechaultima_compra + 'T00:00:00');
        r.diasdesdeultimacompra = isNaN(t) ? null : Math.round((hoy - t.getTime())/86400000);
      } else {
        r.diasdesdeultimacompra = null;
      }
      return r;
    }).sort(function(a,b){
      // Primero lo que mas repite; a igualdad, lo mas reciente. Un articulo
      // comprado diez veces dice mas que uno comprado una vez ayer.
      var d = (b.veces||0) - (a.veces||0);
      return d !== 0 ? d
        : String(b.fechaultima_compra).localeCompare(String(a.fechaultima_compra));
    });
  }catch(e){ return []; }
}

// Compras totales, ticket promedio y dias sin comprar. En Kennedy salen de una
// vista; para NAPA se calculan aqui sobre sus facturas. Ojo: facturas_napa
// tiene una fila por LINEA, asi que el total y el numero de facturas se sacan
// agrupando por documento, no sumando filas.
async function _napaFrecuencia(cardcode){
  try{
    var f = await qAll('facturas_napa',
      'select=docnum,docdate,doctotal&cardcode=eq.'+encodeURIComponent(cardcode));
    var docs = {}, ultima = '';
    (f||[]).forEach(function(x){
      if(x.docnum==null) return;
      var k = String(x.docnum);
      if(!docs[k]) docs[k] = Number(x.doctotal)||0;
      var d = String(x.docdate||'').substring(0,10);
      if(d > ultima) ultima = d;
    });
    var claves = Object.keys(docs);
    if(!claves.length) return [];
    var total = 0;
    claves.forEach(function(k){ total += docs[k]; });

    var dias = null;
    if(ultima){
      var t = new Date(ultima + 'T00:00:00');
      if(!isNaN(t)) dias = Math.round((Date.now() - t.getTime()) / 86400000);
    }
    return [{
      cardcode: cardcode,
      comprastotales: total,
      totalfacturas: claves.length,
      ticketpromedio: total / claves.length,
      ultimacompra: ultima || null,
      diasdesdeultimacompra: dias
    }];
  }catch(e){ return []; }
}

function _tablaSegunEmpresa(tabla){
  if(!CU || CU.rol!=='cliente' || !CU.napa) return tabla;
  return TABLAS_NAPA[tabla] || tabla;
}

// El estado de cuenta de NAPA es el mayor de cuentas y usa otros nombres de
// columna (refdate en vez de docdate, debit/credit en vez de saldopendiente).
// Se traduce lo que llega para que las pantallas no tengan que enterarse.
var _detalleDoc = false;   // la consulta en curso pide un documento concreto

function _adaptarNapa(tabla, filas){
  if(!Array.isArray(filas)) return filas;

  // facturas_napa y pedidos_napa tienen una fila por LINEA. Las pantallas que
  // listan documentos esperan uno por fila, y si no se agrupan salen tres
  // veces la misma factura. Solo se agrupa cuando la consulta no pidio datos
  // de linea (itemcode): si los pidio, es que quiere el detalle.
  if(tabla==='facturas_napa' || tabla==='pedidos_napa'){
    // Se agrupa por documento salvo que la pantalla pida el DETALLE de un
    // documento concreto (docnum=eq.N). Antes se decidia por la presencia de
    // itemcode, pero como la consulta se reescribe a select=* ese campo viene
    // siempre y no se agrupaba nunca: la misma factura salia veinte veces.
    if(_detalleDoc) return filas;
    if(!filas.length || filas[0].docnum===undefined) return filas;

    var vistos={}, out=[];
    filas.forEach(function(f){
      var k=String(f.docnum);
      if(vistos[k]) return;
      vistos[k]=1;
      // Los campos de linea sobran en un listado de documentos y confunden si
      // alguna pantalla los lee.
      var d=Object.assign({}, f);
      delete d.itemcode; delete d.dscription; delete d.quantity;
      delete d.price; delete d.linetotal; delete d.linenum;
      out.push(d);
    });
    return out;
  }

  if(tabla!=='estado_cuenta_nappa') return filas;
  return filas.map(function(r){
    if(r.docdate===undefined && r.refdate!==undefined){
      var deb=Number(r.debit)||0, cre=Number(r.credit)||0;
      r.docdate        = r.refdate;
      r.docduedate     = r.refdate;
      r.docnum         = r.ref1 || r.transid;
      r.doctotal       = deb;
      r.saldopendiente = deb - cre;
      r.comments       = r.linememo || '';
      r.docstatus      = 'O';
      // La ficha del cliente lee 'debito'/'credito' en espanol; el mayor de
      // NAPA los trae en ingles. Sin esta linea la tabla sale vacia aunque
      // los datos hayan llegado bien.
      r.debito         = deb;
      r.credito        = cre;
      // Tipo de movimiento, deducido de TransType de SAP: 13 factura,
      // 14 nota de credito, 24 recibo de cobro, 30 asiento manual.
      r.tipo = (r.transtype===13) ? 'FA'
             : (r.transtype===14) ? 'NC'
             : (r.transtype===24) ? 'RC'
             : (deb>0 ? 'ND' : 'RC');
      if(r.diasvencido===undefined && r.refdate){
        var t=new Date(String(r.refdate).substring(0,10)+'T00:00:00');
        r.diasvencido = isNaN(t) ? 0 : Math.round((Date.now()-t.getTime())/86400000);
      }
    }
    return r;
  });
}

async function q(tabla, params='') {
  // ── SIN CONEXION ────────────────────────────────────────────────────────
  // Se responde con los datos descargados al dispositivo. Va aqui, en el
  // punto por el que pasan TODAS las consultas, en vez de parchear pantalla
  // por pantalla: asi cualquier pantalla que use q() funciona sin señal.
  if(!navigator.onLine){
    if(typeof kccOffline==='function'){
      var _off = await kccOffline(tabla, params);
      if(_off !== null) return _off;      // null = esta tabla no se guarda
    }
    // Tabla no descargada y sin red: se responde vacio AL INSTANTE. Antes se
    // iba a la red igual y el navegador podia tardar mucho en rendirse, con
    // lo que la pantalla se quedaba en "Cargando..." para siempre.
    if(window.KCC_DEBUG) console.log('[offline] sin datos guardados de:', tabla);
    return [];
  }

  // Vistas que no existen para NAPA: se arman con los datos que si hay.
  if(CU && CU.rol==='cliente' && CU.napa && VISTAS_NAPA.indexOf(tabla)>=0){
    if(tabla==='ultimo_precio_cliente'){
      var _up = await _napaUltimoPrecio(CU.cardcode);
      var _lim = String(params).match(/limit=(\d+)/);
      return _lim ? _up.slice(0, +_lim[1]) : _up;
    }
    if(tabla==='frecuencia_compra_cliente') return await _napaFrecuencia(CU.cardcode);
    // El restock sugerido se arma con los mismos datos: la ficha lo pinta a
    // partir de ultimo_precio_cliente, asi que no hace falta nada mas.
    if(tabla==='restock_cliente') return await _napaUltimoPrecio(CU.cardcode);
    return [];
  }

  var _pedida = tabla;
  tabla = _tablaSegunEmpresa(tabla);
  var _adaptar = (tabla !== _pedida);

  // facturas_napa no tiene paidtodate ni docstatus con el mismo sentido:
  // se piden todas las columnas y la pantalla usa las que encuentre.
  if(tabla === 'facturas_napa' || tabla === 'pedidos_napa'){
    // Cuando NO agrupar: si la consulta pide un documento concreto, o si pide
    // columnas de linea (itemcode, quantity, price). El restock, por ejemplo,
    // necesita TODAS las lineas para saber que compra el cliente; agruparlas
    // dejaba una sola por factura y la pantalla salia vacia.
    _detalleDoc = /(^|&)docnum=eq\./.test(String(params))
               || /select=[^&]*\b(itemcode|quantity|price|linetotal|dscription)\b/.test(String(params));
    params = String(params).replace(/select=[^&]*/, 'select=*')
                           .replace(/(^|&)(paidtodate|docstatus)=[^&]*/g, '$1')
                           .replace(/&{2,}/g, '&').replace(/&$/, '');
  }

  // El mayor de NAPA no tiene las columnas que pide el portal (docdate,
  // saldopendiente...). Si se piden por nombre, PostgREST responde 400. Se
  // traen todas y se traducen al recibirlas.
  if(tabla === 'estado_cuenta_nappa'){
    params = String(params).replace(/select=[^&]*/, 'select=*');
    // La consulta de movimientos ordena por docdate y pide tipo/debito/credito,
    // que en el mayor de NAPA se llaman distinto o no existen.
    params = params.replace(/(^|&)(tipo|debito|credito)=[^&]*/g, '$1');
    // Y los filtros y ordenes sobre columnas que no existen se reescriben.
    // El order puede venir con sufijo (order=docdate.desc) o sin el
    // (order=docduedate). Se traduce cualquier columna de fecha a refdate,
    // que es como se llama en el mayor de NAPA, conservando el sentido.
    params = params.replace(/(^|&)order=(docdate|docduedate|creado_en|fecha)(\.[a-z.]+)?/g,
                            function(_, ini, col, suf){ return ini+'order=refdate'+(suf||''); });

    // Filtros sobre columnas que el mayor no tiene: se quitan. Es preferible
    // devolver de mas y que la pantalla lo muestre, a devolver un 400.
    params = params.replace(/(^|&)(saldopendiente|docstatus|diasvencido|categoria|doctotal|paidtodate|docnum|docduedate|docdate)=[^&]*/g, '$1')
                   .replace(/&{2,}/g, '&');

    // Por si quedara algun order de una columna inexistente.
    params = params.replace(/(^|&)order=(?!refdate|cardcode|cardname|transid|debit|credit)[a-z_]+(\.[a-z.]+)?/g, '$1')
                   .replace(/&{2,}/g, '&').replace(/&$/, '');
  }
  const url = `${SB}/rest/v1/${tabla}?${params}`;
  const pedir = () => fetch(url, {
    headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK()},
    cache:'no-store'
  });
  let r = await pedir();
  // Token vencido: lo renovamos una vez y reintentamos.
  if((r.status===401 || r.status===403) && await authRefrescar()) r = await pedir();
  if(!r.ok){
    if(r.status===401 || r.status===403) sesionVencida();
    return [];
  }
  var _filas = await r.json();
  var _res = _adaptar ? _adaptarNapa(tabla, _filas) : _filas;
  return _res;
}

// Sesion caida: no dejamos la pantalla a medias, se vuelve al login.
let _avisoSesion=false;
function sesionVencida(){
  if(_avisoSesion) return;
  _avisoSesion=true;
  SESS=null; CU=null;
  alert('Tu sesion expiro. Vuelve a iniciar sesion.');
  location.reload();
}

// Trae TODAS las filas paginando (PostgREST/Supabase corta en max-rows aunque pidas limit alto)
async function qAll(tabla, params=''){
  var all=[], offset=0, size=1000;
  for(var i=0;i<500;i++){
    var rows=await q(tabla, params+'&limit='+size+'&offset='+offset);
    if(!rows || !rows.length) break;
    all=all.concat(rows);
    if(i===0 && rows.length>0) size=rows.length;   // ajusta al tope real del servidor
    if(rows.length<size) break;
    offset+=size;
  }
  return all;
}

async function qCount(tabla, params='') {
  const url = `${SB}/rest/v1/${tabla}?${params}&limit=1`;
  const pedir = () => fetch(url, {
    headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Prefer':'count=exact'}
  });
  let r = await pedir();
  if((r.status===401 || r.status===403) && await authRefrescar()) r = await pedir();
  if(!r.ok) return 0;
  const ct = r.headers.get('content-range');
  return ct ? parseInt(ct.split('/')[1])||0 : 0;
}

// ══ AUTH ══
const CLI_DOMINIO='clientes.kennedycenter.app';
function aplicarTema(t){
  document.documentElement.setAttribute('data-theme', t==='dark'?'dark':'light');
  var ic=document.getElementById('theme-ic');
  if(ic){ ic.innerHTML = (t==='dark')
    ? '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>'
    : '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>'; }
}
function toggleTheme(){
  var cur=document.documentElement.getAttribute('data-theme')==='dark'?'dark':'light';
  var next=cur==='dark'?'light':'dark';
  aplicarTema(next);
  try{ localStorage.setItem('kc_theme', next); }catch(e){}
}
(function(){ var t='light'; try{ t=localStorage.getItem('kc_theme')||'light'; }catch(e){} aplicarTema(t); })();
function entrarApp(){
  $('auth').style.display='none';
  $('app').style.display='block';
  $('u-av').textContent=CU.av||'';
  $('u-name').textContent=CU.nombre||'';
  $('u-role').textContent=CU.rol==='admin'?'Administrador':CU.rol==='vendedor'?'Vendedor':'Cliente';
  if(CU.rol==='cliente'){
    clienteLockdown();
  } else {
    // Mostrar "Nuevo cliente" solo para vendedores y gerencia/admin
    try{
      var _rol=String(CU.rol||'').toLowerCase();
      if(_rol==='vendedor'||_rol==='gerencia'||_rol==='admin'||_rol==='administrador'){
        var _nc=document.getElementById('nav-nc'); if(_nc)_nc.style.display='';
      }
      // Control de pedidos: administracion y gerencia ven el de todos; los
      // vendedores, solo sus pedidos y los de sus codigos compartidos. A los
      // clientes se lo oculta clienteLockdown.
      if(['admin','administrador','gerencia','vendedor'].indexOf(_rol)<0){
        var _cp=document.getElementById('nav-cpd'); if(_cp)_cp.style.display='none';
      }
      // El radar es del equipo: un cliente no ve quien se esta enfriando.
      if(_rol==='cliente'){
        var _rd=document.getElementById('nav-radar'); if(_rd)_rd.style.display='none';
      }

      // Morosidad: la ve TODO EL EQUIPO. Se oculta solo a los clientes.
      // Va por lista negra y no por lista blanca a proposito: si manana
      // aparece un rol nuevo ("cobranza", "supervisor"), la ve igual en vez
      // de quedarse fuera sin que nadie se entere. Lo que cada uno ve DENTRO
      // lo decide la propia pantalla: un vendedor, solo sus clientes.
      if(_rol==='cliente'){
        var _mo=document.getElementById('nav-mor'); if(_mo)_mo.style.display='none';
      }
    }catch(e){}
    initDashboard();
    loadClientes();
    loadPedidos();
    loadFacturas();
    loadInventario();
    loadEC();
    loadAlertas();
    loadUP();
  }
}
// Guarda la sesion devuelta por Supabase Auth y programa su refresco.
function _guardarSesion(d){
  SESS = {
    access_token: d.access_token,
    refresh_token: d.refresh_token,
    expira_en_ms: Date.now() + ((Number(d.expires_in)||3600) * 1000)
  };
}

// Renueva el access_token con el refresh_token. Devuelve true si sigue habiendo sesion.
async function authRefrescar(){
  if(!SESS || !SESS.refresh_token) return false;
  try{
    var r = await fetch(SB+'/auth/v1/token?grant_type=refresh_token',{
      method:'POST',
      headers:{'apikey':KEY,'Content-Type':'application/json'},
      body: JSON.stringify({refresh_token: SESS.refresh_token})
    });
    if(!r.ok){ SESS=null; return false; }
    var d = await r.json();
    if(!d || !d.access_token){ SESS=null; return false; }
    _guardarSesion(d);
    return true;
  }catch(e){ return false; }
}

// Refresco preventivo cada 10 min si al token le quedan menos de 5.
setInterval(function(){
  if(SESS && (SESS.expira_en_ms - Date.now()) < 5*60*1000) authRefrescar();
}, 10*60*1000);

// Login unico para todos los perfiles.
// Se puede entrar con el usuario corto (se le pega el dominio) o con el correo completo.
async function loginSupabase(usuario, password){
  var u = String(usuario).trim().toLowerCase();
  var email = u.indexOf('@')>=0 ? u : (u.replace(/[^a-z0-9._-]/g,'') + '@' + CLI_DOMINIO);
  try{
    var r = await fetch(SB+'/auth/v1/token?grant_type=password',{
      method:'POST',
      headers:{'apikey':KEY,'Content-Type':'application/json'},
      body: JSON.stringify({email: email, password: password})
    });
    if(!r.ok) return false;
    var d = await r.json();
    if(!d || !d.access_token) return false;
    _guardarSesion(d);

    // El ROL y el CARDCODE se leen SOLO de app_metadata (no editable por el usuario).
    var app = (d.user && d.user.app_metadata) || {};
    var perfil = (d.user && d.user.user_metadata) || {};   // solo para datos cosmeticos
    var rol = String(app.rol || 'cliente').toLowerCase();
    var cc  = String(app.cardcode || '');
    var nombre = perfil.nombre || app.cardname || perfil.cardname ||
                 (rol==='cliente' ? ('Cliente '+cc) : u);

    if(rol==='cliente' && !cc) return false;  // cliente sin cardcode asignado: no entra

    // Un cliente puede ser de Kennedy o de NAPA. Los de NAPA tienen sus
    // facturas y su estado de cuenta en otras tablas, asi que hay que saberlo
    // ANTES de pintar nada: si no, entra y ve el portal vacio.
    //
    // La empresa se decide asi, en orden:
    //   1. Si el usuario la trae en app_metadata, manda eso (es lo fiable).
    //   2. Si no, se mira si el codigo existe en la tabla de clientes de
    //      Kennedy. Si NO esta ahi, se asume NAPA.
    //
    // No se consulta clientes_napa a proposito: sus politicas RLS solo dejan
    // leer a usuarios internos, asi que un cliente siempre recibiria vacio y
    // se le clasificaria mal. La ausencia en Kennedy es la senal fiable.
    // Hay codigos que existen en LAS DOS empresas siendo clientes distintos
    // (C10170 es CITY MALL en NAPA y NAPPA-G-FIVE/CM en Kennedy). Por eso el
    // codigo por si solo NO identifica la empresa: manda lo que diga la
    // cuenta en app_metadata.empresa, que se fija al crearla.
    // La empresa la fija la cuenta (app_metadata.empresa) cuando esta puesta.
    var esNapa = String(app.empresa || '').toLowerCase() === 'napa';

    if(rol==='cliente' && !app.empresa){
      // Sin ese campo hay que deducirla. NAPA tiene PRIORIDAD: si el codigo
      // existe en las dos empresas, entra como cliente de NAPA.
      //
      // Es una decision de negocio, no tecnica: hay codigos repetidos que son
      // clientes distintos (C10170 es CITY MALL en NAPA y NAPPA-G-FIVE/CM en
      // Kennedy) y se prefiere que entre el de NAPA.
      try{
        var enN = await q('clientes_napa','select=cardcode&cardcode=eq.'+encodeURIComponent(cc)+'&limit=1');
        esNapa = !!(enN && enN.length);
      }catch(e){
        // clientes_napa puede estar cerrada por RLS para este usuario: en ese
        // caso se cae al criterio anterior (si no esta en Kennedy, es NAPA).
        try{
          var enK = await q('clientes','select=cardcode&cardcode=eq.'+encodeURIComponent(cc)+'&limit=1');
          esNapa = !(enK && enK.length);
        }catch(e2){ esNapa=false; }
      }
    }

    CU = {
      rol: rol,
      cardcode: cc,
      nombre: nombre,
      av: String(nombre).slice(0,2).toUpperCase(),
      email: email,
      username: String(email).split('@')[0].toLowerCase(),   // dan@kennedyzl.com -> dan
      napa: esNapa,
      slpcode: (app.slpcode != null ? app.slpcode : null)
    };
    entrarApp();
    // El chat arranca en segundo plano: asi el badge de mensajes sin leer
    // aparece aunque el usuario nunca abra la pagina del chat.
    if(rol!=='cliente' && typeof chatArrancar==='function'){ try{ chatArrancar(); }catch(e){} }
    return true;
  }catch(e){ return false; }
}

async function login(){
  const u=$('iu').value.trim().toLowerCase(), p=$('ip').value;
  const btn=$('btn-login');
  $('aerr').style.display='none';
  if(btn) btn.disabled=true;
  const ok = await loginSupabase(u,p);
  if(btn) btn.disabled=false;
  if(!ok){
    $('aerr').style.display='block';
    $('ip').value='';
  }
}
$('ip').addEventListener('keydown',e=>{if(e.key==='Enter')login()});
/* ===== Idioma ES / EN (por defecto espanol) ===== */
var LANG='es';
var _i18nObs=null, _i18nApplying=false, _i18nEN2ES=null;
var I18N_ES2EN={"Afganistán": "Afghanistan", "Arabia Saudita": "Saudi Arabia", "Azerbaiyán": "Azerbaijan", "Bangladés": "Bangladesh", "Baréin": "Bahrain", "Bélgica": "Belgium", "Benín": "Benin", "Bosnia y Herzegovina": "Bosnia and Herzegovina", "Brunéi": "Brunei", "Bután": "Bhutan", "Cabo Verde": "Cape Verde", "Camerún": "Cameroon", "Canadá": "Canada", "CANADÁ": "CANADA", "Ciudad del Vaticano": "Vatican City", "Colón, Rep. de Panamá": "Colon, Rep. of Panama", "Colon, Rep. de Panama": "Colon, Rep. of Panama", "Congo (RDC)": "Congo (DRC)", "Corea del Norte": "North Korea", "Corea del Sur": "South Korea", "Costa de Marfil": "Ivory Coast", "Emiratos Árabes Unidos": "United Arab Emirates", "España": "Spain", "ESPAÑA": "SPAIN", "Estados Unidos": "United States", "ESTADOS UNIDOS": "UNITED STATES", "Etiopía": "Ethiopia", "Gabón": "Gabon", "Guayana Francesa": "French Guiana", "Guinea Ecuatorial": "Equatorial Guinea", "Guinea-Bisáu": "Guinea-Bissau", "Haití": "Haiti", "HAITÍ": "HAITI", "Hungría": "Hungary", "Irán": "Iran", "Islas Caimán": "Cayman Islands", "Islas Canarias": "Canary Islands", "Islas Turcas y Caicos": "Turks and Caicos Islands", "Islas Vírgenes (EE.UU.)": "Virgin Islands (U.S.)", "Islas Vírgenes Británicas": "British Virgin Islands", "Japón": "Japan", "Kazajistán": "Kazakhstan", "Kirguistán": "Kyrgyzstan", "Líbano": "Lebanon", "Macedonia del Norte": "North Macedonia", "Malí": "Mali", "México": "Mexico", "MÉXICO": "MEXICO", "Mónaco": "Monaco", "Níger": "Niger", "Nueva Zelanda": "New Zealand", "Omán": "Oman", "Pakistán": "Pakistan", "Panamá": "Panama", "PANAMÁ": "PANAMA", "Papúa Nueva Guinea": "Papua New Guinea", "Perú": "Peru", "PERÚ": "PERU", "Polinesia Francesa": "French Polynesia", "Reino Unido": "United Kingdom", "Rep. Centroafricana": "Central African Rep.", "República Dominicana": "Dominican Republic", "REPUBLICA DOMINICANA": "DOMINICAN REPUBLIC", "REPÚBLICA DOMINICANA": "DOMINICAN REPUBLIC", "Rumanía": "Romania", "Sáhara Occidental": "Western Sahara", "San Cristóbal y Nieves": "Saint Kitts and Nevis", "San Martín": "Saint Martin", "San Pedro y Miquelón": "Saint Pierre and Miquelon", "San Vicente y las Granadinas": "Saint Vincent and the Grenadines", "Santa Elena": "Saint Helena", "Santa Lucía": "Saint Lucia", "Santo Tomé y Príncipe": "Sao Tome and Principe", "Sierra Leona": "Sierra Leone", "Sudáfrica": "South Africa", "Sudán": "Sudan", "Sudán del Sur": "South Sudan", "Taiwán": "Taiwan", "Tayikistán": "Tajikistan", "Trinidad y Tobago": "Trinidad and Tobago", "Turkmenistán": "Turkmenistan", "Turquía": "Turkey", "Túnez": "Tunisia", "Uzbekistán": "Uzbekistan", "Antigua y Barbuda": "Antigua and Barbuda", "Principal": "Main", "Inventario": "Inventory", "Reportes": "Reports", "Clientes": "Customers", "Pedidos": "Orders", "Facturas": "Invoices", "Nuevo pedido": "New order", "Nuevo Pedido": "New order", "Estado de cuenta": "Account statement", "Estados de cuenta NAPPA": "NAPPA account statements", "Código del cliente": "Customer code", "Consultar": "Look up", "Sin movimientos para ese cliente / fecha": "No transactions for that customer / date", "Link de pago": "Payment link", "Ley 23": "Law 23", "Mercancía separada": "Reserved stock", "Mercanca separada": "Reserved stock", "Alertas": "Alerts", "Restock cliente": "Customer restock", "Clientes atrasados": "Overdue customers", "Reactivar clientes": "Reactivate customers", "Entregas de un pedido": "Order deliveries", "Mejores artículos vendidos": "Best selling items", "Mejores articulos vendidos": "Best selling items", "Mejores articulos": "Best selling items", "Cerrar sesion": "Log out", "Cerrar sesión": "Log out", "Portal de Ventas": "Sales Portal", "Portal de ventas": "Sales Portal", "Portal de Ventas & Inventario": "Sales & Inventory Portal", "Kennedy — Portal de Ventas": "Kennedy — Sales Portal", "Administrador": "Administrator", "Vendedor": "Salesperson", "Cliente": "Customer", "Vendedor 1": "Salesperson 1", "Vendedor 2": "Salesperson 2", "Todos los vendedores": "All salespeople", "Usuario": "User", "usuario": "user", "Contraseña": "Password", "Entrar": "Log in", "Usuario o contraseña incorrectos": "Wrong username or password", "Tema claro / oscuro": "Light / dark theme", "Buscar": "Search", "Exportar": "Export", "Exportar lo filtrado": "Export filtered", "Guardar": "Save", "Cancelar": "Cancel", "Cancelado": "Cancelled", "Cerrar": "Close", "Confirmar": "Confirm", "Aplicar": "Apply", "Limpiar": "Clear", "limpiar": "clear", "Vaciar": "Empty", "Actualizar": "Refresh", "Cambiar": "Change", "Ver": "View", "Ver detalle": "View detail", "Ver todos": "View all", "Ver todo": "View all", "Ver pedidos": "View orders", "Ver inventario": "View inventory", "Ver ficha del cliente": "View customer card", "Consultar inventario": "Check inventory", "Cargar documento": "Load document", "Escanear": "Scan", "Escanear código de barras": "Scan barcode", "Buscar de nuevo": "Search again", "Buscar con IA": "Search with AI", "Borrar historial": "Clear history", "Añadir todo (1 c/u)": "Add all (1 each)", "Agregar al pedido": "Add to order", "Crear pedido": "Create order", "Procesar pedido": "Process order", "Importar lista": "Import list", "Importar pedido desde Excel": "Import order from Excel", "Importar pedido desde lista": "Import order from list", "Imprimir": "Print", "Imprimir / PDF": "Print / PDF", "Vista previa": "Preview", "Generar Excel": "Generate Excel", "Generar PDF": "Generate PDF", "Generar PDF / Excel con caracteristicas": "Generate PDF / Excel with features", "Generar reporte de la factura": "Generate invoice report", "Generar reporte de un documento": "Generate document report", "Recientes:": "Recent:", "Resumen de actividad": "Activity summary", "Mi estado de cuenta": "My account statement", "Mi restock": "My restock", "Catálogo y stock": "Catalog & stock", "Lista de precios": "Price list", "Nuevo pedido de venta": "New sales order", "Nueva cotización": "New quote", "Nueva cotizacion": "New quote", "Selecciona el cliente": "Select the customer", "Detalles del pedido": "Order details", "Resumen del pedido": "Order summary", "Detalle de pedido": "Order detail", "Detalle de producto": "Product detail", "Detalle de factura": "Invoice detail", "Ficha de cliente": "Customer card", "Información del producto": "Product information", "Informacion del producto": "Product information", "Ficha tecnica del producto": "Product datasheet", "Reporte de restock por cliente": "Restock report by customer", "Restock por cliente": "Restock by customer", "Reporte de Restock — historial de compras": "Restock report — purchase history", "Restock sugerido — productos que compra regularmente": "Suggested restock — regularly purchased products", "Ultimo precio pagado por producto": "Last price paid per product", "Ultimo precio por cliente": "Last price by customer", "Clientes con deuda": "Customers with debt", "Clientes que adeudan a Kennedy.": "Customers owing Kennedy.", "Saldos y vencimientos": "Balances and due dates", "Ventas por mes": "Monthly sales", "Ventas del mes": "Sales this month", "Ventas por mes vs año pasado": "Monthly sales vs last year", "vs año pasado": "vs last year", "vs año pasado (a la fecha)": "vs last year (to date)", "Este año": "This year", "Año pasado": "Last year", "Ventas del año": "Sales this year", "Pedidos por autorizar": "Orders to authorize", "vs mes anterior": "vs last month", "en total": "total", "acumulado": "YTD", "Cobranza por antigüedad": "Receivables by age", "Total pendiente:": "Total outstanding:", "Este mes:": "This month:", "vs mes anterior:": "vs last month:", "Pedidos por autorizar:": "Orders to authorize:", "Sin saldos pendientes": "No outstanding balances", "Colecciones": "Collections", "Todas las colecciones": "All collections", "Campos a imprimir": "Fields to print", "Columnas al descargar:": "Columns on download:", "Caracteristicas a incluir en el documento:": "Features to include in the document:", "Descripcion": "Description", "Descripción": "Description", "Cantidad": "Quantity", "Cantidad vendida": "Quantity sold", "Cant.": "Qty", "Cant. vendida": "Qty sold", "Cant. pedida": "Qty ordered", "Cant. separada": "Qty reserved", "Cant. sugerida": "Suggested qty", "Cant. ult.": "Last qty", "Cant. última": "Last qty", "Codigo": "Code", "Código": "Code", "Codigo:": "Code:", "Código · Cantidad · Precio": "Code · Quantity · Price", "CÓDIGO CANTIDAD PRECIO": "CODE QUANTITY PRICE", "Codigo barras": "Barcode", "Marca": "Brand", "Grupo": "Group", "Precio": "Price", "Precio actual": "Current price", "Precio de venta": "Sale price", "Precio máx.": "Max price", "Precio mín.": "Min price", "Precio: mayor a menor": "Price: high to low", "Precio: menor a mayor": "Price: low to high", "Disponible": "Available", "Disponible p/vender": "Available to sell", "Disponibilidad": "Availability", "Stock actual": "Current stock", "Stock disponible": "Available stock", "Stock mín.": "Min stock", "Bajo stock": "Low stock", "En stock": "In stock", "Con stock": "With stock", "Agotado": "Out of stock", "En bodega": "In warehouse", "Descuento": "Discount", "Descuentos": "Discounts", "Descuento general %": "General discount %", "Descuento general %:": "General discount %:", "Descuento líneas:": "Line discounts:", "Desc%": "Disc%", "Desc.": "Disc.", "Monto": "Amount", "Monto vendido": "Amount sold", "Monto faltante": "Missing amount", "Fecha": "Date", "Fecha:": "Date:", "Fecha del pedido": "Order date", "Fecha de entrega": "Delivery date", "Fecha entrega": "Delivery date", "Nombre": "Name", "Nombre:": "Name:", "Estado": "Status", "Tipo": "Type", "Tipo de producto": "Product type", "Acciones": "Actions", "Bultos": "Packages", "Bultos disp.": "Pkgs avail.", "Bultos min": "Min pkgs", "Bultos mín.": "Min pkgs", "Bultos máx.": "Max pkgs", "Peso": "Weight", "Peso bulto": "Package weight", "peso bulto": "package weight", "Peso producto": "Product weight", "Composición": "Composition", "Cubicaje": "Cubic volume", "Pie Cub": "Cu ft", "Pie Cub.": "Cu ft", "Piezas máx.": "Max pieces", "Piezas mín.": "Min pieces", "Moneda": "Currency", "Referencia": "Reference", "Comentario": "Comment", "Comentarios": "Comments", "Nota": "Note", "Nota...": "Note...", "Instrucciones especiales...": "Special instructions...", "Cliente o # pedido...": "Customer or order #...", "Cliente o producto...": "Customer or product...", "Cliente, código o # factura...": "Customer, code or invoice #...", "Producto o lista...": "Product or list...", "Buscar cliente por nombre o código...": "Search customer by name or code...", "Buscar cliente, producto...": "Search customer, product...", "Buscar por nombre o codigo...": "Search by name or code...", "Buscar por nombre o SKU...": "Search by name or SKU...", "Buscar producto...": "Search product...", "Buscar mercancía separada por SKU": "Search reserved stock by SKU", "SKU del producto": "Product SKU", "Ej. 12345": "e.g. 12345", "Ej. 49659": "e.g. 49659", "Selecciona un cliente.": "Please select a customer.", "Ordenar por": "Sort by", "Filtros avanzados": "Advanced filters", "Más reciente": "Most recent", "Mas reciente": "Most recent", "Reciente": "Recent", "Más stock primero": "Most stock first", "Mas stock primero": "Most stock first", "Menos stock primero": "Least stock first", "Nombre A-Z": "Name A-Z", "Todos": "All", "Todo": "All", "Todas": "All", "Todos los grupos": "All groups", "Todas las marcas": "All brands", "Todos los paises": "All countries", "Todos los países": "All countries", "Todos los productos": "All products", "Con foto": "With photo", "Solo imagen": "Image only", "Cuadrícula": "Grid", "Lista": "List", "Año": "Year", "Cualquier año": "Any year", "Todos los años": "All years", "Desde": "From", "Hasta": "To", "Entrada desde": "Entry from", "Entrada desde 2025": "Entry from 2025", "Mercancía reciente": "Recent merchandise", "Mercanca reciente": "Recent merchandise", "Último mes": "Last month", "Ultimo mes": "Last month", "Últimos 2 meses": "Last 2 months", "Últimos 3 meses (90 días)": "Last 3 months (90 days)", "Últimos 4 meses": "Last 4 months", "Últimos 5 meses": "Last 5 months", "Últimos 6 meses": "Last 6 months", "≤ 3 meses": "≤ 3 months", "≤ 6 meses": "≤ 6 months", "o más reciente": "or more recent", "Sin límite": "No limit", "País": "Country", "País:": "Country:", "Tamaño del item": "Item size", "Tamano bulto": "Package size", "Unidades por bulto": "Units per package", "Unidad compra": "Purchase unit", "Unidad venta": "Sale unit", "Autorizado": "Authorized", "Autorizados": "Authorized", "Autorización": "Authorization", "Por autorizar": "To authorize", "Pendiente": "Pending", "Pendientes": "Pending", "Confirmado": "Confirmed", "Entregado": "Delivered", "No entregado": "Not delivered", "Parcial": "Partial", "Abierto": "Open", "Cerrado": "Closed", "Pagada": "Paid", "Pagado": "Paid", "Vencido": "Overdue", "Vence": "Due", "Al dia": "Up to date", "Crédito al día": "Credit up to date", "Contado": "Cash", "Credito": "Credit", "Crédito": "Credit", "Debito": "Debit", "Limite": "Limit", "Excede lim.": "Exceeds lim.", "Critico": "Critical", "Comprometido": "Committed", "Devuelto": "Returned", "Facturado": "Invoiced", "Vendido": "Sold", "Por llegar": "Incoming", "Reunión": "Reunion", "Bts.": "Pkgs.", "Compras totales": "Total purchases", "Total histórico": "Historical total", "Total hist.": "Hist. total", "Total vencido": "Total overdue", "Saldo vencido": "Overdue balance", "Saldo actual": "Current balance", "Saldo pend.": "Pending bal.", "Saldo a la fecha:": "Balance to date:", "Saldo a la Fecha :": "Balance to date:", "Saldo:": "Balance:", "Saldo": "Balance", "Ticket promedio": "Average ticket", "Facturas recientes": "Recent invoices", "Pedidos recientes": "Recent orders", "Facturas abiertas": "Open invoices", "facturas abiertas": "open invoices", "Facturas vencidas": "Overdue invoices", "Ordenes Pend. :": "Pending orders:", "Límite de crédito": "Credit limit", "Límite de crédito:": "Credit limit:", "Limite de credito": "Credit limit", "Límite de Cr. :": "Credit limit:", "Mora máx.:": "Max overdue:", "Dias venc.": "Days overdue", "Dias": "Days", "Dias sin comprar": "Days without buying", "Ult. compra": "Last purchase", "Ultima compra": "Last purchase", "Última compra": "Last purchase", "Ult. precio": "Last price", "Ultimo precio": "Last price", "Últimos 15 pedidos": "Last 15 orders", "Ultimo costo": "Last cost", "Num. facturas": "# invoices", "Num.": "No.", "Nº facturas": "# invoices", "por factura": "per invoice", "Ventas netas": "Net sales", "Total vendido": "Total sold", "1-30 dias": "1-30 days", "31-60 dias": "31-60 days", "61-90 dias": "61-90 days", "Mas 240": "240+", "Más 240": "240+", "Sin deuda vencida": "No overdue debt", "Sin saldo vencido.": "No overdue balance.", "Sin deuda": "No debt", "Cargando...": "Loading...", "Cargando factura...": "Loading invoice...", "Cargando producto...": "Loading product...", "Cargando datos de contacto...": "Loading contact data...", "Buscando...": "Searching...", "Generando...": "Generating...", "Generando pedido...": "Generating order...", "Generando cotización...": "Generating quote...", "Generando estado de cuenta...": "Generating account statement...", "Preparando Excel...": "Preparing Excel...", "Preparando datos (en filtros grandes puede tardar)...": "Preparing data (may take a while for large filters)...", "Optimizando imagenes": "Optimizing images", "Optimizando imagenes...": "Optimizing images...", "Sin datos": "No data", "Sin resultados": "No results", "Sin productos": "No products", "Sin productos agregados": "No products added", "Sin pedidos": "No orders", "Sin facturas": "No invoices", "Sin lineas": "No lines", "Sin foto": "No photo", "Sin movimientos": "No movements", "Sin movimientos desde esa fecha": "No movements since that date", "Sin ventas para esos filtros": "No sales for those filters", "Sin productos para este filtro.": "No products for this filter.", "No hay productos en el pedido.": "There are no products in the order.", "No hay productos en la cotización.": "There are no products in the quotation.", "No hay productos que coincidan con el filtro.": "No products match the filter.", "No hay productos que coincidan con la busqueda actual.": "No products match the current search.", "No hay datos para el reporte.": "There is no data for this report.", "No hay clientes que cumplan el criterio este mes.": "No customers meet the criteria this month.", "Este cliente no tiene productos frecuentes registrados.": "This customer has no frequent products registered.", "Todo el pedido fue entregado.": "The whole order was delivered.", "Todo el pedido fue entregado. No hay pendientes.": "The whole order was delivered. Nothing pending.", "Todos los productos que coinciden ya estan en el pedido.": "All matching products are already in the order.", "Agrega productos al pedido primero.": "Add products to the order first.", "Carga un documento primero.": "Load a document first.", "Marca al menos una columna.": "Select at least one column.", "Marca al menos una caracteristica para incluir.": "Select at least one feature to include.", "Permite ventanas emergentes para generar el PDF.": "Please allow pop-ups to generate the PDF.", "Permite ventanas emergentes.": "Allow pop-ups.", "Error al buscar. Intenta de nuevo.": "Search error. Try again.", "Error al enviar": "Error sending", "Error al importar. Revisa tu conexión e intenta de nuevo.": "Import error. Check your connection and try again.", "Error de conexion con Supabase": "Connection error with Supabase", "No se pudo cargar.": "Could not load.", "No se pudo cargar el catálogo": "Could not load the catalog", "No se pudo cargar el inventario": "Could not load the inventory", "No se pudo cargar el producto.": "Could not load the product.", "No se pudo cargar la lista:": "Could not load the list:", "No se pudieron leer los productos seleccionados.": "Could not read the selected products.", "No se reconocieron líneas.": "No lines were recognized.", "Pega al menos una línea (Código Cantidad Precio).": "Paste at least one line (Code Quantity Price).", "Pega una línea por producto:": "Paste one line per product:", "Aplicar este % de descuento a TODAS las líneas (0-100):": "Apply this % discount to ALL lines (0-100):", "¿Vaciar la cotización?": "Empty the quote?", "Ya hay": "There are already", "No se encontró": "Not found", "No se encontró el SKU": "SKU not found", "Avance": "Progress", "Avance del pedido": "Order progress", "Avance del pedido:": "Order progress:", "Faltante": "Missing", "Detalles": "Details", "Contacto:": "Contact:", "Teléfono": "Phone", "Teléfono:": "Phone:", "Celular:": "Cell:", "Dirección": "Address", "Dirección:": "Address:", "Ciudad": "City", "Condición:": "Terms:", "CONDICION DE PAGO:": "PAYMENT TERMS:", "Vendedor:": "Salesperson:", "Vendedor asignado": "Assigned salesperson", "Nuevo cliente": "New customer", "Búsqueda": "Search", "Cotización": "Quotation", "Cotizacion": "Quote", "COTIZACION": "QUOTE", "Abrir cotización →": "Open quote →", "Revisar y enviar →": "Review and send →", "Ver pedido →": "View order →", "Ver pedido (0) →": "View order (0) →", "Siguiente →": "Next →", "← Anterior": "← Previous", "← Volver": "← Back", "← Catalogo": "← Catalog", "← Editar": "← Edit", "← Volver al reporte de restock": "← Back to restock report", "PRODUCTOS EN EL PEDIDO": "PRODUCTS IN THE ORDER", "Catalogo de inventario": "Inventory catalog", "Catalogo de productos": "Product catalog", "Comida Artificial": "Artificial Food", "± Ajustar precio a todo": "± Adjust price to all", "% Descuento a todo": "% Discount to all", "📊 Generar Excel": "📊 Generate Excel", "📊 Avance del pedido": "📊 Order progress", "📊 Excel (no entregado)": "📊 Excel (not delivered)", "📄 Estado de cuenta": "📄 Account statement", "📄 Generar PDF": "📄 Generate PDF", "📄 Generar reporte del pedido": "📄 Generate order report", "📄 Reportes": "📄 Reports", "📋 Pedidos": "📋 Orders", "📋 Detalle de pedido": "📋 Order detail", "📦 Inventario": "📦 Inventory", "📦 Detalle de producto": "📦 Product detail", "📦 Lineas del pedido": "📦 Order lines", "🔔 Alertas": "🔔 Alerts", "🛒 Nuevo pedido": "🛒 New order", "➕ Nuevo Pedido": "➕ New order", "👥 Clientes": "👥 Customers", "👤 Ficha de cliente": "👤 Customer card", "💬 Comentarios": "💬 Comments", "💲 Ultimo precio": "💲 Last price", "💲 Ultimo precio pagado por producto": "💲 Last price paid per product", "💳 Estado de cuenta": "💳 Account statement", "💵 Pago": "💵 Payment", "🏷️ Lista de precios": "🏷️ Price list", "🖨️ Imprimir": "🖨️ Print", "🖨️ Imprimir estado de cuenta": "🖨️ Print account statement", "🖨️ Imprimir pedido": "🖨️ Print order", "🖨️ PDF (no entregado)": "🖨️ PDF (not delivered)", "🗂️ Colecciones": "🗂️ Collections", "🔎 Mercancía separada": "🔎 Reserved stock", "🔄 Recomprar frecuentes": "🔄 Reorder frequent", "🔄 Restock en nuevo pedido": "🔄 Restock in new order", "🔄 Restock por cliente": "🔄 Restock by customer", "🔄 Restock sugerido — productos que compra regularmente": "🔄 Suggested restock — regularly purchased products", "🧾 Factura": "🧾 Invoice", "🧾 Facturas": "🧾 Invoices", "🧾 Detalle de factura": "🧾 Invoice detail", "🧾 Lineas de la factura": "🧾 Invoice lines", "🧾 Ultimas facturas": "🧾 Latest invoices", "🧾 Nota débito": "🧾 Debit note", "↩️ Nota crédito": "↩️ Credit note", "✉️ Enviar recordatorio de pago": "✉️ Send payment reminder", "✓ Confirmar y enviar cotización": "✓ Confirm and send quote", "✓ Crédito al día": "✓ Credit up to date", "⚠️ Atención de crédito": "⚠️ Credit attention", "⚠️ Hay productos sin stock suficiente": "⚠️ There are products without enough stock", "Top 10 más vendidos · último mes": "Top 10 best sellers · last month", "ULTIMOS PRODUCTOS COMPRADOS": "LAST PRODUCTS PURCHASED", "Últimos artículos recibidos": "Latest items received", "— Sin asignar —": "— Unassigned —", "Zona Libre de Colón": "Colon Free Zone", "Zona Libre de Colon": "Colon Free Zone", "ZONA LIBRE DE COLON": "COLON FREE ZONE", "Zona Libre": "Free Zone", "Abridor de Botellas": "Bottle Opener", "Acc. Groove Ceiling": "Groove Ceiling Acc.", "Acc. Lay In Ceiling": "Lay In Ceiling Acc.", "Acc. P/ Techo de Policarbonato": "Polycarbonate Ceiling Acc.", "Accesorios A/V": "A/V Accessories", "Acero Inoxidable": "Stainless Steel", "Aire acondicionado": "Air conditioning", "ALF. DE BANO": "BATH RUG", "ALF. DE COCINA": "KITCHEN RUG", "Alfombras De Bano": "Bath Rugs", "Alfombras De Cocina": "Kitchen Rugs", "Almacenamiento y Organizacion": "Storage & Organization", "Aluminio Hexagonal": "Hexagonal Aluminum", "Aluminio P/ Techo": "Ceiling Aluminum", "Aluminio Triangular": "Triangular Aluminum", "ARTICULO DE LIMPIEZA": "CLEANING ITEM", "Auxiliares de Bano": "Bath Auxiliaries", "Azulejo 30x90 cm": "Tile 30x90 cm", "Baldosa Decorativa": "Decorative Tile", "Bandeja De Servir": "Serving Tray", "Barras de Cortina": "Curtain Rods", "Barras de sonido": "Sound bars", "Bocinas amplificadas": "Amplified speakers", "Bocinas bluetooth": "Bluetooth speakers", "Bocinas inalambricas": "Wireless speakers", "Bolsa de Basura": "Trash Bag", "BOTELLA VASO TERMICO": "THERMAL BOTTLE CUP", "Bowl Y Ensaladeras": "Bowls & Salad Bowls", "Butaca - Silla": "Armchair - Chair", "Caja De Herramienta": "Tool Box", "Caja de Llaves": "Key Box", "Caja Herramientas": "Toolbox", "Cajas fuertes": "Safes", "Cajas Organizadoras": "Organizer Boxes", "Calentadores de agua": "Water heaters", "Cama De Exterior": "Outdoor Bed", "Camas Deco": "Deco Beds", "Capacidad 150 Kgs": "150 Kg Capacity", "Capacidad 180 Kgs": "180 Kg Capacity", "Capacidad 200 Kg": "200 Kg Capacity", "Carretilla Cap. 250 Kg": "250 Kg Wheelbarrow", "Carrito Para Servir": "Serving Cart", "Ceramica 30x60 cm": "Ceramic 30x60 cm", "Ceramica Pulida 30x60 cm": "Polished Ceramic 30x60 cm", "Chapa D/ Aluminio": "Aluminum Sheet", "COLADOR DE ALIMENTOS": "FOOD STRAINER", "Cortador de Pizza": "Pizza Cutter", "Cristaleria Vasos Y Copas": "Glassware Cups & Goblets", "CUBETAS DE HIELO": "ICE BUCKETS", "Cubetas para Hielo": "Ice Buckets", "Dispensadores de agua": "Water dispensers", "Escobilla de Bano": "Toilet Brush", "Esculturas Y Art Deco": "Sculptures & Art Deco", "Espejo P/Bano": "Bathroom Mirror", "Espejos Con Joyero": "Mirrors With Jewelry Box", "Espejos Decorativos": "Decorative Mirrors", "ESPONJA PARA BANO": "BATH SPONGE", "ESPUMADOR ELECTRICO DE LECHE": "ELECTRIC MILK FROTHER", "Estanteria de Vino": "Wine Rack", "Estufas electricas": "Electric stoves", "Extensiones electricas y adaptadores": "Electric extensions and adapters", "Extensiones Electricas y Adaptadores": "Electric Extensions and Adapters", "Flores Artificiales": "Artificial Flowers", "FRASCO D/VIDRIO": "GLASS JAR", "Freidoras de aire": "Air fryers", "Frutas Falsas": "Fake Fruits", "Funda para Almohada": "Pillow Case", "Glaceado/Pulido 800x800": "Glazed/Polished 800x800", "GORRO TURBANTE DE BANO": "BATH TURBAN CAP", "Grama Artifical": "Artificial Grass", "Grama Artificial": "Artificial Grass", "Granito 25.8X40X1.2": "Granite 25.8X40X1.2", "Granito 51X51X1.2": "Granite 51X51X1.2", "Granito 60x100": "Granite 60x100", "Grifo P/Fregador": "Sink Faucet", "Grifo P/Lavamano": "Basin Faucet", "Grifo P/Lavamano con disco": "Basin Faucet with disc", "Grill Y Sandwicheras": "Grills & Sandwich Makers", "Herramientas Manuales": "Hand Tools", "Instalaciones accesorios y adhesivos de ferreteria": "Hardware fittings, accessories and adhesives", "JGO. DE BANO": "BATH SET", "JGO. DE COCINA": "KITCHEN SET", "Juego De Cama": "Bed Set", "Juego De Comedor": "Dining Set", "Juego de Duvet": "Duvet Set", "Juegos De Bano": "Bath Sets", "Juegos De Cocina": "Kitchen Sets", "Juegos De Cuchillo": "Knife Sets", "Lamina de Policarbonato": "Polycarbonate Sheet", "Lavamano D/Vidrio": "Glass Basin", "Lavamano D/Vidrios": "Glass Basin", "Lavamano de Ceramica": "Ceramic Basin", "Librero De Oficina": "Office Bookcase", "LIMPIADOR INDUSTRIAL": "INDUSTRIAL CLEANER", "Manteles E Individuales": "Tablecloths & Placemats", "Mesa De Comedor": "Dining Table", "Mesa De Exterior": "Outdoor Table", "Mesa De Oficina": "Office Desk", "Mesas de Centro": "Coffee Tables", "Mesita De Noche": "Nightstand", "Mesitas para monitor": "Monitor stands", "Mosaico D/ Vidrio 23X98X8": "Glass Mosaic 23X98X8", "Mosaico D/ Vidrio 30X30X4": "Glass Mosaic 30X30X4", "Mosaico D/ Vidrio 55X8/300X305": "Glass Mosaic 55X8/300X305", "Mosaico de Acero 300X310MM": "Steel Mosaic 300X310MM", "Mosaico de Ceramica 300x300MM": "Ceramic Mosaic 300x300MM", "Mosaico Decorativo": "Decorative Mosaic", "Mueble de Bano": "Bathroom Cabinet", "Mueble P/Bano": "Bathroom Cabinet", "Mueble P/Bano C/Espejo": "Bathroom Cabinet with Mirror", "Muebles para tv": "TV furniture", "Ollas arroceras": "Rice cookers", "Ollas de coccion lenta": "Slow cookers", "Ollas Electricas": "Electric pots", "Organizador De Bano": "Bathroom Organizer", "organizador bano": "bathroom organizer", "Organizador De Cocina": "Kitchen Organizer", "Organizador de Puerta": "Door Organizer", "Organizador de Zapatos": "Shoe Organizer", "organizadores de bano y sartenes": "bathroom organizers and pans", "PALETA PARA PIZZA": "PIZZA PEEL", "Panel Decorativo Para Pared": "Decorative Wall Panel", "Panel Redondo": "Round Panel", "Papel de Aluminio": "Aluminum Foil", "Papel Pergamino": "Parchment Paper", "Picadores Y Ralladores": "Choppers & Graters", "PIEDRA DECORATIVA": "DECORATIVE STONE", "Pinza para alimento": "Food tongs", "PISO DE VYNIL": "VINYL FLOOR", "PISO VYNIL": "VINYL FLOOR", "Placas Para Pared": "Wall Plates", "Planchas para pelo": "Hair straighteners", "Planta Artificial": "Artificial Plant", "Porcelanato Delgado": "Thin Porcelain Tile", "Porcelanato Diseno de Madera": "Wood-Look Porcelain Tile", "Porcelanato Pulido": "Polished Porcelain Tile", "Porta Caliente": "Trivet", "Porta Pasteles": "Cake Carrier", "Porta Retratos": "Picture Frames", "PORTA ROPA": "CLOTHES RACK", "Procesadores De Alimentos": "Food Processors", "Protector de Almohada": "Pillow Protector", "Protector de Colchon": "Mattress Protector", "Protector de Fregadero": "Sink Protector", "Pulido 1000x1000": "Polished 1000x1000", "Ralladores de vegetal": "Vegetable graters", "RECIPIENTE P/ALMACENAR": "STORAGE CONTAINER", "Reloj Y Arte De Pared": "Wall Clock & Art", "Riel De Cortinas": "Curtain Rail", "Rieles y Cortinas": "Rails and Curtains", "Rueda 16x4.00-8": "Wheel 16x4.00-8", "SALERO PIMENTERO": "SALT & PEPPER SHAKER", "Saleros y Pimenteros": "Salt & Pepper Shakers", "Secadoras de pelo": "Hair dryers", "Short De Playa": "Beach Shorts", "Silla Comedor bebe": "Baby High Chair", "Silla De Bar": "Bar Stool", "Silla De Comedor": "Dining Chair", "Silla De Exterior": "Outdoor Chair", "Silla De Oficina": "Office Chair", "Sillas y Poltronas": "Chairs and Armchairs", "Sobre de Granito Redondo": "Round Granite Top", "Sofa Cama": "Sofa Bed", "Sofa De Exterior": "Outdoor Sofa", "Sofas Deco": "Deco Sofas", "Soporte De Tv": "TV Stand", "Soporte para TV": "TV Stand", "Soporte Multiuso": "Multipurpose Bracket", "Soportes para DVD": "DVD Stands", "Soportes para monitor": "Monitor Stands", "Sujetador de Bolsa": "Bag Holder", "Tabla de Picar": "Cutting Board", "Tabla de Planchar": "Ironing Board", "Techo con Cliip de Aluminio": "Aluminum Clip Ceiling", "Techo Suspendido de Aluminio": "Suspended Aluminum Ceiling", "Televisores LED": "LED TVs", "Televisores Smart TV": "Smart TVs", "Teteras Y Cafeteras": "Teapots & Coffee Makers", "Toallas De Cocina": "Kitchen Towels", "Toallas De Cuerpo": "Body Towels", "Toallas De Mano": "Hand Towels", "Toallas De Piso": "Floor Towels", "Toallas De Tocador": "Vanity Towels", "Tv Stand": "TV Stand", "Utensilios Y Gadgets": "Utensils & Gadgets", "Vasos botellas termicas": "Thermal cups & bottles", "Velas Y Difusores": "Candles & Diffusers", "Vestido De Bano": "Swimsuit", "Zapato Escolar": "School Shoe", "Zapato para vestir": "Dress Shoe", "Agregar": "Add", "Anadir al pedido": "Add to order", "Agregar al pedido (1 bulto c/u)": "Add to order (1 carton each)", "Artículo": "Item", "Artículos": "Items", "Agrupar por": "Group by", "Campos del catálogo": "Catalog fields", "Características a incluir en el documento": "Features to include in the document", "Caracteristicas a incluir en el documento": "Features to include in the document", "Buscar artículo": "Search item", "Buscar cliente": "Search customer", "Buscar grupo...": "Search group...", "Buscar por nombre o código...": "Search by name or code...", "Cargando más artículos...": "Loading more items...", "Cargando más…": "Loading more...", "Cargando…": "Loading...", "Cargando pedidos enviados…": "Loading submitted orders...", "Cerrar todo": "Collapse all", "Cerrar todos": "Collapse all", "$ Precio máx.": "$ Max price", "$ Precio mín.": "$ Min price", "(tarda más)": "(takes longer)", "Abrir cotización": "Open quotation", "A cotización SAP": "To SAP quotation", "Abrir pedido de venta": "Open sales order", "Con error": "With error", "Condición": "Terms", "CONDICION DE PAGO": "PAYMENT TERMS", "Cotización y pedido": "Quotation and order", "Enviar a SAP como": "Send to SAP as", "Guardar cambios": "Save changes", "Barcode · Cantidad · Precio": "Barcode / Quantity / Price", "Cant. últ.": "Last qty", "Cant. últ. compra": "Last purchase qty", "Mora máx.": "Max overdue", "Descripción (Inglés)": "Description (English)", "INSTRUCCIONES DE EMBARQUE": "SHIPPING INSTRUCTIONS", "Sin precio": "No price", "La cotización está vacía.": "The quotation is empty.", "El pedido no tiene líneas.": "The order has no lines.", "La factura no tiene líneas.": "The invoice has no lines.", "No hay artículos con los filtros puestos.": "No items match the current filters.", "No hay artículos que incluir.": "There are no items to include.", "No hay artículos.": "There are no items.", "Ningún pedido con esos filtros.": "No orders match those filters.", "El rango esta al reves.": "The range is reversed.", "El stock puede haber cambiado": "Stock may have changed", "Guardado sin conexión": "Saved offline", "Error al generar": "Could not generate", "Error de conexión": "Connection error", "No se pudo generar el PDF": "Could not generate the PDF", "No se pudo generar el Excel": "Could not generate the Excel file", "Marca al menos un producto (con el check) para hacer restock.": "Tick at least one product to create a restock order.", "No se pudieron leer los datos del inventario": "Could not read inventory data", "El catálogo salió sin fotos.": "The catalog was generated without photos.", "No encuentro el carrito de pedidos.": "The order cart could not be found.", "El generador de Excel no está disponible.": "The Excel generator is not available.", "No disponible para tu usuario.": "Not available for your user.", "Esta pantalla es de compras.": "This screen belongs to Purchasing.", "El margen es información de costos: solo administración.": "Margin is cost information: administration only.", "No hay nada que exportar con estos filtros.": "There is nothing to export with these filters.", "No hay pedidos de venta abiertos con este producto separado.": "There are no open sales orders with this product reserved.", "Consulta de inventario": "Inventory lookup", "Control de pedidos": "Order control", "Pedidos realizados y en proceso": "Submitted and in-process orders", "Notas de crédito": "Credit notes", "Mercancía por llegar": "Incoming goods", "Mercancía en tránsito": "Goods in transit", "Historial de venta": "Sales history", "Reporte de Ventas por Vendedor": "Sales report by salesperson", "Reporte de ventas por vendedor": "Sales report by salesperson", "Registro del sync": "Sync log", "Distribución de clientes": "Customer distribution", "Cliente x Mercancía recién llegada": "Customer x Newly arrived goods", "Cliente x Mercancía recín llegada": "Customer x Newly arrived goods", "Mercancía detenida — candidata a oferta": "Slow-moving goods - offer candidates", "Mercancía con existencia y sin precio de venta": "Goods in stock with no sale price", "Añadir al pedido": "Add to order", "Añadir al pedido en curso": "Add to current order", "Añadir un bulto al pedido": "Add one carton to the order", "Revisar y enviar": "Review and send", "Detener y enviar": "Stop and send", "Solo cotización": "Quotation only", "Pedido de venta": "Sales order", "Pedido": "Order", "Número de pedido": "Order number", "Importe pedido": "Order amount", "Nuevo total": "New total", "Descuento líneas": "Line discounts", "Condición de pago": "Payment terms", "Condición de pago del cliente": "Customer payment terms", "Crear la cotización en SAP": "Create the quotation in SAP", "Crear cliente en SAP": "Create customer in SAP", "Guardar como borrador, sin enviarlo a SAP": "Save as draft without sending it to SAP", "Se guardan solos mientras armas la cotización": "Saved automatically while you build the quotation", "Pega una línea por producto": "Paste one line per product", "Pedido autorizado · ya no se puede modificar": "Authorized order - it can no longer be changed", "Abrir en el carrito para editarla antes": "Open in the cart to edit it first", "Restock en nuevo pedido": "Restock in a new order", "Restock seleccionados → Nuevo pedido": "Restock selected -> New order", "Marcar todo lo de este cliente": "Select everything for this customer", "BULTOS": "CARTONS", "Bultos c/u": "Cartons each", "Bultos disponibles": "Cartons available", "Bultos completos disponibles": "Full cartons available", "Bultos completos en el WMS": "Full cartons in the WMS", "Bultos mín. disp.": "Min. cartons avail.", "0 bultos": "0 cartons", "0 productos": "0 products", "0 productos · 0 unidades · 0 bultos": "0 products / 0 units / 0 cartons", "Stock": "Stock", "Stock SAP": "SAP stock", "Stock hoy": "Stock today", "Disponible SAP": "Available in SAP", "Disponible WMS": "Available in WMS", "Disp. / Por llegar": "Avail. / Incoming", "Con existencia": "In stock", "Sin existencia": "Out of stock", "Con comprometidas": "Including committed", "En pedidos": "On orders", "Mayor stock primero": "Highest stock first", "Inventario en WarehouseEdge": "Inventory in WarehouseEdge", "Inventario Kennedy Center": "Kennedy Center inventory", "Lo que el WMS tiene de cada artículo, junto al stock de SAP.": "What the WMS holds for each item, next to the SAP stock.", "Este artículo está en el WMS pero no en el inventario de SAP.": "This item is in the WMS but not in the SAP inventory.", "Consultando el WMS…": "Querying the WMS...", "No se pudo consultar el WMS": "Could not query the WMS", "Precio venta": "Sale price", "Precio etiqueta": "List price", "Precio original": "Original price", "Precio desde el CIF": "Price from CIF", "Margen": "Margin", "Margen %": "Margin %", "Margen hist. %": "Hist. margin %", "Margen es real": "Margin is actual", "Margen de ganancia de este pedido": "Profit margin of this order", "Falta el precio CIF en la base.": "The CIF price is missing in the database.", "Límite crédito": "Credit limit", "Límite de Cr.": "Credit limit", "Pasado del límite de crédito": "Over the credit limit", "Saldo cliente": "Customer balance", "Saldo CXP": "AP balance", "Saldo Inicial": "Opening balance", "Saldo a la Fecha": "Balance to date", "Saldo a la fecha": "Balance to date", "Saldo del cliente en su estado de cuenta": "Customer balance in their account statement", "Saldo pendiente del cliente en su estado de cuenta": "Customer outstanding balance in their account statement", "Sin saldo pendiente": "No outstanding balance", "Días": "Days", "15 días": "15 days", "30 días": "30 days", "60 días": "60 days", "90 días": "90 days", "Días para llegar": "Days to arrival", "Fecha de llegada": "Arrival date", "Fecha Orden": "Order date", "FECHA": "DATE", "Sin fecha": "No date", "Este mes": "This month", "Próximos 30 días": "Next 30 days", "Próximos 60 días": "Next 60 days", "Próximos 90 días": "Next 90 days", "Entró en los últimos": "Arrived in the last", "Más nuevo primero": "Newest first", "Más viejo primero": "Oldest first", "Elegir en el calendario": "Pick from the calendar", "Comparar con el ano pasado": "Compare with last year", "Compró el año pasado": "Bought last year", "No compra desde": "No purchases since", "Sin venderse hace más de": "Not sold for more than", "60 DIAS FECHA BL": "60 DAYS FROM BL DATE", "Factura": "Invoice", "Orden de Compra": "Purchase order", "Líneas": "Lines", "Líneas de la Orden": "Order lines", "Sin líneas": "No lines", "GRAN TOTAL": "GRAND TOTAL", "ESTADO DE CUENTA": "ACCOUNT STATEMENT", "ESTADO DE CUENTA-NP": "ACCOUNT STATEMENT-NP", "NOTAS": "NOTES", "KC PEDIDO": "KC ORDER", "M. Pedido": "Order amt.", "Gastos adicionales del documento": "Additional charges on the document", "Factura formato LIRAN": "Invoice in LIRAN format", "Facturas formato LIRAN": "Invoices in LIRAN format", "Ficha técnica de alfombras": "Rug technical sheet", "PDF formato pedido": "PDF in order format", "Idioma del reporte": "Report language", "Incluir fotos": "Include photos", "Columnas al descargar": "Columns on download", "Sección": "Section", "Para guardarlo o adjuntarlo a mano": "To save it or attach it manually", "Enviar por correo o WhatsApp": "Send by email or WhatsApp", "Compartir estado de cuenta": "Share account statement", "Pulsa un mes para ver sus facturas.": "Click a month to see its invoices.", "Producto": "Product", "Productos": "Products", "Foto": "Photo", "Categoría": "Category", "Código de barras": "Barcode", "Código Prov.": "Supplier code", "Del artículo": "Item", "Del embarque": "Shipment", "Abrir la ficha": "Open the item card", "Click para ampliar": "Click to enlarge", "Pasa el mouse para ver grande": "Hover to enlarge", "Pasa el mouse para ver grande · click para ampliar": "Hover to enlarge - click for full size", "Cantidad de la última compra": "Last purchase quantity", "Compras 12m": "Purchases 12m", "SKU que compraba": "SKU previously bought", "Sin vender": "Not sold", "Aun sin ventas": "No sales yet", "Artículos detenidos": "Slow-moving items", "Artículos con": "Items with", "Artículos que ya compra y vienen en camino": "Items they already buy that are on the way", "Quién lo compró, cuándo, cuánto y a qué precio": "Who bought it, when, how much and at what price", "Este artículo no registra ventas con estos filtros.": "This item has no sales with these filters.", "SKU o descripción...": "SKU or description...", "SKU, descripción o marca...": "SKU, description or brand...", "SKU, descripción o código de barras": "SKU, description or barcode", "SKU, descripción, proveedor, contenedor, OC...": "SKU, description, supplier, container, PO...", "Escribe nombre o código...": "Type a name or code...", "Código o nombre...": "Code or name...", "Nombre, código o No. de documento...": "Name, code or document no....", "Cliente, vendedor o número de documento": "Customer, salesperson or document number", "Pedido, cliente, país, marca o comentario": "Order, customer, country, brand or comment", "Filtrando por": "Filtering by", "Limpiar límites": "Clear limits", "Prueba a quitar el filtro": "Try removing the filter", "Búsqueda inteligente: ej. organizadores de baño y sartenes con más de 5 bultos": "Smart search: e.g. bathroom organizers and pans with more than 5 cartons", "Escoja el vendedor": "Choose the salesperson", "Elige un vendedor.": "Choose a salesperson.", "Elige un vendedor…": "Choose a salesperson...", "Elige un vendedor para ver qué le llega a sus clientes.": "Choose a salesperson to see what is arriving for their customers.", "Selecciona una orden": "Select an order", "Sin asignar": "Unassigned", "Sin resultados.": "No results.", "Sin resultados con esos filtros": "No results with those filters", "Sin resultados para esa búsqueda.": "No results for that search.", "Sin resultados en los datos descargados": "No results in the downloaded data", "Ningún artículo con ese filtro.": "No items match that filter.", "Ningún artículo de este documento tiene foto.": "No item on this document has a photo.", "Nada disponible ahora.": "Nothing available right now.", "Nada que ofrecer con este filtro.": "Nothing to offer with this filter.", "Nada pendiente de autorizar con este filtro.": "Nothing pending authorization with this filter.", "Sin pedidos autorizados con este filtro.": "No authorized orders with this filter.", "Sin pedidos registrados": "No orders on record", "Sin facturas registradas": "No invoices on record", "Sin compras registradas": "No purchases on record", "Sin datos de ventas.": "No sales data.", "Sin datos de contacto": "No contact details", "Sin documentos para": "No documents for", "Sin clientes en esta región.": "No customers in this region.", "Sin clientes que mostrar.": "No customers to show.", "Este vendedor no tiene clientes asignados.": "This salesperson has no customers assigned.", "No hay mercancía pendiente de llegar.": "There are no goods pending arrival.", "Sin mercancía detenida con ese criterio. ¡Todo rota!": "No slow-moving goods with that criterion. Everything is turning over!", "Este SKU no está separado en ningún pedido abierto. Todo el stock está libre.": "This SKU is not reserved on any open order. All stock is free.", "No se pudo cargar el reporte": "Could not load the report", "No se pudo cargar el reporte.": "Could not load the report.", "No se pudo cargar la gráfica de ventas.": "Could not load the sales chart.", "No se pudo cargar la lista": "Could not load the list", "No se pudo cargar más.": "Could not load more.", "No se pudo buscar": "Search failed", "No pude identificar el artículo": "I could not identify the item", "No encontrada": "Not found", "No cabe.": "Does not fit.", "No cuadran en total": "Totals do not match", "Sin errores": "No errors", "Solo los que no cuadran": "Only those that do not match", "Sin conexión y sin catálogo descargado": "Offline and no catalog downloaded", "Conéctate y pulsa": "Go online and press", "Cargando departamentos…": "Loading departments...", "Cargando órdenes OPOR...": "Loading purchase orders...", "Leyendo el documento…": "Reading the document...", "Leyendo mercancía en camino…": "Reading incoming goods...", "Buscando mercancia sin movimiento…": "Looking for non-moving goods...", "Buscando mercancía en tránsito…": "Looking for goods in transit...", "Cruzando su historial con lo que viene en camino…": "Matching their history with what is on the way...", "Cruzando sus clientes con lo que viene en camino…": "Matching their customers with what is on the way...", "Pedidos no autorizados": "Unauthorized orders", "Pedidos autorizados y montos pendientes": "Authorized orders and outstanding amounts", "SIN AUTORIZAR": "NOT AUTHORIZED", "Orden con varios proveedores": "Order with several suppliers", "Viabilidad del pedido": "Order feasibility", "Puedes cotizar igual, pero revisa estos antes de enviar el pedido a SAP": "You can still quote, but check these before sending the order to SAP", "Los que no se pueden servir completos": "Those that cannot be fully supplied", "Pedía": "Requested", "Pedía el pedido": "The order requested", "Pedido pedia": "The order requested", "Por lleg": "Incoming", "Por que": "Why", "Descripción / por qué": "Description / why", "Escribe un mensaje": "Type a message", "Nota de voz": "Voice note", "Marcar todos los chats como leídos": "Mark all chats as read", "Compartida con": "Shared with", "Adjunta el archivo con el clip": "Attach the file with the clip", "Arrastra aquí las fotos": "Drag the photos here", "Cada archivo nombrado con su SKU, sin recomprimir": "Each file named with its SKU, without recompressing", "Descargar las fotos de los artículos en alta definición": "Download item photos in high definition", "La foto parece": "The photo looks like", "Probar con otra": "Try another", "Probar con otra foto": "Try another photo", "Armar catálogo de este grupo": "Build a catalog for this group", "Armar catálogo eligiendo una o varias entradas": "Build a catalog by choosing one or more arrivals", "Descargar catálogo y clientes para trabajar sin internet": "Download catalog and customers to work offline", "Descargar este panel en Excel": "Download this panel to Excel", "Mostrar u ocultar el desglose": "Show or hide the breakdown", "Que se puede hacer en esta pantalla": "What you can do on this screen", "Centroamérica": "Central America", "Norteamérica": "North America", "Resto del mundo": "Rest of the world", "Español": "Spanish", "Débito": "Debit", "Entrega": "Delivery", "Enviar": "Send", "Enviar mercancía por llegar": "Send incoming goods", "Persona de contacto": "Contact person", "Clientes que compraron": "Customers who bought", "500k o más": "500k or more", "Es el que tienes abierto": "This is the one you have open", "Escribe el primero.": "Write the first one.", "Pide que te asignen el código en el portal.": "Ask to be assigned the code in the portal.", "Marca los sugeridos que ya hayas desplegado": "Tick the suggestions you have already displayed", "Las sugerencias de la IA con el artículo que las originó": "The AI suggestions with the item that triggered them", "Número de": "Number of", "Copia del Excel las columnas": "Copy the columns from Excel", "Cubicaje del pedido": "Order cubic volume", "Estimado según el volumen registrado por producto. Capacidad útil aproximada por tipo de contenedor.": "Estimated from the volume recorded per product. Approximate usable capacity by container type.", "Se crea la cotización y el pedido, y se avisa de los dos números.": "The quotation and the order are created, and both numbers are reported.", "Desc": "Desc", "Subtotal": "Subtotal", "Sube una foto del artículo": "Upload a photo of the item", "Sube una foto y te muestro los artículos más parecidos": "Upload a photo and I will show you the closest items", "Subtotal líneas": "Line subtotal", "Sudamérica": "South America", "Sus clientes no han comprado nada de lo que viene en camino.": "Their customers have not bought anything that is on the way.", "Mercancía en tránsito de lo que este cliente ya compra": "Goods in transit of what this customer already buys", "TOTAL DEL DOCUMENTO": "DOCUMENT TOTAL", "Tamaño": "Size", "Tipo de mercancia con mas compras": "Product type with the most purchases", "Todavía no has enviado pedidos desde el portal.": "You have not submitted any orders from the portal yet.", "Todos los departamentos": "All departments", "Todos los estados": "All statuses", "Todos los proveedores": "All suppliers", "Total histórico comprado: facturas de compra menos notas": "Total purchased to date: purchase invoices minus credit notes", "Una foto por página, con SKU y descripción": "One photo per page, with SKU and description", "Usar también la cámara": "Use the camera as well", "Valor a su precio": "Value at its price", "Valor de compra": "Purchase value", "Variación": "Change", "Ventas del año, mes a mes": "Sales for the year, month by month", "Ver el detalle de la factura": "See the invoice detail", "Ver el pedido con las fotos, para mostrarlo al cliente": "See the order with photos, to show the customer", "Ver en qué orden viene": "See which order it is coming on", "Ver la ficha del artículo": "See the item card", "Ver la ficha del cliente: estado de cuenta, facturas, pedidos": "See the customer card: account statement, invoices, orders", "Ver las ventas del mes por vendedor": "See this month's sales by salesperson", "Ver las ventas por departamento": "See sales by department", "Ver los de todos": "See everyone's", "Ver pedido": "View order", "Ver quién lo tiene separado": "See who has it reserved", "Ver qué le llega a los clientes de cada vendedor": "See what is arriving for each salesperson's customers", "Volver a intentar": "Try again", "Volver a lo más nuevo primero": "Back to newest first", "Volver a los chats": "Back to chats", "Ya compró": "Already bought", "Zona Libre de Colón, Panamá · Tel. 441-6755": "Colon Free Zone, Panama - Tel. 441-6755", "al menos 1 bulto completo": "at least 1 full carton", "cotización": "quotation", "devolución": "return", "factura": "invoice", "pedido cerrado": "order closed", "pedido de venta": "sales order", "por llegar": "incoming", "por recibir": "to receive", "sin autorizar": "not authorized", "sin correo": "no email", "sin costo": "no cost", "sin fecha": "no date", "teléfono": "phone", "todo el equipo": "the whole team", "todo el mundo": "everyone", "más stock": "more stock", "más de 6 meses sin comprar": "more than 6 months without buying", "este mismo mes el año pasado": "the same month last year", "nombre del archivo debe ser el código del artículo": "the file name must be the item code", "no parece válido": "does not look valid", "no tiene la columna": "does not have the column", "para que la IA proponga reemplazos disponibles.": "so the AI can suggest available replacements.", "vendedor, cantidad, precio y descuento": "salesperson, quantity, price and discount", "cualquier saldo pendiente.": "any outstanding balance.", "Ítems": "Items", "Órdenes": "Orders", "Órdenes Pend.": "Pending orders", "Órdenes de Compra Pendientes": "Pending purchase orders", "Órdenes pend.": "Pending orders", "Últ. precio": "Last price", "Última entrada": "Last arrival", "Última venta": "Last sale", "Últimas facturas": "Latest invoices", "Último cambio": "Last change", "Últimos 2 años": "Last 2 years", "Últimos pedidos": "Latest orders", "ℹ️ La cotización se enviará a SAP B1 en los próximos 5 minutos.": "ℹ️ The quotation will be sent to SAP B1 within the next 5 minutes.", "↻ Más reciente": "↻ Most recent", "− bulto": "− carton", "▣ Piezas máx.": "▣ Max pcs", "▣ Piezas mín.": "▣ Min pcs", "▤ Bultos máx.": "▤ Max cartons", "▤ Bultos mín.": "▤ Min cartons", "✉ Enviar por correo": "✉ Send by email", "✕ Cerrar": "✕ Close", "✨ Sugeridos para reemplazar": "✨ Suggested replacements", "📄 Nota de crédito": "📄 Credit note", "📋 PDF formato pedido": "📋 PDF in order format", "📋 Viabilidad del pedido": "📋 Order feasibility", "📷 Buscar por foto": "📷 Search by photo", "📷 Por foto": "📷 By photo", "🔍 Buscar orden o proveedor...": "🔍 Search order or supplier...", "🚚 Ofrecer mercancía x llegar": "🚚 Offer incoming goods", "es la foto del 753492.": "is the photo of 753492.", "si un barcode está asociado a varios artículos, se elige el que tenga": "if a barcode is linked to several items, the one with the most stock is chosen", "saca el catalogo con fotos grandes;": "produces the catalog with large photos;", "del proveedor; si no lo tiene, se usa la fecha de entrega pactada.": "from the supplier; if there is none, the agreed delivery date is used.", "y que llevan": "and that carry", "en el catálogo.": "in the catalog.", "en el catálogo…": "in the catalog...", "en el Dashboard.": "on the Dashboard.", "en la tarjeta del Dashboard.": "on the Dashboard card.", "en el SQL Editor.": "in the SQL Editor.", "de la tabla": "of the table", ", con": ", with", ", en qué orden viene.": ", which order it comes on.", "Mercancía sin rotación": "Slow-moving goods", "Inventario WMS": "WMS inventory", "Subir fotos al server": "Upload photos to the server", "Tamano": "Size", "Composicion": "Composition", "Arancel": "Tariff code", "Origen": "Origin", "TIPO DE PRODUCTO": "PRODUCT TYPE", "Todos los tipos": "All types", "IMAGEN": "IMAGE", "Imagen": "Image", "Desde dd/mm/aaaa": "From dd/mm/yyyy", "Hasta dd/mm/aaaa": "To dd/mm/yyyy", "Mercancía recién llegada": "Newly arrived goods", "COLECCIONES": "COLLECTIONS", "Tamaño del bulto": "Package size", "Medida de caja": "Box size", "Características a incluir en el documento:": "Features to include in the document:", "Exportar filtrado": "Export filtered", "Buscar por foto": "Search by photo", "Agrupar": "Group", "Crítico": "Critical", "U/Bulto": "U/Carton", "Color": "Color", "Salir": "Log out", "Inglés": "English", "Capacidad del contenedor": "Container capacity", "Volumen": "Volume", "pies cúbicos": "cubic feet", "Borrador guardado": "Draft saved", "cotizacion": "quotation", "P. c/desc": "Net price", "El límite lo marca el volumen.": "The limit is set by volume.", "El límite lo marca el peso.": "The limit is set by weight.", "+ bulto": "+ carton", "- bulto": "- carton", "+ u": "+ u", "− u": "− u", "Fecha de pedido": "Order date", "¿Continuar?": "Continue?", "Continuar?": "Continue?", "Se añadirá 1 BULTO de cada uno:": "One CARTON of each will be added:", "no tiene bulto definido y entra con 1 unidad.": "has no carton defined and will be added as 1 unit.", "no tienen bulto definido y entran con 1 unidad.": "have no carton defined and will be added as 1 unit.", "ya estaban en el pedido.": "were already in the order."};
function _i18nRev(){ if(_i18nEN2ES) return _i18nEN2ES; _i18nEN2ES={}; for(var k in I18N_ES2EN){ var v=I18N_ES2EN[k]; if(!(v in _i18nEN2ES)) _i18nEN2ES[v]=k; } return _i18nEN2ES; }
// Textos que se arman con numeros ("bulto 72", "Disp: 1,440", "2 productos ·
// 73 unidades · 2 bultos"). Un diccionario de frases exactas no los alcanza
// nunca, porque la frase cambia con cada articulo.
//
// Las reglas van ANCLADAS a cifras o a dos puntos, no a palabras sueltas: asi
// no tocan los nombres de producto, que tambien estan en castellano pero son
// DATOS y no deben traducirse (para eso esta el nombre en ingles de SAP).
// Reglas de FRASE: traducen expresiones completas, asi que se pueden aplicar
// tambien a textos largos sin romperlos.
var _I18N_FRASES=[
  [/\bCaben\b/g, 'Room for'],
  [/\bEl l[íi]mite lo marca el volumen\./g, 'The limit is set by volume.'],
  [/\bEl l[íi]mite lo marca el peso\./g, 'The limit is set by weight.'],
  [/\s+m[áa]s\s+\(/g, ' more ('],
  [/\bpies c[úu]bicos\b/gi, 'cubic feet'],
  [/\bBultos\s*:/g, 'Cartons:'], [/\bUnidades\s*:/g, 'Units:'], [/\bPiezas\s*:/g, 'Pieces:'],
  [/\bBorrador guardado\b/g, 'Draft saved'],
  [/\bu\/bulto\b/gi, 'u/carton'], [/\bpz\/bulto\b/gi, 'pcs/carton'],
  [/\bbulto\s+(\d)/gi, 'carton: $1'],
  [/\bsin fecha\b/gi, 'no date'], [/\bsin autorizar\b/gi, 'not authorized'],
  [/\bc\/u\b/g, 'each'], [/\bx\s+bulto\b/gi, 'per carton'],
  [/\bContenedor\b/g, 'Container']
];
// Reglas de PALABRA: valen para etiquetas cortas ("2 productos · 73 unidades"),
// pero destrozarian una frase larga ("de cada uno" -> "de each uno"), asi que
// NO se aplican a prosa.
var _I18N_PALABRAS=[
  [/(\d[\d.,]*)\s*bultos\b/gi, '$1 cartons'],
  [/\bBULTOS\b/g, 'CARTONS'], [/\bbultos\b/gi, 'cartons'],
  [/(^|[\s·])unidades\b/gi, '$1units'], [/(^|[\s·])uds\b/gi, '$1units'],
  [/(^|[\s·])pzs?\b/gi, '$1pcs'], [/(^|[\s·])piezas?\b/gi, '$1pcs'],
  [/(^|[\s·])productos?\b/gi, '$1products'],
  [/(^|[\s·])[ií]tems?\b/gi, '$1items'],
  [/\bDisp\.?\s*:/g, 'Avail.:'], [/\bDisp\b(?!\.)/g, 'Avail'],
  [/(^|[\s·])p[áa]gina\b/gi, '$1page'],
  [/(^|[\s·])facturas?\b/gi, '$1invoices'], [/(^|[\s·])pedidos?\b/gi, '$1orders'],
  [/(^|[\s·])l[ií]neas?\b/gi, '$1lines'], [/(^|[\s·])art[ií]culos?\b/gi, '$1items'],
  [/(^|[\s·])clientes?\b/gi, '$1customers'], [/(^|[\s·])d[ií]as?\b/gi, '$1days'],
  [/(\d)\s+de\s+(\d)/g, '$1 of $2'],
  [/(^|[\s·])cotizaci[óo]n\b/gi, '$1quotation']
];

// Un texto es una ETIQUETA si es corto o va separado por puntos medios. La
// prosa larga solo recibe las reglas de frase: aplicarle las de palabra daria
// Spanglish del tipo "1 BULTO de each uno".
function _i18nDinamico(t){
  if(t.length>170 || !/\d/.test(t)) return null;
  // Los nombres de articulo van en MAYUSCULAS: son datos de SAP, nunca se tocan.
  if(t === t.toUpperCase() && /[A-Z]{6,}/.test(t) && !/^BULTOS?\b/.test(t)) return null;
  var o=t, i;
  for(i=0;i<_I18N_FRASES.length;i++) t=t.replace(_I18N_FRASES[i][0], _I18N_FRASES[i][1]);
  var esEtiqueta = (t.length<=46) || t.indexOf('\u00b7')>=0;
  if(esEtiqueta){
    for(i=0;i<_I18N_PALABRAS.length;i++) t=t.replace(_I18N_PALABRAS[i][0], _I18N_PALABRAS[i][1]);
  }
  return t!==o ? t : null;
}

function _i18nNode(node,map){ var v=node.nodeValue; if(!v) return; var t=v.trim(); if(!t) return; var tr=map[t]; if(!tr && map===I18N_ES2EN) tr=_i18nDinamico(t); if(tr!=null && tr!==t) node.nodeValue=v.replace(t,tr); }
function _i18nEl(root,map){
  if(!root) return;
  if(root.nodeType===3){ _i18nNode(root,map); return; }
  if(root.nodeType!==1) return;
  try{
    var wk=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null,false), n, list=[];
    while(n=wk.nextNode()) list.push(n);
    for(var i=0;i<list.length;i++) _i18nNode(list[i],map);
  }catch(e){}
  var els=root.querySelectorAll?root.querySelectorAll('[placeholder],[title]'):[];
  for(var j=0;j<els.length;j++){ (function(e){ ['placeholder','title'].forEach(function(a){ var v=e.getAttribute(a); if(v){ var t=v.trim(); var tr=map[t]; if(tr!=null&&tr!==t) e.setAttribute(a,v.replace(t,tr)); } }); })(els[j]); }
}
function _i18nAll(map){ _i18nApplying=true; try{ _i18nEl(document.body,map); }catch(e){} _i18nApplying=false; }
function _i18nStart(){ if(_i18nObs) return;
  _i18nObs=new MutationObserver(function(ms){ if(_i18nApplying) return; _i18nApplying=true;
    try{ for(var i=0;i<ms.length;i++){ var m=ms[i];
      if(m.type==='childList'){ for(var j=0;j<m.addedNodes.length;j++) _i18nEl(m.addedNodes[j],I18N_ES2EN); }
      else if(m.type==='characterData'){ _i18nNode(m.target,I18N_ES2EN); } } }catch(e){}
    _i18nApplying=false; });
  _i18nObs.observe(document.body,{childList:true,subtree:true,characterData:true});
}
// ── Avisos del navegador ──────────────────────────────────────────────
// alert() y confirm() son dialogos nativos: el observador del DOM no los ve,
// asi que hasta ahora salian SIEMPRE en castellano. Un cliente en ingles que
// fallaba al enviar su pedido leia el error en un idioma que no entiende, y se
// quedaba atascado sin saber por que.
//
// Se traducen aqui, frase por frase y tambien por lineas: muchos avisos llevan
// varios parrafos y solo algunos estan en el diccionario.
function _tAviso(txt){
  if(LANG!=='en') return txt;
  var t=String(txt==null?'':txt);
  // Completo primero: es lo mas fiel cuando la frase esta tal cual.
  var ent=I18N_ES2EN[t.trim()];
  if(ent) return ent;
  // Si no, linea a linea, conservando los saltos.
  return t.split('\n').map(function(l){
    var k=l.trim();
    if(!k) return l;
    var tr=I18N_ES2EN[k];
    if(tr) return l.replace(k, tr);
    // Y por ultimo la parte fija de los avisos que terminan en un dato
    // variable ("No se pudo enviar: <motivo>").
    var c=k.indexOf(':');
    if(c>3){
      var cab=k.slice(0,c).trim(), tr2=I18N_ES2EN[cab];
      if(tr2) return l.replace(cab, tr2);
    }
    return l;
  }).join('\n');
}
(function(){
  if(typeof window==='undefined') return;
  var _al=window.alert, _cf=window.confirm;
  window.alert   = function(m){ return _al.call(window, _tAviso(m)); };
  window.confirm = function(m){ return _cf.call(window, _tAviso(m)); };
})();

// ── Nombres de articulo en ingles ─────────────────────────────────────
// SAP guarda el nombre en ingles en OITM.FrgnName, y el sync lo trae a la
// tabla `inventario` (ojo: `vista_inventario` NO lo tiene, por eso se pide
// aparte). Si un articulo no lo tiene, se queda con el nombre normal.
//
// Va por el DICCIONARIO en vez de tocar cada pantalla: el traductor ya
// reescribe los nodos de texto, asi que registrando "nombre ES" -> "nombre EN"
// se traducen solos el pedido, el inventario, el catalogo, las facturas y
// cualquier pantalla futura, sin cambiar una linea de su codigo.
var _i18nItemsVistos={};     // itemcode -> true, para no volver a pedirlo
var _i18nItemsCola=[];
var _i18nItemsTimer=null;

// De una respuesta de q() saca los codigos de articulo que aun no conocemos.
function _i18nItemsDesde(filas){
  if(LANG!=='en' || !Array.isArray(filas)) return;
  for(var i=0;i<filas.length;i++){
    var r=filas[i];
    if(!r || typeof r!=='object') continue;
    var c=r.itemcode;
    if(!c || _i18nItemsVistos[c]) continue;
    // Si la propia fila ya trae el nombre en ingles, se registra y listo.
    var es=r.itemname || r.dscription;
    if(r.frgnname && es){
      _i18nItemsVistos[c]=true;
      if(String(r.frgnname).trim() && r.frgnname!==es) I18N_ES2EN[String(es).trim()]=String(r.frgnname).trim();
      continue;
    }
    if(es) _i18nItemsCola.push(c);
  }
  if(_i18nItemsCola.length) _i18nItemsPedir();
}

// Se piden en bloque y con un respiro: una pantalla de inventario dispara
// varias consultas seguidas y no tiene sentido ir a la red por cada una.
function _i18nItemsPedir(){
  if(_i18nItemsTimer) return;
  _i18nItemsTimer=setTimeout(async function(){
    _i18nItemsTimer=null;
    var codes=_i18nItemsCola.splice(0, 300).filter(function(c){ return !_i18nItemsVistos[c]; });
    if(!codes.length) return;
    codes.forEach(function(c){ _i18nItemsVistos[c]=true; });
    try{
      var inList=codes.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      var rows=await q('inventario',
        'select=itemcode,itemname,frgnname&itemcode=in.('+inList+')&limit='+codes.length);
      var hubo=false;
      (rows||[]).forEach(function(r){
        if(!r || !r.itemname || !r.frgnname) return;
        var es=String(r.itemname).trim(), en=String(r.frgnname).trim();
        if(en && en!==es){ I18N_ES2EN[es]=en; hubo=true; }
      });
      // El mapa inverso (ingles -> castellano) se arma una sola vez; si se
      // aprenden nombres despues, hay que rehacerlo o al volver al castellano
      // los articulos se quedarian en ingles.
      if(hubo) _i18nEN2ES=null;
      // Repintar lo que ya esta en pantalla con los nombres recien aprendidos.
      if(hubo && LANG==='en') _i18nAll(I18N_ES2EN);
    }catch(e){}
    if(_i18nItemsCola.length) _i18nItemsPedir();
  }, 350);
}

// Se engancha en fetch y no en q(): varias pantallas (el inventario, el
// catalogo) no pasan por q() sino que llaman directo a los RPC de Supabase.
// Aqui pasa TODO, asi que no hay pantalla que se escape, ni ahora ni luego.
(function(){
  if(typeof window==='undefined' || !window.fetch || window._i18nFetchOk) return;
  window._i18nFetchOk = true;
  var _f = window.fetch;
  window.fetch = function(){
    var p = _f.apply(this, arguments);
    try{
      if(LANG==='en'){
        var u = String((arguments[0] && arguments[0].url) || arguments[0] || '');
        // Solo las respuestas de la base, y nunca la consulta que hacemos
        // nosotros para aprender: se morderia la cola.
        if(u.indexOf('/rest/v1/')>=0 && u.indexOf('frgnname')<0){
          p.then(function(r){
            try{
              if(!r || !r.ok) return;
              var ct=r.headers && r.headers.get && r.headers.get('content-type');
              if(ct && ct.indexOf('json')<0) return;
              r.clone().json().then(function(d){
                try{ _i18nItemsDesde(Array.isArray(d)?d:[d]); }catch(e){}
              }).catch(function(){});
            }catch(e){}
          }).catch(function(){});
        }
      }
    }catch(e){}
    return p;
  };
})();

function _i18nStop(){ if(_i18nObs){ _i18nObs.disconnect(); _i18nObs=null; } }
function _i18nFlags(){ var es=document.getElementById('lang-es'), en=document.getElementById('lang-en'); if(es)es.classList.toggle('active',LANG==='es'); if(en)en.classList.toggle('active',LANG==='en'); }
function setLang(l){ if(l!=='en'&&l!=='es') return; if(l===LANG){ _i18nFlags(); return; } if(l==='en'){ _i18nItemsVistos={}; _i18nItemsCola=[]; } LANG=l; try{localStorage.setItem('kc_lang',l);}catch(e){} if(l==='en'){ _i18nAll(I18N_ES2EN); _i18nStart(); } else { _i18nStop(); _i18nAll(_i18nRev()); } _i18nFlags(); }
function _i18nInit(){ var l='es'; try{ l=localStorage.getItem('kc_lang')||'es'; }catch(e){} LANG='es'; _i18nFlags(); if(l==='en') setLang('en'); }
if(document.readyState!=='loading'){ try{_i18nInit();}catch(e){} } else { document.addEventListener('DOMContentLoaded',function(){ try{_i18nInit();}catch(e){} }); }

// El numero de documento, pulsable cuando es una factura: abre su detalle
// con las lineas. Las notas de credito y los recibos no tienen detalle de
// articulos, asi que se dejan como texto.
function ecnDocLink(r, cardcode){
  var tipo = ecnTipo(r);
  var ref  = String(r.ref1 || '');
  var eti  = '<b>' + tipo + '</b> ' + ref;
  if(tipo !== 'FA' || !ref || !/^\d+$/.test(ref)) return eti;
  var cc = String(cardcode || r.cardcode || '').replace(/'/g, "\\'");
  return '<span onclick="verFactura('+ref+',null,true)" '
    + 'style="color:var(--blue2);cursor:pointer;text-decoration:underline;text-underline-offset:2px" '
    + 'title="Ver el detalle de la factura">' + eti + '</span>';
}

function ecnTipo(r){ var d=Number(r.debit)||0, c=Number(r.credit)||0; if(c>0) return 'RC'; if(d<0) return 'NC'; if(d>0) return 'FA'; return ''; }
function ecnDias(fecha){ try{ var t=new Date(String(fecha)+'T00:00:00'); if(isNaN(t.getTime())) return ''; return Math.max(0, Math.round((Date.now()-t.getTime())/86400000)); }catch(e){ return ''; } }
async function ecNappaConsultar(){
  var code=(($('ecn-code')||{}).value||'').trim();
  var desde=(($('ecn-desde')||{}).value||'').trim();
  var out=$('ecn-result'); if(!out) return;
  var pb=$('ecn-pdf-btn'); if(pb) pb.style.display='none';
  if(!code){ out.innerHTML=empty('Escribe o elige el cliente'); return; }
  out.innerHTML=loading();
  window._ecnAll=null; window._ecnRows=null; window._ecnOpen=0; window._ecnCode=code;
  var params='select=*&cardcode=eq.'+encodeURIComponent(code)+'&order=refdate.asc';
  var all;
  try{ all=await qAll('estado_cuenta_nappa',params); }catch(e){ all=[]; }
  if(window._ecnCode!==code) return;
  if(!all||!all.length){ out.innerHTML=empty('Sin movimientos para ese cliente'); return; }
  // El saldo se calcula sumando los movimientos. NO se usa h.balance: eso
  // es el campo de la PRIMERA fila del historial (la mas antigua), no el
  // saldo actual del cliente. Comparar contra el daba diferencias falsas.
  var _ecnSaldoReal = 0;
  (all||[]).forEach(function(m){
    _ecnSaldoReal += (Number(m.debit)||0) - (Number(m.credit)||0);
  });

  // Orden idéntico a SAP: refdate, luego secuencia de asiento (transid, lineid)
  all.sort(function(a,b){
    var fa=String(a.refdate||''), fb=String(b.refdate||'');
    if(fa!==fb) return fa<fb?-1:1;
    var ta=+a.transid, tb=+b.transid;
    if(!isNaN(ta)&&!isNaN(tb)&&ta!==tb) return ta-tb;
    var la=+a.lineid, lb=+b.lineid;
    return (!isNaN(la)&&!isNaN(lb))?la-lb:0;
  });
  var opening=0, disp=[];
  all.forEach(function(r){
    if(desde && String(r.refdate) < desde){ opening += (Number(r.debit)||0)-(Number(r.credit)||0); }
    else disp.push(r);
  });
  window._ecnAll=all; window._ecnRows=disp; window._ecnOpen=opening; window._ecnDesde=desde; window._ecnCode=code;
  // Se pasa TODO el historial (all), no solo lo visible: la antiguedad tiene
  // que repartir el saldo completo. Con la lista filtrada llegaban debitos
  // viejos sin los pagos que ya los habian saldado, y las cubetas sumaban
  // mas que el saldo.
  ecNappaRender(disp, opening, all[0], out, _ecnSaldoReal, all);
  if(pb) pb.style.display='';
}
// saldoReal: suma de los movimientos. Llega desde ecNappaConsultar porque se
// calcula alli, sobre TODOS los movimientos, no solo los que se muestran.
// Reparte el saldo por antiguedad. Los creditos (pagos, notas de credito) se
// aplican a los debitos mas antiguos primero: es el criterio habitual de
// cobranza y el que hace que las cubetas sumen el saldo real.
function ecnAntiguedad(rows, opening){
  var hoy = Date.now();
  var abiertos = [];

  // El saldo inicial, si lo hay, cuenta como el debito mas antiguo.
  if(opening && opening > 0.005) abiertos.push({dias: 99999, monto: opening});

  var creditos = 0;
  (rows||[]).forEach(function(m){
    var d = Number(m.debit)||0, c = Number(m.credit)||0;

    // El neto de la fila es lo que cuenta. Hay notas de credito registradas
    // como DEBITO NEGATIVO (18 en este cliente): con un filtro d>0 quedaban
    // fuera por completo, ni sumaban deuda ni restaban como pago, y las
    // cubetas acababan sumando casi cuatro veces el saldo.
    var neto = d - c;

    if(neto > 0.005){
      var t = new Date(String(m.refdate||'').substring(0,10)+'T00:00:00');
      var dias = isNaN(t) ? 0 : Math.round((hoy - t.getTime())/86400000);
      abiertos.push({dias: dias, monto: neto});
    } else if(neto < -0.005){
      creditos += -neto;      // pago, nota de credito o debito en negativo
    }
  });
  if(opening && opening < -0.005) creditos += -opening;

  abiertos.sort(function(a,b){ return b.dias - a.dias; });   // de mas viejo a mas nuevo
  for(var i=0; i<abiertos.length && creditos > 0.005; i++){
    var usa = Math.min(abiertos[i].monto, creditos);
    abiertos[i].monto -= usa;
    creditos -= usa;
  }

  var r = {d30:0,d60:0,d90:0,d120:0,d150:0,d180:0,d210:0,d240:0,d240p:0};
  abiertos.forEach(function(x){
    if(x.monto <= 0.005) return;
    var v = x.monto, n = x.dias;
    if(n<=30) r.d30+=v; else if(n<=60) r.d60+=v; else if(n<=90) r.d90+=v;
    else if(n<=120) r.d120+=v; else if(n<=150) r.d150+=v; else if(n<=180) r.d180+=v;
    else if(n<=210) r.d210+=v; else if(n<=240) r.d240+=v; else r.d240p+=v;
  });
  // Creditos sobrantes: el cliente tiene saldo a favor. Va en la primera
  // cubeta en negativo para que la suma siga cuadrando con el saldo.
  if(creditos > 0.005) r.d30 -= creditos;
  return r;
}

function ecNappaRender(rows, opening, h, out, saldoReal, todos){
  h=h||{};
  var run=opening, totD=0, totC=0;
  var filas=rows.map(function(r){
    var d=Number(r.debit)||0, c=Number(r.credit)||0; totD+=d; totC+=c; run+=d-c;
    return '<tr>'
      +'<td style="white-space:nowrap">'+fmtD(r.refdate)+'</td>'
      +'<td style="white-space:nowrap">'+ecnDocLink(r, h.cardcode)+'</td>'
      +'<td>'+(r.u_pedido||'')+'</td>'
      +'<td style="max-width:340px;white-space:normal">'+(r.linememo||'')+'</td>'
      +'<td>'+(r.u_marcli||'')+'</td>'
      +'<td class="tr">'+(d?fmtN2(d):'')+'</td>'
      +'<td class="tr">'+(c?fmtN2(c):'')+'</td>'
      +'<td class="tr"><b>'+fmtN2(run)+'</b></td>'
    +'</tr>';
  }).join('');
  var iniRow = opening ? '<tr style="background:#eef2f7"><td colspan="7" style="text-align:right;font-weight:700">Saldo Inicial &nbsp;&rarr;</td><td class="tr"><b>'+fmtN2(opening)+'</b></td></tr>' : '';
  // La antiguedad se calcula de los movimientos, no de las columnas tdias*:
  // esas llegan repetidas en cada fila del historial y corresponden a un
  // corte anterior, asi que no cuadran con el saldo actual.
  //
  // Como es un mayor de cuentas y no una lista de facturas abiertas, se
  // reparte aplicando los creditos a los debitos mas antiguos, que es como se
  // cobra en la practica: lo que se paga salda primero lo viejo.
  var _ag = ecnAntiguedad(todos || rows, (todos ? 0 : opening));
  var ag=[['0-30',_ag.d30],['31-60',_ag.d60],['61-90',_ag.d90],['91-120',_ag.d120],
          ['121-150',_ag.d150],['151-180',_ag.d180],['181-210',_ag.d210],
          ['211-240',_ag.d240],['M\u00e1s 240',_ag.d240p]];
  var agHtml=ag.map(function(a){ var v=Number(a[1])||0; return '<div style="text-align:center;padding:6px 10px;background:var(--bg);border-radius:8px;min-width:66px"><div style="font-size:11px;color:var(--text3)">'+a[0]+'</div><div style="font-weight:700;font-size:13px;color:'+(v>0?'var(--red)':'var(--text)')+'">'+fmt(v)+'</div></div>'; }).join('');
  var contacto=[h.cntctprsn,(h.cellular||h.phone1),h.email].filter(Boolean).join(' \u00b7 ');
  var direccion=[h.street,h.block,h.city,h.country].filter(Boolean).join(', ');
  var periodo = window._ecnDesde ? ('Incluye transacciones desde el '+fmtD(window._ecnDesde)) : 'Todo el historial';
  out.innerHTML=
    '<div class="card" style="margin-bottom:14px"><div style="display:flex;justify-content:space-between;flex-wrap:wrap;gap:12px">'
      +'<div style="min-width:240px"><div style="font-size:18px;font-weight:700">'+(h.cardname||h.cardcode||'')+'</div>'
        +'<div style="color:var(--text3);font-size:13px">'+(h.cardcode||'')+(h.slpname?(' \u00b7 Vendedor: '+h.slpname):'')+'</div>'
        +(contacto?'<div style="color:var(--text3);font-size:12px;margin-top:4px">'+contacto+'</div>':'')
        +(direccion?'<div style="color:var(--text3);font-size:12px">'+direccion+'</div>':'')
      +'</div>'
      +'<div style="display:flex;gap:12px;flex-wrap:wrap;align-items:flex-start">'
        +'<div style="text-align:right"><div style="font-size:11px;color:var(--text3)">Saldo a la fecha</div><div style="font-size:20px;font-weight:800;color:var(--red)">'+fmt(saldoReal!=null ? saldoReal : h.balance)+'</div></div>'
        +'<div style="text-align:right"><div style="font-size:11px;color:var(--text3)">\u00d3rdenes pend.</div><div style="font-size:15px;font-weight:700">'+fmt(h.ordersbal)+'</div></div>'
        +'<div style="text-align:right"><div style="font-size:11px;color:var(--text3)">L\u00edmite cr\u00e9dito</div><div style="font-size:15px;font-weight:700">'+fmt(h.creditline)+'</div></div>'
      +'</div></div>'
      // Acceso a la ficha completa: facturas, restock y nuevo pedido. Desde
      // aqui solo se ve el mayor, y hacia falta poder saltar al resto.
      +'<div style="margin-top:12px;display:flex;gap:8px;flex-wrap:wrap">'
        +'<button class="btn btn-sm btn-p" onclick="verClienteNapa(\''+String(h.cardcode).replace(/'/g,"\\'")+'\')">'
        +'\u{1F464} Ficha del cliente</button>'
        +'<button class="btn btn-sm" onclick="rsElegirCli(\''+String(h.cardcode).replace(/'/g,"\\'")+'\',\''
        +String(h.cardname||'').replace(/['\"\\]/g,' ')+'\',true);go(\'restock\',document.getElementById(\'nav-rst\'))">'
        +'\u{1F504} Restock</button>'
      +'</div>'
      +'<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:14px">'+agHtml+'</div>'
      
    +'</div>'
    +'<div class="card" style="padding:0;overflow:hidden">'
      +'<div style="padding:8px 14px;font-size:12px;color:var(--text3);border-bottom:1px solid var(--border)">'+periodo+'</div>'
      +'<div style="overflow-x:auto"><table class="dtable"><thead><tr><th>Fecha</th><th>Documento</th><th>Pedido</th><th>Comentarios</th><th>Marca</th><th class="tr">D\u00e9bito</th><th class="tr">Cr\u00e9dito</th><th class="tr">Saldo</th></tr></thead><tbody>'
      +iniRow+filas
      +'<tr style="background:var(--bg);font-weight:700"><td colspan="5" class="tr">Totales &rarr;</td><td class="tr">'+fmtN2(totD)+'</td><td class="tr">'+fmtN2(totC)+'</td><td class="tr">'+fmtN2(run)+'</td></tr>'
    +'</tbody></table></div></div>';
}
function ecNappaPdf(){
  var rows=window._ecnRows||[]; var all=window._ecnAll||rows; var h=(all&&all[0])||{}; var opening=window._ecnOpen||0;
  // El saldo se suma de los movimientos, igual que en la pantalla, para que
  // el PDF y lo que se ve en el portal digan siempre lo mismo.
  var _saldoReal = 0;
  (all||[]).forEach(function(m){
    _saldoReal += (Number(m.debit)||0) - (Number(m.credit)||0);
  });
  // La antiguedad, igual: las columnas tdias* de SAP vienen del cierre y no
  // cuadran con el saldo. Se reparte con la misma funcion que la pantalla.
  var _ag = (typeof ecnAntiguedad==='function') ? ecnAntiguedad(all||[], 0)
          : {d30:0,d60:0,d90:0,d120:0,d150:0,d180:0,d210:0,d240:0,d240p:0};
  if(!rows.length && !all.length){ alert('Consulta primero un cliente.'); return; }
  var w=window.open('','_blank'); if(!w){ alert('Permite ventanas emergentes para generar el PDF.'); return; }
  var run=opening, tD=0, tC=0;
  var filas=rows.map(function(r){ var d=Number(r.debit)||0,c=Number(r.credit)||0; tD+=d; tC+=c; run+=d-c;
    return '<tr><td>'+fmtD(r.refdate)+'</td><td>'+ecnTipo(r)+'</td><td>'+(r.ref1||'')+'</td><td>'+(r.u_pedido||'')+'</td><td class="c">'+ecnDias(r.refdate)+'</td><td>'+String(r.linememo||'').replace(/</g,'&lt;')+'</td><td class="r">'+(d?fmtN2(d):'')+'</td><td class="r">'+(c?fmtN2(c):'')+'</td><td class="r">'+fmtN2(run)+'</td></tr>';
  }).join('');
  var iniRow = opening? '<tr class="ini"><td colspan="8" class="r">Saldo Inicial ------&gt;</td><td class="r"><b>'+fmtN2(opening)+'</b></td></tr>' : '';
  var ag=[['0-30',_ag.d30],['31-60',_ag.d60],['61-90',_ag.d90],['91-120',_ag.d120],['121-150',_ag.d150],['151-180',_ag.d180],['181-210',_ag.d210],['211-240',_ag.d240],['Más 240',_ag.d240p]];
  var agHead=ag.map(function(a){return '<td class="r">'+a[0]+'</td>';}).join('');
  var agCols=ag.map(function(a){return '<td class="r">'+fmtN2(Number(a[1])||0)+'</td>';}).join('');
  var per=window._ecnDesde?('INCLUYE TRANSACCIONES DESDE EL '+fmtD(window._ecnDesde)):'TODAS LAS TRANSACCIONES';
  var html='<html><head><meta charset="utf-8"><title>Estado de cuenta '+(h.cardcode||'')+'</title><style>'
    +'body{font-family:Arial,Helvetica,sans-serif;color:#000;margin:16px;font-size:11px}'
    +'.co{font-size:14px;font-weight:700}.addr{font-size:10px;color:#333;max-width:380px}'
    +'.tit{font-size:13px;font-weight:700;text-align:right}'
    +'.hdr{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #000;padding-bottom:6px;margin-bottom:8px}'
    +'.lab{color:#333;display:inline-block;min-width:78px}'
    +'.per{font-weight:700;margin:8px 0 4px}'
    +'table.mov{width:100%;border-collapse:collapse;font-size:10.5px}table.mov td{padding:2px 6px}'
    +'table.mov thead td{border-bottom:1px solid #000;font-weight:700}'
    +'.r{text-align:right}.c{text-align:center}'
    +'tr.ini td{border-top:1px solid #999;font-weight:700}.tot td{border-top:1px solid #000;font-weight:700}'
    +'table.ag{width:100%;border-collapse:collapse;font-size:10px;margin-top:12px}table.ag td{padding:3px 6px;border:1px solid #ccc;text-align:right}'
    +'</style></head><body>'
    +'<div class="hdr"><div><div class="co">NAPPA PROPERTIES INC.</div><div class="addr">Zona Libre de Col\u00f3n, Calle 15 y Ave. Santa Isabel. Edificio Central Plaza. P.O. Box 0302-00737 Panam\u00e1. Tel. 441-6755 / 441-6767</div></div><div class="tit">ESTADO DE CUENTA-NP<div style="font-weight:400;font-size:10px">'+new Date().toLocaleString()+'</div></div></div>'
    +'<div style="display:flex;justify-content:space-between;flex-wrap:wrap">'
      +'<div>'
        +'<div><span class="lab">C\u00f3digo:</span> <b>'+(h.cardcode||'')+'</b></div>'
        +'<div><span class="lab">Nombre:</span> <b>'+(h.cardname||'')+'</b></div>'
        +'<div><span class="lab">Pa\u00eds:</span> '+(h.country||'')+'</div>'
        +'<div><span class="lab">Direcci\u00f3n:</span> '+[h.street,h.block,h.city].filter(Boolean).join(', ')+'</div>'
        +'<div><span class="lab">E-mail:</span> '+(h.email||'')+'</div>'
        +'<div><span class="lab">Contacto:</span> '+(h.cntctprsn||'')+'</div>'
      +'</div>'
      +'<div>'
        +'<div><span class="lab">Vendedor:</span> '+(h.slpname||'')+'</div>'
        +'<div><span class="lab">Tel\u00e9fono:</span> '+(h.phone1||'')+'</div>'
        +'<div><span class="lab">Celular:</span> '+(h.cellular||'')+'</div>'
        +'<div><span class="lab">L\u00edmite de Cr.:</span> '+fmtN2(h.creditline)+'</div>'
        +'<div><span class="lab">Saldo a la Fecha:</span> <b>'+fmtN2(_saldoReal)+'</b></div>'
        +'<div><span class="lab">\u00d3rdenes Pend.:</span> '+fmtN2(h.ordersbal)+'</div>'
      +'</div>'
    +'</div>'
    +'<div class="per">'+per+'</div>'
    +'<table class="mov"><thead><tr><td>Fecha</td><td>#</td><td>Doc.#</td><td>Ped.</td><td class="c">D\u00edas</td><td>Comentarios</td><td class="r">D\u00e9bito</td><td class="r">Cr\u00e9dito</td><td class="r">Saldo</td></tr></thead><tbody>'
    +iniRow+filas
    +'<tr class="tot"><td colspan="6" class="r">Totales &rarr;</td><td class="r">'+fmtN2(tD)+'</td><td class="r">'+fmtN2(tC)+'</td><td class="r">'+fmtN2(run)+'</td></tr>'
    +'</tbody></table>'
    +'<table class="ag"><tr><td style="border:none;text-align:left;font-weight:700">Antig\u00fcedad &rarr;</td>'+agHead+'</tr><tr><td style="border:none"></td>'+agCols+'</tr></table>'
    +'<scr'+'ipt>window.onload=function(){setTimeout(function(){window.print();},350);};</scr'+'ipt></body></html>';
  w.document.open(); w.document.write(html); w.document.close();
}
var ECN_CLIENTES=null;
async function ecnCargarClientes(){
  if(ECN_CLIENTES) return ECN_CLIENTES;
  try{ ECN_CLIENTES=await q('clientes_nappa','select=cardcode,cardname&order=cardname&limit=8000'); }catch(e){ ECN_CLIENTES=[]; }
  if(!ECN_CLIENTES||!ECN_CLIENTES.length){ try{ ECN_CLIENTES=await q('clientes','select=cardcode,cardname&cardtype=eq.C&order=cardname&limit=8000'); }catch(e){ ECN_CLIENTES=[]; } }
  return ECN_CLIENTES||[];
}
function ecnFiltrar(){
  var inp=$('ecn-code'), drop=$('ecn-drop'); if(!inp||!drop) return;
  if(!ECN_CLIENTES){ ecnCargarClientes().then(function(){ ecnFiltrar(); }); }
  var t=(inp.value||'').trim().toLowerCase();
  var arr=ECN_CLIENTES||[];
  var res=(t? arr.filter(function(c){ return (String(c.cardcode||'').toLowerCase().indexOf(t)>=0) || (String(c.cardname||'').toLowerCase().indexOf(t)>=0); }) : arr).slice(0,80);
  if(!res.length){ drop.style.display='none'; return; }
  drop.innerHTML=res.map(function(c){
    var nm=String(c.cardname||'').replace(/</g,'&lt;'), cd=String(c.cardcode||'');
    return '<div onmousedown="ecnPick(\''+cd.replace(/'/g,"\\'")+'\')" style="padding:7px 10px;cursor:pointer;display:flex;justify-content:space-between;gap:12px;border-bottom:1px solid #f0f0f0" onmouseover="this.style.background=\'#f5f7fa\'" onmouseout="this.style.background=\'\'"><span>'+nm+'</span><span style="color:var(--text3);font-size:12px;white-space:nowrap">'+cd+'</span></div>';
  }).join('');
  drop.style.display='';
}
function ecnPick(code){
  var inp=$('ecn-code'); if(inp) inp.value=code;
  ecnCerrarDrop();
  ecNappaConsultar();
}
function ecnCerrarDrop(){ var d=$('ecn-drop'); if(d) d.style.display='none'; }
function logout(){
  try{
    if(SESS && SESS.access_token){
      fetch(SB+'/auth/v1/logout',{method:'POST',headers:{'apikey':KEY,'Authorization':'Bearer '+SESS.access_token}});
    }
  }catch(e){}
  SESS=null; CU=null;
  location.reload();
}

// El boton de subir fotos solo para gerencia: cambia el catalogo que ve todo
// el mundo, no es una accion de vendedor.
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    setTimeout(function(){
      if(CU && String(CU.rol||'').toLowerCase()!=='admin'){
        var b=document.getElementById('btn-subir-fotos');
        if(b) b.style.display='none';
        // El registro del sync trae errores internos de SAP: solo gerencia.
        var sl=document.getElementById('nav-synclog');
        if(sl) sl.style.display='none';
      }
      // Compras: proveedores y costos fuera del alcance de ventas.
      if(!veCompras()){
        ['nav-oc','nav-ordenes','nav-opor','nav-compras'].forEach(function(nid){
          var n=document.getElementById(nid);
          if(n) n.style.display='none';
        });
        // La opcion de subir fotos queda para vendedores tambien; solo se
        // oculta a los clientes, que ya lo hace la lista de arriba.

      }
    }, 1200);
  });
})();

function relabelNav(id,txt){var e=document.getElementById(id);if(!e)return;for(var i=0;i<e.childNodes.length;i++){var n=e.childNodes[i];if(n.nodeType===3&&n.textContent&&n.textContent.trim()){n.textContent=txt;return;}}}
function clienteLockdown(){
  ['nav-dash','nav-cli','nav-ped','nav-cpd','nav-mor','nav-fac','nav-ncr','nav-cinv','nav-inv','nav-sep','nav-ale','nav-rep','nav-atr','nav-rec','nav-recien','nav-entp','nav-tva','nav-sinrot','nav-porllegar','nav-wms','nav-chat','nav-ecnappa','nav-subfotos','nav-synclog','nav-inv-section','nav-sec-principal','nav-sec-reportes'].forEach(function(id){var e=document.getElementById(id);if(e)e.style.display='none';});
  var gw=document.getElementById('gs-wrap');if(gw)gw.style.display='none';
  var _qa=document.getElementById('qa-rvv'); if(_qa) _qa.style.display='none';
  var _sf=document.getElementById('btn-subir-fotos'); if(_sf) _sf.style.display='none';
  relabelNav('nav-np','Nueva cotizacion');relabelNav('nav-ec','Mi estado de cuenta');relabelNav('nav-rst','Mi restock');relabelNav('nav-predl','Mis pedidos');
  var ks=document.querySelectorAll('#page-estado_cuenta .kpi');if(ks&&ks[2])ks[2].style.display='none';
  var _pl=document.querySelector('#page-estado_cuenta .pills');if(_pl)_pl.style.display='none';
  q('clientes','select=cardname&cardcode=eq.'+encodeURIComponent(CU.cardcode)+'&limit=1').then(function(rows){if(rows&&rows[0]&&rows[0].cardname){var un=document.getElementById('u-name');if(un)un.textContent=rows[0].cardname;}});
  go('estado_cuenta',document.getElementById('nav-ec'));
}
function clienteRestock(){
  var qel=document.getElementById('rs-cli-q');var box=qel&&qel.closest?qel.closest('.sbox'):null;if(box)box.style.display='none';
  q('clientes','select=cardcode,cardname&cardcode=eq.'+encodeURIComponent(CU.cardcode)+'&limit=1').then(function(rows){var nm=(rows&&rows[0]&&rows[0].cardname)||CU.nombre||CU.cardcode;rsCargar(CU.cardcode,nm);});
}

// ══ NAVEGACION ══

/* ═══ Iconos SVG modernos (estilo Lucide) para títulos/encabezados ═══ */
var _ICONS={
  dashboard:'<rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/><rect width="7" height="9" x="14" y="12" rx="1"/><rect width="7" height="5" x="3" y="16" rx="1"/>',
  users:'<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  user:'<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
  clipboard:'<rect x="8" y="2" width="8" height="4" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/>',
  receipt:'<path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/><path d="M12 17.5v-11"/>',
  filetext:'<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v5h5"/><path d="M16 13H8"/><path d="M16 17H8"/><path d="M10 9H8"/>',
  package:'<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.27 6.96 12 12.01l8.73-5.05"/><path d="M12 22.08V12"/>',
  tag:'<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/>',
  wallet:'<path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"/><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"/>',
  bell:'<path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>',
  dollar:'<line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>',
  cart:'<circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>',
  barchart:'<line x1="12" x2="12" y1="20" y2="10"/><line x1="18" x2="18" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="16"/>',
  refresh:'<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>',
  alert:'<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
  userplus:'<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" x2="19" y1="8" y2="14"/><line x1="22" x2="16" y1="11" y2="11"/>',
  truck:'<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
  trending:'<polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>',
  search:'<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
  landmark:'<line x1="3" x2="21" y1="22" y2="22"/><line x1="6" x2="6" y1="18" y2="11"/><line x1="10" x2="10" y1="18" y2="11"/><line x1="14" x2="14" y1="18" y2="11"/><line x1="18" x2="18" y1="18" y2="11"/><polygon points="12 2 20 7 4 7"/>'
};
function ico(name,o){o=o||{};var sz=o.size||18,mr=(o.mr!=null?o.mr:8),ml=(o.ml!=null?o.ml:0),col=o.color||'currentColor';var inner=_ICONS[name];if(!inner)return '';return '<svg class="ico" viewBox="0 0 24 24" width="'+sz+'" height="'+sz+'" fill="none" stroke="'+col+'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 auto;vertical-align:-3px;margin-right:'+mr+'px;margin-left:'+ml+'px">'+inner+'</svg>';}
var TITLE_ICONS={ventas_vendedor:'dashboard',ecnappa:'landmark',dashboard:'dashboard',clientes:'users',pedidos:'clipboard',facturas:'receipt',inventario:'package',precios:'tag',estado_cuenta:'wallet',alertas:'bell',ultimo_precio:'dollar',pedido_det:'clipboard',factura_det:'receipt',cliente_det:'user',item_det:'package',nuevo_pedido:'cart',reportes:'barchart',restock:'refresh',atrasados:'alert',radar:'users',reconquista:'userplus',entregaspedido:'truck',topart:'trending',separados:'search',sinrotacion:'package',porllegar:'truck',chat:'users',pedrealizados:'clipboard',wms:'package',notas:'filetext',cinv:'search',control_pedidos:'clipboard',morosidad:'clock'};
const TITLES={ventas_vendedor:'Reporte de Ventas por Vendedor',ecnappa:'Estados de cuenta NAPPA',dashboard:'Dashboard',clientes:'Clientes',pedidos:'Pedidos',facturas:'Facturas',inventario:'Inventario',precios:'Lista de precios',estado_cuenta:'Estado de cuenta',alertas:'Alertas',ultimo_precio:'Ultimo precio',pedido_det:'Detalle de pedido',factura_det:'Detalle de factura',cliente_det:'Ficha de cliente',item_det:'Detalle de producto',nuevo_pedido:'Nuevo Pedido',reportes:'Reportes',restock:'Restock por cliente',atrasados:'Clientes atrasados',radar:'Radar de clientes',reconquista:'Reactivar clientes',entregaspedido:'Entregas de un pedido',topart:'Mejores articulos vendidos',separados:'Mercancía separada',sinrotacion:'Mercancía sin rotación',porllegar:'Mercancia por llegar',chat:'Live Chat',pedrealizados:'Pedidos realizados y en proceso',wms:'Inventario WMS',notas:'Notas de cr\u00e9dito y d\u00e9bito',cinv:'Consulta de inventario',control_pedidos:'Control de pedidos',morosidad:'An\u00e1lisis de morosidad'};
var NAVSTACK=[];
var VISTA_ACTUAL=null;
var NAV_EL={};
var _navFromPop=false, _navSeq=1, _navCur=1;
function _navElFor(id){ if(NAV_EL[id]) return NAV_EL[id]; var f=null; document.querySelectorAll('.ni').forEach(function(n){ var oc=n.getAttribute('onclick')||''; if(oc.indexOf("go('"+id+"'")>=0||oc.indexOf('go("'+id+'"')>=0) f=n; }); if(f) NAV_EL[id]=f; return f; }
function _navPush(d){
  if(_navFromPop) return;
  try{
    var c=history.state;
    if(c && c.v===d.v && (''+c.id)===(''+d.id) && (''+c.a)===(''+d.a)){ d._p=c._p||_navCur; history.replaceState(d,''); }
    else { _navSeq++; d._p=_navSeq; _navCur=_navSeq; history.pushState(d,''); }
  }catch(e){}
}
function _navRender(d){
  if(!d||!d.v) return;
  _navFromPop=true;
  try{
    if(d.v==='page') go(d.id,_navElFor(d.id));
    else if(d.v==='item') verItem(d.a,true);
    else if(d.v==='pedido') verPedido(d.a,true);
    else if(d.v==='cliente') verCliente(d.a,true);
    else if(d.v==='factura') verFactura(d.a,true);
  }catch(e){}
  _navFromPop=false;
}
// Los paneles a pantalla completa que abren algunos modulos. No son una
// "pagina" del portal: se dibujan encima. Si hay uno abierto, el boton Atras
// del navegador debe CERRARLO, no cambiar de pantalla ni salirse.
var NAV_PANELES=[
  {id:'mur-overlay', cerrar:'murCerrar'},    // vista visual del pedido
  {id:'hvi-ov',      cerrar:'hviCerrar'},    // historial de venta del item
  {id:'ncr-adj-ov',  cerrar:null},           // galeria de adjuntos
  {id:'lst-ov',      cerrar:'lstCerrar'}
];
function _navCerrarPanel(){
  for(var i=NAV_PANELES.length-1;i>=0;i--){
    var p=NAV_PANELES[i];
    if(!document.getElementById(p.id)) continue;
    // Se usa la funcion del modulo si existe: ademas de quitar el panel,
    // libera el scroll del body y limpia su estado.
    if(p.cerrar && typeof window[p.cerrar]==='function'){
      try{ window[p.cerrar](); return true; }catch(e){}
    }
    var el=document.getElementById(p.id);
    if(el){ el.remove(); try{ document.body.style.overflow=''; }catch(e){} return true; }
  }
  // Los modales sueltos que los modulos crean como <div style="position:fixed">
  var sobra=document.querySelectorAll('div[style*="position:fixed"][style*="inset:0"]');
  if(sobra && sobra.length){
    sobra[sobra.length-1].remove();
    try{ document.body.style.overflow=''; }catch(e){}
    return true;
  }
  return false;
}

window.addEventListener('popstate',function(e){
  var d=e.state;

  // 1) Si hay un panel o un modal abierto, Atras solo lo cierra. Se devuelve
  // la entrada al historial para no gastar un paso.
  if(_navCerrarPanel()){
    try{ history.pushState(d || {v:'page',id:'dashboard',_p:_navCur}, ''); }catch(e2){}
    return;
  }

  // 2) Sin estado significa que se salio del historial del portal: es el
  // momento en que el navegador abandonaba la app. En vez de eso se vuelve a
  // entrar y se va al Dashboard, que es el "atras" que la gente espera.
  if(!d || !d.v){
    try{ history.pushState({v:'page',id:'dashboard',_p:1}, ''); }catch(e2){}
    _navCur=1;
    _navRender({v:'page',id:'dashboard'});
    return;
  }

  _navCur = (d._p!=null) ? d._p : 1;
  _navRender(d);
});

// Dos entradas al arrancar: la del portal y una de respaldo. Asi el primer
// Atras cae en la de respaldo y el manejador de arriba lo atrapa, en vez de
// sacar al usuario del sitio.
try{
  if(!history.state) history.replaceState({v:'page',id:'dashboard',_p:1},'');
  history.pushState({v:'page',id:'dashboard',_p:1},'');
}catch(e){}
/* ===== Historial de busquedas (inventario / pedidos / clientes) ===== */
var _HIST_MEM={};
function _histKey(t){ return 'kc_hist_'+t; }
function histGet(t){
  try{ var r=localStorage.getItem(_histKey(t)); if(r) return JSON.parse(r)||[]; }catch(e){}
  return _HIST_MEM[t]||[];
}
function _histSave(t,arr){
  _HIST_MEM[t]=arr;
  try{ localStorage.setItem(_histKey(t), JSON.stringify(arr)); }catch(e){}
}
function histAdd(t,texto){
  var qv=(texto||'').trim(); if(qv.length<2) return;
  var low=qv.toLowerCase();
  var arr=histGet(t).slice().filter(function(x){ var xl=(x||'').toLowerCase(); return xl!==low && low.indexOf(xl)!==0; });
  arr.unshift(qv);
  if(arr.length>12) arr=arr.slice(0,12);
  _histSave(t,arr);
}
function histClear(t){ _histSave(t,[]); histRender(t); }
var HIST_CFG={
  inv:{inp:'inv-search', run:function(qv){ searchInventario(qv); }},
  ped:{inp:'ped-search', run:function(qv){ searchPedidos(qv); }},
  cli:{inp:'cli-search', run:function(qv){ searchClientes(qv); }}
};
function _histTarget(t){
  if(t==='ped'){ var tb=document.getElementById('ped-tbody'); return tb?(tb.closest('table')||tb):null; }
  return document.getElementById(t==='inv'?'inv-grid':'cli-grid');
}
function histRender(t){
  var cfg=HIST_CFG[t]; if(!cfg) return;
  var box=document.getElementById('hist-'+t);
  if(!box){
    var tgt=_histTarget(t); if(!tgt||!tgt.parentNode) return;
    box=document.createElement('div'); box.id='hist-'+t;
    box.style.cssText='display:flex;flex-wrap:wrap;gap:6px;align-items:center;margin:2px 0 10px 2px';
    tgt.parentNode.insertBefore(box, tgt);
  }
  var arr=histGet(t);
  if(!arr.length){ box.style.display='none'; box.innerHTML=''; return; }
  box.style.display='flex';
  var chips=arr.map(function(qq,i){
    return '<button type="button" onclick="histUse(\''+t+'\','+i+')" title="Buscar de nuevo" style="border:1px solid var(--border);background:var(--surface2);color:var(--text2);border-radius:14px;padding:3px 10px;font-size:11.5px;cursor:pointer;font-family:inherit;max-width:190px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+npEsc(qq)+'</button>';
  }).join('');
  box.innerHTML='<span style="font-size:11px;color:var(--text3);display:inline-flex;align-items:center;gap:4px"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v5h5"/><path d="M3.05 13A9 9 0 1 0 6 5.3L3 8"/><path d="M12 7v5l3 3"/></svg>Recientes:</span>'+chips+'<button type="button" onclick="histClear(\''+t+'\')" title="Borrar historial" style="border:none;background:none;color:var(--text3);font-size:11px;cursor:pointer;text-decoration:underline;font-family:inherit">limpiar</button>';
}
function histUse(t,i){
  var arr=histGet(t); var qq=arr[i]; if(qq==null) return;
  var cfg=HIST_CFG[t]; var inp=document.getElementById(cfg.inp); if(inp) inp.value=qq;
  cfg.run(qq);
}
function _closeSb(){document.body.classList.remove('sb-open');}
function go(id,el){
  if(CU&&CU.rol==='cliente'){var _allow=['nuevo_pedido','restock','pedrealizados','cliente_det','factura_det','item_det','pedido_det'] /* pedrealizados = "Mis pedidos" (el id del menu es nav-predl, pero la pagina se llama asi) */;if(_allow.indexOf(id)===-1){var _ne=document.getElementById('nav-ec');document.querySelectorAll('.ni').forEach(function(n){n.classList.remove('active');});if(_ne)_ne.classList.add('active');verCliente(CU.cardcode);return;}}

  // Pantallas de compras: el proveedor y los costos no son cosa de ventas.
  // Con el proveedor y el costo, cualquiera puede ir por su cuenta o filtrar
  // el margen a un cliente.
  if(!veCompras()){
    var _soloCompras = ['ordenes_compra','oc_det'];
    if(_soloCompras.indexOf(id) >= 0){
      alert('Esta pantalla es de compras.');
      return;
    }
  }
  _closeSb();
  document.querySelectorAll('.page').forEach(p=>p.classList.remove('active'));
  const pg=$('page-'+id); if(pg) pg.classList.add('active');
  $('ptitle').innerHTML=(TITLE_ICONS[id]?ico(TITLE_ICONS[id],{size:19,mr:9,color:'var(--blue2)'}):'')+'<span>'+(TITLES[id]||id)+'</span>';
  // Icono (i) con la explicacion de la pantalla. Va aqui porque el titulo
  // se reescribe entero en cada navegacion y se llevaria el boton por delante.
  try{ if(typeof ayudaMontar==='function') ayudaMontar(id); }catch(e){}
  if(el){document.querySelectorAll('.ni').forEach(n=>n.classList.remove('active'));el.classList.add('active');}
  if(el){ NAVSTACK=[]; VISTA_ACTUAL=(function(i,e){return function(){go(i,e);};})(id,el); }
  if(id==='pedidos')setTimeout(loadPedidos,50);
  if(id==='nuevo_pedido'){npInit();setTimeout(function(){npIr(1);},50);}
  if(id==='inventario')setTimeout(loadInventario,50);
  if(id==='facturas')setTimeout(loadFacturas,50);
  if(id==='estado_cuenta')setTimeout(loadEC,50);
  if(id==='alertas')setTimeout(loadAlertas,50);
  if(id==='ultimo_precio')setTimeout(loadUP,50);
  if(id==='precios')setTimeout(loadPrecios,50);
  if(id==='reportes')setTimeout(loadReportes,50);
  if(id==='restock')setTimeout(function(){loadRestock();if(CU&&CU.rol==='cliente')clienteRestock();},50);
  if(id==='atrasados')setTimeout(rptAtrasadosCargar,50);
  if(id==='radar')setTimeout(function(){ try{ radInit(); }catch(e){} },50);
  if(id==='reconquista')setTimeout(reconCargar,50);
  if(id==='entregaspedido')setTimeout(entpInit,50);
  if(id==='topart')setTimeout(taInit,50);
  if(id==='sinrotacion')setTimeout(srInit,50);
  if(id==='porllegar')setTimeout(plInit,50);
  if(id==='wms')setTimeout(function(){ if(typeof wmsInit==='function') wmsInit(); },50);
  if(id==='notas')setTimeout(function(){ if(typeof ncrInit==='function') ncrInit(); },50);
  if(id==='cinv')setTimeout(function(){ if(typeof cinvInit==='function') cinvInit(); },50);
  if(id==='control_pedidos')setTimeout(function(){ if(typeof cpdInit==='function') cpdInit(); },50);
  if(id==='morosidad')setTimeout(function(){ if(typeof morInit==='function') morInit(); },50);
  if(id==='chat')setTimeout(function(){ if(typeof chatInit==='function') chatInit(); },50);
  if(id==='pedrealizados')setTimeout(function(){ if(typeof prInit==='function') prInit(); },50);
  if(id==='recien')setTimeout(function(){ if(typeof recCargar==='function' && !(window._recAll&&window._recAll.length)) recCargar(); },50);
  if(id==='ecnappa')setTimeout(ecnCargarClientes,50);
  if(id==='dashboard')setTimeout(function(){ try{ kccPintarTarjeta(); }catch(e){} },300);
  if(id==='nuevo_pedido')setTimeout(function(){
    try{ npPintarDestino(); }catch(e){}
    // Red de seguridad: si por cualquier via las fechas quedaron vacias,
    // aqui se rellenan.
    try{ npFechasPorDefecto(false); }catch(e){}
  },200);
  if(id==='ventas_vendedor')setTimeout(function(){ try{ rvvInit(); }catch(e){} },50);
  else { var _rvv=document.getElementById('page-ventas_vendedor'); if(_rvv) _rvv.innerHTML=''; }
  if(el) NAV_EL[id]=el;
  _navPush({v:'page',id:id});
}
function setVal(id,v){var e=$(id);if(e)e.value=(v===''||v==null)?'':v;}
async function iaBuscar(modo){
  var inp=$(modo==='inv'?'inv-ia':'cat-ia');
  var txt=((inp&&inp.value)||'').trim();
  var msg=$(modo==='inv'?'inv-ia-msg':'cat-ia-msg');
  var btn=$(modo==='inv'?'inv-ia-btn':'cat-ia-btn');
  if(!txt){ if(msg)msg.textContent=''; return; }
  if(btn){btn.disabled=true;btn.textContent='Pensando...';}
  if(msg){msg.style.color='var(--blue2)';msg.textContent='🤖 Interpretando tu búsqueda...';}
  try{
    var f = await iaLlamar('filtros', txt);
    iaAplicar(modo, f);
  }catch(e){
    if(msg){msg.style.color='var(--red)';msg.textContent='No se pudo interpretar: '+e.message;}
  }finally{
    if(btn){btn.disabled=false;btn.textContent='Buscar con IA';}
  }
}
function iaAplicar(modo, f){
  var textos=Array.isArray(f.textos)?f.textos.filter(Boolean):[];
  if(modo==='inv'){
    invTextos=textos; invQ=''; setVal('inv-search','');
    invBMin=(f.bmin!=null)?f.bmin:''; invBMax=(f.bmax!=null)?f.bmax:'';
    invPMin=(f.pmin!=null)?f.pmin:''; invPMax=(f.pmax!=null)?f.pmax:'';
    invSMin=(f.smin!=null)?f.smin:''; invSMax='';
    invDispF=(f.disp||''); invOrden=(f.orden||'reciente');
    setVal('inv-bmin',invBMin);setVal('inv-bmax',invBMax);setVal('inv-pmin',invPMin);setVal('inv-pmax',invPMax);setVal('inv-smin',invSMin);
    var d=$('inv-disp');if(d)d.value=invDispF; var o=$('inv-orden');if(o)o.value=invOrden;
    invPage=0; loadInventario();
  } else {
    catTextos=textos; catQ=''; setVal('np-prod-q','');
    catPMin=(f.pmin!=null)?f.pmin:''; catPMax=(f.pmax!=null)?f.pmax:'';
    catSMin=(f.smin!=null)?f.smin:''; catBMin=(f.bmin!=null)?f.bmin:''; catBMax=(f.bmax!=null)?f.bmax:'';
    catDispF=(f.disp||''); catOrden=(f.orden||'reciente');
    catPage=0; catCargar();
  }
  var msg=$(modo==='inv'?'inv-ia-msg':'cat-ia-msg');
  if(msg){
    var p=[];
    if(textos.length)p.push('🔎 '+textos.join(' / '));
    if(f.bmin!=null)p.push('≥'+f.bmin+' bultos'); if(f.bmax!=null)p.push('≤'+f.bmax+' bultos');
    if(f.pmin!=null)p.push('precio ≥'+f.pmin); if(f.pmax!=null)p.push('precio ≤'+f.pmax);
    if(f.smin!=null)p.push('≥'+f.smin+' pzas');
    if(f.disp==='stock')p.push('con stock'); if(f.disp==='agotado')p.push('agotados');
    msg.style.color='var(--blue2)';
    msg.textContent='Mostrando: '+(p.length?p.join(' · '):'todo el catálogo');
  }
}
function iaLimpiar(modo){
  if(modo==='inv'){ invTextos=[]; setVal('inv-ia',''); var m=$('inv-ia-msg');if(m)m.textContent=''; invPage=0; loadInventario(); }
  else { catTextos=[]; setVal('cat-ia',''); var m=$('cat-ia-msg');if(m)m.textContent=''; catPage=0; catCargar(); }
}
async function buscarSeparados(){
  var sku=(($('sep-sku')||{}).value||'').trim();
  var cont=$('sep-result');
  if(!sku){cont.innerHTML='';return;}
  cont.innerHTML='<div class="card"><div class="empty">Buscando...</div></div>';
  try{
    var skuEnc=encodeURIComponent(sku);
    var res=await Promise.all([
      q('inventario','select=itemcode,itemname,stockbodega,disponiblebodega,onorder&itemcode=eq.'+skuEnc+'&limit=1'),
      q('pedidos','select=docnum,docdate,cardcode,cardname,nombrevendedor,quantity,openqty,linestatus&itemcode=eq.'+skuEnc+'&docstatus=eq.O&openqty=gt.0&or=(linestatus.eq.O,linestatus.is.null)&order=docnum.desc&limit=300')
    ]);
    var inv=(res[0]&&res[0][0])||null;
    var peds=res[1]||[];
    if(!inv && !peds.length){
      cont.innerHTML='<div class="card"><div class="empty">No se encontró el SKU <b>'+sku+'</b> en inventario ni en pedidos.</div></div>';
      return;
    }
    var stock=inv?Number(inv.stockbodega||0):0;
    var onorder=inv?Number(inv.onorder||0):0;
    var separado=peds.reduce(function(a,p){return a+Number(p.openqty||0);},0);
    var disp=stock-separado;
    var puede=disp>0;
    var html='<div class="card" style="margin-bottom:14px">'+
      '<div class="ch"><span class="ct">📦 '+(inv?(inv.itemname||''):'')+' <span style="font-family:monospace;color:var(--text3);font-size:12px">'+sku+'</span></span></div>'+
      '<div class="kpi-grid" style="grid-template-columns:repeat(4,1fr)">'+
        '<div class="kpi"><div class="kpi-lbl">En bodega</div><div class="kpi-val" style="color:rgb(21,206,43)">'+fmtN(stock)+'</div></div>'+
        '<div class="kpi" onclick="verSeparadoVentas(\''+sku+'\')" style="cursor:pointer"><div class="kpi-lbl">Separado</div><div class="kpi-val" style="color:rgb(255,0,0);text-decoration:underline">'+fmtN(separado)+'</div></div>'+
        '<div class="kpi"><div class="kpi-lbl">Disponible p/vender</div><div class="kpi-val" style="color:'+(puede?'var(--green)':'var(--red)')+'">'+fmtN(disp)+'</div></div>'+
        '<div class="kpi"><div class="kpi-lbl">Por llegar</div><div class="kpi-val" style="color:#C9A800">'+fmtN(onorder)+'</div></div>'+
      '</div>'+
      '<div style="margin-top:12px;padding:12px 16px;border-radius:10px;background:'+(puede?'var(--green-bg)':'var(--red-bg)')+';color:'+(puede?'var(--green)':'var(--red)')+';font-weight:600;font-size:13px">'+
        (puede?'✅ Hay '+fmtN(disp)+' unidades disponibles. Puedes tomar un pedido con este SKU.':'⛔ No hay disponible para vender; todo está comprometido en los pedidos de abajo.')+
      '</div></div>';
    if(peds.length){
      html+='<div class="card"><div class="ch"><span class="ct">📋 Separada en '+peds.length+' pedido(s)</span></div>'+
        '<table class="tbl"><tr><th>Pedido</th><th>Fecha</th><th>Cliente</th><th>Vendedor</th><th>Cant. pedida</th><th>Cant. separada</th></tr>'+
        peds.map(function(p){return '<tr>'+
          '<td style="color:var(--blue2);cursor:pointer" onclick="verPedido('+p.docnum+')"><u>'+p.docnum+'</u></td>'+
          '<td>'+fmtFechaCorta(p.docdate)+'</td>'+
          '<td>'+(p.cardname||'')+'<div style="font-size:11px;color:var(--text3)">'+(p.cardcode||'')+'</div></td>'+
          '<td>'+(p.nombrevendedor||'—')+'</td>'+
          '<td>'+fmtN(p.quantity)+'</td>'+
          '<td style="font-weight:600;color:var(--amber)">'+fmtN(p.openqty)+'</td>'+
        '</tr>';}).join('')+'</table></div>';
    } else {
      html+='<div class="card"><div class="empty">Este SKU no está separado en ningún pedido abierto. Todo el stock está libre.</div></div>';
    }
    cont.innerHTML=html;
  }catch(e){
    cont.innerHTML='<div class="card"><div class="empty" style="color:var(--red)">Error: '+e.message+'</div></div>';
  }
}
function navBack(){
  if(NAVSTACK.length){ var fn=NAVSTACK.pop(); VISTA_ACTUAL=fn; fn(); }
  else { go('dashboard',document.getElementById('nav-dash')); }
}

// ══ DASHBOARD ══
async function initDashboard(){
  var _adm=(CU&&CU.rol==='admin');
  var _kg=document.getElementById('kpi-dash'); if(_kg) _kg.style.display=_adm?'':'none';
  if(_adm) cargarKpisVenta();
  const saldoData = await q('estado_cuenta','select=saldopendiente,categoria&limit=2000');
  cargarTopVendidos('db-top');
  // El bloque de ultimos pedidos se cambio por el reporte de ventas por
  // vendedor, que solo ven vendedores y administradores.
  try{ rvInit(); }catch(e){}
  cargarUltimosRecibidos('db-rec');
  cargarVentasMes('db-ventas');
  cargarCobranzaAging('db-aging', saldoData);
}
async function cargarKpisVenta(){
  try{
    var c=await q('ventas_comparativo','select=mes_actual,mes_ano_pasado,ytd_actual,ytd_ano_pasado');
    var d=(c&&c[0])||{};
    var ma=Number(d.mes_actual)||0, mp=Number(d.mes_ano_pasado)||0;
    var ya=Number(d.ytd_actual)||0, yp=Number(d.ytd_ano_pasado)||0;
    function trend(cur,prev,suf){ var p=(prev>0)?Math.round((cur-prev)/prev*100):null;
      if(p===null) return 'vs a\u00f1o pasado'+(suf||'');
      return (p>=0?'<span style="color:var(--green);font-weight:700">\u25b2 '+p+'%</span>':'<span style="color:var(--red);font-weight:700">\u25bc '+Math.abs(p)+'%</span>')+' vs a\u00f1o pasado'+(suf||''); }
    var e=$('k-vmes'); if(e) e.textContent=fmt(ma);
    var es=$('k-vmes-sub'); if(es) es.innerHTML=trend(ma,mp,'');
    var ea=$('k-vanio'); if(ea) ea.textContent=fmt(ya);
    var eas=$('k-vanio-sub'); if(eas) eas.innerHTML=trend(ya,yp,' (a la fecha)');
  }catch(e){ var x=$('k-vmes'); if(x)x.textContent='\u2014'; }
  try{
    var ped=await q('pedidos','select=docnum,doctotal&confirmed=eq.N&docstatus=eq.O&linenum=lte.1&limit=4000');
    var n=(ped||[]).length, sum=(ped||[]).reduce(function(s,p){return s+Number(p.doctotal||0);},0);
    var e2=$('k-pauth'); if(e2) e2.textContent=n.toLocaleString();
    var e2s=$('k-pauth-sub'); if(e2s) e2s.textContent=fmt(sum)+' en total';
  }catch(e){}
  cargarChartYoY();
}
async function cargarChartYoY(){
  var el=$('k-chart'); if(!el) return;
  try{
    var rows=await q('ventas_por_mes','select=mes,total&order=mes.asc&limit=30');
    var by={}; (rows||[]).forEach(function(r){ by[r.mes]=Number(r.total)||0; });
    var now=new Date(), Y=now.getFullYear(), curM=now.getMonth()+1;
    var mm=['','E','F','M','A','M','J','J','A','S','O','N','D'];
    var data=[]; for(var m=1;m<=curM;m++){ var k=Y+'-'+String(m).padStart(2,'0'), kp=(Y-1)+'-'+String(m).padStart(2,'0'); data.push({m:m, act:by[k]||0, pas:by[kp]||0}); }
    if(!data.length){ el.innerHTML=empty('Sin datos'); return; }
    var max=Math.max.apply(null, data.map(function(d){return Math.max(d.act,d.pas);}))||1;
    var H=96, pad=6, gp=Math.max(15,(232-pad*2)/data.length), bw=Math.min(6,(gp-3)/2), W=pad*2+data.length*gp;
    var bars=data.map(function(d,i){
      var x=pad+i*gp, ha=Math.round((d.act/max)*(H-24)), hp=Math.round((d.pas/max)*(H-24));
      return '<g>'
        +'<rect x="'+x.toFixed(1)+'" y="'+(H-14-hp)+'" width="'+bw.toFixed(1)+'" height="'+Math.max(1,hp)+'" rx="1.5" fill="var(--text3)" opacity="0.4"><title>A\u00f1o pasado '+mm[d.m]+': '+fmt(d.pas)+'</title></rect>'
        +'<rect x="'+(x+bw+1.5).toFixed(1)+'" y="'+(H-14-ha)+'" width="'+bw.toFixed(1)+'" height="'+Math.max(1,ha)+'" rx="1.5" fill="var(--blue)"><title>Este a\u00f1o '+mm[d.m]+': '+fmt(d.act)+'</title></rect>'
        +'<text x="'+(x+bw).toFixed(1)+'" y="'+(H-3)+'" text-anchor="middle" font-size="8" fill="var(--text3)">'+mm[d.m]+'</text></g>';
    }).join('');
    el.innerHTML='<div style="display:flex;gap:10px;font-size:10px;color:var(--text3);margin-bottom:2px"><span><span style="display:inline-block;width:8px;height:8px;background:var(--blue);border-radius:2px;vertical-align:middle;margin-right:3px"></span>Este a\u00f1o</span><span><span style="display:inline-block;width:8px;height:8px;background:var(--text3);opacity:.4;border-radius:2px;vertical-align:middle;margin-right:3px"></span>A\u00f1o pasado</span></div>'
      +'<div style="overflow-x:auto"><svg viewBox="0 0 '+W+' '+H+'" width="100%" height="'+H+'" preserveAspectRatio="xMidYMid meet" style="min-width:'+Math.min(W,232)+'px">'+bars+'</svg></div>';
  }catch(e){ el.innerHTML='<div class="empty" style="font-size:11px">Falta la vista ventas_por_mes.</div>'; }
}
async function cargarVentasMes(elId){
  var el=$(elId||'db-ventas'); if(!el) return;
  try{
    var rows=await q('ventas_por_mes','select=mes,total,facturas&order=mes.asc&limit=24');
    if(!rows||!rows.length){ el.innerHTML='<div class="empty">Sin datos de ventas.<br><span style="font-size:11px">Crea la vista <b>ventas_por_mes</b> en Supabase (archivo ventas_por_mes.sql).</span></div>'; return; }
    rows=rows.slice(-12);
    var vals=rows.map(function(r){return Number(r.total)||0;});
    var max=Math.max.apply(null,vals)||1;
    var W=Math.max(340,rows.length*52), H=180, pad=20;
    var gap=(W-pad*2)/rows.length, bw=Math.min(34,gap-8);
    var bars=rows.map(function(r,i){
      var v=Number(r.total)||0, h=Math.max(2,Math.round((v/max)*(H-52)));
      var x=pad+i*gap+(gap-bw)/2, y=H-30-h, cur=(i===rows.length-1);
      var mm=String(r.mes).slice(5);
      return '<g><rect x="'+x.toFixed(1)+'" y="'+y+'" width="'+bw.toFixed(1)+'" height="'+h+'" rx="3" fill="var(--blue2)" opacity="'+(cur?1:0.55)+'"><title>'+r.mes+': '+fmt(v)+' \u00b7 '+(r.facturas||0)+' fact.</title></rect>'
        +'<text x="'+(x+bw/2).toFixed(1)+'" y="'+(H-14)+'" text-anchor="middle" font-size="10" fill="var(--text3)">'+mm+'</text></g>';
    }).join('');
    var last=vals[vals.length-1]||0, prev=vals.length>1?vals[vals.length-2]:0;
    var pct=prev>0?Math.round((last-prev)/prev*100):null;
    var trend=pct===null?'\u2014':(pct>=0?'<span style="color:var(--green);font-weight:700">\u25b2 '+pct+'%</span>':'<span style="color:var(--red);font-weight:700">\u25bc '+Math.abs(pct)+'%</span>');
    el.innerHTML='<div style="overflow-x:auto"><svg viewBox="0 0 '+W+' '+H+'" width="100%" height="'+H+'" preserveAspectRatio="xMidYMid meet" style="min-width:'+Math.min(W,520)+'px">'+bars+'</svg></div>'
      +'<div style="display:flex;justify-content:space-between;font-size:12px;color:var(--text3);margin-top:4px;padding:0 4px"><span>Este mes: <b style="color:var(--text)">'+fmt(last)+'</b></span><span>vs mes anterior: '+trend+'</span></div>';
  }catch(e){ el.innerHTML='<div class="empty">No se pudo cargar la gr\u00e1fica de ventas.</div>'; }
}
function cargarCobranzaAging(elId, saldoData){
  var el=$(elId||'db-aging'); if(!el) return;
  var g={};
  (saldoData||[]).forEach(function(r){ var c=(r.categoria||'Sin clasificar').trim(); g[c]=(g[c]||0)+Number(r.saldopendiente||0); });
  var arr=Object.keys(g).map(function(k){return {cat:k, monto:g[k]};}).filter(function(x){return Math.abs(x.monto)>0.5;});
  if(!arr.length){ el.innerHTML=empty('Sin saldos pendientes'); return; }
  function ord(c){ c=(c||'').toLowerCase(); if(/(corr|al d|por vencer|vigente)/.test(c) && !/\d/.test(c)) return 0; var m=c.match(/(\d+)/); return m?parseInt(m[1],10):500; }
  function col(c){ var o=ord(c); if(o<=0) return 'var(--green)'; if(o<=30) return '#FBBF24'; if(o<=60) return '#FB923C'; if(o<=90) return '#F87171'; return 'var(--red)'; }
  arr.sort(function(a,b){ return ord(a.cat)-ord(b.cat) || b.monto-a.monto; });
  var max=Math.max.apply(null,arr.map(function(x){return x.monto;}))||1;
  var tot=arr.reduce(function(s,x){return s+x.monto;},0);
  el.innerHTML='<div style="font-size:12px;color:var(--text3);margin-bottom:10px">Total pendiente: <b style="color:var(--text);font-size:14px">'+fmt(tot)+'</b></div>'
    + arr.map(function(x){ var pct=Math.round(x.monto/max*100);
        return '<div style="margin-bottom:9px"><div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:3px"><span>'+npEsc(x.cat)+'</span><b>'+fmt(x.monto)+'</b></div>'
          +'<div class="ibar" style="margin:0;height:8px;background:var(--bg);border-radius:5px"><div class="ibar-f" style="width:'+pct+'%;height:8px;border-radius:5px;background:'+col(x.cat)+'"></div></div></div>';
      }).join('');
}


// ══ CLIENTES ══
let cliData = [];
var cliVendF='', cliPaisF='';
// Anios del desplegable "No compra desde": desde el actual hasta el de la
// compra mas antigua que haya en la base, para no ofrecer anios vacios.
async function cliCargarAnios(){
  var sel=document.getElementById('cli-ano'); if(!sel || sel.dataset.listo) return;
  var desde=2015;
  try{
    var r=await q('vista_cliente_perfil','select=ultima_compra&ultima_compra=not.is.null&order=ultima_compra.asc&limit=1');
    if(r && r[0] && r[0].ultima_compra){
      var y=parseInt(String(r[0].ultima_compra).substring(0,4),10);
      if(isFinite(y) && y>1990) desde=y;
    }
  }catch(e){}
  var hoy=new Date().getFullYear(), ops='<option value="">Todos los a\u00f1os</option>';
  for(var y=hoy; y>=desde; y--) ops+='<option value="'+y+'">'+y+' o antes</option>';
  ops+='<option value="nunca">Nunca han comprado</option>';
  sel.innerHTML=ops;
  sel.value=cliAnoF||'';
  sel.dataset.listo='1';
}

async function cliCargarFiltros(){
  try{ cliCargarAnios(); }catch(e){}
  var sv=document.getElementById('cli-vend');
  if(sv && !sv.dataset.listo){
    try{
      var v=await q('vendedores','select=slpcode,slpname&order=slpname');
      var seen={};
      (v||[]).forEach(function(x){ if(x.slpcode!=null && !seen[x.slpcode]){ seen[x.slpcode]=1; var o=document.createElement('option'); o.value=x.slpcode; o.textContent=x.slpname||('Vendedor '+x.slpcode); sv.appendChild(o); } });
      sv.dataset.listo='1';
    }catch(e){}
  }
  var sp=document.getElementById('cli-pais');
  if(sp && !sp.dataset.listo){
    try{
      var rows=await qAll('clientes','select=country&cardtype=eq.C');
      var seen2={}, arr=[];
      (rows||[]).forEach(function(r){ var c=(r.country||'').trim(); if(c && !seen2[c]){ seen2[c]=1; arr.push(c); } });
      arr.sort(function(a,b){ return paisNombre(a).localeCompare(paisNombre(b)); });
      arr.forEach(function(c){ var o=document.createElement('option'); o.value=c; o.textContent=paisNombre(c); sp.appendChild(o); });
      sp.dataset.listo='1';
    }catch(e){}
  }
}
function cliFiltrar(){
  cliVendF=(document.getElementById('cli-vend')||{}).value||'';
  cliPaisF=(document.getElementById('cli-pais')||{}).value||'';
  cliAnoF=(document.getElementById('cli-ano')||{}).value||'';
  cliMontoF=(document.getElementById('cli-monto')||{}).value||'';
  window.cliPaisesF=null;                 // el desplegable manda sobre el mapa
  try{ if(typeof cmMarcar==='function') cmMarcar(); }catch(e){}
  cliPage=0;
  loadClientes();
}
async function loadClientes(append){
  if(!append){ cliPage=0; $('cli-grid').innerHTML = loading(); try{histRender('cli');}catch(e){} cliCargarFiltros();
    try{ if(typeof cmInit==='function') cmInit(); }catch(e){} }
  const offset = cliPage * PAGE_SIZE;
  let f = 'cardtype=eq.C';
  if(CU.rol==='cliente') f += '&cardcode=eq.'+CU.cardcode;
  if(cliVendF) f += '&slpcode=eq.'+encodeURIComponent(cliVendF);
  // Un pais suelto, o varios de golpe cuando se elige una region en el mapa.
  if(window.cliPaisesF && window.cliPaisesF.length){
    f += '&country=in.('+window.cliPaisesF.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',')+')';
  } else if(cliPaisF){
    f += '&country=eq.'+encodeURIComponent(cliPaisF);
  }
  // No compra desde: el ano elegido HACIA ATRAS. Los que nunca compraron
  // tienen ano 0, asi que entran solos en cualquier ano que se elija.
  if(cliAnoF){
    if(cliAnoF==='nunca') f += '&ano_ultima_compra=eq.0';
    else                  f += '&ano_ultima_compra=lte.'+encodeURIComponent(cliAnoF);
  }
  // Total facturado historico, por tramos.
  if(cliMontoF){
    var r=CLI_MONTOS[cliMontoF];
    if(r){
      f += '&total_historico=gte.'+r[0];
      if(r[1]!=null) f += '&total_historico=lt.'+r[1];
    }
  }

  let params = 'select=cardcode,cardname,phone1,phone2,cellular,e_mail,cntctprsn,city,country,'
    +'balance,creditline,nombrevendedor,condicionpago,ultima_compra,ano_ultima_compra,'
    +'meses_sin_comprar,total_12m,total_12m_previos,total_historico,tipo_principal,tipo_principal_pct'
    +'&order=cardname&limit='+PAGE_SIZE+'&offset='+offset+'&'+f;
  const data = await q('vista_clientes_perfil',params);
  cliData = data;
  renderClientes(data, append);
}

var ISO2_PAIS={af:'Afganistán',al:'Albania',de:'Alemania',ad:'Andorra',ao:'Angola',ai:'Anguila',ag:'Antigua y Barbuda',sa:'Arabia Saudita',dz:'Argelia',ar:'Argentina',am:'Armenia',aw:'Aruba',au:'Australia',at:'Austria',az:'Azerbaiyán',bs:'Bahamas',bd:'Bangladés',bb:'Barbados',bh:'Baréin',be:'Bélgica',bz:'Belice',bj:'Benín',bm:'Bermudas',by:'Bielorrusia',bo:'Bolivia',ba:'Bosnia y Herzegovina',bw:'Botsuana',br:'Brasil',bn:'Brunéi',bg:'Bulgaria',bf:'Burkina Faso',bi:'Burundi',bt:'Bután',cv:'Cabo Verde',kh:'Camboya',cm:'Camerún',ca:'Canadá',qa:'Catar',td:'Chad',cz:'Chequia',cl:'Chile',cn:'China',cy:'Chipre',co:'Colombia',km:'Comoras',cg:'Congo',cd:'Congo (RDC)',kp:'Corea del Norte',kr:'Corea del Sur',ci:'Costa de Marfil',cr:'Costa Rica',hr:'Croacia',cu:'Cuba',cw:'Curazao',dk:'Dinamarca',dm:'Dominica',ec:'Ecuador',eg:'Egipto',sv:'El Salvador',ae:'Emiratos Árabes Unidos',er:'Eritrea',sk:'Eslovaquia',si:'Eslovenia',es:'España',us:'Estados Unidos',ee:'Estonia',sz:'Esuatini',et:'Etiopía',ph:'Filipinas',fi:'Finlandia',fj:'Fiyi',fr:'Francia',ga:'Gabón',gm:'Gambia',ge:'Georgia',gh:'Ghana',gi:'Gibraltar',gd:'Granada',gr:'Grecia',gl:'Groenlandia',gp:'Guadalupe',gu:'Guam',gt:'Guatemala',gf:'Guayana Francesa',gg:'Guernsey',gn:'Guinea',gq:'Guinea Ecuatorial',gw:'Guinea-Bisáu',gy:'Guyana',ht:'Haití',hn:'Honduras',hk:'Hong Kong',hu:'Hungría',in:'India',id:'Indonesia',iq:'Irak',ir:'Irán',ie:'Irlanda',is:'Islandia',ky:'Islas Caimán',ic:'Islas Canarias',tc:'Islas Turcas y Caicos',vg:'Islas Vírgenes Británicas',vi:'Islas Vírgenes (EE.UU.)',il:'Israel',it:'Italia',jm:'Jamaica',jp:'Japón',je:'Jersey',jo:'Jordania',kz:'Kazajistán',ke:'Kenia',kg:'Kirguistán',ki:'Kiribati',kw:'Kuwait',la:'Laos',ls:'Lesoto',lv:'Letonia',lb:'Líbano',lr:'Liberia',ly:'Libia',li:'Liechtenstein',lt:'Lituania',lu:'Luxemburgo',mo:'Macao',mk:'Macedonia del Norte',mg:'Madagascar',my:'Malasia',mw:'Malaui',mv:'Maldivas',ml:'Malí',mt:'Malta',ma:'Marruecos',mq:'Martinica',mu:'Mauricio',mr:'Mauritania',mx:'México',fm:'Micronesia',md:'Moldavia',mc:'Mónaco',mn:'Mongolia',me:'Montenegro',ms:'Montserrat',mz:'Mozambique',mm:'Birmania',na:'Namibia',np:'Nepal',ni:'Nicaragua',ne:'Níger',ng:'Nigeria',no:'Noruega',nz:'Nueva Zelanda',nl:'Holanda',om:'Omán',pk:'Pakistán',pw:'Palaos',pa:'Panamá',pg:'Papúa Nueva Guinea',py:'Paraguay',pe:'Perú',pf:'Polinesia Francesa',pl:'Polonia',pt:'Portugal',pr:'Puerto Rico',gb:'Reino Unido',cf:'Rep. Centroafricana',do:'República Dominicana',re:'Reunión',rw:'Ruanda',ro:'Rumanía',ru:'Rusia',eh:'Sáhara Occidental',ws:'Samoa',kn:'San Cristóbal y Nieves',sm:'San Marino',mf:'San Martín',pm:'San Pedro y Miquelón',vc:'San Vicente y las Granadinas',sh:'Santa Elena',lc:'Santa Lucía',st:'Santo Tomé y Príncipe',sn:'Senegal',rs:'Serbia',sc:'Seychelles',sl:'Sierra Leona',sg:'Singapur',sx:'Sint Maarten',sy:'Siria',so:'Somalia',lk:'Sri Lanka',za:'Sudáfrica',sd:'Sudán',ss:'Sudán del Sur',se:'Suecia',ch:'Suiza',sr:'Surinam',th:'Tailandia',tw:'Taiwán',tz:'Tanzania',tj:'Tayikistán',tg:'Togo',to:'Tonga',tt:'Trinidad y Tobago',tn:'Túnez',tm:'Turkmenistán',tr:'Turquía',tv:'Tuvalu',ua:'Ucrania',ug:'Uganda',uy:'Uruguay',uz:'Uzbekistán',vu:'Vanuatu',va:'Ciudad del Vaticano',ve:'Venezuela',vn:'Vietnam',ye:'Yemen',dj:'Yibuti',zm:'Zambia',zw:'Zimbabue'};
var ISO3_PAIS={rus:'Rusia',usa:'Estados Unidos',mex:'México',col:'Colombia',pan:'Panamá',ven:'Venezuela',gtm:'Guatemala',hnd:'Honduras',nic:'Nicaragua',cri:'Costa Rica',slv:'El Salvador',dom:'República Dominicana',ecu:'Ecuador',per:'Perú',chl:'Chile',arg:'Argentina',bra:'Brasil',ury:'Uruguay',pry:'Paraguay',bol:'Bolivia',cub:'Cuba',jam:'Jamaica',hti:'Haití',guy:'Guyana',sur:'Surinam',tto:'Trinidad y Tobago',chn:'China',esp:'España',can:'Canadá'};
var LOCAL_PAIS={zl:'Zona Libre',zlc:'Zona Libre de Colón'};
var LOCAL_FLAG={zl:'pa',zlc:'pa',rus:'ru'};
function paisNombre(country){
  if(!country) return '';
  var c=(''+country).trim(); if(!c) return '';
  var k=c.toLowerCase();
  if(LOCAL_PAIS[k]) return LOCAL_PAIS[k];
  if(/^[A-Za-z]{2}$/.test(c)) return ISO2_PAIS[k] || c.toUpperCase();
  if(/^[A-Za-z]{3}$/.test(c) && ISO3_PAIS[k]) return ISO3_PAIS[k];
  return c;
}
var HAKOL_ICO='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAE5ElEQVR4Aa2XA5ckSxCF+/88Hq1tjbW2bXtss5dj217bxpgPq7aqY/NWr7N6qhZxTra77peRoVIRUR85TDPUEgRB09fXb7hy9Zq5uLTcdvJ0upCUkmpPTE6zq0+ctucVFNlaz1+wvHjZZrRarVr8R2bB+lTiGxm7fecuxcQlUGhEFIWER1JYZDRFxsRRVGy8uPA6PCqGQtj3gSFhdCY9kxgwKTCNLMDLtjY6FhAEAYjJrlgGGhAcSm3t7b8G4PyFi9i1InF4KTgsgiKYR/R6g2MDL9uor6/vxwEuXrxEoZHRisQBGhQawcT1ZDKZaMGCReTm5kHu7l508OAhMpvNQwPY7XasrwEuXcbZy4njN0w8nLRanXiNOXNcycXFjebNW0B+fvNpypTpdPTocXwnDQC6y5ev8B64dEUWAPFxPDCE3r59RzBvb18RAB4AABZejx8/ifLz86UBKiuraePGLTIA/M4jomPp8LEAevPmDTFjQotp1qw5H8W/Wr6+82jChEn04sWLrwF0Op34p+DgEA6guaUVaeZU/NAxf/rv1SuCrV65hmbOnC0pjjV//kJRZ8eOXTiKzwDY/dix4yklJZUDaGxqhhgnHs7Ej/oHUv/gIME2b95G06bNlBDnISZOnEy3bt12ANhsNu2mTVtB7gSghROP/HDmfQMO8a1bt4lBtnDhYojIAsye7cKy4rAD4Nmz5wZ84OHhpQgAbj8eFEKdXd0EO3z4CE2erEz840JWuLi4U1dXt15VW1tvhus8Pb0VARw5HkBtbe0EC2AVctKkKZzblXhh+vRZVF9fb1bFxcXbXFxcRYDk5JQhAQ6yPH767BnBoqKi2c6n4mKcgJKFNI2PT7Cpdu/eKyBvHUegdgqAnd+4eZNgocGh2PkPi2NBc+fO3YJq3boNduQn4iA9PZMDaGhsQTNiPeESfTQEECJZxvWycbBq1Ro7A1jPAOaL+ZmRkcUB5BUWUz5bXxpyeM+evYh8eQg5gL179wteXj4MQNoDXT09xAYM7vOPzYYrPAqXj89cVpB2Ch+C0I0/AnlD+UU0s4By+24IaEZERNnENMRFHADpnMjjJ0/EKceEViph/f0DqO+s5Xp+FwQ8V1JSalG1t3cYII6UKigo4gTq6hvInxWe02edj1lPnz5FKWep7KM4MxBzjx8/MaAUa9av30jDh4+isrJyyTSMjU+koywTikvLyJldu3adxo2bgI4nCwFvLV++kiwWi1ZsRg0NDfT7739TUVGxJMDHHnD4eICYlk6MbaCCxowZN6Q4jglHxo7+czfECOXq6k7+/gGypfjwMX9WkG6RM0tPz2KDx0RJL+Az7B5a0PxqIKmoqGRuWSULgNngECvJjx4/IWcWHBwqWagAAA9dvXqNn4iQ1zdu3FDUjjGCYQrq6eklKUOw7tq1B13yEwS6JaDCwyOUTMUcAAeBSRkx8f///5OUYcZcunQ56gQCE88Y+RB4Pw4gdQ/gHxRKGq1WeujXaMRox2i+Zs1a0vK/kweoq2+CmCQE0hNFKowdCY5QyrDjV69eceVcMcCdu/dQiBB8TiHwfar6FLGaQgpNOQACqrSsEjekuPPBiI6xjAM5cOQYlVdW/wCAwttzHTPWF0z1jU3WrJw8IU19Srw1T0pR20+dyRDSM7KFJ0+fmbj/ytyevwef2DwoGaG9wQAAAABJRU5ErkJggg==';
var HAKOL_ICO_IMG='<img src="'+HAKOL_ICO+'" alt="HAKOL" title="HAKOL" style="width:18px;height:18px;vertical-align:middle;border-radius:3px;margin-right:5px;object-fit:contain">';
// ── Banderas dibujadas aqui mismo, sin pedir nada a internet ──────────────
// Antes venian de flagcdn.com; en redes con firewall eso no carga y los
// botones quedaban en blanco. Son SVG simples: colores y formas, sin escudos.
var BANDERA_DEF={
  MX:'v|#006847,#ffffff,#ce1126', GT:'v|#4997d0,#ffffff,#4997d0',
  PE:'v|#d91023,#ffffff,#d91023', GF:'v|#002395,#ffffff,#ed2939',
  GP:'v|#002395,#ffffff,#ed2939', MQ:'v|#002395,#ffffff,#ed2939',
  SV:'h|#0f47af,#ffffff,#0f47af', HN:'h|#0073cf,#ffffff,#0073cf',
  NI:'h|#0067c6,#ffffff,#0067c6', AR:'h|#74acdf,#ffffff,#74acdf',
  VE:'h|#ffcc00,#00247d,#cf142b', BO:'h|#d52b1e,#f9e300,#007934',
  PY:'h|#d52b1e,#ffffff,#0038a8', HT:'h|#00209f,#d21034',
  CO:'p|#fcd116:7,#003893:3.5,#ce1126:3.5', EC:'p|#ffdd00:7,#0072ce:3.5,#ef3340:3.5',
  CR:'p|#002b7f:2.5,#ffffff:2,#ce1126:5,#ffffff:2,#002b7f:2.5',
  SR:'p|#377e3f:3,#ffffff:2,#b40a2d:4,#ffffff:2,#377e3f:3',
  // Fuera de la region, por si algun cliente o proveedor los usa
  ES:'p|#aa151b:3.5,#f1bf00:7,#aa151b:3.5', IT:'v|#008c45,#f4f5f0,#cd212a',
  FR:'v|#002395,#ffffff,#ed2939',           NL:'h|#ae1c28,#ffffff,#21468b',
  DE:'h|#000000,#dd0000,#ffce00',           RU:'h|#ffffff,#0039a6,#d52b1e',
  PT:'v|#046a38:8,#da291c:12',              BE:'v|#000000,#fdda24,#ef3340',
  IE:'v|#169b62,#ffffff,#ff883e',           CO_:'',
  AT:'h|#ed2939,#ffffff,#ed2939',           PL:'h|#ffffff,#dc143c',
  // Paises que aparecen en la cartera de Kennedy
  GN:'v|#ce1126,#fcd116,#009460',           CI:'v|#f77f00,#ffffff,#009e60',
  SK:'h|#ffffff,#0b4ea2,#ee1c25',           IC:'v|#ffffff,#0071ce,#ffe500',
  MF:'v|#002395,#ffffff,#ed2939',           BY:'p|#c8313e:9,#4aa657:5',
  AO:'h|#cc092f,#000000'
};

function _bndStar(cx,cy,r,fill){
  var p='';
  for(var i=0;i<5;i++){
    var a=(Math.PI/180)*(72*i-90), b=(Math.PI/180)*(72*i-90+36);
    p+=(i?'L':'M')+(cx+r*Math.cos(a)).toFixed(2)+','+(cy+r*Math.sin(a)).toFixed(2)
      +'L'+(cx+r*0.4*Math.cos(b)).toFixed(2)+','+(cy+r*0.4*Math.sin(b)).toFixed(2);
  }
  return '<path d="'+p+'Z" fill="'+fill+'"/>';
}

function _bndFranjas(dir, defs){
  var tot=0, out='', pos=0;
  defs.forEach(function(d){ tot+=d.w; });
  defs.forEach(function(d){
    var tam=(dir==='h'? 14 : 20)*d.w/tot;
    out += dir==='h'
      ? '<rect x="0" y="'+pos.toFixed(2)+'" width="20" height="'+(tam+0.02).toFixed(2)+'" fill="'+d.c+'"/>'
      : '<rect x="'+pos.toFixed(2)+'" y="0" width="'+(tam+0.02).toFixed(2)+'" height="14" fill="'+d.c+'"/>';
    pos+=tam;
  });
  return out;
}

function banderaSVG(iso, ancho){
  var g='', d=BANDERA_DEF[iso];
  if(d){
    var pr=d.split('|'), dir=(pr[0]==='v'?'v':'h');
    var defs=pr[1].split(',').map(function(x){
      var q=x.split(':'); return {c:q[0], w:q[1]?Number(q[1]):1};
    });
    g=_bndFranjas(dir, defs);
  } else {
    switch(iso){
      case 'US':
        g='<rect width="20" height="14" fill="#fff"/>';
        for(var i=0;i<13;i+=2) g+='<rect x="0" y="'+(i*14/13).toFixed(2)+'" width="20" height="'+(14/13+0.02).toFixed(2)+'" fill="#b22234"/>';
        g+='<rect width="8.5" height="7.54" fill="#3c3b6e"/>';
        break;
      case 'CA':
        g='<rect width="20" height="14" fill="#fff"/><rect width="5" height="14" fill="#d52b1e"/>'
         +'<rect x="15" width="5" height="14" fill="#d52b1e"/>'
         +'<path d="M10 3.2l.9 2.1 2.1-.6-1.1 2 1.6 1-2.1.5.2 1.3-1.6-1-1.6 1 .2-1.3-2.1-.5 1.6-1-1.1-2 2.1.6z" fill="#d52b1e"/>';
        break;
      case 'PA':
        g='<rect width="20" height="14" fill="#fff"/><rect x="10" width="10" height="7" fill="#da121a"/>'
         +'<rect y="7" width="10" height="7" fill="#072357"/>'+_bndStar(5,3.5,2.1,'#072357')+_bndStar(15,10.5,2.1,'#da121a');
        break;
      case 'CU': case 'PR':
        var az=(iso==='CU')?'#002a8f':'#ed0000', tri=(iso==='CU')?'#cf142b':'#0050f0';
        g='<rect width="20" height="14" fill="#fff"/>';
        for(var j=0;j<5;j+=2) g+='<rect x="0" y="'+(j*2.8).toFixed(2)+'" width="20" height="2.82" fill="'+az+'"/>';
        g+='<path d="M0 0L8.5 7L0 14Z" fill="'+tri+'"/>'+_bndStar(2.8,7,1.7,'#fff');
        break;
      case 'DO':
        g='<rect width="20" height="14" fill="#002d62"/><rect x="10" width="10" height="7" fill="#ce1126"/>'
         +'<rect y="7" width="10" height="7" fill="#ce1126"/>'
         +'<rect x="8.6" width="2.8" height="14" fill="#fff"/><rect y="5.6" width="20" height="2.8" fill="#fff"/>';
        break;
      case 'BR':
        g='<rect width="20" height="14" fill="#009b3a"/><path d="M10 1.3L18.7 7L10 12.7L1.3 7Z" fill="#fedf00"/>'
         +'<circle cx="10" cy="7" r="3.1" fill="#002776"/>';
        break;
      case 'CL':
        g='<rect width="20" height="14" fill="#fff"/><rect y="7" width="20" height="7" fill="#d52b1e"/>'
         +'<rect width="7" height="7" fill="#0039a6"/>'+_bndStar(3.5,3.5,2,'#fff');
        break;
      case 'UY':
        g='<rect width="20" height="14" fill="#fff"/>';
        for(var k=1;k<9;k+=2) g+='<rect x="8" y="'+(k*14/9).toFixed(2)+'" width="12" height="'+(14/9+0.02).toFixed(2)+'" fill="#0038a8"/>';
        g+='<rect width="8" height="7.8" fill="#fff"/><circle cx="4" cy="3.9" r="1.9" fill="#fcd116"/>';
        break;
      case 'JM':
        g='<rect width="20" height="14" fill="#009b3a"/><path d="M0 0L10 7L0 14Z" fill="#000"/>'
         +'<path d="M20 0L10 7L20 14Z" fill="#000"/>'
         +'<path d="M0 0L1.8 0L20 12.6L20 14L18.2 14L0 1.4Z" fill="#fed100"/>'
         +'<path d="M20 0L18.2 0L0 12.6L0 14L1.8 14L20 1.4Z" fill="#fed100"/>';
        break;
      case 'TT':
        g='<rect width="20" height="14" fill="#da1a35"/><path d="M2.6 0L20 12.2L20 14L17.4 14L0 1.8L0 0Z" fill="#fff"/>'
         +'<path d="M4.2 0L20 11.1L20 12.9L15.8 14L0 3L0 1Z" fill="#000"/>';
        break;
      case 'BS':
        g='<rect width="20" height="14" fill="#00abc9"/><rect y="4.67" width="20" height="4.66" fill="#fae042"/>'
         +'<path d="M0 0L8 7L0 14Z" fill="#000"/>';
        break;
      case 'AW':
        g='<rect width="20" height="14" fill="#418fde"/><rect y="9.6" width="20" height="1.2" fill="#f9e814"/>'
         +'<rect y="11.6" width="20" height="1.2" fill="#f9e814"/>'+_bndStar(4,4,2.1,'#ef3340');
        break;
      case 'CW':
        g='<rect width="20" height="14" fill="#002b7f"/><rect y="9.4" width="20" height="2.2" fill="#f9e814"/>'
         +_bndStar(3.6,3.4,1.5,'#fff')+_bndStar(6.6,5.6,1.1,'#fff');
        break;
      case 'BZ':
        g='<rect width="20" height="14" fill="#003f87"/><rect width="20" height="2" fill="#ce1126"/>'
         +'<rect y="12" width="20" height="2" fill="#ce1126"/><circle cx="10" cy="7" r="4" fill="#fff"/>';
        break;
      case 'GY':
        g='<rect width="20" height="14" fill="#009e49"/><path d="M0 0L20 7L0 14Z" fill="#fcd116"/>'
         +'<path d="M0 0L11 7L0 14Z" fill="#ce1126"/>';
        break;
      case 'IL':
        g='<rect width="20" height="14" fill="#fff"/><rect y="1.6" width="20" height="1.8" fill="#0038b8"/>'
         +'<rect y="10.6" width="20" height="1.8" fill="#0038b8"/>'
         +'<path d="M10 4L12.3 8.2L7.7 8.2Z" fill="none" stroke="#0038b8" stroke-width="0.7"/>'
         +'<path d="M10 10L7.7 5.8L12.3 5.8Z" fill="none" stroke="#0038b8" stroke-width="0.7"/>';
        break;
      case 'HK':
        g='<rect width="20" height="14" fill="#de2910"/><circle cx="10" cy="7" r="3.2" fill="#fff"/>'
         +'<circle cx="10" cy="7" r="1.1" fill="#de2910"/>';
        break;
      case 'MO':
        g='<rect width="20" height="14" fill="#00785e"/><circle cx="10" cy="7.5" r="2.6" fill="#fbd116"/>'
         +_bndStar(10,3,1.1,'#fbd116');
        break;
      case 'TW':
        g='<rect width="20" height="14" fill="#fe0000"/><rect width="10" height="7" fill="#000095"/>'
         +'<circle cx="5" cy="3.5" r="2.1" fill="#fff"/><circle cx="5" cy="3.5" r="1.2" fill="#000095"/>';
        break;
      case 'KE':
        g='<rect width="20" height="14" fill="#fff"/><rect width="20" height="4" fill="#000"/>'
         +'<rect y="5" width="20" height="4" fill="#bb0000"/><rect y="10" width="20" height="4" fill="#006600"/>'
         +'<ellipse cx="10" cy="7" rx="1.9" ry="3.4" fill="#bb0000" stroke="#fff" stroke-width="0.5"/>';
        break;
      case 'MZ':
        g='<rect width="20" height="14" fill="#fff"/><rect width="20" height="4.4" fill="#009a44"/>'
         +'<rect y="5" width="20" height="4" fill="#000"/><rect y="9.6" width="20" height="4.4" fill="#fcd116"/>'
         +'<path d="M0 0L7 7L0 14Z" fill="#d21034"/>'+_bndStar(2.3,7,1.4,'#fff');
        break;
      case 'LB':
        g='<rect width="20" height="14" fill="#fff"/><rect width="20" height="3.5" fill="#ee161f"/>'
         +'<rect y="10.5" width="20" height="3.5" fill="#ee161f"/>'
         +'<path d="M10 4.4L12.4 9.2L7.6 9.2Z" fill="#00a850"/>';
        break;
      case 'NE':
        g='<rect width="20" height="14" fill="#fff"/><rect width="20" height="4.66" fill="#e05206"/>'
         +'<rect y="9.34" width="20" height="4.66" fill="#0db02b"/><circle cx="10" cy="7" r="1.9" fill="#e05206"/>';
        break;
      case 'JE':
        g='<rect width="20" height="14" fill="#fff"/><path d="M0 0L20 14M20 0L0 14" stroke="#cf142b" stroke-width="2.2"/>';
        break;
      case 'BN':
        g='<rect width="20" height="14" fill="#f7e017"/><path d="M0 3.4L20 9.2V11.6L0 5.8Z" fill="#fff"/>'
         +'<path d="M0 5.8L20 11.6V14L0 8.2Z" fill="#000"/><circle cx="10" cy="7" r="1.7" fill="#cf1126"/>';
        break;
      case 'AN':
        g='<rect width="20" height="14" fill="#fff"/><rect y="5.4" width="20" height="3.2" fill="#0033a0"/>'
         +'<rect x="8.4" width="3.2" height="14" fill="#c8102e"/>';
        break;
      case 'CN':
        g='<rect width="20" height="14" fill="#de2910"/>'+_bndStar(4.5,4,2.4,'#ffde00')
         +_bndStar(8.5,1.8,0.9,'#ffde00')+_bndStar(9.9,3.6,0.9,'#ffde00')
         +_bndStar(9.9,5.9,0.9,'#ffde00')+_bndStar(8.5,7.5,0.9,'#ffde00');
        break;
      case 'JP':
        g='<rect width="20" height="14" fill="#fff"/><circle cx="10" cy="7" r="4.2" fill="#bc002d"/>';
        break;
      case 'IN':
        g='<rect width="20" height="14" fill="#ff9933"/><rect y="4.67" width="20" height="4.66" fill="#fff"/>'
         +'<rect y="9.33" width="20" height="4.67" fill="#138808"/>'
         +'<circle cx="10" cy="7" r="1.9" fill="none" stroke="#000080" stroke-width="0.5"/>';
        break;
      case 'GB':
        g='<rect width="20" height="14" fill="#00247d"/>'
         +'<path d="M0 0L20 14M20 0L0 14" stroke="#fff" stroke-width="2.8"/>'
         +'<path d="M0 0L20 14M20 0L0 14" stroke="#cf142b" stroke-width="1.6"/>'
         +'<path d="M10 0V14M0 7H20" stroke="#fff" stroke-width="4.6"/>'
         +'<path d="M10 0V14M0 7H20" stroke="#cf142b" stroke-width="2.6"/>';
        break;
      case 'TC': case 'KY': case 'VG': case 'BM': case 'MS': case 'AI':
      case 'AU': case 'NZ': case 'FK':
        g='<rect width="20" height="14" fill="#00247d"/><rect width="9" height="6.3" fill="#00247d"/>'
         +'<path d="M0 0L9 6.3M9 0L0 6.3" stroke="#fff" stroke-width="1.2"/>'
         +'<path d="M4.5 0V6.3M0 3.15H9" stroke="#fff" stroke-width="2"/>'
         +'<path d="M4.5 0V6.3M0 3.15H9" stroke="#cf142b" stroke-width="1.1"/>';
        break;
      default:
        return '';   // sin dibujo: se usa el codigo del pais
    }
  }
  var w=Number(ancho)||20;
  return '<svg viewBox="0 0 20 14" width="'+w+'" height="'+(w*0.7).toFixed(1)+'" style="border-radius:2px;box-shadow:0 0 0 1px rgba(0,0,0,.14);display:inline-block;vertical-align:middle;flex:0 0 auto">'+g+'</svg>';
}

function paisFlag(country){
  if(!country) return '';
  var c=(''+country).trim(); var k=c.toLowerCase(); var cc='';
  if(LOCAL_FLAG[k]) cc=LOCAL_FLAG[k];
  else if(/^[A-Za-z]{2}$/.test(c)) cc=k;
  else {
    var map={'PANAMA':'pa','PANAMÁ':'pa','COLOMBIA':'co','COSTA RICA':'cr','VENEZUELA':'ve','CUBA':'cu','ESTADOS UNIDOS':'us','USA':'us','MEXICO':'mx','MÉXICO':'mx','ECUADOR':'ec','PERU':'pe','PERÚ':'pe','CHILE':'cl','ARGENTINA':'ar','ESPAÑA':'es','GUATEMALA':'gt','HONDURAS':'hn','NICARAGUA':'ni','EL SALVADOR':'sv','REPUBLICA DOMINICANA':'do','REPÚBLICA DOMINICANA':'do','BRASIL':'br','BRAZIL':'br','CHINA':'cn','CANADA':'ca','CANADÁ':'ca','JAMAICA':'jm','GUYANA':'gy','SURINAM':'sr','HAITI':'ht','HAITÍ':'ht'};
    cc=(map[c.toUpperCase()]||'');
  }
  if(!cc) return '';
  // Antes esto pedia la imagen a flagcdn.com. En redes con firewall no cargaba
  // y las banderas salian en blanco por todo el portal, asi que ahora se
  // dibujan aqui mismo. Si el pais no tiene dibujo, se muestra su codigo.
  var iso=cc.toUpperCase();
  var svg=banderaSVG(iso, 20);
  if(svg) return '<span title="'+c+'" style="margin-right:5px;display:inline-block;vertical-align:middle">'+svg+'</span>';
  return '<span title="'+c+'" style="display:inline-block;vertical-align:middle;margin-right:5px;font-size:9px;font-weight:800;'
    +'padding:2px 4px;border-radius:3px;background:#EFF6FF;color:#2563EB;letter-spacing:.3px">'+iso+'</span>';
}
// Fila de contacto: solo lo que el cliente tenga. Los enlaces no abren la
// ficha (stopPropagation), para poder llamar o escribir de un clic.
function _cliContacto(c){
  var tel = c.cellular || c.phone1 || c.phone2 || '';
  var p=[];
  if(tel) p.push('<a href="tel:'+npEsc(String(tel).replace(/[^0-9+]/g,''))+'" onclick="event.stopPropagation()" '
    +'style="color:var(--blue2);text-decoration:none" title="Llamar">\u260e '+npEsc(tel)+'</a>');
  if(c.e_mail) p.push('<a href="mailto:'+npEsc(c.e_mail)+'" onclick="event.stopPropagation()" '
    +'style="color:var(--blue2);text-decoration:none" title="Escribir">\u2709 '+npEsc(String(c.e_mail).substring(0,26))+'</a>');
  if(c.cntctprsn) p.push('<span style="color:var(--text3)" title="Persona de contacto">\u{1F464} '+npEsc(c.cntctprsn)+'</span>');
  if(!p.length) return '<span style="color:var(--text3)">Sin datos de contacto</span>';
  return p.join('<span style="color:var(--border)"> | </span>');
}

var cliAnoF='', cliMontoF='';

// Tramos de total facturado. El segundo valor null = sin tope.
var CLI_MONTOS={
  '0'      : [0,       1000],
  '1k'     : [1000,    10000],
  '10k'    : [10000,   50000],
  '50k'    : [50000,   100000],
  '100k'   : [100000,  200000],
  '200k'   : [200000,  500000],
  '500k'   : [500000,  null]
};

var _CP_SEQ=0;

// Rellena el bloque de perfil de cada ficha ya pintada. Va aparte porque
// renderClientes es sincrona y los datos vienen de otra tabla.
function _cliPerfilFill(tid, filas){
  (filas||[]).forEach(function(p, i){
    var box=document.getElementById('cp-'+tid+'-'+i); if(!box) return;
    if(!p || (!p.ultima_compra && !Number(p.total_historico))){
      box.innerHTML='<div class="cc-stat" style="grid-column:1/-1"><label>Historial</label>'
        +'<span style="font-size:11px;color:var(--text3)">Sin compras registradas</span></div>';
      return;
    }

    // Antiguedad de la ultima compra, en color segun lo lejos que quede.
    var ms=Number(p.meses_sin_comprar);
    var col = !isFinite(ms) ? 'var(--text3)'
            : (ms>=12 ? 'var(--red)' : (ms>=6 ? 'var(--amber)' : 'var(--green)'));
    var ult = p.ultima_compra ? String(p.ultima_compra).substring(0,7) : '—';   // AAAA-MM
    var txtU = !p.ultima_compra ? 'Nunca'
             : (ms<=0 ? ('Este mes ('+ult+')')
                      : (ms+' mes'+(ms===1?'':'es')+' \u00b7 '+ult));

    // Compras del ano, con la flecha de como va contra el ano anterior.
    var t12=Number(p.total_12m)||0, tpr=Number(p.total_12m_previos)||0;
    var flecha='';
    if(tpr>0){
      var dif=(t12-tpr)/tpr*100;
      var cf = dif>=5 ? 'var(--green)' : (dif<=-5 ? 'var(--red)' : 'var(--text3)');
      flecha=' <span style="color:'+cf+'">'+(dif>=0?'\u25b2':'\u25bc')+Math.abs(Math.round(dif))+'%</span>';
    }

    var tipo = p.tipo_principal
      ? ((typeof subgLabel==='function' ? subgLabel(p.tipo_principal) : p.tipo_principal)
         + (p.tipo_principal_pct!=null ? (' \u00b7 '+Math.round(p.tipo_principal_pct)+'%') : ''))
      : '\u2014';

    box.innerHTML =
       '<div class="cc-stat"><label>Ultima compra</label>'
      +'<span style="font-size:11px;font-weight:600;color:'+col+'">'+txtU+'</span></div>'
      +'<div class="cc-stat"><label>Compras 12m</label>'
      +'<span style="font-size:11px;font-weight:600">'+fmt(t12)+flecha+'</span></div>'
      +'<div class="cc-stat"><label>Compra sobre todo</label>'
      +'<span style="font-size:11px" title="Tipo de mercancia con mas compras">'+npEsc(String(tipo))+'</span></div>'
      +'<div class="cc-stat"><label>Total facturado</label>'
      +'<span style="font-size:11px;font-weight:600">'+fmt(Number(p.total_historico)||0)+'</span></div>';
  });
}

function renderClientes(data, append){
  var _tid = (++_CP_SEQ);
  var _h = data.length ? data.map((c,_i)=>`
    <div class="cc" onclick="verCliente('${c.cardcode}')">
      <div class="cc-top">
        <div class="cc-av">${ini(c.cardname)}</div>
        <div><div class="cc-name">${paisFlag(c.country)}${c.cardname}</div><div class="cc-code">${c.cardcode} · ${c.city||''}</div></div>
      </div>
      <div class="cc-stats">
        <div class="cc-stat"><label>Saldo</label><span>${fmt(c.balance)}</span></div>
        <div class="cc-stat"><label>Limite</label><span>${fmt(c.creditline)}</span></div>
        <div class="cc-stat"><label>Vendedor</label><span style="font-size:11px">${c.nombrevendedor||'—'}</span></div>
      </div>
      <div class="cc-stats" id="cp-${_tid}-${_i}" style="border-top:1px dashed var(--border);padding-top:8px;margin-top:2px">
        <div class="cc-stat"><label>Ultima compra</label><span style="font-size:11px;color:var(--text3)">…</span></div>
        <div class="cc-stat"><label>Compras 12m</label><span style="font-size:11px;color:var(--text3)">…</span></div>
        <div class="cc-stat"><label>Compra sobre todo</label><span style="font-size:11px;color:var(--text3)">…</span></div>
      </div>
      <div style="font-size:11px;padding-top:7px;display:flex;gap:6px;flex-wrap:wrap;align-items:center">
        ${_cliContacto(c)}
      </div>
    </div>`).join('') : '';
  if(append){ var _s=document.getElementById('cli-sentinel'); if(_s)_s.remove(); $('cli-grid').insertAdjacentHTML('beforeend', _h); }
  else{ $('cli-grid').innerHTML = _h || empty('Sin resultados'); }
  var _pg=$('cli-pager'); if(_pg && !append)_pg.innerHTML='';
  _cliPerfilFill(_tid, data);
  cliHasNext=(data.length===PAGE_SIZE); cliLoadingMore=false;
  _infScroll('cli-grid','cli-sentinel',cliHasNext,function(){ if(!cliLoadingMore&&cliHasNext){ cliLoadingMore=true; cliPage++; loadClientes(true); } });
}

let cliSearchTimer = null;
// Ordena los candidatos: primero el codigo exacto, luego los que empiezan por
// lo escrito, y al final los que solo lo contienen. Sin esto, pedir 8 filas a
// PostgREST devolvia 8 cualesquiera y el cliente exacto podia quedar fuera:
// buscar 2273 sacaba 12273, 22273, 22731... y justo el 2273 no aparecia.
function _cliRank(c, v){
  var cod=String(c.cardcode||'').toLowerCase();
  var nom=String(c.cardname||'').toLowerCase();
  if(cod===v) return 0;                                   // codigo exacto
  if(cod.replace(/^[a-z]+/,'')===v) return 1;             // exacto ignorando el prefijo (C2273)
  if(cod.indexOf(v)===0) return 2;                        // el codigo empieza igual
  if(nom===v) return 3;
  if(nom.indexOf(v)===0) return 4;                        // el nombre empieza igual
  if(cod.indexOf(v)>=0) return 5;
  return 6;
}

function searchClientes(val){
  clearTimeout(cliSearchTimer);
  const drop=$('cli-drop');
  if(val.length<2){drop.classList.remove('show');drop.innerHTML='';return;}
  drop.innerHTML=`<div class="ac-searching"><div class="spinner"></div> Buscando...</div>`;
  drop.classList.add('show');
  cliSearchTimer = setTimeout(async()=>{
    histAdd('cli',val); histRender('cli');
    const v=String(val).trim().toLowerCase(), ve=encodeURIComponent(val.trim());
    const campos='select=cardcode,cardname,city,balance&cardtype=eq.C';

    // Dos consultas: la del codigo exacto va aparte, para que no dependa del
    // corte de la busqueda amplia. Se piden 40 y se recortan tras ordenar.
    const [exacto, amplio] = await Promise.all([
      q('clientes',`${campos}&cardcode=ilike.${ve}&limit=3`),
      q('clientes',`${campos}&or=(cardname.ilike.*${ve}*,cardcode.ilike.*${ve}*)&limit=40`)
    ]);

    // Tambien se busca en NAPA: son clientes de la otra empresa y se pueden
    // consultar desde aqui, aunque sus pedidos entren bajo el codigo paraguas.
    var napa=[];
    try{
      if(typeof npBuscarNapa==='function') napa=await npBuscarNapa(val)||[];
    }catch(e){}

    const vistos={}, todos=[];
    (exacto||[]).concat(amplio||[]).forEach(function(c){
      if(!c || vistos[c.cardcode]) return;
      vistos[c.cardcode]=1; todos.push(c);
    });
    // Los de NAPA van primero: si el codigo coincide con uno de Kennedy, este
    // ya esta en la lista y aquel se distingue por la etiqueta.
    napa.forEach(function(c){ c.napa=true; });
    todos.sort(function(a,b){
      var d=_cliRank(a,v)-_cliRank(b,v);
      return d!==0 ? d : String(a.cardname||'').localeCompare(String(b.cardname||''));
    });
    const data=napa.concat(todos).slice(0,10);

    drop.innerHTML = data.length ? data.map(c=>`
      <div class="ac-item" onclick="${c.napa?`verClienteNapa('${c.cardcode}')`:`verCliente('${c.cardcode}')`};$('cli-drop').classList.remove('show');$('cli-search').value=''">
        <div class="ac-av"${c.napa?' style="background:#7C3AED"':''}>${ini(c.cardname)}</div>
        <div class="ac-info"><p>${c.cardname}${c.napa?'<span style="background:#7C3AED;color:#fff;padding:1px 6px;border-radius:8px;font-size:10px;font-weight:700;margin-left:6px;vertical-align:middle">NAPA</span>':''}</p><span>${c.cardcode} · ${c.city||''}${c.napa?'':' · '+fmt(c.balance)}</span></div>
      </div>`).join('') : `<div class="ac-searching">Sin resultados</div>`;
  },300);
}

// ══ GLOBAL SEARCH ══
function globalSearch(val){
  clearTimeout(gsTimer);
  const drop=$('gs-drop');
  if(val.length<2){drop.classList.remove('show');drop.innerHTML='';return;}
  drop.innerHTML=`<div class="ac-searching"><div class="spinner"></div> Buscando...</div>`;
  drop.classList.add('show');
  gsTimer=setTimeout(async()=>{
    // Tambien busca en NAPA: si no, este buscador dice "sin resultados" para
    // un cliente que el buscador de la pantalla de Clientes si encuentra.
    // Si lo escrito es un numero, tambien se busca como DOCUMENTO. Antes este
    // buscador solo miraba clientes e inventario, asi que teclear el numero de
    // un pedido que existe devolvia "Sin resultados".
    //
    // Va por igualdad, no por ilike: docnum es entero en Postgres y un ilike
    // sobre un entero da error 400 y tumba la busqueda entera.
    const _n = val.trim();
    const _esDoc = /^\d{3,10}$/.test(_n);

    const [clisK,items,clisN,peds,facs] = await Promise.all([
      q('clientes',`select=cardcode,cardname,city&cardtype=eq.C&or=(cardname.ilike.*${encodeURIComponent(val)}*,cardcode.ilike.*${encodeURIComponent(val)}*)&limit=5`),
      q('inventario',`select=itemcode,itemname,disponible,picturname,foto_url&or=(itemname.ilike.*${encodeURIComponent(val)}*,itemcode.ilike.*${encodeURIComponent(val)}*)&limit=5`),
      (typeof npBuscarNapa==='function' ? npBuscarNapa(val) : Promise.resolve([])),
      // `pedidos` y `facturas` traen una fila por LINEA: basta con una.
      _esDoc ? q('pedidos',`select=docnum,cardcode,cardname,docdate,doctotal&docnum=eq.${_n}&limit=1`).catch(()=>[]) : Promise.resolve([]),
      _esDoc ? q('facturas',`select=docnum,cardcode,cardname,docdate,doctotal&docnum=eq.${_n}&limit=1`).catch(()=>[]) : Promise.resolve([])
    ]);
    // Los de NAPA van primero, como en el resto del portal.
    const clis = (clisN||[]).slice(0,5).concat(clisK||[]).slice(0,8);
    let html='';
    if(clis.length) html+=`<div style="padding:6px 14px;font-size:10px;color:var(--text3);text-transform:uppercase;letter-spacing:.06em">Clientes</div>`+clis.map(c=>`<div class="ac-item" onclick="${c.napa?`verClienteNapa('${c.cardcode}')`:`verCliente('${c.cardcode}')`};$('gsearch').value='';$('gs-drop').classList.remove('show')"><div class="ac-av">${ini(c.cardname)}</div><div class="ac-info"><p>${c.cardname}${c.napa?'<span style=\"background:#7C3AED;color:#fff;padding:1px 6px;border-radius:8px;font-size:9.5px;font-weight:700;margin-left:5px\">NAPA</span>':''}</p><span>${c.cardcode} · ${c.city||''}</span></div></div>`).join('');
    if(items.length) html+=`<div style="padding:6px 14px;font-size:10px;color:var(--text3);text-transform:uppercase;letter-spacing:.06em">Productos</div>`+items.map(i=>`<div class="ac-item" onclick="verItem('${i.itemcode}');$('gsearch').value='';$('gs-drop').classList.remove('show')">${fotoThumb(i.picturname, i.foto_url)}<div class="ac-info"><p>${i.itemname}</p><span>${i.itemcode} · Stock: ${fmtN(i.disponible)}</span></div></div>`).join('');
    // Los documentos van PRIMERO: si alguien teclea un numero de seis cifras,
    // es lo que esta buscando.
    const _docs=[].concat(
      (peds||[]).map(d=>Object.assign({},d,{_t:'Pedido',_f:'verPedido'})),
      (facs||[]).map(d=>Object.assign({},d,{_t:'Factura',_f:'verFactura'})));
    if(_docs.length){
      html=`<div style="padding:6px 14px;font-size:10px;color:var(--text3);text-transform:uppercase;letter-spacing:.06em">Documentos</div>`
        +_docs.map(d=>`<div class="ac-item" onclick="${d._f}(${d.docnum});$('gsearch').value='';$('gs-drop').classList.remove('show')"><div class="ac-av" style="background:${d._t==='Pedido'?'#2563EB':'#0F766E'}">${d._t[0]}</div><div class="ac-info"><p>${d._t} #${d.docnum}</p><span>${(d.cardname||d.cardcode||'')} · ${fmtD(d.docdate)} · ${fmt(d.doctotal)}</span></div></div>`).join('')
        +html;
    }

    drop.innerHTML = html||`<div class="ac-searching">Sin resultados</div>`;
  },300);
}
document.addEventListener('click',e=>{if(!e.target.closest('.ac-wrap')){document.querySelectorAll('.ac-drop').forEach(d=>d.classList.remove('show'))}});

// ══ FOTOS ══
function fotoUrl(foto_url, picturname){
  // 1) Imagen de SAP (Supabase Storage): base + picturname TAL CUAL está en el bucket.
  //    (fotoPair/fotoFallback prueban variantes de mayús/minús; aquí usamos el nombre exacto)
  if(FOTO_BASE && picturname){ return FOTO_BASE + encodeURIComponent(String(picturname).trim()); }
  // 2) Respaldo: foto de Shopify (para items que no tengan picturname)
  if(foto_url) return foto_url;
  return null;
}
function fotoPair(picturname, foto_url){
  // Genera la URL primaria + una lista de respaldos para cubrir las diferencias de
  // mayúsculas en el bucket (unos archivos están .jpg, otros .JPG, nombre en mayús/minús).
  // Orden de intento: nombre TAL CUAL, minúscula, mayúscula, y por último la de Shopify.
  var shop=foto_url||'';
  var pn=(picturname||'').toString().trim();
  var variantes=[];
  if(FOTO_BASE && pn){
    // Los nombres con espacios o '#' no se pueden guardar tal cual en el
    // bucket (Supabase los rechaza), asi que el sync los sanea antes de
    // subirlos. Aqui se aplica la MISMA regla, o las fotos que si estan
    // subidas no se encontrarian nunca.
    var limpio = pn.toLowerCase().replace(/[^a-z0-9._-]/g,'_');
    variantes.push(FOTO_BASE+encodeURIComponent(limpio));                 // como las sube el sync
    if(limpio!==pn) variantes.push(FOTO_BASE+encodeURIComponent(pn));     // por si alguna quedo con el nombre viejo
    if(pn.toLowerCase()!==pn && pn.toLowerCase()!==limpio) variantes.push(FOTO_BASE+encodeURIComponent(pn.toLowerCase()));
    if(pn.toUpperCase()!==pn) variantes.push(FOTO_BASE+encodeURIComponent(pn.toUpperCase()));
  }
  if(shop) variantes.push(shop);
  var primary=variantes.length?variantes[0]:'';
  // fb = lista de respaldos separada por "|" (fotoFallback la recorre)
  var fb=variantes.slice(1).join('|');
  return {primary:primary, fb:fb};
}
// ── Lightbox: zoom de fotos al hacer click ──────────────────
function imgZoom(url){
  if(!url) return;
  var ov=document.getElementById('img-zoom-ov');
  if(!ov){
    ov=document.createElement('div');
    ov.id='img-zoom-ov';
    ov.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.85);display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out;opacity:0;transition:opacity .15s';
    ov.onclick=function(){ ov.style.opacity='0'; setTimeout(function(){ov.style.display='none';},150); };
    ov.innerHTML='<img id="img-zoom-img" style="max-width:95vw;max-height:95vh;border-radius:8px;box-shadow:0 10px 40px rgba(0,0,0,.5);object-fit:contain">'
      +'<button aria-label="Cerrar" style="position:absolute;top:16px;right:20px;background:rgba(255,255,255,.15);color:#fff;border:none;border-radius:50%;width:40px;height:40px;font-size:22px;line-height:1;cursor:pointer">&times;</button>';
    document.body.appendChild(ov);
  }
  document.getElementById('img-zoom-img').src=url;
  ov.style.display='flex';
  requestAnimationFrame(function(){ ov.style.opacity='1'; });
}
document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ var ov=document.getElementById('img-zoom-ov'); if(ov&&ov.style.display!=='none'){ ov.style.opacity='0'; setTimeout(function(){ov.style.display='none';},150); } } });

function fotoFallback(img){
  // Recorre la lista de respaldos (data-fb, separada por "|") una por una.
  var fb=img.getAttribute('data-fb')||'';
  var lista=fb?fb.split('|'):[];
  var idx=parseInt(img.getAttribute('data-fbi')||'0',10);
  if(idx < lista.length){
    img.setAttribute('data-fbi', String(idx+1));
    img.src=lista[idx];
    return;
  }
  var ph=img.getAttribute('data-ph');
  if(ph==='card'){ img.parentElement.innerHTML='<div style="width:100%;height:140px;background:var(--bg);display:flex;align-items:center;justify-content:center;color:var(--text3)">Sin foto</div>'; }
  else if(ph==='item'){ img.outerHTML='<div style="width:100%;height:280px;background:var(--bg);border-radius:var(--r);display:flex;align-items:center;justify-content:center;font-size:48px">📦</div>'; }
  else { img.style.display='none'; }
}
// ══ ZOOM AL PASAR EL MOUSE POR UNA FOTO ══
// Muestra una vista grande flotante que sigue al cursor. El clic para ampliar
// a pantalla completa (imgZoom) sigue funcionando igual.
var _hvBox=null;
function _hvShow(img){
  if(!img || !img.src) return;
  if(!_hvBox){
    _hvBox=document.createElement('div');
    _hvBox.id='foto-hover';
    _hvBox.style.cssText='position:fixed;z-index:99999;pointer-events:none;display:none;'
      +'background:#fff;border:1px solid rgba(0,0,0,.14);border-radius:10px;'
      +'box-shadow:0 12px 40px rgba(0,0,0,.22);padding:5px';
    _hvBox.innerHTML='<img style="display:block;width:260px;height:260px;object-fit:contain;border-radius:6px">';
    document.body.appendChild(_hvBox);
  }
  var im=_hvBox.querySelector('img');
  if(im.src!==img.src) im.src=img.src;
  _hvBox.style.display='block';
}
function _hvMove(ev){
  if(!_hvBox || _hvBox.style.display==='none') return;
  var w=280, h=280, m=16;
  var x=ev.clientX+m, y=ev.clientY+m;
  // Si no cabe a la derecha o abajo, se coloca al otro lado del cursor.
  if(x+w>window.innerWidth)  x=ev.clientX-w-m;
  if(y+h>window.innerHeight) y=Math.max(m, window.innerHeight-h-m);
  _hvBox.style.left=x+'px';
  _hvBox.style.top=y+'px';
}
function _hvHide(){ if(_hvBox) _hvBox.style.display='none'; }
// Atributos que se pegan a cada <img> para activar el zoom.
var _HV_ATTRS=' onmouseenter="_hvShow(this)" onmousemove="_hvMove(event)" onmouseleave="_hvHide()"';

function lineFoto(picturname, foto_url){
  var f=fotoPair(picturname, foto_url); var url=f.primary;
  if(!url) return '<div style="width:40px;height:40px;border-radius:6px;background:var(--bg);display:flex;align-items:center;justify-content:center"><svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';
  return '<img src="'+url+'" data-fb="'+f.fb+'" data-ph="hide" onclick="imgZoom(this.src)" title="Pasa el mouse para ver grande \u00b7 click para ampliar"'+_HV_ATTRS+' style="width:40px;height:40px;border-radius:6px;object-fit:cover;cursor:zoom-in;border:1px solid var(--border)" onerror="fotoFallback(this)">';
}
function fotoThumb(picturname, foto_url){
  var f=fotoPair(picturname, foto_url); var url=f.primary;
  if(!url) return `<div style="width:32px;height:32px;border-radius:4px;background:var(--bg);display:flex;align-items:center;justify-content:center;flex-shrink:0"><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>`;
  return `<img src="${url}" data-fb="${f.fb}" data-ph="hide"${_HV_ATTRS} title="Pasa el mouse para ver grande" style="width:32px;height:32px;border-radius:4px;object-fit:cover;flex-shrink:0;cursor:zoom-in" onerror="fotoFallback(this)">`;
}
function fotoCard(picturname, foto_url){
  var f=fotoPair(picturname, foto_url); var url=f.primary;
  if(!url) return `<div class="icard-img-placeholder"><svg width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" style="color:var(--text3)"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>`;
  return `<div class="icard-img"><img src="${url}" data-fb="${f.fb}" data-ph="card" onerror="fotoFallback(this)"></div>`;
}

// ══ VER CLIENTE ══
var _ecCliMovs=[];
// Reparte los movimientos segun el rango: lo anterior a "desde" se arrastra
// como saldo inicial, lo posterior a "hasta" se deja fuera. Lo usan la tabla
// de pantalla Y el PDF, para que no se puedan desincronizar otra vez.
function ecCliRango(movs, desde, hasta){
  var ini=0, out=[];
  (movs||[]).forEach(function(m){
    var f=String(m.docdate||'').substring(0,10);
    if(desde && f < desde){ ini += Number(m.debito||0)-Number(m.credito||0); return; }
    if(hasta && f > hasta) return;
    out.push(m);
  });
  return {ini:ini, movs:out};
}

// Muestra 25 movimientos y el resto bajo demanda: un cliente antiguo puede
// tener cientos y la ficha se hacia interminable.
function ecCliTablaHTML(movs, desde, hasta){
  window._PM_eccli = function(){
    var c=document.getElementById('ec-cli-tabla');
    if(c) c.innerHTML = ecCliTablaHTML(_ecCliMovs, desde, hasta);
  };
  if(!movs||!movs.length) return empty('Sin movimientos');
  var r=ecCliRango(movs, desde, hasta);
  var ini=r.ini, filtered=r.movs;
  if(!filtered.length) return empty('Sin movimientos en ese rango');
  var saldo=ini;
  // Solo las que se han pedido ver. El saldo acumulado se calcula sobre
  // TODAS, asi que recortar aqui no altera las cifras.
  var _total = filtered.length;
  var _ver = (typeof pmVisibles==='function') ? pmVisibles('eccli') : 25;
  var rows=filtered.slice(0, _ver).map(function(m){
    saldo += Number(m.debito||0)-Number(m.credito||0);
    var fa=m.tipo==='FA';
    var tipoLbl=fa?'🧾 Factura'
      :(m.tipo==='NC'?'↩️ Nota crédito'
      :((m.tipo==='PC'||m.tipo==='ND')?'🧾 Nota débito'
      :(m.tipo==='RC'?'💵 Pago'
      :(m.tipo?('📄 '+m.tipo):'💵 Pago'))));
    var doc=fa?'<span style="color:var(--blue2);cursor:pointer" onclick="verFactura('+m.docnum+')"><u>#'+m.docnum+'</u></span>':'#'+m.docnum;
    return '<tr><td>'+fmtD(m.docdate)+'</td><td>'+tipoLbl+'</td><td>'+doc+'</td><td style="font-size:12px;color:var(--text3)">'+(m.comments||'')+'</td><td style="text-align:right">'+(m.debito?fmt(m.debito):'')+'</td><td style="text-align:right;color:var(--green)">'+(m.credito?fmt(m.credito):'')+'</td><td style="text-align:right;font-weight:600">'+fmt(saldo)+'</td></tr>';
  }).join('');
  return '<div style="text-align:right;font-size:13px;color:var(--text3);margin-bottom:8px">Saldo a la fecha: <b style="color:'+(saldo>0.005?'var(--red)':'var(--green)')+'">'+fmt(saldo)+'</b></div>'
    +'<table class="tbl"><tr><th>Fecha</th><th>Tipo</th><th>Doc</th><th>Comentario</th><th style="text-align:right">Debito</th><th style="text-align:right">Credito</th><th style="text-align:right">Saldo</th></tr>'
    +'<tr style="color:var(--text3)"><td colspan="6">Saldo inicial'+(desde?' (antes de '+fmtD(desde)+')':'')+'</td><td style="text-align:right">'+fmt(ini)+'</td></tr>'
    +rows+'</table>'
    + ((typeof pmPie==='function') ? pmPie('eccli', _total) : '');
}

function cliAgingLedger(movs){
  // Antiguedad desde el ledger con pagos aplicados FIFO a los cargos mas antiguos.
  // BUCKETS por FECHA DE DOCUMENTO (igual que el Estado de Cuenta de SAP).
  // maxDias / vencido por FECHA DE VENCIMIENTO (morosidad real, para credito y atrasados).
  var cargos=[], abono=0, hoy=new Date();
  (movs||[]).forEach(function(mv){
    var net=Number(mv.debito||0)-Number(mv.credito||0);
    if(net>0.005) cargos.push({fdoc:(mv.docdate||mv.docduedate), fdue:(mv.docduedate||mv.docdate), r:net});
    else if(net<-0.005) abono+=(-net);
  });
  cargos.sort(function(a,b){ return String(a.fdoc||'').localeCompare(String(b.fdoc||'')); });
  var pago=abono;
  cargos.forEach(function(c){ if(pago<=0.005) return; var a=Math.min(pago,c.r); c.r-=a; pago-=a; });
  var B=[0,0,0,0,0,0,0,0,0], tot=0, maxd=0, vnc=0;
  cargos.forEach(function(c){
    if(c.r<=0.005) return;
    var ddoc=c.fdoc?Math.floor((hoy-new Date(c.fdoc))/86400000):0; if(ddoc<0) ddoc=0;
    var idx=ddoc<=30?0:ddoc<=60?1:ddoc<=90?2:ddoc<=120?3:ddoc<=150?4:ddoc<=180?5:ddoc<=210?6:ddoc<=240?7:8;
    B[idx]+=c.r; tot+=c.r;
    var ddue=c.fdue?Math.floor((hoy-new Date(c.fdue))/86400000):0; if(ddue<0) ddue=0;
    if(ddue>maxd) maxd=ddue; if(ddue>0) vnc+=c.r;
  });
  return {B:B, total:tot, maxDias:maxd, vencido:vnc};
}

// "Imprimir estado de cuenta" saca el MISMO PDF que Generar PDF, pero sin
// aplicar los filtros de fecha que haya en pantalla: el estado de cuenta
// impreso debe ser el completo. Antes esto llamaba a window.print(), que
// mandaba a la impresora la pagina entera del portal, menus incluidos.
/* ══════════════════════════════════════════════════════════════════════════
   MANDAR EL ESTADO DE CUENTA POR WHATSAPP
   ---------------------------------------------------------------------------
   WhatsApp NO deja adjuntar un archivo desde un enlace: `wa.me` solo lleva
   texto. Y el PDF no se guarda en ningun servidor: un estado de cuenta es
   informacion sensible y, colgado de un enlace publico, sigue accesible
   mucho despues de haber dejado de ser cierto.

   Asi que el archivo no sale del aparato del vendedor:

     En el TELEFONO se comparte con el boton del sistema. WhatsApp lo recibe
     como documento, con el mensaje incluido. Un solo toque.

     En el ESCRITORIO se descarga y se abre WhatsApp Web con el mensaje ya
     escrito. El vendedor arrastra el PDF al chat. Son dos pasos, pero no
     queda copia en ningun sitio.

   El enlace de pago es generico y el cliente escribe el monto: por eso el
   mensaje dice cuanto debe, pero no lo impone.
   ══════════════════════════════════════════════════════════════════════════ */

var EC_LINK_PAGO = 'https://checkout.wompi.pa/l/VPOS_GSdQE6';

function ecCodigo(n){
  // Sin vocales ni caracteres que se confundan: el nombre del archivo puede
  // acabar dictandose por telefono.
  var a='23456789bcdfghjkmnpqrstvwxz', s='';
  var r=(window.crypto&&crypto.getRandomValues)
    ? crypto.getRandomValues(new Uint32Array(n||8)) : null;
  for(var i=0;i<(n||8);i++){
    s += a[(r ? r[i] : Math.floor(Math.random()*4e9)) % a.length];
  }
  return s;
}

// El PDF, a partir del MISMO HTML que genera "Imprimir estado de cuenta".
//
// Antes se armaba aparte con jsPDF y salia un documento distinto: otras
// columnas, otro formato. Dos versiones del mismo estado de cuenta es pedir
// que un dia no cuadren.
//
// Se pinta ese HTML fuera de la vista, se fotografia con html2canvas y se
// mete en el PDF. Mas lento que dibujarlo a mano, pero es EL MISMO
// documento, con sus totales y su formato.
var EC_H2C_URL = 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js';
var _ecH2CProm = null;

function ecCargarH2C(){
  if(window.html2canvas) return Promise.resolve();
  if(_ecH2CProm) return _ecH2CProm;
  _ecH2CProm = new Promise(function(res, rej){
    var sc = document.createElement('script');
    sc.src = EC_H2C_URL;
    sc.onload = function(){ res(); };
    sc.onerror = function(){ _ecH2CProm = null;
      rej(new Error('No se pudo cargar el conversor de PDF.')); };
    document.head.appendChild(sc);
  });
  return _ecH2CProm;
}

async function ecPdfBlob(){
  if(typeof ncrCargarLib === 'function') await ncrCargarLib();
  else if(typeof catCargarLib === 'function') await catCargarLib();
  if(!(window.jspdf && window.jspdf.jsPDF))
    throw new Error('No se pudo cargar el generador de PDF.');
  await ecCargarH2C();

  var cl = _cliActual || {};

  // El mismo HTML del boton de imprimir, SIN abrir la ventana.
  _ecHtml = null;
  _ecSoloHtml = true;
  try{ ecClientePDF(); }
  finally{ _ecSoloHtml = false; }
  if(!_ecHtml) throw new Error('No hay movimientos que mandar.');

  // El saldo final, para el mensaje. Sale de los mismos movimientos.
  var saldo = 0;
  (_ecCliMovs || []).forEach(function(m){
    saldo += (Number(m.debito)||0) - (Number(m.credito)||0);
  });

  // Se pinta fuera de la vista: 794px es el ancho de un A4 a 96 ppp.
  var caja = document.createElement('div');
  caja.style.cssText = 'position:fixed;left:-10000px;top:0;width:794px;'
    + 'background:#fff;z-index:-1';
  var cuerpo = _ecHtml
    .replace(/^[\s\S]*?<body[^>]*>/i, '')
    .replace(/<\/body>[\s\S]*$/i, '');
  var estilos = (_ecHtml.match(/<style>([\s\S]*?)<\/style>/i) || [])[1] || '';
  caja.innerHTML = '<style>' + estilos + '</style>'
    + '<div style="padding:20px">' + cuerpo + '</div>';
  document.body.appendChild(caja);

  try{
    var lienzo = await window.html2canvas(caja, {scale: 2, backgroundColor: '#fff'});
    var doc = new window.jspdf.jsPDF({unit:'pt', format:'a4'});
    var W = doc.internal.pageSize.getWidth();
    var H = doc.internal.pageSize.getHeight();
    var alto = lienzo.height * W / lienzo.width;
    var img = lienzo.toDataURL('image/jpeg', 0.92);

    doc.addImage(img, 'JPEG', 0, 0, W, alto);
    // Si no cabe en una hoja, se reparte en varias desplazando la imagen.
    var restante = alto - H, y = -H;
    while(restante > 1){
      doc.addPage();
      doc.addImage(img, 'JPEG', 0, y, W, alto);
      restante -= H;
      y -= H;
    }
    return {blob: doc.output('blob'), saldo: saldo, cliente: cl};
  }finally{
    try{ caja.remove(); }catch(e){}
  }
}

// Guarda lo preparado entre el primer toque y el segundo.
var _ecListo = null;

async function ecWhatsApp(){
  var btn = document.getElementById('ec-wa');
  var txt0 = btn ? btn.innerHTML : '';
  if(btn){ btn.disabled = true; btn.textContent = 'Preparando\u2026'; }
  try{
    var r = await ecPdfBlob();
    var cl = r.cliente;
    var nom = 'estado-' + String(cl.cardcode||'cliente').replace(/[^\w-]/g,'')
            + '-' + ecCodigo(6) + '.pdf';

    var saldoTxt = (r.saldo > 0.005)
      ? ('Su saldo pendiente es de $' + r.saldo.toLocaleString('en-US',
          {minimumFractionDigits:2, maximumFractionDigits:2}) + '.')
      : 'Su cuenta esta al dia.';

    var msg = 'Aqu\u00ed tiene su estado de cuenta para revisi\u00f3n.\n\n'
            + saldoTxt
            + '\n\nPuede realizar su pago por el monto que desee en:\n'
            + EC_LINK_PAGO;

    var file = null;
    try{ file = new File([r.blob], nom, {type:'application/pdf'}); }catch(e){}

    // El navegador EXIGE que `navigator.share` se llame en el mismo instante
    // del toque del usuario. Generar el PDF antes rompe esa cadena y el
    // aparato lo rechaza con "not allowed by the user agent".
    //
    // Por eso va en dos pasos: este toque prepara, y el boton del aviso -que
    // es un toque nuevo y limpio- comparte.
    if(file && navigator.canShare && navigator.canShare({files:[file]})){
      _ecListo = {file:file, msg:msg, nom:nom};
      ecAvisoCompartir(cl, r.saldo);
      if(btn){ btn.disabled=false; btn.innerHTML=txt0; }
      return;
    }

    // Sin compartir en el aparato -escritorio-: se descarga y se abre
    // WhatsApp con el mensaje. El archivo no se sube a ninguna parte.
    ecDescargar(r.blob, nom);
    window.open('https://wa.me/' + ecTelefono(cl) + '?text='
                + encodeURIComponent(msg), '_blank');
    setTimeout(function(){
      alert('El PDF se descargo a tu equipo como:\n' + nom +
            '\n\nArrastralo al chat de WhatsApp que acaba de abrirse.' +
            '\n\nWhatsApp Web no permite adjuntar archivos desde una pagina: ' +
            'es una limitacion suya. Desde el telefono se manda de una vez.');
    }, 600);
  }catch(e){
    alert('No se pudo preparar el env\u00edo: ' + (e.message || e));
  }finally{
    if(btn){ btn.disabled = false; btn.innerHTML = txt0; }
  }
}

function ecDescargar(blob, nom){
  var a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = nom;
  document.body.appendChild(a);
  a.click();
  setTimeout(function(){
    try{ URL.revokeObjectURL(a.href); a.remove(); }catch(e){}
  }, 4000);
}

// El segundo toque. Tiene que ser un boton de verdad: un `setTimeout` o una
// promesa por medio y el navegador ya no lo considera accion del usuario.
function ecAvisoCompartir(cl, saldo){
  var v = document.getElementById('ec-wa-modal');
  if(v) v.remove();
  var m = document.createElement('div');
  m.id = 'ec-wa-modal';
  m.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    + 'display:flex;align-items:center;justify-content:center;padding:16px';
  m.innerHTML = '<div style="background:var(--surface,#fff);border-radius:14px;'
    + 'max-width:380px;width:100%;padding:20px;text-align:center">'
    + '<div style="font-size:16px;font-weight:700;margin-bottom:4px">'
    + 'Estado de cuenta listo</div>'
    + '<div style="font-size:13px;color:var(--text3);margin-bottom:16px">'
    + (cl.cardname || cl.cardcode || '')
    + (saldo > 0.005
        ? ('<br>Saldo: <b>$' + saldo.toLocaleString('en-US',
            {minimumFractionDigits:2, maximumFractionDigits:2}) + '</b>')
        : '<br>Cuenta al d\u00eda')
    + '</div>'
    + '<button id="ec-wa-go" class="btn" style="background:#25D366;color:#fff;'
    + 'border-color:#25D366;width:100%;padding:12px;font-size:15px;font-weight:700;'
    + 'display:inline-flex;align-items:center;justify-content:center;gap:8px">'
    + '<svg viewBox="0 0 32 32" width="18" height="18" aria-hidden="true">'
    + '<path fill="#fff" d="M16 3.2C8.9 3.2 3.2 8.9 3.2 16c0 2.3.6 4.4 1.7 6.3L3.2 28.8'
    + 'l6.7-1.7c1.8 1 3.9 1.6 6.1 1.6 7.1 0 12.8-5.7 12.8-12.8S23.1 3.2 16 3.2z'
    + 'm0 23c-1.9 0-3.7-.5-5.3-1.4l-.4-.2-4 1 1.1-3.9-.3-.4c-1-1.6-1.5-3.5-1.5-5.4'
    + ' 0-5.7 4.7-10.4 10.4-10.4S26.4 10.3 26.4 16 21.7 26.2 16 26.2z"/></svg>'
    + 'Adjuntar en WhatsApp</button>'
    + '<div style="margin-top:10px">'
    + '<button id="ec-wa-dl" class="btn btn-sm" style="width:100%">Descargar el PDF</button>'
    + '</div>'
    + '<div style="margin-top:12px"><a href="javascript:void(0)" id="ec-wa-no" '
    + 'style="font-size:12.5px;color:var(--text3)">Cancelar</a></div>'
    + '</div>';
  document.body.appendChild(m);

  document.getElementById('ec-wa-go').onclick = async function(){
    if(!_ecListo) return;
    try{
      await navigator.share({
        files: [_ecListo.file],
        title: 'Estado de cuenta',
        text: _ecListo.msg
      });
      m.remove();
    }catch(e){
      // Cancelar el menu del sistema tambien llega aqui: no es un error.
      if(e && e.name === 'AbortError') return;
      alert('No se pudo compartir: ' + (e.message || e) +
            '\n\nPuedes descargar el PDF y adjuntarlo a mano.');
    }
  };
  document.getElementById('ec-wa-dl').onclick = function(){
    if(_ecListo) ecDescargar(_ecListo.file, _ecListo.nom);
  };
  document.getElementById('ec-wa-no').onclick = function(){ m.remove(); };
  m.addEventListener('click', function(e){ if(e.target === m) m.remove(); });
}

// El telefono del cliente, limpio. Sin el, WhatsApp abre para que el vendedor
// elija el contacto, que tambien sirve.
function ecTelefono(cl){
  var t = String((cl && (cl.cellular || cl.phone1 || cl.phone2)) || '')
            .replace(/[^0-9]/g,'');
  if(!t) return '';
  // Panama son 8 digitos: se les antepone el pais.
  if(t.length === 8) t = '507' + t;
  return t;
}

function ecClientePDFCompleto(){
  var d=document.getElementById('ec-cli-desde'), h=document.getElementById('ec-cli-hasta');
  var vd=d?d.value:'', vh=h?h.value:'';
  if(d) d.value=''; if(h) h.value='';
  try{ ecClientePDF(); }
  finally{ if(d) d.value=vd; if(h) h.value=vh; }   // se devuelve la pantalla como estaba
}

var _ecHtml = null, _ecSoloHtml = false;

function ecClientePDF(){
  var cl=_cliActual||{};
  // El PDF sale con EXACTAMENTE el mismo rango que se ve en pantalla.
  var _d=(document.getElementById('ec-cli-desde')||{}).value||'';
  var _h=(document.getElementById('ec-cli-hasta')||{}).value||'';
  var _todos=(_ecCliMovs||[]).slice().sort(function(a,b){return String(a.docdate||'').localeCompare(String(b.docdate||''));});
  var _r=ecCliRango(_todos,_d,_h);
  var movs=_r.movs, saldoIni=_r.ini;
  if(!movs.length){ alert('No hay movimientos en ese rango de fechas.'); return; }
  var ec=_cliEC||[];
  function m2(n){ n=Number(n)||0; return n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function sal(v){ v=Number(v)||0; return '<span style="color:'+(v<-0.005?'#c00000':'#000')+'">'+m2(v)+'</span>'; }
  var w=null;
  if(!_ecSoloHtml){
    w=window.open('','_blank');
    if(!w){ alert('Permite ventanas emergentes para generar el PDF.'); return; }
    w.document.write('<p style="font-family:Arial;padding:20px">Generando estado de cuenta...</p>');
  }
  var saldo=saldoIni,sumD=0,sumC=0;
  var filas=movs.map(function(mv){
    var d=Number(mv.debito||0), c=Number(mv.credito||0);
    saldo+=d-c; sumD+=d; sumC+=c;
    return '<tr>'
      +'<td>'+fmtD(mv.docdate)+'</td>'
      +'<td>'+npEsc(mv.tipo||'')+'</td>'
      +'<td>'+npEsc(mv.docnum!=null?mv.docnum:'')+'</td>'
      +'<td></td>'
      +'<td></td>'
      +'<td class="cm">'+npEsc(mv.comments||'')+'</td>'
      +'<td class="r">'+(d?m2(d):'')+'</td>'
      +'<td class="r">'+(c?m2(c):'')+'</td>'
      +'<td class="r">'+sal(saldo)+'</td>'
      +'</tr>';
  }).join('');
  var desde = _d ? fmtD(_d) : (movs.length ? fmtD(movs[0].docdate) : '—');
  var hastaTxt = _h ? ('&nbsp;&nbsp;HASTA EL&nbsp;&nbsp;&nbsp;'+fmtD(_h)) : '';
  var saldoFecha = movs.length ? saldo : Number(cl.balance||0);
  // La antiguedad se calcula sobre TODOS los movimientos, no solo los del
  // periodo filtrado: si no, ignora la deuda anterior y las cubetas no suman
  // el saldo. Con el filtro de 1 anio sumaban 41,357.25 en vez de 118,567.55,
  // justo los 77,210.30 del saldo inicial que quedaban fuera.
  var _ag=cliAgingLedger(
    (typeof _ecCliMovs!=='undefined' && _ecCliMovs && _ecCliMovs.length) ? _ecCliMovs : movs);
  var B=_ag.B;
  var bt=B.reduce(function(s,x){return s+x;},0);
  var labels=['0-30','31-60','61-90','91-120','121-150','151-180','181-210','211-240','Más 240'];
  var bcells=B.map(function(x){return '<td class="r">'+m2(x)+'</td>';}).join('');
  var pcells=B.map(function(x){return '<td class="r">'+(bt?(x/bt*100).toFixed(2):'0.00')+' %</td>';}).join('');
  var now=new Date();
  var hora=now.toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit',second:'2-digit'});
  // En local, no en UTC: pasadas las 7 de la tarde el PDF salia con la
  // fecha de manana.
  var fechaHdr=fmtD(new Date(now.getTime()-now.getTimezoneOffset()*60000)
                      .toISOString())+'  '+hora;
  var css='*{box-sizing:border-box}body{font-family:Arial,Helvetica,sans-serif;font-size:13px;color:#000;margin:16px}'
    +'.hdr{display:flex;justify-content:space-between;align-items:flex-start}.hdr .ttl{text-align:center;flex:1}'
    +'.hdr .ttl h1{font-size:24px;margin:0;font-weight:bold;letter-spacing:.5px}.sm{font-size:12px}'
    +'.addr{text-align:center;font-size:12px;margin-top:3px}'
    +'.bar{background:#d9d9d9;border:1px solid #8a8a8a;text-align:center;font-weight:bold;padding:5px;margin:12px 0;font-size:15px;letter-spacing:.04em}'
    +'.info{display:flex;gap:14px;margin-bottom:10px;align-items:flex-start;font-size:13px}.info .col{flex:1}'
    +'.info .box{flex:0 0 230px;border:1px solid #8a8a8a;padding:6px 8px}'
    +'.info .row{margin-bottom:3px}.info .col b{display:inline-block;min-width:86px}'
    +'.box .row{display:flex;justify-content:space-between}'
    +'.desde{text-align:center;font-weight:bold;margin:10px 0;font-size:11px}'
    +'table.tx{width:100%;border-collapse:collapse;font-size:12.5px}'
    +'table.tx th{background:#ececec;border-top:1px solid #8a8a8a;border-bottom:1px solid #8a8a8a;padding:6px 7px;text-align:left;white-space:nowrap}'
    +'table.tx th.r,table.tx td.r{text-align:right;white-space:nowrap}'
    +'table.tx td{padding:4px 7px;border-bottom:1px solid #eee;vertical-align:top}'
    +'tr.tot td{border-top:1px solid #8a8a8a;border-bottom:2px solid #8a8a8a;font-weight:bold}'
    +'table.ag{width:100%;border-collapse:collapse;font-size:12.5px;margin-top:18px}'
    +'table.ag th{background:#bfbfbf;border:1px solid #8a8a8a;padding:6px;text-align:right}'
    +'table.ag td{background:#dcdcdc;border:1px solid #8a8a8a;padding:6px;text-align:right}'
    +'@media print{body{margin:8mm}}';
  var html='<!DOCTYPE html><html><head><meta charset="utf-8"><title>Estado de cuenta '+npEsc(cl.cardcode||'')+'</title><style>'+css+'</style></head><body>'
    +'<div class="hdr"><div class="sm">'+fechaHdr+'</div><div class="ttl"><h1>KENNEDY CENTER CORP.</h1></div><div class="sm">Page 1 of 1</div></div>'
    +'<div class="addr">Zona Libre de Colón, Calle 15 y Ave. Santa Isabel. Edificio Central Plaza. P.O. Box 0302-00737 Panamá</div>'
    +'<div class="addr">Tel. 441-6755 / 441-6767</div>'
    +'<div class="bar">ESTADO DE CUENTA</div>'
    +'<div class="info">'
      +'<div class="col">'
        +'<div class="row"><b>Codigo:</b>'+npEsc(cl.cardcode||'')+'</div>'
        +'<div class="row"><b>Nombre:</b>'+npEsc(cl.cardname||'')+'</div>'
        +'<div class="row"><b>País:</b>'+npEsc(cl.country||'')+'</div>'
        +'<div class="row"><b>Dirección:</b>'+npEsc(cl.address||cl.mailaddres||cl.city||'')+'</div>'
      +'</div>'
      +'<div class="col">'
        +'<div class="row"><b>Teléfono:</b>'+npEsc(cl.phone1||cl.phone||'')+'</div>'
        +'<div class="row"><b>Celular:</b>'+npEsc(cl.cellular||'')+'</div>'
        +'<div class="row"><b>E-mail:</b>'+npEsc(cl.e_mail||'')+'</div>'
        +'<div class="row"><b>Contacto:</b>'+npEsc(cl.cntctprsn||'')+'</div>'
        +'<div class="row"><b>Vendedor:</b>'+npEsc(cl.nombrevendedor||'')+'</div>'
      +'</div>'
      +'<div class="box">'
        +'<div class="row"><span>Saldo a la Fecha :</span><b>'+m2(saldoFecha)+'</b></div>'
        +'<div class="row"><span>Límite de Cr. :</span><b>'+m2(cl.creditline)+'</b></div>'
        +'<div class="row"><span>Ordenes Pend. :</span><b>0.00</b></div>'
      +'</div>'
    +'</div>'
    +'<div class="desde">INCLUYE TRANSACCIONES DESDE EL&nbsp;&nbsp;&nbsp;'+desde+hastaTxt+'</div>'
    +'<table class="tx"><thead><tr><th>Fecha</th><th></th><th># Doc.</th><th>Dias</th><th># Ped.</th><th>Comentarios</th><th class="r">Debito</th><th class="r">Credito</th><th class="r">Saldo</th></tr></thead><tbody>'
    +'<tr><td colspan="8" style="text-align:right;font-style:italic">Saldo Inicial -----&gt;</td><td class="r">'+m2(saldoIni)+'</td></tr>'
    +filas
    // Los totales incluyen el saldo inicial y cierran con el saldo final. Antes
    // sumaban solo el periodo filtrado y dejaban la ultima celda vacia: al
    // poner una fecha, los totales ya no cuadraban con el saldo de arriba
    // (261,370.25 - 220,013.00 no da 118,567.55 sin sumar los 77,210.30 del
    // saldo inicial).
    +(saldoIni ? ('<tr class="tot" style="font-weight:400"><td colspan="6" style="text-align:right">'
        +'Saldo inicial del periodo</td><td class="r"></td><td class="r"></td>'
        +'<td class="r">'+m2(saldoIni)+'</td></tr>') : '')
    +'<tr class="tot"><td colspan="6" style="text-align:right">Totales-&gt;</td>'
      +'<td class="r">'+m2(sumD)+'</td><td class="r">'+m2(sumC)+'</td>'
      +'<td class="r">'+m2(saldo)+'</td></tr>'
    +'</tbody></table>'
    +'<table class="ag"><thead><tr>'+labels.map(function(l){return '<th>'+l+'</th>';}).join('')+'</tr></thead>'
    +'<tbody><tr>'+bcells+'</tr><tr>'+pcells+'</tr></tbody></table>'
    +'</body></html>';
  // Se guarda el HTML tal cual para que el envio por WhatsApp mande
  // EXACTAMENTE el mismo documento, sin recrearlo por otro lado.
  _ecHtml = html;
  if(_ecSoloHtml) return html;   // llamada desde ecWhatsApp: no abre ventana
  w.document.open(); w.document.write(html); w.document.close(); w.focus();
  if(w) setTimeout(function(){ try{ w.print(); }catch(e){} }, 500);
}

function ecCliFiltrar(){
  var d=(document.getElementById('ec-cli-desde')||{}).value||'';
  var h=(document.getElementById('ec-cli-hasta')||{}).value||'';
  var c=document.getElementById('ec-cli-tabla');
  if(c) c.innerHTML=ecCliTablaHTML(_ecCliMovs,d,h);
}
var _cliActual=null, _cliEC=[], _cliUP=[];
function enviarRecordatorio(){
  var cl=_cliActual||{};
  var email=(cl.e_mail||'').trim();
  var _agR=cliAgingLedger(_ecCliMovs);
  var saldo=_agR.total;
  if(saldo<=0.005){ if(!confirm('Este cliente no tiene saldo pendiente. ¿Enviar el correo igual?')) return; }
  var L=[];
  L.push('Estimados señores de '+(cl.cardname||'')+',');
  L.push('');
  L.push('Reciban un cordial saludo de parte de Kennedy Center Corp. Le recordamos que mantiene un saldo pendiente con nosotros y agradecemos su pago a la mayor brevedad posible.');
  L.push('');
  L.push('SALDO TOTAL PENDIENTE: USD '+fmt(saldo).replace('$',''));
  // ===== Estado de cuenta (misma info que el PDF, resumido a 20 lineas) =====
  var _movsAsc=(_ecCliMovs||[]).slice().sort(function(a,b){return String(a.docdate||'').localeCompare(String(b.docdate||''));});
  var _sR=0,_sumD=0,_sumC=0,_filas=[];
  _movsAsc.forEach(function(mv){
    var d=Number(mv.debito||0), c=Number(mv.credito||0);
    _sR+=d-c; _sumD+=d; _sumC+=c;
    _filas.push({fecha:fmtD(mv.docdate),tipo:String(mv.tipo||''),doc:(mv.docnum!=null?String(mv.docnum):''),deb:d,cred:c,saldo:_sR,com:String(mv.comments||'')});
  });
  var _saldoFecha=_movsAsc.length?_sR:Number(cl.balance||0);
  var _desde=_movsAsc.length?fmtD(_movsAsc[0].docdate):'';
  var _ult=_filas.slice(-20);
  var _omit=_filas.length-_ult.length;
  function _pr(x,n){ x=String(x); return x.length>=n?x.slice(0,n):x+Array(n-x.length+1).join(' '); }
  function _pl(x,n){ x=String(x); return x.length>=n?x:Array(n-x.length+1).join(' ')+x; }
  function _mny(n){ return (Number(n)||0).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  L.push('');
  L.push('==================================================');
  L.push('                ESTADO DE CUENTA');
  L.push('==================================================');
  L.push('Codigo:   '+(cl.cardcode||''));
  L.push('Nombre:   '+(cl.cardname||''));
  if(cl.country) L.push('Pais:     '+paisNombre(cl.country));
  if(cl.nombrevendedor) L.push('Vendedor: '+cl.nombrevendedor);
  L.push('Saldo a la fecha:   USD '+_mny(_saldoFecha));
  if(cl.creditline!=null&&cl.creditline!=='') L.push('Limite de credito:  USD '+_mny(cl.creditline));
  L.push('');
  L.push('Incluye transacciones desde el '+_desde+(_omit>0?'   (se muestran las ultimas 20)':''));
  L.push('');
  L.push(_pr('Fecha',11)+' '+_pr('Tipo',4)+' '+_pr('#Doc',10)+' '+_pl('Debito',12)+' '+_pl('Credito',12)+' '+_pl('Saldo',13)+'  Comentario');
  L.push('---------------------------------------------------------------------------------------');
  if(_omit>0) L.push('('+_omit+' movimiento'+(_omit!==1?'s':'')+' anterior'+(_omit!==1?'es':'')+' no mostrado'+(_omit!==1?'s':'')+')');
  _ult.forEach(function(f){
    L.push(_pr(f.fecha,11)+' '+_pr(f.tipo,4)+' '+_pr(f.doc,10)+' '+_pl(f.deb?_mny(f.deb):'',12)+' '+_pl(f.cred?_mny(f.cred):'',12)+' '+_pl(_mny(f.saldo),13)+'  '+f.com.slice(0,24));
  });
  L.push('---------------------------------------------------------------------------------------');
  L.push(_pr('',11)+' '+_pr('',4)+' '+_pr('Totales',10)+' '+_pl(_mny(_sumD),12)+' '+_pl(_mny(_sumC),12)+' '+_pl(_mny(_saldoFecha),13));
  L.push('');
  var _BK=_agR.B;
  var _btk=_BK.reduce(function(s,x){return s+x;},0);
  var _lab=['0-30','31-60','61-90','91-120','121-150','151-180','181-210','211-240','Mas 240'];
  L.push('RESUMEN POR ANTIGUEDAD (por fecha de factura):');
  if(_btk<=0.005){ L.push('  Sin saldo vencido.'); }
  else {
    _lab.forEach(function(lb,i){ if(_BK[i]>0.005) L.push('  '+_pr(lb+':',9)+' USD '+_pl(_mny(_BK[i]),13)+'   ('+(_BK[i]/_btk*100).toFixed(1)+'%)'); });
    L.push('  '+_pr('TOTAL:',9)+' USD '+_pl(_mny(_btk),13));
  }
  L.push('');
  L.push('==============================================');
  L.push('INSTRUCCIONES PARA RECIBIR TRANSFERENCIAS');
  L.push('==============================================');
  L.push('');
  L.push('1) BANCO CORRESPONSAL / INTERMEDIARIO:');
  L.push('   CITIBANK, N.A.');
  L.push('   111 Wall St. New York City, NY 10043, USA');
  L.push('   SWIFT CODE: CITIUS33XXX');
  L.push('');
  L.push('2) BANCO BENEFICIARIO:');
  L.push('   BANISTMO, S.A.');
  L.push('   Torre Banistmo, Calle 50, Panama, Rep. de Panama');
  L.push('   SWIFT: MIDLPAPA');
  L.push('');
  L.push('3) ULTIMO BENEFICIARIO (pago final):');
  L.push('   KENNEDY CENTER CORP.');
  L.push('   Calle 15 Ave. Santa Isabel, Edificio Kennedy Center,');
  L.push('   Zona Libre de Colon, Panama');
  L.push('   Cuenta No.: 0100154112');
  L.push('');
  L.push('4) ORDENANTE / REMITENTE:');
  L.push('   Nombre y direccion fisica (ciudad y pais) del remitente.');
  L.push('');
  L.push('NOTA: Favor seguir estas instrucciones al pie de la letra para evitar contratiempos y demoras en el recibo de la transferencia.');
  L.push('');
  L.push('Quedamos atentos a su pago. Muchas gracias.');
  L.push('');
  L.push('Kennedy Center Corp.');
  L.push('Zona Libre de Colon, Colon, Rep. de Panama');
  L.push('Tel: (507) 441-6755 / 441-6767');
  L.push('Email: kennedy@kennedyzl.com');
  var cuerpo=L.join('\n');
  var asunto='Estado de cuenta y recordatorio de pago - Kennedy Center Corp';
  var link='mailto:'+encodeURIComponent(email)+'?subject='+encodeURIComponent(asunto)+'&body='+encodeURIComponent(cuerpo);
  if(!email){
    alert('Este cliente no tiene correo registrado en SAP. Se abrirá el correo con el mensaje para que escribas el destinatario.');
  }
  window.location.href=link;
}
async function verCliente(cardcode,noPush){
  if(CU&&CU.rol==='cliente'&&String(cardcode)!==String(CU.cardcode))return;
  if(!noPush && VISTA_ACTUAL){ NAVSTACK.push(VISTA_ACTUAL); }
  VISTA_ACTUAL=function(){ verCliente(cardcode,true); };
  if(!noPush) _navPush({v:'cliente',a:cardcode});
  $('cli-det-content').innerHTML = loading();
  go('cliente_det',null);
  const [c,ec,up,facs,frec,movs,peds] = await Promise.all([
    q('clientes',`select=*&cardcode=eq.${cardcode}&limit=1`),
    q('estado_cuenta',`select=*&cardcode=eq.${cardcode}&order=docduedate`),
    q('ultimo_precio_cliente',`select=*&cardcode=eq.${cardcode}&order=fechaultima_compra.desc&limit=20`),
    qAll('vista_facturas',`select=docnum,docdate,docduedate,cardname,doctotal,paidtodate,docstatus&cardcode=eq.${cardcode}&order=docdate.desc`),
    q('frecuencia_compra_cliente',`select=*&cardcode=eq.${cardcode}&limit=1`),
    qAll('movimientos',`select=docdate,docduedate,tipo,docnum,debito,credito,comments&cardcode=eq.${cardcode}&order=docdate.asc`),
    qAll('pedidos',`select=docnum,docdate,docduedate,doctotal,docstatus,confirmed,openqty,linenum&cardcode=eq.${cardcode}&order=docnum.desc`),
  ]);
  const cl=c[0]||{}, fr=frec[0]||{};
  _cliActual=cl; _cliEC=ec; _cliUP=up;
  // Antes se cortaban en 20 y no habia forma de ver el resto. Ahora las
  // muestra el panel de 25 en 25.
  const uniqF=(facs||[]);
  // Fusiona en el estado de cuenta las FACTURAS que estan en vista_facturas
  // pero no llegaron a movimientos.
  //
  // OJO: solo lo que de verdad SIGUE DEBIENDO.
  //
  // Antes se añadia la factura por su total sin mirar si estaba cobrada, y
  // su pago no se añadia nunca -porque esta en `movimientos`, no en
  // `vista_facturas`-. Resultado: una factura pagada y cerrada aparecia
  // como deuda viva. Paso con la 214751 de CASABELLA PATIO: SAP decia saldo
  // cero y el portal 48.053,22.
  //
  // Ahora se usa `paidtodate` y `docstatus`, que esa consulta ya traia y
  // nadie miraba.
  try{
    var _faSet={}; movs.forEach(function(m){ if(m.tipo==='FA' && m.docnum!=null) _faSet[String(m.docnum)]=1; });
    var _add=0, _omit=0;
    (facs||[]).forEach(function(f){
      if(f.docnum==null || _faSet[String(f.docnum)]) return;
      var _tot=Number(f.doctotal)||0;
      var _pag=Number(f.paidtodate)||0;
      var _pend=Math.round((_tot-_pag)*100)/100;
      // Cerrada en SAP (`C`) o sin saldo: no debe nada, no entra.
      if(String(f.docstatus||'').toUpperCase()==='C' || _pend<=0.004){ _omit++; return; }
      movs.push({docdate:f.docdate, docduedate:f.docduedate, tipo:'FA', docnum:f.docnum,
                 // Lo pendiente, no el total: si hubo un abono parcial, el
                 // estado de cuenta debe reflejar lo que queda.
                 debito:_pend, credito:0,
                 comments:'Facturas clientes - '+cardcode
                          + (_pag>0.004 ? (' (abonado '+_pag.toLocaleString('en-US',
                              {minimumFractionDigits:2,maximumFractionDigits:2})+')') : '')});
        _add++;
    });
    if(_omit) try{ console.info('[ec] '+_omit+' factura(s) ya cobradas, no suman'); }catch(e){}
    if(_add) movs.sort(function(a,b){ return String(a.docdate||'').localeCompare(String(b.docdate||'')); });
  }catch(e){}
  let saldoAc=0;
  const movRows=movs.map(m=>{saldoAc+=Number(m.debito||0)-Number(m.credito||0);return Object.assign({},m,{saldo:saldoAc});});
  _ecCliMovs=movs;

  const _agC=cliAgingLedger(movs);
  const saldo=_agC.total;
  const limiteCred=Number(cl.creditline||0);
  const saldoTotal=Number(cl.balance||0);
  const moraMax=_agC.maxDias;
  const pasadoCredito=limiteCred>0 && saldoTotal>limiteCred;
  const pasadoDias=moraMax>0;
  const creditOK=!pasadoCredito && !pasadoDias;
  const condPago=cl.condicionpago||'—';

  // Un cliente NO debe ver las herramientas del vendedor: enviar recordatorios
  // de pago a si mismo, compartir su estado de cuenta con terceros u ofrecerse
  // mercancia. Solo se le deja imprimir lo suyo y hacer un pedido.
  var _esCli = (CU && CU.rol==='cliente');
  $('cli-det-content').innerHTML=`
  <div style="display:flex;gap:8px;align-items:center;margin-bottom:14px">
    <button class="btn btn-sm" onclick="navBack()">← Volver</button>
    <button class="btn btn-sm" onclick="ecClientePDFCompleto()">🖨️ Imprimir estado de cuenta</button>
    <button class="btn btn-sm" id="cli-showroom" onclick="vtShowroom(_cliActual&&_cliActual.cardcode, _cliActual&&_cliActual.cardname)" title="Un enlace para que el cliente vea todo el catalogo con sus precios">&#127978; Showroom del cliente</button>
    <button class="btn btn-sm" id="ec-wa" onclick="ecWhatsApp()" style="background:#25D366;color:#fff;border-color:#25D366;display:inline-flex;align-items:center;gap:6px"><svg viewBox="0 0 32 32" width="15" height="15" aria-hidden="true" style="flex:0 0 auto"><path fill="#fff" d="M16 3.2C8.9 3.2 3.2 8.9 3.2 16c0 2.3.6 4.4 1.7 6.3L3.2 28.8l6.7-1.7c1.8 1 3.9 1.6 6.1 1.6 7.1 0 12.8-5.7 12.8-12.8S23.1 3.2 16 3.2zm0 23c-1.9 0-3.7-.5-5.3-1.4l-.4-.2-4 1 1.1-3.9-.3-.4c-1-1.6-1.5-3.5-1.5-5.4 0-5.7 4.7-10.4 10.4-10.4S26.4 10.3 26.4 16 21.7 26.2 16 26.2z"/><path fill="#fff" d="M21.7 18.9c-.3-.2-1.8-.9-2.1-1-.3-.1-.5-.2-.7.2s-.8 1-1 1.2c-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-1-2.3c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.1 1.4 3.4c.2.2 2.4 3.7 5.8 5.1.8.3 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.8-.8 2.1-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z"/></svg>Enviar por WhatsApp</button>
    ${_esCli?'':`<button class="btn btn-sm" onclick="ecCompartir()" title="Enviar por correo o WhatsApp">📤 Compartir</button>`}
    ${_esCli?'':`<button class="btn btn-sm btn-p" onclick="enviarRecordatorio()">✉️ Enviar recordatorio de pago</button>`}<button class="btn btn-sm" onclick="nuevoPedidoCliente('${cardcode}')">🛒 Nuevo pedido</button>${_esCli?'':`<button class="btn btn-sm" onclick="ofrecerPorLlegar('${cardcode}')" title="Mercancía en tránsito de lo que este cliente ya compra">🚚 Ofrecer mercancía x llegar</button>`}${_esCli?'':`<button class="btn btn-sm" onclick="recomprarFrecuentes()">🔄 Recomprar frecuentes</button>`}
  </div>
  <div class="cd-header">
    <div class="cd-av">${ini(cl.cardname)}</div>
    <div class="cd-info">
      <div class="cd-name">${cl.cardname||cardcode}</div>
      <div class="cd-meta">
        <span>${cl.cardcode||''}</span>
        <span>${cl.phone1||cl.cellular||''}</span>
        <span>${cl.e_mail||''}</span>
        <span>${cl.city||''} ${paisFlag(cl.country)}${paisNombre(cl.country)}</span>
        <span>Vendedor: ${cl.nombrevendedor||'—'}</span>
      </div>
      <div class="cd-tags">
        <span class="badge b-blue">Limite: ${fmt(cl.creditline)}</span>
        ${saldo>0?`<span class="badge b-red">Saldo vencido: ${fmt(saldo)}</span>`:'<span class="badge b-green">Sin deuda vencida</span>'}
        ${fr.diasdesdeultimacompra>30?`<span class="badge b-amber">Sin comprar ${fr.diasdesdeultimacompra} dias</span>`:''}
      </div>
    </div>
  </div>
  <div style="display:flex;gap:12px;flex-wrap:wrap;align-items:center;margin-bottom:14px;padding:12px 16px;border-radius:10px;background:${creditOK?'#e8f5e3':'#fff7ed'};border:1px solid ${creditOK?'#90c878':'#fdba74'}">
    <span style="font-weight:700;font-size:14px;color:${creditOK?'#2f7d32':'#9a3412'}">${creditOK?'✓ Crédito al día':'⚠️ Atención de crédito'}</span>
    <span style="font-size:12px;color:var(--text2)">Condición: <b>${condPago}</b></span>
    <span style="font-size:12px;color:var(--text2)">Límite de crédito: <b>${fmt(limiteCred)}</b></span>
    <span style="font-size:12px;color:var(--text2)">Saldo: <b style="color:${pasadoCredito?'#c0392b':'inherit'}">${fmt(saldoTotal)}</b></span>
    <span style="font-size:12px;color:var(--text2)">Mora máx.: <b style="color:${pasadoDias?'#c0392b':'inherit'}">${moraMax} días</b></span>
    ${pasadoCredito?'<span class="badge b-amber">Pasado del límite de crédito</span>':''}
    ${pasadoDias?'<span class="badge b-amber">Facturas vencidas</span>':''}
  </div>
  <div class="kpi-grid">
    <div class="kpi"><div class="kpi-lbl">Saldo actual</div><div class="kpi-val">${fmt(cl.balance)}</div><div class="kpi-sub">Limite: ${fmt(cl.creditline)}</div></div>
    <div class="kpi"><div class="kpi-lbl">Compras totales</div><div class="kpi-val">${fmt(fr.comprastotales)}</div><div class="kpi-sub">${fr.totalfacturas||0} facturas</div></div>
    <div class="kpi"><div class="kpi-lbl">Ticket promedio</div><div class="kpi-val">${fmt(fr.ticketpromedio)}</div><div class="kpi-sub">por factura</div></div>
    <div class="kpi"><div class="kpi-lbl">Dias sin comprar</div><div class="kpi-val" style="color:${(fr.diasdesdeultimacompra||0)>30?'#a32d2d':'inherit'}">${fr.diasdesdeultimacompra||'—'}</div><div class="kpi-sub">Ultima: ${fmtD(fr.ultimacompra)}</div></div>
  </div>
  <div class="card">
    <div class="ch" style="flex-wrap:wrap;gap:8px">
      <span class="ct">📄 Estado de cuenta</span>
      <span style="display:flex;align-items:center;gap:8px">
        <label style="font-size:12px;color:var(--text3);display:flex;align-items:center;gap:4px">📅 Desde <input type="date" id="ec-cli-desde" onchange="ecCliFiltrar()" style="padding:5px 8px;border:1px solid var(--border);border-radius:8px;font-size:12px"></label>
        <label style="font-size:12px;color:var(--text3);display:flex;align-items:center;gap:4px">→ Hasta <input type="date" id="ec-cli-hasta" onchange="ecCliFiltrar()" style="padding:5px 8px;border:1px solid var(--border);border-radius:8px;font-size:12px"></label>
        <button class="btn btn-sm" onclick="['ec-cli-desde','ec-cli-hasta'].forEach(function(i){var d=document.getElementById(i);if(d)d.value='';});ecCliFiltrar()">Todo</button><button class="btn btn-sm btn-p" onclick="ecClientePDF()">📄 Generar PDF</button>
      </span>
    </div>
    <div id="ec-cli-tabla">${ecCliTablaHTML(_ecCliMovs,'')}</div>
  </div>
  <div class="card" style="margin-top:14px">
    <div class="ch"><span class="ct">🧾 Ultimas facturas</span><span style="font-size:12px;color:var(--text3)">${fmtN(uniqF.length)} factura(s)</span></div>
    <div id="cli-fac-tabla">${tablFacturas(uniqF)}</div>
  </div>
  <div class="card">
    <div class="ch"><span class="ct">📋 Ultimos pedidos</span></div>
    <div id="cli-ped-tabla"></div>
  </div>
  <div class="card">
    <div class="ch"><span class="ct">💲 Ultimo precio pagado por producto</span></div>
    ${up.length?`<table class="tbl"><tr><th>Producto</th><th>Fecha</th><th>Cant.</th><th>Precio</th><th>Descuento</th><th>Dias</th></tr>${up.map(u=>`<tr><td>${u.dscription||u.itemcode}</td><td>${fmtD(u.fechaultima_compra)}</td><td>${u.ultimacantidad||'—'}</td><td><b>${fmt(u.ultimoprecio)}</b></td><td>${u.descuento?Number(u.descuento).toFixed(1)+'%':'—'}</td><td><span class="badge ${Number(u.diasdesdeultimacompra||0)>60?'b-red':Number(u.diasdesdeultimacompra||0)>30?'b-amber':'b-green'}">${u.diasdesdeultimacompra||0}d</span></td></tr>`).join('')}</table>`:empty('Sin compras anteriores')}
  </div>
  <div class="card" style="margin-top:14px">
    <div class="ch"><span class="ct">🔄 Restock sugerido — productos que compra regularmente</span></div>
    ${up.length?`<table class="tbl"><tr><th>Producto</th><th>Ultima compra</th><th>Dias</th><th>Ultimo precio</th><th>Cant. sugerida</th></tr>${up.map(u=>`<tr><td>${u.dscription||u.itemcode}</td><td>${fmtD(u.fechaultima_compra)}</td><td><span class="badge ${Number(u.diasdesdeultimacompra||0)>60?'b-red':Number(u.diasdesdeultimacompra||0)>30?'b-amber':'b-green'}">${u.diasdesdeultimacompra||0}d</span></td><td><b>${fmt(u.ultimoprecio)}</b></td><td>${u.ultimacantidad||'—'} uds</td></tr>`).join('')}</table>`:empty('Sin datos')}
  </div>`;

  // El panel de pedidos se pinta aparte: agrupa las lineas por documento y
  // pagina de 25 en 25, igual que los otros dos.
  window._PM_cliped_lista = peds || [];
  window._PM_cliped = cliPanelPedidos;
  // Los contadores viven en kennedy-2.js, que carga despues: se comprueba
  // antes de tocarlos para no fallar si algo cambia el orden de carga.
  if(typeof PM_VIS!=='undefined'){
    PM_VIS['cliped']=PM_PASO; PM_VIS['clifac']=PM_PASO; PM_VIS['eccli']=PM_PASO;
  }
  cliPanelPedidos();
}

// Pedidos del cliente en la ficha. 'pedidos' trae una fila por linea, asi que
// se agrupa por documento y se cuenta lo que queda pendiente de entregar.
/* ══════════════════════════════════════════════════════════════════════════
   ORDENAR LAS TABLAS DE LA FICHA DEL CLIENTE
   ---------------------------------------------------------------------------
   Un solo ordenador para todas, en vez de añadirlo panel por panel. Funciona
   sobre lo que ya hay pintado: se escucha el clic en cualquier cabecera de
   tabla dentro de la ficha y se reordenan las filas.

   Entiende lo que hay en la celda sin que haya que decirselo:
     fechas    04-10-2026, 2026-10-04 y 04/10/2026
     numeros   $1,234.56 y 1.234 piezas
     texto     por orden alfabetico, respetando acentos

   Se ordena lo CARGADO. Los paneles muestran 25 y cargan mas al bajar, asi
   que conviene ordenar despues de haber cargado lo que se quiere ver.
   ══════════════════════════════════════════════════════════════════════════ */

function tblValor(td){
  var t = (td ? td.textContent : '').trim();
  if(!t) return {tipo:'vacio', v:''};

  // Fecha: dd-mm-aaaa o dd/mm/aaaa
  var m = t.match(/(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})/);
  if(m) return {tipo:'num', v: +(m[3] + m[2].padStart(2,'0') + m[1].padStart(2,'0'))};
  // Fecha: aaaa-mm-dd
  m = t.match(/(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})/);
  if(m) return {tipo:'num', v: +(m[1] + m[2].padStart(2,'0') + m[3].padStart(2,'0'))};

  // Numero: admite $ , % y el signo
  var limpio = t.replace(/[^0-9.,\-]/g, '').replace(/,/g, '');
  if(limpio && /\d/.test(limpio) && isFinite(parseFloat(limpio))){
    return {tipo:'num', v: parseFloat(limpio)};
  }
  return {tipo:'txt', v: t.toLowerCase()};
}

function tblOrdenar(th){
  var tabla = th.closest('table');
  if(!tabla) return;
  var fila = th.parentElement;
  var col = Array.prototype.indexOf.call(fila.children, th);
  if(col < 0) return;

  // Las filas de datos: las que no estan en la cabecera.
  var filas = Array.prototype.filter.call(tabla.querySelectorAll('tr'), function(tr){
    return tr !== fila && tr.querySelector('td');
  });
  if(filas.length < 2) return;

  // Al pulsar otra vez, al reves.
  var desc = th.getAttribute('data-ord') !== 'desc';
  Array.prototype.forEach.call(fila.children, function(x){
    x.removeAttribute('data-ord');
    var f = x.querySelector('.ord'); if(f) f.remove();
  });
  th.setAttribute('data-ord', desc ? 'desc' : 'asc');
  var flecha = document.createElement('span');
  flecha.className = 'ord';
  flecha.textContent = desc ? ' \u25bc' : ' \u25b2';
  th.appendChild(flecha);

  filas.sort(function(a, b){
    var x = tblValor(a.children[col]), y = tblValor(b.children[col]);
    // Las celdas vacias siempre al final, se ordene como se ordene: una fila
    // sin fecha arriba del todo no dice nada.
    if(x.tipo === 'vacio' && y.tipo !== 'vacio') return 1;
    if(y.tipo === 'vacio' && x.tipo !== 'vacio') return -1;
    var r;
    if(x.tipo === 'num' && y.tipo === 'num') r = x.v - y.v;
    else r = String(x.v).localeCompare(String(y.v), 'es');
    return desc ? -r : r;
  });

  var cuerpo = filas[0].parentElement;
  filas.forEach(function(tr){ cuerpo.appendChild(tr); });
}

// Un solo oyente para toda la ficha. Asi sigue funcionando aunque los paneles
// se repinten, que es lo que pasa al cargar mas filas.
document.addEventListener('click', function(ev){
  var th = ev.target.closest ? ev.target.closest('th') : null;
  if(!th) return;
  var ficha = th.closest('#page-cliente_det');
  if(!ficha) return;
  tblOrdenar(th);
});

function cliPanelPedidos(){
  var c = document.getElementById('cli-ped-tabla'); if(!c) return;
  var filas = window._PM_cliped_lista || [];

  var m = {};
  filas.forEach(function(p){
    var k = String(p.docnum);
    if(!m[k]) m[k] = {docnum:p.docnum, docdate:String(p.docdate||'').substring(0,10),
                      vence:String(p.docduedate||'').substring(0,10),
                      total:Number(p.doctotal)||0, estado:p.docstatus,
                      confirmado:p.confirmed, lineas:0, pendientes:0};
    m[k].lineas++;
    if((Number(p.openqty)||0) > 0) m[k].pendientes++;
  });
  var todos = Object.keys(m).map(function(k){ return m[k]; })
    .sort(function(a,b){ return (Number(b.docnum)||0) - (Number(a.docnum)||0); });

  if(!todos.length){ c.innerHTML = empty('Sin pedidos'); return; }

  var ver = todos.slice(0, (typeof pmVisibles==='function' ? pmVisibles('cliped') : 25));
  c.innerHTML =
     '<table class="tbl"><tr><th>Pedido</th><th>Fecha</th><th>Entrega</th>'
    +'<th style="text-align:right">Lineas</th><th>Estado</th>'
    +'<th style="text-align:right">Total</th></tr>'
    + ver.map(function(x){
        var abierto = String(x.estado)==='O';
        var aut = String(x.confirmado||'').toUpperCase()==='Y';
        return '<tr style="cursor:pointer" onclick="verPedido('+x.docnum+')">'
          +'<td><span style="color:#185FA5;font-weight:700"><u>#'+x.docnum+'</u></span></td>'
          +'<td>'+fmtD(x.docdate)+'</td>'
          +'<td>'+(x.vence?fmtD(x.vence):'\u2014')+'</td>'
          +'<td style="text-align:right">'+x.lineas
            +(x.pendientes?('<span style="font-size:10.5px;color:var(--amber)"> \u00b7 '+x.pendientes+' pend.</span>'):'')
            +'</td>'
          +'<td>'+(abierto
              ? ('<span class="badge b-amber">abierto</span>'
                 + (aut?'':' <span class="badge" style="background:#FEE2E2;color:#991B1B">sin autorizar</span>'))
              : '<span class="badge b-green">cerrado</span>')+'</td>'
          +'<td style="text-align:right;font-weight:600">'+fmt(x.total)+'</td></tr>';
      }).join('')
    +'</table>'
    + ((typeof pmPie==='function') ? pmPie('cliped', todos.length) : '');
}

// ══ PEDIDOS ══
// Condicion de pago del cliente. Se colorea para distinguir de un vistazo:
// contado y credito no se atienden igual.
function _pedCond(txt){
  var t=String(txt||'').trim();
  if(!t) return '<span style="color:#bbb">\u2014</span>';
  var l=t.toLowerCase();
  var col = /contado|cash|anticip/.test(l) ? 'var(--green)'
          : (/credit|dias|d\u00edas|plazo/.test(l) ? 'var(--blue2)' : 'var(--text3)');
  return '<span style="color:'+col+';font-weight:600" title="'+npEsc(t)+'">'
    + npEsc(t.length>18 ? t.substring(0,18)+'\u2026' : t) + '</span>';
}

// Saldo pendiente del cliente. En rojo si debe, gris si esta al dia.
function _pedSaldo(v){
  if(v==null) return '<span style="color:#bbb">\u2014</span>';
  var n=Number(v)||0;
  if(Math.abs(n)<0.005) return '<span style="color:var(--green)" title="Sin saldo pendiente">0.00</span>';
  var col = n>0 ? 'var(--red)' : 'var(--green)';
  return '<span style="color:'+col+';font-weight:600" title="Saldo del cliente en su estado de cuenta">'+fmtN2(n)+'</span>';
}

// Carga la siguiente pagina. La llama el boton y tambien el scroll infinito.
function pedCargarMas(){
  if(pedLoadingMore || !pedHasNext) return;
  pedLoadingMore = true;
  var b = document.getElementById('ped-mas');
  if(b){ b.disabled = true; b.textContent = 'Cargando\u2026'; }
  pedPage++;
  loadPedidos(true);
}

async function loadPedidos(append){
  var tb=document.getElementById('ped-tbody');
  if(!tb)return;
  if(!append){ pedPage=0; try{histRender('ped');}catch(e){} cargarVendedoresPed(); tb.innerHTML='<tr><td colspan="11" style="text-align:center;padding:30px;color:#888">Cargando...</td></tr>'; }
  var off=pedPage*PAGE_SIZE;
  // No todos los pedidos de SAP tienen linea 0: el 1037244, por ejemplo,
  // empieza en la 1 y con "linenum=eq.0" quedaba invisible en el portal
  // aunque estuviera completo en la base. Se pide la linea minima que
  // exista, que es lo unico seguro para tener una fila por documento.
  // `pedidos_primera` devuelve la PRIMERA linea de cada pedido, sea la 0, la 1 o
  // la 4. Antes se pedia `linenum<=1` y un pedido al que le hubieran borrado
  // las primeras lineas -al divorciarlo, por ejemplo- desaparecia de esta
  // pantalla aunque estuviera entero en la base. Paso con el 1038037.
  var cond='';
  if(pedQ){var n=parseInt((pedQ||'').trim());if(!isNaN(n)&&n>0)cond+='&docnum=eq.'+n;else cond+='&cardname=ilike.*'+encodeURIComponent(pedQ)+'*';}
  if(pedConfF)cond+='&confirmed=eq.'+pedConfF;
  if(pedVendF!=='' && pedVendF!=null)cond+='&slpcode=eq.'+encodeURIComponent(pedVendF);
  if(CU&&CU.rol==='cliente')cond+='&cardcode=eq.'+CU.cardcode;
  if(!pedQ)cond+='&or=(confirmed.eq.Y,docstatus.eq.O)'; // oculta cancelados (no autorizado + cerrado); si buscan, si aparecen
  var f='select=docnum,docdate,cardcode,cardname,doctotal,doccur,docstatus,comments,nombrevendedor,confirmed&order=docnum.desc&limit='+PAGE_SIZE+'&offset='+off+cond;
  var res=await q('pedidos_primera',f);
  // Cuantas filas trajo el SERVIDOR, que es lo que decide si hay mas
  // paginas. Con `pedidos_primera` ya viene una por pedido, pero el filtro de
  // repetidos de abajo se queda como red por si acaso: mirar el resultado ya
  // deduplicado haria creer al portal que no hay mas paginas.
  var _filasServidor = (res||[]).length;

  (function(){
    var v={}, u=[];
    (res||[]).forEach(function(p){
      var k=String(p.docnum);
      if(v[k]) return;
      v[k]=1; u.push(p);
    });
    res=u;
  })();
  var AVANCE_MAP={};
  try{
    var _dn=res.map(function(p){return p.docnum;}).filter(function(x){return x!=null;});
    if(_dn.length){
      var _av=await q('vista_pedidos','select=docnum,autorizado,pct_entregado,pct_facturado,pct_devuelto&docnum=in.('+_dn.join(',')+')');
      (_av||[]).forEach(function(a){AVANCE_MAP[a.docnum]=a;});
    }
  }catch(e){}
  var PAIS_MAP={}, COND_MAP={}, SALDO_MAP={};
  try{
    var _seen={}, _uc=[];
    res.forEach(function(p){ if(p.cardcode && !_seen[p.cardcode]){_seen[p.cardcode]=1;_uc.push(p.cardcode);} });
    if(_uc.length){
      var _inc=_uc.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',');
      // Se aprovecha el mismo viaje que ya se hacia por el pais para traer
      // tambien la condicion de pago y el saldo del cliente.
      var _cl=await q('clientes','select=cardcode,country,condicionpago,balance&cardcode=in.('+_inc+')&limit='+_uc.length);
      (_cl||[]).forEach(function(c){
        PAIS_MAP[c.cardcode]=c.country;
        COND_MAP[c.cardcode]=c.condicionpago;
        SALDO_MAP[c.cardcode]=c.balance;
      });
    }
  }catch(e){}
  var MARCA_MAP={};
  try{
    var _dn16=res.filter(function(p){return String(p.cardcode)==='16414';}).map(function(p){return p.docnum;}).filter(function(x){return x!=null;});
    if(_dn16.length){
      var _mk=await q('pedidos','select=docnum,marca_cliente&linenum=lte.1&docnum=in.('+_dn16.join(',')+')');
      (_mk||[]).forEach(function(m){ if(m.marca_cliente) MARCA_MAP[m.docnum]=m.marca_cliente; });
    }
  }catch(e){}
  var C='border-bottom:1px solid #e8eaed;border-right:1px solid #e8eaed;padding:6px 10px;white-space:nowrap';
  var _rows=res.map(function(p){
    var cc=String(p.cardcode||'');var ccJs=cc.replace(/'/g,"\\'");
    var _canc=(p.confirmed!=='Y' && String(p.docstatus)==='C');
    var _bcls=p.confirmed==='Y'?'b-green':(_canc?'b-red':'b-amber');
    var _btxt=p.confirmed==='Y'?'Autorizado':(_canc?'Cancelado':'Pendiente');
    return '<tr onclick="verPedido('+p.docnum+')" style="cursor:pointer" onmouseover="this.style.background=\"#fffde7\"" onmouseout="this.style.background=\"\"">'
      +'<td style="'+C+'"><b style="color:#0C447C">'+p.docnum+'</b></td>'
      +'<td style="'+C+';color:#555">'+fmtD(p.docdate)+'</td>'
      +'<td style="'+C+';font-size:11.5px">'+_pedCond(COND_MAP[p.cardcode])+'</td>'
      +'<td style="'+C+(cc?';padding:0':';color:#888')+'">'+(cc?('<span onclick="event.stopPropagation();verCliente(\''+ccJs+'\')" style="display:block;padding:6px 10px;color:#0C447C;cursor:pointer;text-decoration:underline;text-underline-offset:2px" title="Ver ficha del cliente">'+npEsc(cc)+'</span>'):'—')+'</td>'
      +'<td style="'+C+'">'+((String(p.cardcode)==='16414'&&MARCA_MAP[p.docnum]&&/hakol/i.test(MARCA_MAP[p.docnum]))?HAKOL_ICO_IMG:paisFlag(PAIS_MAP[p.cardcode]))+(p.cardname||'—')+(String(p.cardcode)==='16414'&&MARCA_MAP[p.docnum]?(' - MARCA DEL CLIENTE: '+MARCA_MAP[p.docnum]):'')+'</td>'
      +'<td style="'+C+';text-align:right;font-weight:600;white-space:nowrap"><span style="color:var(--text3);font-weight:500;font-size:11px">'+(p.doccur||'')+'</span> '+fmtN2(p.doctotal)+'</td>'
      +'<td style="'+C+';text-align:right;white-space:nowrap">'+_pedSaldo(SALDO_MAP[p.cardcode])+'</td>'
      +'<td style="'+C+'">'+(p.nombrevendedor||'—')+'</td>'
      +'<td style="'+C+';text-align:center"><span class="badge '+_bcls+'">'+_btxt+'</span></td>'
      +'<td style="border-bottom:1px solid #e8eaed;padding:6px 10px;color:#888"><div style="max-width:300px;white-space:normal;word-break:break-word">'+(p.comments||'')+'</div></td>'
      +'<td style="'+C+';text-align:center">'+miniAvance(AVANCE_MAP[p.docnum])+'</td>'
      +'</tr>';
  }).join('');
  if(append){ tb.insertAdjacentHTML('beforeend',_rows); }
  else{ tb.innerHTML=_rows||'<tr><td colspan="11" style="text-align:center;padding:30px;color:#888">Sin pedidos</td></tr>'; }
  pedHasNext=(_filasServidor===PAGE_SIZE); pedLoadingMore=false;

  // El centinela va en 'ped-pager', un div vacio DEBAJO de la tabla. Si la
  // tabla es ancha y la pagina no llega a desplazarse en vertical, ese
  // centinela nunca entra en pantalla y el scroll infinito no dispara: de
  // ahi que la lista se quedara en 50. Se anade un boton visible como
  // respaldo, que ademas deja claro que hay mas.
  var _pp=document.getElementById('ped-pager');
  if(_pp){
    _pp.innerHTML = pedHasNext
      ? '<div style="text-align:center;padding:14px">'
        +'<button class="btn btn-sm" id="ped-mas" onclick="pedCargarMas()">'
        +'Cargar m\u00e1s pedidos</button>'
        +'<div style="font-size:11.5px;color:var(--text3);margin-top:5px">'
        +'mostrando '+fmtN(document.getElementById('ped-tbody').rows.length)+'</div></div>'
      : (pedPage>0
          ? '<div style="text-align:center;padding:12px;font-size:12px;color:var(--text3)">'
            +'No hay m\u00e1s pedidos</div>'
          : '');
  }
  _infScroll('ped-pager','ped-sentinel',pedHasNext,function(){ if(!pedLoadingMore&&pedHasNext){ pedLoadingMore=true; pedPage++; loadPedidos(true); } });
}
async function cargarVendedoresPed(){
  var sel=document.getElementById('ped-vend'); if(!sel||sel.dataset.listo)return;
  try{
    var v=await q('vendedores','select=slpcode,slpname&order=slpname');
    var seen={};
    (v||[]).forEach(function(x){ if(x.slpcode!=null && !seen[x.slpcode]){ seen[x.slpcode]=1; var o=document.createElement('option'); o.value=x.slpcode; o.textContent=x.slpname||('Vendedor '+x.slpcode); sel.appendChild(o); } });
    sel.dataset.listo='1';
  }catch(e){}
}
function pedConfFiltro(v,el){pedConfF=v;pedPage=0;document.querySelectorAll('#ped-status-pills .pill').forEach(function(p){p.classList.remove('active');});if(el)el.classList.add('active');loadPedidos();}
function pedVendFiltro(v){pedVendF=v;pedPage=0;loadPedidos();}
var pedT2=null;
function searchPedidos(v){pedQ=v;pedPage=0;clearTimeout(pedT2);pedT2=setTimeout(function(){ histAdd('ped',v); histRender('ped'); loadPedidos(); },400);}
function pedFiltro(s,el){pedS=s;pedPage=0;loadPedidos();}
function pedStatusFilt(v){pedS=v;pedPage=0;loadPedidos();}
function pedSort(c){if(pedSortCol===c)pedSortDir=pedSortDir==='desc'?'asc':'desc';else{pedSortCol=c;pedSortDir='desc';}loadPedidos();}
var pedSortCol='docnum',pedSortDir='desc';
var fmtN2=function(n){return n==null||isNaN(+n)?'0.00':Number(n).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});};

var FIC_IC={
  desc:'<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/>',
  size:'<path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/>',
  cube:'<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>',
  weight:'<path d="M6.5 7h11l1.6 13H4.9z"/><path d="M9 7a3 3 0 1 1 6 0"/>',
  tag:'<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>',
  globe:'<circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>',
  box:'<path d="M16.5 9.4 7.5 4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>',
  layers:'<polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>',
  color:'<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>',
  list:'<line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>'
};
function _ficIc(n){ return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+(FIC_IC[n]||FIC_IC.list)+'</svg>'; }
// Lo que de verdad se puede vender de este articulo.
//
// SAP resta TODO lo comprometido, este el pedido autorizado o no. Un pedido
// sin autorizar puede caerse, asi que esas piezas siguen disponibles. Aqui se
// descuenta SOLO lo que esta en pedidos ya autorizados.
//
// `_IT_SEP` lo llena verItem al abrir la ficha.
var _IT_SEP = {aut:0, sin:0};

function _itDisp(base){
  var onhand = Number(base && base.onhand) || 0;
  return onhand - Number(_IT_SEP.aut || 0);
}

function fichaTecnica(base, carac){
  function cv(claves){ return carac?rptCarac(carac,claves):''; }
  var origenRaw=cv(['porigen','origen','origin','pais','country']);
  var origen = origenRaw ? (String(origenRaw).trim().length===2 ? (paisNombre(String(origenRaw).trim())||origenRaw) : origenRaw) : '';
  var cub = base.volumen ? (Math.round(base.volumen*100000)/100000)+' Pies' : cv(['cxblt','cubicaje','volumen']);
  var pesoP = base.peso ? (Math.round(base.peso*100)/100)+' kg' : cv(['peso','weight']);
  var piezas = base.unidadesbulto ? fmtN(base.unidadesbulto) : cv(['piezas','pcs']);
  var nota = base.usertext || base.remark || base.remarks || cv(['nota','note','notes','remarks','observaciones','observacion','comentario','comentarios']);
  var items=[
    {ic:'size',   c:'#E0A82E', lbl:'Tamano',       val:cv(['tamano','tama','medida','size','dimens'])},
    {ic:'cube',   c:'#1FA6A6', lbl:'Cubicaje',     val:cub},
    {ic:'weight', c:'#6B7280', lbl:'Peso producto',val:pesoP},
    {ic:'tag',    c:'#E0457B', lbl:'Marca',        val:(base.marca||cv(['marca','brand']))},
    {ic:'globe',  c:'#2E9E5B', lbl:'Origen',       val:origen},
    {ic:'weight', c:'#B98A3E', lbl:'Peso bulto',   val:cv(['pxblt','pesobulto','peso bulto'])},
    {ic:'box',    c:'#D98C3A', lbl:'Tamano bulto', val:cv(['cartonsize','tamanobulto','carton'])},
    {ic:'layers', c:'#3B82C4', lbl:'Piezas',       val:piezas},
    {ic:'color',  c:'#9B4DCA', lbl:'Color',        val:cv(['color'])},
    {ic:'list',   c:'#7C6FD0', lbl:'Composicion',  val:cv(['composic','compo','material','tela','fabric','content','hecho','confeccion','confección','fibra','algod','poliest','composition'])}
  ].filter(function(x){ return x.val!=null && String(x.val).trim()!==''; });
  if(!items.length && !(nota && String(nota).trim())) return '';
  var cells=items.map(function(x){
    return '<div style="display:flex;gap:12px;align-items:flex-start;padding:11px 4px">'
      +'<div style="flex:0 0 38px;height:38px;border-radius:10px;background:'+(x.c||'#3B82C4')+'1f;display:flex;align-items:center;justify-content:center;color:'+(x.c||'#3B82C4')+'">'+_ficIc(x.ic)+'</div>'
      +'<div style="min-width:0"><div style="font-size:10.5px;letter-spacing:.05em;text-transform:uppercase;color:var(--text3);font-weight:600;margin-bottom:2px">'+npEsc(x.lbl)+'</div>'
      +'<div style="font-size:13.5px;font-weight:600;word-break:break-word">'+npEsc(String(x.val))+'</div></div></div>';
  }).join('');
  var notaHtml='';
  if(nota && String(nota).trim()){
    notaHtml='<div style="margin-top:14px;padding:12px 14px;background:#FEF9E7;border-left:4px solid #E0A82E;border-radius:8px;display:flex;gap:10px;align-items:flex-start">'
      +'<div style="flex:0 0 22px;color:#B98A3E;font-size:16px;line-height:1">📝</div>'
      +'<div style="min-width:0;flex:1">'
        +'<div style="font-size:10.5px;letter-spacing:.05em;text-transform:uppercase;color:#8B6A2A;font-weight:700;margin-bottom:3px">Nota</div>'
        +'<div style="font-size:13.5px;color:#5A4A1F;line-height:1.5;word-break:break-word;white-space:pre-wrap;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,\'Liberation Mono\',\'Courier New\',monospace">'+npEsc(String(nota).replace(/\r\n?/g,'\n').replace(/\t/g,'  ').replace(/[ \t]+$/gm,''))+'</div>'
      +'</div></div>';
  }
  return '<div class="card" style="margin-top:14px"><div class="ct" style="margin-bottom:6px">Ficha tecnica del producto</div>'
    +(cells?'<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:2px 24px">'+cells+'</div>':'')
    +notaHtml
    +'</div>';
}
// Muestra qué clientes tienen separada (comprometida) la mercancía de un item,
// consultando los pedidos de venta abiertos. Permite abrir el pedido de cada cliente.
async function verSeparadoVentas(itemcode){
  if(!itemcode){ return; }
  var ov=document.createElement('div');
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px';
  ov.innerHTML='<div style="background:var(--card,#fff);border-radius:12px;padding:24px;max-width:480px;width:100%"><div style="font-size:13px;color:var(--text3,#888)">Buscando quién tiene separado '+itemcode+'...</div></div>';
  ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  document.body.appendChild(ov);
  try{
    var rows=await q('pedidos','select=docnum,docdate,cardcode,cardname,openqty,quantity,delivrdqty,docstatus,linestatus,nombrevendedor&itemcode=eq.'+encodeURIComponent(itemcode)+'&docstatus=eq.O&openqty=gt.0&or=(linestatus.eq.O,linestatus.is.null)&order=openqty.desc&limit=300');
    if(!Array.isArray(rows)) rows=[];

    // Si un pedido esta autorizado o no cambia lo que se puede hacer con esa
    // mercancia: la de un pedido sin autorizar todavia se puede reasignar. El
    // dato vive en `vista_pedidos`, no en `pedidos`, asi que se pide aparte y
    // en su propio try: si falla, se muestran los pedidos igual, sin el sello.
    var _aut={};
    try{
      var _dn=Array.from(new Set(rows.map(function(x){ return x.docnum; })
        .filter(function(d){ return d!=null; })));
      if(_dn.length){
        var _va=await q('vista_pedidos','select=docnum,autorizado&docnum=in.('+_dn.join(',')+')');
        (_va||[]).forEach(function(v){ _aut[v.docnum]=!!v.autorizado; });
      }
    }catch(e){}

    var totalSep=rows.reduce(function(s,x){return s+(Number(x.openqty)||0);},0);
    var _sinAut=rows.filter(function(x){ return _aut[x.docnum]===false; })
      .reduce(function(s,x){ return s+(Number(x.openqty)||0); }, 0);
    var h='<div style="background:var(--card,#fff);border-radius:12px;padding:20px;max-width:500px;width:100%;max-height:88vh;overflow-y:auto">';
    h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px"><div><div style="font-size:15px;font-weight:600">Mercancía separada</div><div style="font-size:12px;color:var(--text3,#888);margin-top:2px">'+itemcode+' · '+rows.length+' pedido(s) · '+fmtN(totalSep)+' und separadas'+(_sinAut>0?(' · <b style="color:#991B1B">'+fmtN(_sinAut)+' sin autorizar</b>'):'')+'</div></div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="background:none;border:none;font-size:24px;cursor:pointer;color:var(--text3,#888);line-height:1">&times;</button></div>';
    if(!rows.length){
      h+='<div style="font-size:13px;color:var(--text3,#888);padding:10px 0">No hay pedidos de venta abiertos con este producto separado.</div>';
    } else {
      h+='<div style="display:flex;flex-direction:column;gap:8px">';
      rows.forEach(function(p){
        var cliente=p.cardname||p.cardcode||'(sin cliente)';
        var sep=Number(p.openqty)||0;
        var vend=p.nombrevendedor?(' · '+p.nombrevendedor):'';
        h+='<div style="border:1px solid var(--border,#e5e7eb);border-radius:8px;padding:11px 13px">';
        h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px">';
        var _a=_aut[p.docnum];
        var _sello = (_a===undefined) ? ''
          : (_a ? '<span style="font-size:9.5px;font-weight:700;padding:1px 7px;border-radius:20px;'
                  +'background:#EAF3DE;color:#27500A;white-space:nowrap">AUTORIZADO</span>'
                : '<span style="font-size:9.5px;font-weight:700;padding:1px 7px;border-radius:20px;'
                  +'background:#FDE8E8;color:#991B1B;white-space:nowrap">SIN AUTORIZAR</span>');
        h+='<div style="flex:1;min-width:0">'
          +'<div style="display:flex;gap:7px;align-items:center;flex-wrap:wrap">'
          +'<span style="font-size:13px;font-weight:600">'+cliente+'</span>'+_sello+'</div>';
        h+='<div style="font-size:11px;color:var(--text3,#888);margin-top:1px">Pedido #'+(p.docnum||'?')+' · '+fmtD(p.docdate)+vend+'</div></div>';
        h+='<div style="text-align:right;flex-shrink:0"><div style="font-size:16px;font-weight:700;color:rgb(255,0,0)">'+fmtN(sep)+'</div><div style="font-size:9px;color:var(--text3,#888)">separadas</div></div>';
        h+='</div>';
        h+='<button onclick="this.closest(\'div[style*=fixed]\').remove();verPedido(\''+(p.docnum||'')+'\')" style="margin-top:9px;width:100%;background:var(--brand,#2a78d6);color:white;border:none;border-radius:6px;padding:7px 10px;cursor:pointer;font-size:12px;font-weight:600">Abrir pedido de venta →</button>';
        h+='</div>';
      });
      h+='</div>';
    }
    h+='</div>';
    ov.innerHTML=h;
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }catch(e){
    ov.innerHTML='<div style="background:var(--card,#fff);border-radius:12px;padding:24px;max-width:420px"><div style="font-size:13px;color:#c0392b">Error al buscar: '+(e.message||e)+'</div><button onclick="this.closest(\'div[style*=fixed]\').remove()" style="margin-top:14px;background:#eee;border:none;border-radius:7px;padding:7px 14px;cursor:pointer">Cerrar</button></div>';
    ov.addEventListener('click',function(e){ if(e.target===ov) ov.remove(); });
  }
}

async function verItem(codeOrEl,noPush){
  var itemcode=typeof codeOrEl==="string"?codeOrEl:(codeOrEl&&codeOrEl.dataset?codeOrEl.dataset.code:String(codeOrEl));
  if(!noPush && VISTA_ACTUAL){ NAVSTACK.push(VISTA_ACTUAL); }
  VISTA_ACTUAL=function(){ verItem(itemcode,true); };
  if(!noPush) _navPush({v:'item',a:itemcode});
  go('item_det',null);
  const el=document.getElementById('item-det-content');
  el.innerHTML='<div class="loading"><div class="spinner" style="border-top-color:var(--blue)"></div>Cargando producto...</div>';
  const ext=await invCols();
  const [vrow,fotosRow,invRow]=await Promise.all([
    q('vista_inventario','select=*&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=1'),
    q('fotos','select=url&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=1'),
    q('inventario','select=frgnname,usertext&itemcode=eq.'+encodeURIComponent(itemcode)+'&limit=1').catch(function(){return[];})
  ]);
  const base=vrow[0]||{};
  // Cuanto de lo comprometido esta en pedidos AUTORIZADOS y cuanto no. Lo
  // primero se descuenta del disponible; lo segundo se avisa, porque todavia
  // se puede vender pero conviene saber que hay un pedido esperando.
  _IT_SEP = {aut:0, sin:0};
  try{
    var _sa = await Promise.all([
      q('separado_autorizado','select=autorizado&itemcode=eq.'
        +encodeURIComponent(itemcode)+'&limit=1').catch(function(){ return []; }),
      q('separado_sin_autorizar','select=sin_autorizar&itemcode=eq.'
        +encodeURIComponent(itemcode)+'&limit=1').catch(function(){ return []; })
    ]);
    if(_sa[0] && _sa[0][0]) _IT_SEP.aut = Number(_sa[0][0].autorizado)||0;
    if(_sa[1] && _sa[1][0]) _IT_SEP.sin = Number(_sa[1][0].sin_autorizar)||0;
  }catch(e){}

  // Traer frgnname y usertext desde la tabla inventario (vista_inventario no los tiene)
  if(invRow && invRow[0]){
    if(invRow[0].frgnname) base.frgnname=invRow[0].frgnname;
    if(invRow[0].usertext) base.usertext=invRow[0].usertext;
  }
  const nombre=base.itemname||itemcode;
  const _shopFoto=(fotosRow&&fotosRow[0]&&fotosRow[0].url)||base.foto_url||'';
  const _fp=fotoPair(base.picturname, _shopFoto);
  const foto=_fp.primary;
  const bulto=Math.max(1,Number(base.unidadesbulto)||Number(base.numinbuy)||1);
  const pventa=Number(base.precioventa||0);
  const precio=pventa||Number(base.avgprice||base.lastpurprc||0);
  const dispo=Number(base.disponiblebodega||base.disponible||0);
  const carac=(base.caracteristicas&&typeof base.caracteristicas==='object')?base.caracteristicas:null;
  const fichaHtml=fichaTecnica(base,carac);
  const nmJs=nombre.replace(/'/g,"\\'");

  // El CIF, para administracion. Es la lista 2 de SAP -la misma del calculo
  // de margen-. Junto al FOB dice lo que costo la mercancia y lo que costo
  // puesta aqui, que es la diferencia que manda al poner precio.
  var _itemCif = null;
  if(CU && CU.rol === 'admin'){
    try{
      var _lp = await q('lista_precios',
        'select=price&listnum=eq.2&itemcode=eq.' + encodeURIComponent(itemcode) + '&limit=1');
      if(_lp && _lp[0] && Number(_lp[0].price) > 0) _itemCif = Number(_lp[0].price);
    }catch(e){}
  }

  el.innerHTML=`
  <div style="display:flex;gap:8px;align-items:center;margin-bottom:14px">
    <button class="btn btn-sm" onclick="navBack()">← Volver</button>
    ${(function(){var _r=String((CU&&CU.rol)||'').toLowerCase();
      return ['admin','administrador','gerencia','vendedor'].indexOf(_r)>=0
        ? '<button class="btn btn-sm" onclick="hviAbrir(\''+itemcode.replace(/'/g,"\\'")+'\')" style="background:#0F766E;color:#fff;border-color:#0F766E" title="Qui\u00e9n lo compr\u00f3, cu\u00e1ndo, cu\u00e1nto y a qu\u00e9 precio">\u{1F4C8} Historial de venta del item</button>'
        : '';})()}
    <span style="font-size:15px;font-weight:600">${nombre}</span>
    <div style="flex:1"></div>
    <button class="btn btn-p btn-sm" onclick="cartAddUnits('${itemcode.replace(/'/g,"\\'")}','${nmJs}',${precio},${bulto},${bulto})">🛒 Añadir al pedido${bulto>1?' (bulto '+fmtN(bulto)+')':''}</button>
  </div>
  <div style="display:grid;grid-template-columns:280px 1fr;gap:16px;margin-bottom:14px">
    <div>
      ${foto?`<img src="${foto}" data-fb="${_fp.fb}" data-ph="item" onclick="imgZoom(this.src)" title="Click para ampliar" style="width:100%;border-radius:var(--r);border:1px solid var(--border);cursor:zoom-in" onerror="fotoFallback(this)">`
      :`<div style="width:100%;height:280px;background:var(--bg);border-radius:var(--r);display:flex;align-items:center;justify-content:center;font-size:48px">📦</div>`}
    </div>
    <div>
      <div class="kpi-grid" style="grid-template-columns:repeat(${(CU&&CU.rol==='admin')?(_itemCif!=null?'4':'3'):'2'},1fr);margin-bottom:14px">
        <div class="kpi"><div class="kpi-lbl">Precio de venta</div><div class="kpi-val">${pventa?fmt(pventa):'—'}</div></div>
        <div class="kpi"><div class="kpi-lbl">Disponible</div><div class="kpi-val" style="color:rgb(21,206,43)">${fmtN(_itDisp(base))} <span onclick="verSeparadoVentas('${itemcode}')" style="font-size:12px;font-weight:500;color:rgb(255,0,0);cursor:pointer;text-decoration:underline" title="Separado en pedidos ya autorizados: no se puede vender">(${fmtN(_IT_SEP.aut)})</span>${_IT_SEP.sin?` <span onclick="verSeparadoVentas('${itemcode}')" style="font-size:12px;font-weight:500;color:#B45309;cursor:pointer;text-decoration:underline" title="Reservado en pedidos SIN autorizar: todavía se puede vender">+${fmtN(_IT_SEP.sin)} s/aut</span>`:''} <span style="font-size:12px;font-weight:500;color:#C9A800">(${fmtN(base.onorder)})</span></div><div class="kpi-sub">Stock · <span style="color:rgb(255,0,0)">separado</span> · <span style="color:#C9A800">por llegar</span></div></div>
        ${(CU&&CU.rol==='admin')?`<div class="kpi"><div class="kpi-lbl">Ultimo costo</div><div class="kpi-val">${fmt(base.lastpurprc)}</div></div>`:''}
        ${(CU&&CU.rol==='admin' && _itemCif!=null)?`<div class="kpi"><div class="kpi-lbl">Costo CIF</div><div class="kpi-val">${fmt(_itemCif)}</div>${(Number(base.lastpurprc)||0)>0?`<div style="font-size:11px;color:var(--text3);margin-top:2px">+${Math.round((_itemCif/Number(base.lastpurprc)-1)*100)}% sobre el FOB</div>`:''}</div>`:''}
      </div>
      <div class="card">
        <div class="ct" style="margin-bottom:12px">Informacion del producto</div>
        <table class="tbl">
          <tr><td style="color:var(--text3);width:140px">Codigo</td><td><b>${itemcode}</b></td></tr>
          <tr><td style="color:var(--text3)">Descripcion</td><td>${nombre}${base.frgnname?' <span style="color:var(--text3)">/</span> '+base.frgnname:''}</td></tr>
          <tr><td style="color:var(--text3)">Tipo de producto</td><td>${subgLabel(base.subg)}</td></tr>
          <tr><td style="color:var(--text3)">Marca</td><td>${base.marca||(carac?rptCarac(carac,['marca','brand']):'')||''}</td></tr>
          <tr><td style="color:var(--text3)">Codigo barras</td><td>${base.codebars||'—'}</td></tr>
          <tr><td style="color:var(--text3)">Unidades por bulto</td><td>${fmtN(bulto)}</td></tr>
          <tr><td style="color:var(--text3)">Unidad compra</td><td>${base.buyunitmsr||'—'}</td></tr>
          <tr><td style="color:var(--text3)">Unidad venta</td><td>${base.salunitmsr||'—'}</td></tr>
        </table>
      </div>
      ${fichaHtml}
    </div>
  </div>
  <div class="card">
    <div class="ct" style="margin-bottom:12px">Stock disponible</div>
    <table class="tbl">
      <tr><th style="color:rgb(21,206,43)">En stock</th><th style="color:rgb(255,0,0)">Separado</th><th style="color:#C9A800">Por llegar</th><th>Disponible</th></tr>
      <tr><td style="color:rgb(21,206,43);font-weight:600">${fmtN(base.onhand)}</td><td style="color:rgb(255,0,0);font-weight:600;cursor:pointer;text-decoration:underline" onclick="verSeparadoVentas('${itemcode}')" title="Ver quién lo tiene separado">${fmtN(base.iscommited)}</td><td style="color:#C9A800;font-weight:600">${fmtN(base.onorder)}</td><td><b>${fmtN(dispo)}</b></td></tr>
    </table>
  </div>`;
}

async function duplicarPedido(docnum){
  // Cargar líneas del pedido original
  const lines=await q('pedidos','select=itemcode,dscription,quantity,price,descuentolinea,whscode&docnum=eq.'+docnum+'&order=linenum');
  if(!lines.length){alert('Sin lineas para duplicar');return;}
  // Cargar stock actual de cada item
  const itemcodes=lines.map(l=>l.itemcode).filter(Boolean);
  const stocks={};
  if(itemcodes.length){
    const inv=await q('inventario','select=itemcode,disponiblebodega,disponible,onhand&itemcode=in.('+itemcodes.map(c=>'"'+c+'"').join(',')+')');
    inv.forEach(i=>stocks[i.itemcode]=Number(i.onhand!=null?i.onhand:(i.disponiblebodega||i.disponible||0)));
  }
  // Ir a nuevo pedido con las líneas prellenadas
  npLineas=lines.map(l=>({
    itemcode:l.itemcode,
    itemname:l.dscription||l.itemcode,
    quantity:Number(l.quantity)||1,
    price:Number(l.price)||0,
    discount:Number(l.descuentolinea)||0,
    whscode:l.whscode||'',
    bulto:1,
    stockActual:stocks[l.itemcode]||0
  }));
  go('nuevo_pedido',document.getElementById('nav-np'));
  npIr(2);
  setTimeout(()=>{npRenderLineas();},100);
}

// esNapa: la factura vive en facturas_napa. Se usa la MISMA pantalla que las
// de Kennedy —con fotos, exportadores y stock— cambiando solo de que tabla se
// leen la cabecera y las lineas.
async function verFactura(docnum,noPush,esNapa){
  if(!noPush && VISTA_ACTUAL){ NAVSTACK.push(VISTA_ACTUAL); }
  VISTA_ACTUAL=function(){ verFactura(docnum,true); };
  if(!noPush) _navPush({v:'factura',a:docnum});
  go('factura_det',null);
  const el=document.getElementById('fac-det-content');
  el.innerHTML='<div class="loading"><div class="spinner" style="border-top-color:var(--blue)"></div>Cargando factura...</div>';
  const [head, lines] = await Promise.all([
    esNapa
      ? q('facturas_napa','select=docnum,docdate,cardcode,cardname,doctotal,docstatus,nombrevendedor&docnum=eq.'+docnum+'&limit=1')
      : q('facturas','select=docnum,docdate,docduedate,cardcode,cardname,doctotal,paidtodate,docstatus,comments,nombrevendedor&docnum=eq.'+docnum+'&limit=1'),
    esNapa
      ? q('facturas_napa','select=linenum,itemcode,dscription,quantity,price,linetotal&docnum=eq.'+docnum+'&order=linenum')
      : q('facturas','select=linenum,itemcode,dscription,quantity,price,descuentolinea,linetotal,whscode&docnum=eq.'+docnum+'&order=linenum')
  ]);
  // Se dejan a mano para el boton de catalogo: son las mismas lineas y
  // no tiene sentido volver a pedirlas.
  window._FAC_LINEAS = lines || [];
  const h=head[0]||{};
  // Se marca la empresa para que nadie confunda una factura de NAPA con una
  // de Kennedy: los numeros de documento se repiten entre las dos.
  if(esNapa) h._napa = true;
  // Cargar stock actual de items
  const codes=lines.map(l=>l.itemcode).filter(Boolean);
  const stocks={}; const barcodes={}; const fotosMap={};
  if(codes.length){
    const inv=await q('vista_inventario','select=itemcode,disponiblebodega,disponible,onhand,picturname,foto_url&itemcode=in.('+codes.map(c=>'"'+c+'"').join(',')+')');
    inv.forEach(i=>{stocks[i.itemcode]=Number(i.onhand!=null?i.onhand:(i.disponiblebodega||i.disponible||0)); fotosMap[i.itemcode]={pn:i.picturname||'',fu:i.foto_url||''};});
    // Respaldo: tabla `fotos` (misma fuente que el detalle del item)
    try{ const fx=await q('fotos','select=itemcode,url&itemcode=in.('+codes.map(c=>'"'+c+'"').join(',')+')');
      (fx||[]).forEach(function(x){ if(!x.url) return; var m=fotosMap[x.itemcode]||{}; if(!m.fu) m.fu=x.url; fotosMap[x.itemcode]=m; }); }catch(e){}
    try{ const bc=await q('vista_inventario','select=itemcode,codebars&itemcode=in.('+codes.map(c=>'"'+c+'"').join(',')+')'); (bc||[]).forEach(i=>{ if(i.codebars)barcodes[i.itemcode]=i.codebars; }); }catch(e){}
  }
  el.innerHTML=`
  <div style="display:flex;gap:8px;align-items:center;margin-bottom:14px;flex-wrap:wrap">
    <button class="btn btn-sm" onclick="navBack()">← Volver</button>
    <button class="btn btn-sm" onclick="window.print()">🖨️ Imprimir</button>
    <button class="btn btn-sm btn-p" onclick="restockDesdeFactura(${docnum},${!!esNapa})">🔄 Restock en nuevo pedido</button>
    <button class="btn btn-sm" onclick="ncrNueva(${docnum})" style="background:#F97316;color:#fff;border-color:#F97316">📄 Nota de crédito</button>
  </div>
  <div class="card" style="margin-bottom:14px">
    <div class="ct" style="margin-bottom:10px">Generar reporte de la factura</div>
    <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:8px;margin-bottom:12px">${rptChecksHTML('pdc-')}</div>
    <div style="display:flex;gap:8px">
      <button class="btn btn-p btn-sm" onclick="catDesdeFactura(${h.docnum}, window._FAC_LINEAS||[])"><svg class="tic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg> Generar PDF</button>
      <button class="btn btn-sm" onclick="docReporteTabla('factura',${h.docnum},${!!esNapa})" style="background:#6c47ff;color:#fff;border-color:#6c47ff" title="PDF en formato pedido: tabla con lineas, las columnas elegidas y los totales al final">📋 PDF formato pedido</button>
      <button class="btn btn-sm" onclick="fotosHD('factura',${h.docnum},${!!esNapa})" title="Descargar las fotos de los art&iacute;culos en alta definici&oacute;n">&#128444; Fotos HD</button><button class="btn btn-sm" onclick="docReporte('factura',${h.docnum},'excel',${!!esNapa})" style="background:var(--green);color:#fff;border-color:var(--green)"><svg class="tic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg> Generar Excel</button>
    </div>
  </div>
  <div class="ped-header" style="background:var(--blue);color:#fff;border-radius:var(--r);padding:16px 20px;margin-bottom:14px">
    <h2 style="font-size:18px;font-weight:700;margin-bottom:4px">Factura #${h.docnum}${h._napa?' <span style="background:#7C3AED;color:#fff;padding:2px 9px;border-radius:10px;font-size:12px;font-weight:700;vertical-align:middle">NAPA</span>':''}</h2>
    <p style="font-size:12px;opacity:.7">${h.cardname} · ${fmtD(h.docdate)} · Vendedor: ${h.nombrevendedor||'—'}</p>
  </div>
  <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin-bottom:14px">
    <div class="kpi"><div class="kpi-lbl">Total</div><div class="kpi-val">${fmt(h.doctotal)}</div></div>
    <div class="kpi"><div class="kpi-lbl">Pagado</div><div class="kpi-val">${fmt(h.paidtodate)}</div></div>
    <div class="kpi"><div class="kpi-lbl">Saldo</div><div class="kpi-val" style="color:${(Number(h.doctotal)-Number(h.paidtodate||0))>0?'var(--red)':'inherit'}">${fmt(Number(h.doctotal)-Number(h.paidtodate||0))}</div></div>
    <div class="kpi"><div class="kpi-lbl">Estado</div><div class="kpi-val"><span class="badge ${h.docstatus==='O'?'b-blue':'b-gray'}">${h.docstatus==='O'?'Abierta':'Cerrada'}</span></div></div>
  </div>
  <div class="card">
    <div class="ch"><span class="ct">🧾 Lineas de la factura</span><span style="font-size:14px;font-weight:700;color:var(--blue)">${fmt(h.doctotal)}</span></div>
    <table class="tbl">
      <tr><th>Foto</th><th>#</th><th>SKU</th><th>Descripcion</th><th>Barcode</th><th style="text-align:right">Cant.</th><th style="text-align:right">Precio</th><th style="text-align:right">Desc.</th><th style="text-align:right">Total</th><th style="text-align:right">Stock actual</th></tr>
      ${lines.map(function(l){
        var st=stocks[l.itemcode]!=null?stocks[l.itemcode]:'—';
        var stColor=typeof st==='number'&&st<Number(l.quantity)?'color:var(--red);font-weight:600':'color:var(--green)';
        var _fm=fotosMap[l.itemcode]||{};
        return '<tr>'
          +'<td>'+lineFoto(_fm.pn,_fm.fu)+'</td>'
          +'<td>'+(Number(l.linenum)+1)+'</td>'
          +'<td style="color:#185FA5;cursor:pointer" onclick="verItem(\''+l.itemcode+'\')"><u>'+l.itemcode+'</u></td>'
          +'<td>'+(l.dscription||'—')+'</td>'
          +'<td style="font-size:12px;color:var(--text2)">'+(barcodes[l.itemcode]||'—')+'</td>'
          +'<td style="text-align:right">'+fmtN(l.quantity)+'</td>'
          +'<td style="text-align:right">'+fmt(l.price)+'</td>'
          +'<td style="text-align:right">'+(l.descuentolinea?Number(l.descuentolinea).toFixed(1)+'%':'—')+'</td>'
          +'<td style="text-align:right;font-weight:600">'+fmt(l.linetotal)+'</td>'
          +'<td style="text-align:right;'+stColor+'">'+(typeof st==='number'?fmtN(st):st)+'</td>'
          +'</tr>';
      }).join('')}
    </table>
  </div>
  ${h.comments?`<div class="card" style="margin-top:14px"><div class="ct" style="margin-bottom:8px">💬 Comentarios</div><p style="font-size:13px;color:var(--text2)">${h.comments}</p></div>`:''}`;
}

async function restockDesdeFactura(docnum, esNapa){
  // Una factura de NAPA esta en otra tabla; con la de Kennedy se recompraria
  // el documento equivocado, porque los numeros se repiten entre empresas.
  const [head,lines]=await Promise.all([
    esNapa
      ? q('facturas_napa','select=docnum,cardcode,cardname&docnum=eq.'+docnum+'&limit=1')
      : q('vista_facturas','select=docnum,cardcode,cardname&docnum=eq.'+docnum+'&limit=1'),
    esNapa
      ? q('facturas_napa','select=itemcode,dscription,quantity,price&docnum=eq.'+docnum+'&order=linenum')
      : q('facturas','select=itemcode,dscription,quantity,price,descuentolinea,whscode&docnum=eq.'+docnum+'&order=linenum')
  ]);
  if(!lines||!lines.length){alert('Esta factura no tiene líneas para recomprar.');return;}
  const h=(head&&head[0])?head[0]:{};
  const codes=lines.map(l=>l.itemcode).filter(Boolean);
  const stocks={};
  if(codes.length){
    const inv=await q('inventario','select=itemcode,disponiblebodega,disponible,onhand&itemcode=in.('+codes.map(c=>'"'+c+'"').join(',')+')');
    (inv||[]).forEach(i=>stocks[i.itemcode]=Number(i.onhand!=null?i.onhand:(i.disponiblebodega!=null?i.disponiblebodega:i.disponible||0)));
  }
  npLineas=lines.map(l=>({
    itemcode:l.itemcode,
    itemname:l.dscription||l.itemcode,
    quantity:Number(l.quantity)||1,
    price:Number(l.price)||0,
    discount:Number(l.descuentolinea)||0,
    whscode:l.whscode||'',
    bulto:1,note:'',
    stockActual:(stocks[l.itemcode]!=null?stocks[l.itemcode]:0)
  }));
  // Arrastrar el cliente de la factura
  if(h.cardcode){
    npCli={cardcode:h.cardcode,cardname:h.cardname||h.cardcode};
    var inp=document.getElementById('np-cli-q');if(inp)inp.style.display='none';
    var sel=document.getElementById('np-cli-sel');
    if(sel){sel.style.display='block';
      var nm=document.getElementById('np-cli-name');if(nm)nm.textContent=npCli.cardname;
      var mt=document.getElementById('np-cli-meta');if(mt)mt.textContent=npCli.cardcode;
      var av=document.getElementById('np-cli-av');if(av)av.textContent=(npCli.cardname||'?').slice(0,2).toUpperCase();
    }
    var b2=document.getElementById('np-btn2');if(b2)b2.disabled=false;
  }
  go('nuevo_pedido',document.getElementById('nav-np'));
  var faltantes=npLineas.filter(function(l){return l.stockActual!=null && l.stockActual < l.quantity;});
  setTimeout(function(){npIr(3);npRenderLineas();npAvisoStock(faltantes);},120);
}

function npAvisoStock(faltantes){
  var st=document.getElementById('np-status');
  if(!st||!faltantes||!faltantes.length)return;
  st.className='status-box';st.style.display='block';st.style.textAlign='left';st.style.marginBottom='14px';
  st.style.background='#fff7ed';st.style.border='1px solid #fdba74';st.style.borderRadius='10px';st.style.padding='12px 16px';
  st.innerHTML='<div style="font-weight:700;color:#9a3412;margin-bottom:4px">⚠️ Hay productos sin stock suficiente</div>'
    +'<div style="font-size:12px;color:#7c2d12;margin-bottom:6px">Puedes cotizar igual, pero revisa estos antes de enviar el pedido a SAP:</div>'
    +'<ul style="margin:0 0 0 18px;font-size:12px;color:#7c2d12">'
    +faltantes.map(function(l){return '<li><b>'+npEsc(l.itemname)+'</b> ('+npEsc(l.itemcode)+') — pides '+fmtN(l.quantity)+', disponible '+fmtN(l.stockActual||0)+'</li>';}).join('')
    +'</ul>';
}

function miniAvance(est){
  if(!est) return '<span style="color:#c2c8d4">—</span>';
  function seg(pct,color){
    pct=Math.max(0,Math.min(100,Math.round(Number(pct)||0)));
    return '<div style="height:4px;background:#eceef3;border-radius:3px;overflow:hidden"><div style="height:100%;width:'+pct+'%;background:'+color+';border-radius:3px"></div></div>';
  }
  var e=Math.round(Number(est.pct_entregado)||0), f=Math.round(Number(est.pct_facturado)||0), d=Math.round(Number(est.pct_devuelto)||0);
  var tip='Entregado '+e+'%  |  Facturado '+f+'%  |  Devuelto '+d+'%';
  return '<div title="'+tip+'" style="display:inline-flex;flex-direction:column;gap:2px;width:74px;vertical-align:middle">'
    +seg(e,'var(--green)')+seg(f,'var(--blue)')+seg(d,'var(--red)')+'</div>';
}
function barraAvance(label,pct,val,total,color){
  pct=Math.max(0,Math.min(100,Math.round(Number(pct)||0)));
  return '<div style="margin-bottom:14px"><div style="display:flex;justify-content:space-between;font-size:12.5px;margin-bottom:5px"><span style="font-weight:600">'+label+'</span>'
    +'<span style="color:var(--text3)">'+pct+'% · '+fmtN(val||0)+' / '+fmtN(total||0)+' pzas</span></div>'
    +'<div style="height:9px;background:var(--bg);border-radius:6px;overflow:hidden"><div style="height:100%;width:'+pct+'%;background:'+color+';border-radius:6px;transition:width .4s"></div></div></div>';
}
// ── Precio de lista y precio unitario tras el descuento ──────────────
// OJO con la convencion de SAP: en RDR1, `Price` YA viene con el descuento
// aplicado y `PriceBefDi` es el de lista. Mostrar solo "Precio" junto a
// "Descuento" hacia pensar que el descuento estaba pendiente de aplicar.
function _pLista(l){
  var pb=Number(l.pricebefdi);
  if(pb>0) return pb;
  // Sin precio de lista: se reconstruye desde el neto y el descuento.
  var d=Number(l.descuentolinea)||0, pr=Number(l.price)||0;
  return (d>0 && d<100) ? pr/(1-d/100) : pr;
}
// El neto se saca del total de la linea entre la cantidad: es lo que el
// cliente paga de verdad por unidad, sin depender de que convencion siga
// el campo `price`.
function _pNeto(l){
  var q=Number(l.quantity)||0, lt=Number(l.linetotal);
  if(q>0 && isFinite(lt)) return lt/q;
  var pr=Number(l.price)||0, d=Number(l.descuentolinea)||0;
  return (d>0 && d<100 && Math.abs(pr-Number(l.pricebefdi||pr))<0.0001) ? pr*(1-d/100) : pr;
}

// ── EDICION DE LINEAS: solo precios, cantidades y descuentos ────────
// REGLA: un pedido AUTORIZADO ya no se toca. Se comprueba aqui, en la
// politica de la base, en el puente y en el propio UPDATE contra SAP.
window._pedEdLineas = window._pedEdLineas || [];

function _pedEditable(h, est){
  if(est && est.autorizado) return false;                     // ya autorizado
  if(String(h.confirmed||'').toUpperCase()==='Y') return false; // idem, por el otro campo
  if(String(h.docstatus||'').toUpperCase()!=='O') return false; // cerrado o cancelado
  var rol=String((typeof CU!=='undefined'&&CU&&CU.rol)||'').toLowerCase();
  return rol==='admin'||rol==='administrador'||rol==='gerencia'||rol==='vendedor';
}

function pedEditarAbrir(docnum){
  var box=document.getElementById('ped-ed-panel'); if(!box) return;
  if(box.getAttribute('data-open')==='1'){ pedEditarCerrar(); return; }
  box.setAttribute('data-open','1');
  var btn=document.getElementById('ped-ed-btn'); if(btn) btn.textContent='Cancelar edición';

  var filas=(window._pedEdLineas||[]).map(function(l){
    var i=Number(l.linenum);
    var ent=Number(l.delivrdqty)||0;
    var im=(window._pedEdInv||{})[l.itemcode]||{};
    return '<tr data-ln="'+i+'">'
      +'<td>'+lineFoto(im.pn, im.fu)+'</td>'
      +'<td style="color:var(--text3)">'+(i+1)+'</td>'
      +'<td style="font-weight:600">'+npEsc(l.itemcode||'')+'</td>'
      +'<td style="font-size:12px">'+npEsc(l.dscription||'')+'</td>'
      +'<td><input type="number" step="1" min="'+ent+'" value="'+(Number(l.quantity)||0)+'" id="pe-q-'+i+'" oninput="pedEditCalc('+i+')" style="width:82px;padding:5px 7px;border:1px solid var(--border);border-radius:6px;text-align:right;font-size:13px">'
        +(ent>0?'<div style="font-size:10px;color:var(--amber,#B45309);margin-top:2px">'+fmtN(ent)+' ya entregadas</div>':'')+'</td>'
      +'<td><input type="number" step="0.0001" min="0" value="'+(_pLista(l)||0).toFixed(4)+'" id="pe-p-'+i+'" oninput="pedEditCalc('+i+')" style="width:96px;padding:5px 7px;border:1px solid var(--border);border-radius:6px;text-align:right;font-size:13px"></td>'
      +'<td><input type="number" step="0.01" min="0" max="100" value="'+(Number(l.descuentolinea)||0)+'" id="pe-d-'+i+'" oninput="pedEditCalc('+i+')" style="width:74px;padding:5px 7px;border:1px solid var(--border);border-radius:6px;text-align:right;font-size:13px"></td>'
      +'<td style="text-align:right;font-weight:700;color:var(--blue2)" id="pe-n-'+i+'">'+fmt(_pNeto(l))+'</td>'
      +'<td style="text-align:right;font-weight:700" id="pe-t-'+i+'">'+fmt(l.linetotal)+'</td>'
      +'</tr>';
  }).join('');

  box.innerHTML='<div style="background:var(--bg2,#f7f8fa);border-left:3px solid var(--blue2);border-radius:8px;padding:12px 14px;margin:10px 0">'
    +'<div style="font-size:12.5px;font-weight:600;margin-bottom:3px">Editar líneas del pedido '+docnum+'</div>'
    +'<div style="font-size:11.5px;color:var(--text3);margin-bottom:10px">Solo se modifican <b>vendedor, cantidad, precio y descuento</b>. Ningún otro dato del pedido se toca. El precio neto y el total se recalculan según escribes.</div>'
    +'<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;flex-wrap:wrap">'
      +'<label style="font-size:12px;color:var(--text3)">Vendedor:</label>'
      +'<select id="pe-vend" style="padding:6px 10px;border:1px solid var(--border);border-radius:7px;font-size:13px;background:#fff;min-width:220px">'
        +'<option value="">Cargando…</option></select>'
    +'</div>'
    +'<div style="overflow-x:auto"><table class="tbl" style="font-size:12.5px">'
      +'<tr><th>Foto</th><th>#</th><th>Código</th><th>Descripción</th><th>Cantidad</th><th>P. lista</th><th>Desc. %</th>'
      +'<th style="text-align:right">P. neto</th><th style="text-align:right">Total</th></tr>'
      +filas+'</table></div>'
    +'<div style="display:flex;justify-content:space-between;align-items:center;margin-top:12px;gap:10px;flex-wrap:wrap">'
      +'<div style="font-size:13px">Nuevo total: <b id="pe-total" style="font-size:17px;color:var(--blue2)">—</b></div>'
      +'<div style="display:flex;gap:8px">'
        +'<button class="btn btn-sm" onclick="pedEditarCerrar()">Cancelar</button>'
        +'<button class="btn btn-sm btn-p" onclick="pedEditGuardar('+docnum+')">Guardar cambios</button>'
      +'</div>'
    +'</div>'
    +'<div id="pe-msg" style="display:none;font-size:12px;margin-top:8px;line-height:1.4"></div>'
    +'</div>';
  pedEditTotal();
  _pedEdCargarVendedores();
}

// Llena el desplegable con los vendedores y marca el del pedido.
async function _pedEdCargarVendedores(){
  var sel=document.getElementById('pe-vend'); if(!sel) return;
  try{
    if(!window._pedEdVend){
      window._pedEdVend=await q('vendedores','select=slpcode,slpname&order=slpname')||[];
    }
    var actual=String((window._pedEdHead&&window._pedEdHead.slpcode)!=null?window._pedEdHead.slpcode:'');
    sel.innerHTML=(window._pedEdVend||[]).map(function(v){
      var c=String(v.slpcode);
      return '<option value="'+npEsc(c)+'"'+(c===actual?' selected':'')+'>'+npEsc(v.slpname||('Vendedor '+c))+'</option>';
    }).join('');
    sel.setAttribute('data-orig', actual);
  }catch(e){
    sel.innerHTML='<option value="">No se pudo cargar la lista</option>';
  }
}

function pedEditarCerrar(){
  var box=document.getElementById('ped-ed-panel');
  if(box){ box.setAttribute('data-open','0'); box.innerHTML=''; }
  var btn=document.getElementById('ped-ed-btn');
  if(btn) btn.textContent='✏️ Editar precios y cantidades';
}

// Recalcula neto y total de una linea segun lo que se va escribiendo.
function pedEditCalc(i){
  var q=Number((document.getElementById('pe-q-'+i)||{}).value)||0;
  var p=Number((document.getElementById('pe-p-'+i)||{}).value)||0;
  var d=Number((document.getElementById('pe-d-'+i)||{}).value)||0;
  if(d<0)d=0; if(d>100)d=100;
  var neto=p*(1-d/100), tot=neto*q;
  var en=document.getElementById('pe-n-'+i); if(en) en.textContent=fmt(neto);
  var et=document.getElementById('pe-t-'+i); if(et) et.textContent=fmt(tot);
  pedEditTotal();
}

function pedEditTotal(){
  var t=0;
  (window._pedEdLineas||[]).forEach(function(l){
    var i=Number(l.linenum);
    var q=Number((document.getElementById('pe-q-'+i)||{}).value)||0;
    var p=Number((document.getElementById('pe-p-'+i)||{}).value)||0;
    var d=Number((document.getElementById('pe-d-'+i)||{}).value)||0;
    t += p*(1-d/100)*q;
  });
  var e=document.getElementById('pe-total'); if(e) e.textContent=fmt(t);
}

function _pedEdMsg(txt,tipo){
  var m=document.getElementById('pe-msg'); if(!m) return;
  if(!txt){ m.style.display='none'; m.innerHTML=''; return; }
  m.style.display='block';
  m.style.color = tipo==='ok'?'var(--green,#639922)':(tipo==='err'?'#E24B4A':'var(--text2,#374151)');
  m.innerHTML=txt;
}

// Envia los cambios a la cola. El navegador NO escribe en SAP: deja la
// solicitud y el puente de kennedy_live.py la aplica.
async function pedEditGuardar(docnum){
  var cambios=[], errores=[];
  (window._pedEdLineas||[]).forEach(function(l){
    var i=Number(l.linenum);
    var eq=document.getElementById('pe-q-'+i);
    var ep=document.getElementById('pe-p-'+i);
    var ed=document.getElementById('pe-d-'+i);
    if(!eq||!ep||!ed) return;
    var q=Number(eq.value), p=Number(ep.value), d=Number(ed.value);
    var q0=Number(l.quantity)||0, p0=Number(_pLista(l))||0, d0=Number(l.descuentolinea)||0;
    var ent=Number(l.delivrdqty)||0;

    if(!isFinite(q)||!isFinite(p)||!isFinite(d)){ errores.push('Línea '+(i+1)+': hay un valor vacío o inválido.'); return; }
    if(q<=0)          errores.push('Línea '+(i+1)+': la cantidad debe ser mayor que 0.');
    if(q<ent)         errores.push('Línea '+(i+1)+': no puede quedar por debajo de las '+fmtN(ent)+' ya entregadas.');
    if(p<0)           errores.push('Línea '+(i+1)+': el precio no puede ser negativo.');
    if(d<0||d>100)    errores.push('Línea '+(i+1)+': el descuento debe estar entre 0 y 100.');

    // Solo se manda lo que realmente cambió
    if(Math.abs(q-q0)<1e-9 && Math.abs(p-p0)<1e-6 && Math.abs(d-d0)<1e-9) return;
    cambios.push({linenum:i, quantity:q, price:p, disc:d});
  });

  // Vendedor: solo se manda si de verdad cambió
  var selV=document.getElementById('pe-vend');
  var vendNuevo=null, vendTxt='';
  if(selV && selV.value && selV.value!==selV.getAttribute('data-orig')){
    vendNuevo=Number(selV.value);
    vendTxt=selV.options[selV.selectedIndex].text;
  }

  if(errores.length){ _pedEdMsg(errores.slice(0,4).join('<br>'),'err'); return; }
  if(!cambios.length && vendNuevo===null){ _pedEdMsg('No has cambiado nada.','err'); return; }

  var resumen=[];
  if(cambios.length)     resumen.push(cambios.length+' línea(s)');
  if(vendNuevo!==null)   resumen.push('vendedor → '+vendTxt);
  if(!confirm('Se va a modificar el pedido '+docnum+' en SAP:\n\n  · '+resumen.join('\n  · ')
             +'\n\nNingún otro dato se toca.\n\n¿Continuar?')) return;

  _pedEdMsg('','info');
  var fila={ docnum:Number(docnum), lineas:cambios, estado:'pendiente',
             solicitado_por:((typeof CU!=='undefined'&&CU)?(CU.username||CU.nombre||'portal'):'portal') };
  if(vendNuevo!==null) fila.slpcode=vendNuevo;
  try{
    var r=await fetch(SB+'/rest/v1/pedidos_cambios_queue',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json','Prefer':'return=representation'},
      body:JSON.stringify(fila)
    });
    if(!r.ok){ var t=await r.text(); _pedEdMsg('No se pudo enviar: '+t.slice(0,180),'err'); return; }
    var creado=await r.json();
    _pedEdSeguir((creado&&creado[0]&&creado[0].id)||null, docnum);
  }catch(e){ _pedEdMsg('Error de conexión: '+e.message,'err'); }
}

// Espera a que el puente lo aplique en SAP y refresca el pedido.
async function _pedEdSeguir(id, docnum){
  if(!id){ _pedEdMsg('Enviado. Se aplicará en unos momentos.','ok'); return; }
  var intentos=0;
  var timer=setInterval(async function(){
    if(++intentos>25){ clearInterval(timer); _pedEdMsg('Sigue en cola. Se aplicará cuando el sync corra.','info'); return; }
    try{
      var f=await q('pedidos_cambios_queue','select=estado,mensaje&id=eq.'+id+'&limit=1');
      var row=(f&&f[0])||null; if(!row) return;
      if(row.estado==='ok'){
        clearInterval(timer);
        _pedEdMsg('✓ Aplicado en SAP. Actualizando el pedido…','ok');
        setTimeout(function(){ pedEditarCerrar(); verPedido(docnum,true); },1200);
      }else if(row.estado==='error'){
        clearInterval(timer);
        _pedEdMsg('SAP rechazó el cambio: '+(row.mensaje||'sin detalle'),'err');
      }
    }catch(e){}
  },3000);
}

// Codigo del cliente como enlace a su ficha (estado de cuenta, facturas...).
// Se usa en la cabecera del detalle de pedido y en el bloque de datos.
function _cliLink(cardcode){
  if(!cardcode) return '';
  var cs=String(cardcode).replace(/'/g,"\\'");
  return '<a href="javascript:void(0)" onclick="event.stopPropagation();verCliente(\''+cs+'\')" '
    +'title="Ver la ficha del cliente: estado de cuenta, facturas, pedidos" '
    +'style="color:var(--blue2);font-weight:600;text-decoration:none;border-bottom:1px dotted var(--blue2)">'
    +npEsc(cardcode)+'</a>';
}

async function verPedido(docnum,noPush){
  if(CU&&CU.rol==='cliente')return;
  if(!noPush && VISTA_ACTUAL){ NAVSTACK.push(VISTA_ACTUAL); }
  VISTA_ACTUAL=function(){ verPedido(docnum,true); };
  if(!noPush) _navPush({v:'pedido',a:docnum});
  $('ped-det-content').innerHTML=loading();
  go('pedido_det',null);
  const [head,lines,estado,entregas]=await Promise.all([
    // Un cliente solo puede abrir SUS pedidos: sin este filtro bastaba con
    // cambiar el numero en la URL para ver el de otro.
    q('pedidos',`select=docnum,docdate,docduedate,cardcode,cardname,doctotal,doccur,docstatus,comments,nombrevendedor&docnum=eq.${docnum}`
      + ((CU&&CU.rol==='cliente') ? `&cardcode=eq.${encodeURIComponent(CU.cardcode||'')}` : '')
      + `&limit=1`),
    q('pedidos',`select=linenum,itemcode,dscription,quantity,price,pricebefdi,descuentolinea,linetotal,unitmsr,delivrdqty,openqty,docstatus&docnum=eq.${docnum}&order=linenum`),
    q('vista_pedidos',`select=autorizado,pct_entregado,pct_devuelto,pct_facturado,pzas_pedido,pzas_entregadas,pzas_devueltas,pzas_facturadas&docnum=eq.${docnum}&limit=1`).catch(function(){return [];}),
    q('entregas',`select=docnum,docdate,linenum,itemcode,dscription,quantity&pedido=eq.${docnum}&order=docnum.desc,linenum`).catch(function(){return [];})
  ]);
  // Se dejan a mano para el boton de catalogo: son las mismas lineas y
  // no tiene sentido volver a pedirlas.
  window._PED_LINEAS = lines || [];
  const h=head[0]||{};
  const est=(estado&&estado[0])||{};
  window._pedEdLineas=lines||[];   // las usa el editor de líneas
  // Saldo del cliente + barcode/stock de cada item
  var cliSaldo=null, invMap={};
  try{
    var _ex=await Promise.all([
      h.cardcode?q('clientes',`select=balance&cardcode=eq.${h.cardcode}&limit=1`):Promise.resolve([]),
      lines.length?q('inventario','select=itemcode,codebars,disponiblebodega,onhand,picturname,foto_url&itemcode=in.('+lines.map(l=>'"'+(l.itemcode||'')+'"').join(',')+')'):Promise.resolve([])
    ]);
    if(_ex[0]&&_ex[0][0]) cliSaldo=Number(_ex[0][0].balance||0);
    (_ex[1]||[]).forEach(function(i){invMap[i.itemcode]={bc:i.codebars||'',st:Number(i.onhand!=null?i.onhand:(i.disponiblebodega||0)),pn:i.picturname||'',fu:i.foto_url||''};});
    // Respaldo de fotos: tabla `fotos` (misma fuente que el detalle del item)
    try{ if(lines.length){ var _fx=await q('fotos','select=itemcode,url&itemcode=in.('+lines.map(l=>'"'+(l.itemcode||'')+'"').join(',')+')');
      (_fx||[]).forEach(function(x){ if(!x.url) return; var m=invMap[x.itemcode]||{bc:'',st:null,pn:'',fu:''}; if(!m.fu) m.fu=x.url; invMap[x.itemcode]=m; }); } }catch(e){}
  window._pedEdInv=invMap;   // el editor de lineas usa las mismas fotos
  window._pedEdHead=h;       // para saber el vendedor actual
  }catch(e){}
  $('ped-det-content').innerHTML=`
  <div id="ped-divorcio" style="margin-bottom:12px"></div>\n  <div id="ped-revision" style="margin-bottom:12px"></div>\n  <div style="display:flex;gap:8px;align-items:center;margin-bottom:14px;flex-wrap:wrap">
    <button class="btn btn-sm" onclick="navBack()">← Volver</button>
    <button class="btn btn-sm" onclick=\"pedPdf('${h.docnum}')\">🖨️ Imprimir pedido</button>
    ${(estado&&estado[0]&&estado[0].autorizado)?'':`<button class="btn btn-sm" id="ped-div" onclick=\"divAbrir('${h.docnum}')\" title="Separar lo que hay de lo que no: lo marcado se va a un pedido nuevo">&#9986; Divorciar pedido</button>`}\n    <button class="btn btn-sm" id="ped-vt" onclick=\"vtDesdePedido('${h.docnum}')\" title="El cliente lo revisa y pide cambios; tu decides si se aplican">&#128273; Mandar a revisar al cliente</button>\n    <button class="btn btn-sm" id="ped-wa" onclick=\"pedWhatsApp('${h.docnum}')\" style="background:#25D366;color:#fff;border-color:#25D366;display:inline-flex;align-items:center;gap:6px"><svg viewBox="0 0 32 32" width="14" height="14" aria-hidden="true" style="flex:0 0 auto"><path fill="#fff" d="M16 3.2C8.9 3.2 3.2 8.9 3.2 16c0 2.3.6 4.4 1.7 6.3L3.2 28.8l6.7-1.7c1.8 1 3.9 1.6 6.1 1.6 7.1 0 12.8-5.7 12.8-12.8S23.1 3.2 16 3.2zm0 23c-1.9 0-3.7-.5-5.3-1.4l-.4-.2-4 1 1.1-3.9-.3-.4c-1-1.6-1.5-3.5-1.5-5.4 0-5.7 4.7-10.4 10.4-10.4S26.4 10.3 26.4 16 21.7 26.2 16 26.2z"/><path fill="#fff" d="M21.7 18.9c-.3-.2-1.8-.9-2.1-1-.3-.1-.5-.2-.7.2s-.8 1-1 1.2c-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-1-2.3c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.1 1.4 3.4c.2.2 2.4 3.7 5.8 5.1.8.3 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.8-.8 2.1-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z"/></svg>Enviar pedido al cliente</button>
    <button class="btn btn-sm btn-p" onclick="murAbrir(${h.docnum})" title="Ver el pedido con las fotos, para mostrarlo al cliente">&#128444; Vista visual</button>
  </div>
  <div class="card" style="margin-bottom:14px">
    <div class="ct" style="margin-bottom:10px">📄 Generar reporte del pedido</div>
    <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:8px;margin-bottom:12px">${rptChecksHTML('pdc-')}</div>
    <div style="display:flex;gap:8px">
      <button class="btn btn-p btn-sm" onclick="catDesdePedido(${h.docnum}, window._PED_LINEAS||[])">📄 Generar PDF</button>
      <button class="btn btn-sm" onclick="docReporteTabla('pedido',${h.docnum})" style="background:#6c47ff;color:#fff;border-color:#6c47ff" title="PDF en formato pedido: tabla con lineas, las columnas elegidas y los totales al final">📋 PDF formato pedido</button>
      <button class="btn btn-sm" onclick="fotosHD('pedido',${h.docnum})" title="Descargar las fotos de los art&iacute;culos en alta definici&oacute;n">&#128444; Fotos HD</button><button class="btn btn-sm" onclick="docReporte('pedido',${h.docnum},'excel')" style="background:var(--green);color:#fff;border-color:var(--green)">📊 Generar Excel</button>
    </div>
  </div>
  <div class="pedido-header">
    <h2>Pedido #${h.docnum}</h2>
    <p>${h.cardname}${h.cardcode?' · '+_cliLink(h.cardcode):''}${cliSaldo!=null?' · <span class="badge '+(cliSaldo>0.005?'b-red':'b-green')+'" style="vertical-align:middle">Saldo: '+fmt(cliSaldo)+'</span>':''} · ${fmtD(h.docdate)} · Vendedor: ${h.nombrevendedor||'—'}</p>
  </div>
  <div class="pedido-meta">
    <div class="pm"><label>Cliente</label><span>${h.cardname}${h.cardcode?' · '+_cliLink(h.cardcode):''}${cliSaldo!=null?' <span class="badge '+(cliSaldo>0.005?'b-red':'b-green')+'">Saldo '+fmt(cliSaldo)+'</span>':''}</span></div>
    <div class="pm"><label>Fecha</label><span>${fmtD(h.docdate)}</span></div>
    <div class="pm"><label>Autorización</label><span>
      <span class="badge ${est.autorizado?'b-green':'b-amber'}" id="ped-aut-badge">${est.autorizado?'Autorizado':'Por autorizar'}</span>
      ${(_pedPuedeAutorizar() && !est.autorizado)?`
      <span id="ped-aut-ctrl" style="display:flex;align-items:center;gap:10px;margin-top:9px;flex-wrap:wrap">
        <label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:13px;-webkit-tap-highlight-color:transparent">
          <input type="checkbox" id="ped-aut-chk" style="width:17px;height:17px;cursor:pointer;accent-color:var(--blue,#2563eb);margin:0">
          <span>Autorizado</span>
        </label>
        <button class="btn btn-p btn-sm" id="ped-aut-btn" onclick="pedAutorizarUpdate(${h.docnum})">Update</button>
      </span>
      <span id="ped-aut-msg" style="display:none;font-size:12px;margin-top:7px;line-height:1.4"></span>`:''}
      ${_pedVerMargen()?`
      <button class="btn btn-sm" onclick="pedMargen(${h.docnum})" style="margin-top:9px"
        title="Margen de ganancia de este pedido">&#128200; Margen</button>`:''}
    </span></div>
    <div class="pm"><label>Estado</label><span><span class="badge ${h.docstatus==='O'?'b-blue':'b-gray'}">${h.docstatus==='O'?'Abierto':'Cerrado'}</span></span></div>
  </div>
  ${est.autorizado?`<div class="card" style="margin-bottom:14px">
    <div class="ct" style="margin-bottom:14px">📊 Avance del pedido</div>
    ${barraAvance('Entregado',est.pct_entregado,est.pzas_entregadas,est.pzas_pedido,'var(--green)')}
    ${barraAvance('Facturado',est.pct_facturado,est.pzas_facturadas,est.pzas_pedido,'var(--blue)')}
    ${barraAvance('Devuelto',est.pct_devuelto,est.pzas_devueltas,est.pzas_pedido,'var(--red)')}
  </div>`:''}
  <div class="card">
    <div class="ch"><span class="ct">📦 Lineas del pedido</span>
      ${_pedEditable(h,est)?`<button class="btn btn-sm btn-p" id="ped-ed-btn" onclick="pedEditarAbrir(${docnum})">✏️ Editar precios y cantidades</button>`
        :(est.autorizado?`<span style="font-size:11.5px;color:var(--text3)">Pedido autorizado \u00b7 ya no se puede modificar</span>`:'')}
    </div>
    <div id="ped-ed-panel"></div>
    ${lines.length?`<table class="tbl"><tr><th>Foto</th><th>#</th><th>Codigo</th><th>Barcode</th><th>Descripcion</th><th>Cantidad</th><th>Stock</th><th style="text-align:right">P. lista</th><th style="text-align:right">Desc.</th><th style="text-align:right">P. neto</th><th style="text-align:right">Total</th></tr>${lines.map(l=>{var im=invMap[l.itemcode]||{};return `<tr><td>${lineFoto(im.pn,im.fu)}</td><td>${Number(l.linenum)+1}</td><td style="color:var(--blue2);cursor:pointer" onclick="verItem('${(l.itemcode||'').replace(/'/g,"\\'")}')"><u>${l.itemcode}</u></td><td style="font-size:11px;color:var(--text3)">${im.bc||'—'}</td><td>${l.dscription||'—'}</td><td>${fmtN(l.quantity)} ${l.unitmsr||''}</td><td>${im.st!=null?fmtN(im.st):'—'}</td><td style="text-align:right">${fmt(_pLista(l))}</td><td style="text-align:right">${l.descuentolinea?Number(l.descuentolinea).toFixed(1)+'%':'—'}</td><td style="text-align:right;font-weight:700;color:var(--blue2)" title="Precio unitario después del descuento (total de la línea ÷ cantidad)">${fmt(_pNeto(l))}</td><td><b>${fmt(l.linetotal)}</b></td></tr>`;}).join('')}<tr><td colspan="10" style="text-align:right;font-weight:600;padding-top:12px">Total:</td><td style="font-weight:800;font-size:20px;color:var(--blue2)">${fmt(h.doctotal)}</td></tr></table>`:empty('Sin lineas')}
  </div>
  ${resumenEntregaPedido(h.docnum,lines,entregas)}${renderEntregasPedido(entregas)}
  ${h.comments?`<div class="card" style="margin-top:14px"><div class="ct" style="margin-bottom:8px">💬 Comentarios</div><p style="font-size:13px;color:var(--text2)">${h.comments}</p></div>`:''}`;

  // Si este pedido se mando a revisar al cliente, se avisa arriba del todo:
  // antes de tocar nada conviene saber que pide.
  try{ divEstado(h.docnum); }catch(e){}
  try{ vtRevisionPedido(h.docnum); }catch(e){}
}

// ══ AUTORIZACION DE PEDIDOS (app -> cola Supabase -> SAP) ══
// El navegador NO escribe en SAP. Deja la solicitud en `autorizaciones_queue`
// y un worker en el servidor la aplica en SAP tocando solo el campo de
// autorizacion (ORDR.Confirmed). Asi queda rastro de quien autorizo y cuando.

// Quien puede autorizar: SOLO el administrador.
// Se aceptan las dos grafias ('admin' y 'administrador') porque en Supabase
// puede estar guardada cualquiera de las dos en app_metadata.rol; el resto del
// archivo tambien las trata como el mismo rol.
// El margen deja ver los costos y la ganancia de cada linea: solo gerencia.
//
// OJO: esconder el boton no es seguridad de verdad. Quien sepa lo suficiente
// puede consultar avgprice desde la consola si las politicas de la base se lo
// permiten. Si el costo tiene que ser secreto de verdad, hay que cerrarlo con
// RLS en Supabase, no solo aqui.
function _pedVerMargen(){
  return !!(CU && String(CU.rol||'').toLowerCase()==='admin');
}

function _pedPuedeAutorizar(){
  // OJO: CU se declara con `let` (linea 58), asi que NO existe como window.CU.
  // Hay que referenciarla directo, igual que hace el resto del archivo.
  try{
    if(typeof CU==='undefined' || !CU) return false;
    var rol=String(CU.rol||'').toLowerCase();
    return rol==='admin' || rol==='administrador';
  }catch(e){ return false; }
}

function _pedAutMsg(txt, tipo){
  var m=document.getElementById('ped-aut-msg'); if(!m) return;
  // Sin texto = se oculta, para no dejar un hueco vacio bajo los controles.
  if(!txt){ m.style.display='none'; m.innerHTML=''; return; }
  var col = tipo==='ok' ? 'var(--green,#639922)' : (tipo==='err' ? '#E24B4A' : 'var(--text2,#374151)');
  m.style.display='block'; m.style.color=col; m.innerHTML=txt;
}

async function pedAutorizarUpdate(docnum){
  if(!_pedPuedeAutorizar()){ _pedAutMsg('No tienes permiso para autorizar pedidos.','err'); return; }
  var chk=document.getElementById('ped-aut-chk');
  var btn=document.getElementById('ped-aut-btn');
  if(!chk) return;

  // La autorizacion es de una sola via: desde la app solo se puede autorizar,
  // nunca desautorizar. Si la casilla no esta marcada, no hay nada que enviar.
  if(!chk.checked){
    _pedAutMsg('Marca la casilla <b>Autorizado</b> para poder enviarlo a SAP.','err');
    return;
  }
  var quiere = true;

  // Sin mensajes intermedios: el boton deshabilitado ya indica que esta
  // trabajando. Solo se escribe algo cuando hay un resultado real.
  if(btn){ btn.disabled=true; btn.textContent='Enviando…'; }
  _pedAutMsg('','info');

  var fila={
    docnum: Number(docnum),
    autorizado: quiere,
    estado: 'pendiente',
    solicitado_por: ((typeof CU!=='undefined' && CU) ? (CU.username||CU.nombre||'portal') : 'portal')
  };

  try{
    var r=await fetch(SB+'/rest/v1/autorizaciones_queue',{
      method:'POST',
      headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json','Prefer':'return=representation'},
      body:JSON.stringify(fila)
    });
    if(!r.ok){
      var t=await r.text();
      _pedAutMsg('No se pudo enviar: '+t.slice(0,180),'err');
      if(btn){ btn.disabled=false; btn.textContent='Update'; }
      return;
    }
    var creado=await r.json();
    var id=(creado && creado[0] && creado[0].id) || null;
    _pedAutSeguir(id, quiere, btn);
  }catch(e){
    _pedAutMsg('Error de conexi\u00f3n: '+e.message,'err');
    if(btn){ btn.disabled=false; btn.textContent='Update'; }
  }
}

// Consulta la cola hasta que el worker marque la fila como aplicada o con error.
async function _pedAutSeguir(id, quiere, btn){
  if(!id){
    _pedAutMsg('Enviado a SAP. Se aplicar\u00e1 en unos momentos.','ok');
    if(btn){ btn.disabled=false; btn.textContent='Update'; }
    return;
  }
  var intentos=0;
  var timer=setInterval(async function(){
    intentos++;
    if(intentos>20){ // ~60 s
      clearInterval(timer);
      _pedAutMsg('Sigue en cola. Se aplicar\u00e1 cuando el worker corra.','info');
      if(btn){ btn.disabled=false; btn.textContent='Update'; }
      return;
    }
    try{
      var f=await q('autorizaciones_queue','select=estado,mensaje&id=eq.'+id+'&limit=1');
      var row=(f&&f[0])||null; if(!row) return;
      if(row.estado==='ok'){
        clearInterval(timer);
        var b=document.getElementById('ped-aut-badge');
        if(b){ b.textContent='Autorizado'; b.className='badge b-green'; }
        // Ya quedo autorizado: se retiran los controles para que no se pueda
        // volver a autorizar ni desautorizar desde la app.
        var ctrl=document.getElementById('ped-aut-ctrl');
        if(ctrl) ctrl.style.display='none';
        _pedAutMsg('\u2713 Aplicado en SAP.','ok');
      }else if(row.estado==='error'){
        clearInterval(timer);
        _pedAutMsg('SAP rechaz\u00f3 el cambio: '+(row.mensaje||'sin detalle'),'err');
        if(btn){ btn.disabled=false; btn.textContent='Update'; }
      }
    }catch(e){}
  },3000);
}

// ══ FACTURAS ══
async function taInit(){
  var sv=$('ta-vend');
  if(sv && !sv.dataset.listo){
    try{ var v=await q('vendedores','select=slpcode,slpname&order=slpname'); var seen={};
      (v||[]).forEach(function(x){ if(x.slpcode!=null && !seen[x.slpcode]){ seen[x.slpcode]=1; var o=document.createElement('option'); o.value=x.slpcode; o.textContent=x.slpname||('Vendedor '+x.slpcode); sv.appendChild(o); } });
      sv.dataset.listo='1';
    }catch(e){}
  }
  var sp=$('ta-pais');
  if(sp && !sp.dataset.listo){
    try{ var rows=await qAll('clientes','select=country&cardtype=eq.C'); var s2={}, arr=[];
      (rows||[]).forEach(function(r){ var cc=(r.country||'').trim(); if(cc && !s2[cc]){ s2[cc]=1; arr.push(cc); } });
      arr.sort(function(a,b){ return paisNombre(a).localeCompare(paisNombre(b)); });
      arr.forEach(function(cc){ var o=document.createElement('option'); o.value=cc; o.textContent=paisNombre(cc); sp.appendChild(o); });
      sp.dataset.listo='1';
    }catch(e){}
  }
  var sa=$('ta-ano');
  if(sa && !sa.dataset.listo){
    var hoy=new Date().getFullYear();
    for(var y=hoy; y>=hoy-11; y--){ var o=document.createElement('option'); o.value=y; o.textContent=y; sa.appendChild(o); }
    sa.dataset.listo='1';
  }
  taBuscar();
}
var TA_DATA=[], TA_TOT=0;
// Boton para meter UN BULTO completo del articulo en la cotizacion en curso.
// Se manda la cantidad de un bulto (unidades por bulto), que es como se vende
// esta mercancia: pedir piezas sueltas no suele tener sentido.
function _taBtnCarrito(d){
  var pk=Number(d._pk)||1;
  var cs=String(d.itemcode||'').replace(/'/g,"\\'");
  var nm=String(d._nombre||d.dscription||'').replace(/['"\\]/g,' ').slice(0,80);
  var pr=Number(d._precio)||0;
  var sin=(d._disp!=null && Number(d._disp)<pk);
  return '<button class="btn btn-sm'+(sin?'':' btn-p')+'" '
    +'onclick="taAlCarrito(\''+cs+'\',\''+nm+'\','+pr+','+pk+')" '
    +'title="'+(sin?'Sin bulto completo disponible. Se puede pedir igual.':'A\u00f1adir 1 bulto ('+pk+' und) al pedido')+'" '
    +'style="padding:3px 9px'+(sin?';opacity:.65':'')+'">+ '+pk+'</button>';
}

function taAlCarrito(code, nombre, precio, bulto){
  try{
    npAgregarLineaDirecta(code, nombre, Number(precio)||0, Number(bulto)||1);
  }catch(e){ alert('No se pudo a\u00f1adir: '+(e.message||e)); }
}

async function taBuscar(){
  var res=$('ta-res'); if(!res) return;
  res.innerHTML=loading();
  var anoSel=(($('ta-ano')||{}).value)||'';
  var base={ p_pais:(($('ta-pais')||{}).value)||null,
             p_slpcode:(($('ta-vend')||{}).value?parseInt($('ta-vend').value,10):null),
             p_orden:(($('ta-orden')||{}).value)||'cant', p_limit:100 };
  try{
    async function _rpc(body){
      var r=await fetch(SB+'/rest/v1/rpc/top_articulos',{method:'POST',headers:{'apikey':KEY,'Authorization':'Bearer '+AUTHTOK(),'Content-Type':'application/json'},body:JSON.stringify(body)});
      if(!r.ok){
        // El motivo importa: "no existe la funcion" y "no tienes permiso" se
        // arreglan de formas distintas, y el mensaje generico no distinguia.
        var det=''; try{ det=(await r.text()||'').slice(0,300); }catch(_e){}
        throw new Error('HTTP '+r.status+(det?(': '+det):''));
      }
      return await r.json();
    }

    var data;
    if(anoSel==='u2'){
      // La funcion top_articulos solo acepta UN ano, asi que se piden los dos
      // por separado y se suman aqui. Se pide mas de cada uno (150) porque al
      // fusionar y recortar a 100 hay que tener margen: un articulo fuerte en
      // 2025 y flojo en 2026 debe poder entrar por la suma.
      var hoy=new Date().getFullYear();
      var dos=await Promise.all([
        _rpc(Object.assign({}, base, {p_ano:hoy,   p_limit:150})),
        _rpc(Object.assign({}, base, {p_ano:hoy-1, p_limit:150}))
      ]);
      var m={};
      dos.forEach(function(lista){
        (lista||[]).forEach(function(d){
          var k=d.itemcode;
          if(!m[k]){ m[k]=Object.assign({}, d); }
          else{
            m[k].total_cant  =(Number(m[k].total_cant)||0)  +(Number(d.total_cant)||0);
            m[k].total_monto =(Number(m[k].total_monto)||0) +(Number(d.total_monto)||0);
            m[k].num_facturas=(Number(m[k].num_facturas)||0)+(Number(d.num_facturas)||0);
          }
        });
      });
      var campo=(base.p_orden==='monto')?'total_monto':'total_cant';
      data=Object.keys(m).map(function(k){ return m[k]; })
             .sort(function(a,b){ return (Number(b[campo])||0)-(Number(a[campo])||0); })
             .slice(0,100);
    } else {
      data=await _rpc(Object.assign({}, base, {p_ano: anoSel?parseInt(anoSel,10):null}));
    }
    if(!data||!data.length){ res.innerHTML=empty('Sin ventas para esos filtros'); TA_DATA=[]; return; }
    var codes=data.map(function(d){return d.itemcode;}).filter(Boolean);
    var extra={};
    try{
      var inv=await q('vista_inventario','select=itemcode,itemname,precioventa,disponible,unidadesbulto,picturname,foto_url&itemcode=in.('+codes.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',')+')&limit=2000');
      (inv||[]).forEach(function(i){
        var pp=fotoPair(i.picturname,i.foto_url);
        // Se guardan TODAS las candidatas, no solo la primera: si el enlace
        // principal falla (mayusculas/minusculas del nombre, foto aun no
        // subida al bucket) hay que poder probar las siguientes, que es lo
        // que hace la ficha del producto. Antes se ocultaba la imagen y por
        // eso faltaban fotos aqui pero si salian al abrir el articulo.
        extra[i.itemcode]={precio:i.precioventa, disp:i.disponible,
                           foto:(pp.primary||''), fb:(pp.fb||''),
                           picturname:i.picturname||'', foto_url:i.foto_url||'',
                           packing:i.unidadesbulto, nombre:i.itemname};
      });
    }catch(e){}
    data.forEach(function(d){
      var x=extra[d.itemcode]||{};
      d._precio=(x.precio!=null?x.precio:null); d._disp=(x.disp!=null?x.disp:null);
      d._foto=x.foto||''; d._fb=x.fb||''; d._pk=Number(x.packing)||1;
      d._picturname=x.picturname||''; d._foto_url=x.foto_url||'';
      d._nombre=x.nombre||d.dscription||'';
    });
    // Bultos minimos disponibles. Se aplica DESPUES de traer el inventario,
    // porque los bultos salen de disponible / unidades por bulto y eso no lo
    // sabe la funcion top_articulos.
    var bmin=parseFloat(($('ta-bmin')||{}).value);
    var ocultos=0;
    if(isFinite(bmin) && bmin>0){
      var antes=data.length;
      data=data.filter(function(d){
        var pk=Number(d._pk)||1;
        return Math.floor((Number(d._disp)||0)/pk) >= bmin;
      });
      ocultos=antes-data.length;
    }
    if(!data.length){
      res.innerHTML=empty('Ningun articulo con al menos '+bmin+' bulto(s) disponible(s)');
      TA_DATA=[]; return;
    }

    TA_DATA=data;
    var tot=0; data.forEach(function(d){ tot+=Number(d.total_monto)||0; }); TA_TOT=tot;
    var _per = (anoSel==='u2')
      ? ((new Date().getFullYear()-1)+' y '+new Date().getFullYear())
      : (anoSel || 'todos los a\u00f1os');
    var html='<div style="font-size:13px;color:var(--text2);margin-bottom:10px">'
      +data.length+' articulo(s) &middot; '+_per+' &middot; monto total '+fmt(tot)
      +(ocultos?(' &middot; <span style="color:var(--text3)">'+ocultos+' oculto(s) por bultos m\u00ednimos</span>'):'')
      +'</div>';
    html+='<div style="overflow-x:auto"><table class="tbl"><tr><th>Foto</th><th>#</th><th>Codigo</th><th>Descripcion</th><th style="text-align:right">Cant. vendida</th><th style="text-align:right">Monto</th><th style="text-align:right">Facturas</th><th style="text-align:right">Precio actual</th><th style="text-align:right">Disponible</th><th style="text-align:right" title="Bultos completos disponibles">Bultos</th><th style="text-align:center" title="A&ntilde;adir un bulto al pedido">+ Bulto</th></tr>';
    data.forEach(function(d,i){
      var code=(d.itemcode||''), cs=code.replace(/'/g,"\\'");
      // fotoThumb ya trae los respaldos y la ampliacion al pasar el mouse.
      // Antes se armaba el <img> a mano con onerror que la ocultaba, y por eso
      // faltaban fotos que si aparecian al abrir la ficha del producto.
      var img=fotoThumb(d._picturname, d._foto_url);
      html+='<tr><td>'+img+'</td><td>'+(i+1)+'</td><td style="font-family:monospace;font-size:12px"><span style="color:var(--blue2);cursor:pointer" onclick="verItem(\''+cs+'\')"><u>'+code+'</u></span></td><td>'+(d.dscription||'')+'</td><td style="text-align:right">'+fmtN(d.total_cant)+'</td><td style="text-align:right">'+fmt(d.total_monto)+'</td><td style="text-align:right">'+(d.num_facturas||0)+'</td><td style="text-align:right">'+(d._precio!=null?fmt(d._precio):'—')+'</td><td style="text-align:right">'+(d._disp!=null?fmtN(d._disp):'—')+'</td>'
        +'<td style="text-align:right">'+(d._disp!=null?fmtN(Math.floor((Number(d._disp)||0)/(Number(d._pk)||1))):'—')+'</td>'
        +'<td style="text-align:center">'+_taBtnCarrito(d)+'</td></tr>';
    });
    html+='</table></div>';
    res.innerHTML=html;
  }catch(e){
    var _m=String((e&&e.message)||e||'');
    var _falta=/404|does not exist|Could not find the function|PGRST202/i.test(_m);
    res.innerHTML='<div style="padding:16px;color:var(--red);font-size:13px">'
      +'<b>No se pudo cargar el reporte.</b>'
      +(_falta
        ? '<br>La funci\u00f3n <b>top_articulos</b> no existe en Supabase. '
          +'Hay que crearla con <b>top_articulos.sql</b>.'
        : '')
      +'<div style="margin-top:8px;font-size:11.5px;color:var(--text3);'
      +'font-family:monospace;white-space:pre-wrap;word-break:break-word">'
      +String(_m).replace(/[<>&]/g,'')+'</div></div>';
  }
}
var TA_COLS=[{k:'foto',h:'Foto',r:false},{k:'codigo',h:'Codigo',r:false},{k:'dscription',h:'Descripcion',r:false},{k:'cant',h:'Cant. vendida',r:true},{k:'monto',h:'Monto',r:true},{k:'facturas',h:'Facturas',r:true},{k:'precio',h:'Precio actual',r:true},{k:'disp',h:'Disponible',r:true}];
function _taCols(){ return TA_COLS.filter(function(c){ var el=document.getElementById('tac-'+c.k); return !el || el.checked; }); }
function _taVal(d,k,xl){
  switch(k){
    case 'foto': return d._foto?(xl?('<img src="'+d._foto+'" width="46" height="46">'):('<img src="'+d._foto+'" style="width:46px;height:46px;object-fit:contain">')):'';
    case 'codigo': return npEsc(d.itemcode||'');
    case 'dscription': return npEsc(d.dscription||'');
    case 'cant': return xl?(Number(d.total_cant)||0):fmtN(d.total_cant);
    case 'monto': return xl?(Number(d.total_monto)||0).toFixed(2):fmt(d.total_monto);
    case 'facturas': return d.num_facturas||0;
    case 'precio': return (d._precio!=null)?(xl?(Number(d._precio)||0).toFixed(2):fmt(d._precio)):'';
    case 'disp': return (d._disp!=null)?(xl?(Number(d._disp)||0):fmtN(d._disp)):'';
  }
  return '';
}
function _taFiltroTxt(){
  var p=[]; var pa=($('ta-pais')||{}); var an=($('ta-ano')||{}); var ve=($('ta-vend')||{});
  if(pa.value) p.push('Pais: '+(pa.options[pa.selectedIndex]?pa.options[pa.selectedIndex].text:pa.value));
  if(an.value) p.push('Ano: '+an.value);
  if(ve.value) p.push('Vendedor: '+(ve.options[ve.selectedIndex]?ve.options[ve.selectedIndex].text:ve.value));
  return p.length?p.join(' · '):'Todos';
}
function taArtPdf(){
  if(!TA_DATA.length){ alert('Primero genera el reporte con "Ver".'); return; }
  var cols=_taCols(); if(!cols.length){ alert('Marca al menos una columna.'); return; }
  var w=window.open('','_blank'); if(!w){ alert('Permite ventanas emergentes.'); return; }
  var css='@page{size:letter landscape;margin:.4in}*{box-sizing:border-box}body{font-family:Arial,Helvetica,sans-serif;color:#111;font-size:11px;margin:0}'
    +'h1{font-size:17px;margin:0}.sub{color:#555;margin:2px 0 10px;font-size:11px}'
    +'table{width:100%;border-collapse:collapse;font-size:10.5px}th{background:#ececec;border:1px solid #bbb;padding:4px 6px;text-align:left}td{border:1px solid #ddd;padding:3px 6px;vertical-align:middle}.r{text-align:right}img{display:block}';
  var html='<!doctype html><html><head><meta charset="utf-8"><title>Mejores articulos</title><style>'+css+'</style></head><body>';
  html+='<h1>KENNEDY CENTER CORP.</h1><div class="sub">Mejores articulos vendidos &middot; '+_taFiltroTxt()+' &middot; '+TA_DATA.length+' articulos &middot; total '+fmt(TA_TOT)+'</div>';
  html+='<table><tr>'+cols.map(function(c){return '<th'+(c.r?' class="r"':'')+'>'+c.h+'</th>';}).join('')+'</tr>';
  TA_DATA.forEach(function(d){ html+='<tr>'+cols.map(function(c){return '<td'+(c.r?' class="r"':'')+'>'+_taVal(d,c.k,false)+'</td>';}).join('')+'</tr>'; });
  html+='</table></body></html>';
  w.document.open(); w.document.write(html); w.document.close();
  setTimeout(function(){ try{w.focus();w.print();}catch(e){} }, 700);
}
async function taArtExcel(){
  if(!TA_DATA.length){ alert('Primero genera el reporte con "Ver".'); return; }
  var cols=_taCols(); if(!cols.length){ alert('Marca al menos una columna.'); return; }
  var hayFoto=cols.some(function(c){return c.k==='foto';});
  var columns=cols.map(function(c){
    var w=13; if(c.k==='foto') w=9; else if(c.k==='dscription') w=44; else if(c.k==='codigo') w=16; else if(c.k==='monto'||c.k==='precio') w=14;
    var nf; if(c.k==='monto'||c.k==='precio') nf='#,##0.00';
    return {label:c.h, key:c.k, width:w, numFmt:nf};
  });
  try{
    await xlsxExport({
      filename:'mejores-articulos.xlsx',
      titulo:'KENNEDY CENTER CORP. - MEJORES ARTICULOS VENDIDOS',
      subtitulo:_taFiltroTxt()+'  -  '+TA_DATA.length+' articulos  -  monto total '+fmt(TA_TOT),
      columns:columns, rows:TA_DATA, fotoKey:(hayFoto?'foto':null),
      fotoUrlFn:function(d){return d._foto||'';},
      valueFn:_taXlsxVal
    });
  }catch(ex){ _taExcelHtml(cols); }
}
function _taXlsxVal(d,k){
  switch(k){
    case 'foto': return '';
    case 'codigo': return d.itemcode||'';
    case 'dscription': return d.dscription||'';
    case 'cant': return Number(d.total_cant)||0;
    case 'monto': return Number(d.total_monto)||0;
    case 'facturas': return Number(d.num_facturas)||0;
    case 'precio': return (d._precio!=null)?Number(d._precio):'';
    case 'disp': return (d._disp!=null)?Number(d._disp):'';
  }
  return '';
}
function _taExcelHtml(cols){
  var H='<table border="1"><tr><td colspan="'+cols.length+'"><b>KENNEDY CENTER CORP. - Mejores articulos vendidos - '+_taFiltroTxt()+'</b></td></tr>';
  H+='<tr>'+cols.map(function(c){return '<th>'+c.h+'</th>';}).join('')+'</tr>';
  TA_DATA.forEach(function(d){ H+='<tr>'+cols.map(function(c){return '<td>'+_taVal(d,c.k,true)+'</td>';}).join('')+'</tr>'; });
  H+='</table>';
  var blob=new Blob(['\ufeff','<html><head><meta charset="utf-8"></head><body>'+H+'</body></html>'],{type:'application/vnd.ms-excel;charset=utf-8'});
  var url=URL.createObjectURL(blob), a=document.createElement('a');
  a.href=url; a.download='mejores-articulos.xls'; document.body.appendChild(a); a.click();
  setTimeout(function(){ document.body.removeChild(a); URL.revokeObjectURL(url); }, 1000);
}
function entpInit(){ var i=$('entp-num'); if(i){ try{i.focus();}catch(e){} } }
async function entpBuscar(){
  var inp=$('entp-num'), res=$('entp-res');
  var num=parseInt((inp&&inp.value)||'',10);
  if(!res) return;
  if(!num){ res.innerHTML=empty('Escribe un numero de pedido'); return; }
  res.innerHTML=loading();
  var r=await Promise.all([
    q('entregas','select=docnum,docdate,linenum,itemcode,dscription,quantity&pedido=eq.'+num+'&order=docnum.desc,linenum').catch(function(){return [];}),
    q('pedidos','select=linenum,itemcode,dscription,quantity,price,linetotal,delivrdqty,openqty,docstatus,cardname,doctotal&docnum=eq.'+num+'&order=linenum').catch(function(){return [];})
  ]);
  var entregas=r[0]||[], lineas=r[1]||[];
  if((!entregas||!entregas.length)&&(!lineas||!lineas.length)){ res.innerHTML=empty('No encontre el pedido #'+num); return; }
  var stockMap={};
  try{
    var scodes=lineas.map(function(l){return l.itemcode;}).filter(Boolean);
    if(scodes.length){
      var invS=await q('vista_inventario','select=itemcode,disponible&itemcode=in.('+scodes.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',')+')&limit=2000');
      (invS||[]).forEach(function(i){ stockMap[i.itemcode]=i.disponible; });
    }
  }catch(e){}
  res.innerHTML = resumenEntregaPedido(num, lineas, entregas, stockMap) + renderEntregasPedido(entregas);
}
// Entregado se calcula sumando las ENTREGAS reales (tabla entregas) por itemcode,
// repartidas sobre las lineas del pedido. No depende de delivrdqty (que puede venir en 0).
function _entregaCalc(lineas, entregas){
  lineas=lineas||[]; entregas=entregas||[];
  var rem={};
  entregas.forEach(function(e){ var k=(e.itemcode||''); rem[k]=(rem[k]||0)+(Number(e.quantity)||0); });
  var o={pedTotal:0,pedPzas:0,entMonto:0,entPzas:0,cliente:'',cerrado:false,faltantes:[]};
  lineas.forEach(function(l){
    var qy=Number(l.quantity)||0, lt=Number(l.linetotal)||0, code=(l.itemcode||'');
    if(l.cardname && !o.cliente) o.cliente=l.cardname;
    if(String(l.docstatus)==='C') o.cerrado=true;
    var avail=rem[code]||0, dl=Math.min(qy, avail); rem[code]=avail-dl;
    o.pedTotal+=lt; o.pedPzas+=qy; o.entPzas+=dl;
    var frac=qy>0?(dl/qy):0, entLinea=lt*frac;
    o.entMonto+=entLinea;
    var falQ=qy-dl;
    if(falQ>0.0001) o.faltantes.push({itemcode:code,dscription:l.dscription,ped:qy,ent:dl,fal:falQ,falMonto:(lt-entLinea)});
  });
  o.noMonto=o.pedTotal-o.entMonto; if(o.noMonto<0)o.noMonto=0;
  o.noPzas=o.pedPzas-o.entPzas; if(o.noPzas<0)o.noPzas=0;
  o.pe=o.pedTotal>0?(o.entMonto/o.pedTotal*100):0; o.pn=100-o.pe; if(o.pn<0)o.pn=0;
  var ents={}; entregas.forEach(function(e){ ents[e.docnum]=1; });
  o.nEnt=Object.keys(ents).length;
  return o;
}
// Cada tabla de faltantes lleva su propio identificador: si se abren dos
// pedidos seguidos, los datos de uno no se escriben sobre los del otro.
var _FW_SEQ=0;

// Rellena las columnas Disponible SAP / Disponible WMS de una tabla ya pintada.
async function _fwPedirStocks(tid, codes){
  codes=(codes||[]).filter(Boolean);
  if(!codes.length) return;
  var enc=codes.map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');

  function poner(pref, i, txt, col){
    var td=document.getElementById('fw-'+pref+'-'+tid+'-'+i);
    if(td) td.innerHTML = (col?('<span style="color:'+col+';font-weight:700">'+txt+'</span>'):txt);
  }

  // SAP y WMS se piden en paralelo y cada uno se pinta en cuanto llega.
  q('vista_inventario','select=itemcode,disponible&itemcode=in.('+enc+')&limit=2000')
    .then(function(inv){
      var m={}; (inv||[]).forEach(function(i){ m[i.itemcode]=i.disponible; });
      codes.forEach(function(c,i){
        var v=m[c];
        poner('sap', i, (v!=null?fmtN(v):'\u2014'), (Number(v)>0?'var(--green)':'var(--text3)'));
      });
    })
    .catch(function(){ codes.forEach(function(c,i){ poner('sap', i, '\u2014'); }); });

  q('vista_wms_vs_sap','select=itemcode,existencia_wms,comprometidas_wms&itemcode=in.('+enc+')&limit=2000')
    .then(function(w){
      var m={}; (w||[]).forEach(function(x){
        m[x.itemcode]=(Number(x.existencia_wms)||0)-(Number(x.comprometidas_wms)||0);
      });
      codes.forEach(function(c,i){
        var v=m[c];
        poner('wms', i, (v!=null?fmtN(Math.round(v)):'\u2014'), (Number(v)>0?'var(--green)':'var(--text3)'));
      });
    })
    .catch(function(){
      // Si aun no existe la vista del WMS, no se deja la columna en puntos.
      codes.forEach(function(c,i){ poner('wms', i, '\u2014'); });
    });
}

function resumenEntregaPedido(num, lineas, entregas, stockMap){
  var hasStock=!!stockMap;
  var _FW_ID = (++_FW_SEQ);
  var o=_entregaCalc(lineas, entregas);
  var box='border:1px solid var(--border);border-radius:var(--r2);padding:12px 13px;background:var(--surface2)';
  var lab='font-size:11px;color:var(--text3);text-transform:uppercase;letter-spacing:.04em;font-weight:600';
  var big='font-size:22px;font-weight:800;line-height:1.15;margin-top:3px';
  var sub='font-size:12px;color:var(--text3);margin-top:2px';
  var h='<div class="card" style="margin-bottom:14px">';
  h+='<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;flex-wrap:wrap;margin-bottom:4px">';
  h+='<div class="ct">Resumen de entrega — Pedido #'+num+((o.cliente)?(' &middot; '+o.cliente):'')+'</div>';
  h+='<div style="display:flex;gap:6px"><button class="btn btn-sm" onclick="entregaPdf('+num+')">🖨️ PDF (no entregado)</button><button class="btn btn-sm" style="background:var(--green);color:#fff;border-color:var(--green)" onclick="entregaExcel('+num+')">📊 Excel (no entregado)</button></div>';
  h+='</div>';
  h+='<div style="font-size:12px;color:var(--text3);margin-bottom:12px">'+o.nEnt+' entrega(s) registrada(s)'+(o.cerrado?' &middot; pedido cerrado':'')+'</div>';
  h+='<div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px">';
  h+='<div style="'+box+'"><div style="'+lab+'">Pedido</div><div style="'+big+';color:var(--text)">'+fmt(o.pedTotal)+'</div><div style="'+sub+'">'+fmtN(o.pedPzas)+' pzas &middot; 100%</div></div>';
  h+='<div style="'+box+'"><div style="'+lab+'">Entregado</div><div style="'+big+';color:var(--green)">'+fmt(o.entMonto)+'</div><div style="'+sub+'">'+fmtN(o.entPzas)+' pzas &middot; '+o.pe.toFixed(1)+'%</div></div>';
  h+='<div style="'+box+'"><div style="'+lab+'">No entregado</div><div style="'+big+';color:'+(o.noMonto>0.005?'var(--red)':'var(--text3)')+'">'+fmt(o.noMonto)+'</div><div style="'+sub+'">'+fmtN(o.noPzas)+' pzas &middot; '+o.pn.toFixed(1)+'%</div></div>';
  h+='</div>';
  h+='<div style="margin-top:14px;height:11px;border-radius:7px;overflow:hidden;background:'+(o.noMonto>0.005?'rgba(239,68,68,.25)':'var(--surface2)')+';display:flex">';
  h+='<div style="width:'+o.pe.toFixed(2)+'%;background:var(--green)"></div></div>';
  h+='</div>';
  if(o.faltantes.length){
    h+='<div class="card" style="margin-bottom:14px">';
    h+='<div class="ct" style="margin-bottom:8px">Lo que falta por entregar ('+o.faltantes.length+')</div>';
    h+='<div style="overflow-x:auto"><table class="tbl"><tr><th>Codigo</th><th>Descripcion</th><th style="text-align:right">Pedido</th><th style="text-align:right">Entregado</th><th style="text-align:right">Faltante</th>'+'<th style="text-align:right" title="Disponible en SAP (vista_inventario.disponible)">Disponible SAP</th>'
      +'<th style="text-align:right" title="Existencia en WarehouseEdge menos lo comprometido">Disponible WMS</th>'
      +'<th style="text-align:right">Monto faltante</th></tr>';
    o.faltantes.forEach(function(f, _i){
      var code=(f.itemcode||''), cs=code.replace(/'/g,"\\'");
      h+='<tr><td style="font-family:monospace;font-size:12px"><span style="color:var(--blue2);cursor:pointer" onclick="verItem(\''+cs+'\')"><u>'+code+'</u></span></td><td>'+(f.dscription||'')+'</td><td style="text-align:right">'+fmtN(f.ped)+'</td><td style="text-align:right">'+fmtN(f.ent)+'</td><td style="text-align:right;font-weight:700;color:var(--red)">'+fmtN(f.fal)+'</td>'
        +'<td style="text-align:right" id="fw-sap-'+_FW_ID+'-'+_i+'">'+((hasStock&&stockMap[f.itemcode]!=null)?fmtN(stockMap[f.itemcode]):'<span style="color:var(--text3)">\u2026</span>')+'</td>'
        +'<td style="text-align:right" id="fw-wms-'+_FW_ID+'-'+_i+'"><span style="color:var(--text3)">\u2026</span></td>'
        +'<td style="text-align:right;color:var(--red)">'+fmt(f.falMonto)+'</td></tr>';
    });
    h+='</table></div></div>';
    // Los dos stocks se piden despues de pintar: esta funcion es sincrona
    // (la usan plantillas de texto), asi que no puede esperar la consulta.
    _fwPedirStocks(_FW_ID, o.faltantes.map(function(f){ return f.itemcode||''; }));
  } else if((lineas||[]).length){
    h+='<div class="card" style="margin-bottom:14px;color:var(--green);font-weight:600">Todo el pedido fue entregado.</div>';
  }
  return h;
}
async function _entregaExport(docnum){
  var r=await Promise.all([
    q('pedidos','select=linenum,itemcode,dscription,quantity,price,linetotal,delivrdqty,openqty,docstatus,cardname,cardcode,docdate&docnum=eq.'+docnum+'&order=linenum').catch(function(){return [];}),
    q('entregas','select=docnum,docdate,linenum,itemcode,dscription,quantity&pedido=eq.'+docnum+'&order=docnum.desc,linenum').catch(function(){return [];})
  ]);
  var lineas=r[0]||[], entregas=r[1]||[];
  var o=_entregaCalc(lineas,entregas);
  var fotos={}, stock={};
  var codes=o.faltantes.map(function(f){return f.itemcode;}).filter(Boolean);
  if(codes.length){
    try{
      var inv=await q('vista_inventario','select=itemcode,picturname,foto_url,disponible&itemcode=in.('+codes.map(function(c){return '"'+String(c).replace(/"/g,'')+'"';}).join(',')+')&limit=2000');
      (inv||[]).forEach(function(i){ var pp=fotoPair(i.picturname,i.foto_url); fotos[i.itemcode]=(pp.primary||''); stock[i.itemcode]=i.disponible; });
    }catch(e){}
  }
  return {lineas:lineas, entregas:entregas, o:o, fotos:fotos, stock:stock, fecha:((lineas[0]&&lineas[0].docdate)?fmtD(lineas[0].docdate):'')};
}
async function entregaPdf(docnum){
  var w=window.open('','_blank');
  if(!w){ alert('Permite ventanas emergentes para generar el PDF.'); return; }
  w.document.write('<p style="font-family:Arial;padding:20px">Generando...</p>');
  var d=await _entregaExport(docnum); var o=d.o;
  var css='@page{size:letter;margin:.5in}*{box-sizing:border-box}body{font-family:Arial,Helvetica,sans-serif;color:#111;font-size:12px;margin:0}'
    +'h1{font-size:18px;margin:0;letter-spacing:.3px}.sub{color:#555;margin:2px 0 10px;font-size:12px}'
    +'.tot{margin:6px 0 12px;font-size:13px}.tot b{font-size:15px}.rd{color:#dc2626}'
    +'table{width:100%;border-collapse:collapse;margin:6px 0;font-size:11px}'
    +'th{background:#ececec;border:1px solid #bbb;padding:5px 6px;text-align:left}td{border:1px solid #ddd;padding:4px 6px;vertical-align:middle}.r{text-align:right}'
    +'img{width:46px;height:46px;object-fit:contain;display:block}';
  var html='<!doctype html><html><head><meta charset="utf-8"><title>No entregado pedido '+docnum+'</title><style>'+css+'</style></head><body>';
  html+='<h1>KENNEDY CENTER CORP.</h1>';
  html+='<div class="sub">Lo que NO se entrego &middot; Pedido #'+docnum+(o.cliente?(' &middot; '+npEsc(o.cliente)):'')+(d.fecha?(' &middot; '+d.fecha):'')+(o.cerrado?' &middot; cerrado':'')+'</div>';
  html+='<div class="tot">Pedido: <b>'+fmt(o.pedTotal)+'</b> ('+fmtN(o.pedPzas)+' pzas) &nbsp;&middot;&nbsp; No entregado: <b class="rd">'+fmt(o.noMonto)+'</b> ('+fmtN(o.noPzas)+' pzas &middot; '+o.pn.toFixed(1)+'%)</div>';
  if(o.faltantes.length){
    html+='<table><tr><th>Foto</th><th>Codigo</th><th>Descripcion</th><th class="r">Pedido</th><th class="r">Faltante</th><th class="r">Stock actual</th><th class="r">Monto faltante</th></tr>';
    o.faltantes.forEach(function(f){
      var src=d.fotos[f.itemcode]||'';
      var img=src?('<img src="'+src+'" onerror="this.style.display=\'none\'">'):'';
      html+='<tr><td>'+img+'</td><td>'+npEsc(f.itemcode||'')+'</td><td>'+npEsc(f.dscription||'')+'</td><td class="r">'+fmtN(f.ped)+'</td><td class="r">'+fmtN(f.fal)+'</td><td class="r">'+((d.stock[f.itemcode]!=null)?fmtN(d.stock[f.itemcode]):'-')+'</td><td class="r">'+fmt(f.falMonto)+'</td></tr>';
    });
    html+='</table>';
  } else {
    html+='<p style="color:#16a34a;font-weight:bold">Todo el pedido fue entregado. No hay pendientes.</p>';
  }
  html+='</body></html>';
  w.document.open(); w.document.write(html); w.document.close();
  setTimeout(function(){ try{w.focus();w.print();}catch(e){} }, 700);
}
async function entregaExcel(docnum){
  var d=await _entregaExport(docnum); var o=d.o;
  function td(x){ return '<td>'+x+'</td>'; }
  var H='<table border="1">';
  H+='<tr><td colspan="7"><b>KENNEDY CENTER CORP. - Lo que NO se entrego - Pedido #'+docnum+(o.cliente?(' - '+npEsc(o.cliente)):'')+'</b></td></tr>';
  H+='<tr><td>Pedido</td>'+td(o.pedTotal.toFixed(2))+td(o.pedPzas+' pzas')+'<td>No entregado</td>'+td(o.noMonto.toFixed(2))+td(o.noPzas+' pzas ('+o.pn.toFixed(1)+'%)')+'</tr>';
  H+='<tr></tr>';
  H+='<tr><th>Foto</th><th>Codigo</th><th>Descripcion</th><th>Pedido</th><th>Faltante</th><th>Stock actual</th><th>Monto faltante</th></tr>';
  o.faltantes.forEach(function(f){
    var src=d.fotos[f.itemcode]||'';
    var img=src?('<img src="'+src+'" width="48" height="48">'):'';
    H+='<tr><td>'+img+'</td>'+td(npEsc(f.itemcode||''))+td(npEsc(f.dscription||''))+td(f.ped)+td(f.fal)+td(d.stock[f.itemcode]!=null?d.stock[f.itemcode]:'')+td(f.falMonto.toFixed(2))+'</tr>';
  });
  if(!o.faltantes.length) H+='<tr><td colspan="7">Todo el pedido fue entregado. No hay pendientes.</td></tr>';
  H+='</table>';
  var blob=new Blob(['\ufeff','<html><head><meta charset="utf-8"></head><body>'+H+'</body></html>'],{type:'application/vnd.ms-excel;charset=utf-8'});
  var url=URL.createObjectURL(blob), a=document.createElement('a');
  a.href=url; a.download='no-entregado-pedido-'+docnum+'.xls'; document.body.appendChild(a); a.click();
  setTimeout(function(){ document.body.removeChild(a); URL.revokeObjectURL(url); }, 1000);
}
function togEntrega(n){ var d=document.getElementById('ent-'+n); if(d) d.style.display=(d.style.display==='none'?'block':'none'); }
function renderEntregasPedido(entregas){
  if(!entregas||!entregas.length) return '';
  var grp={};
  entregas.forEach(function(e){
    var k=String(e.docnum);
    if(!grp[k]) grp[k]={docnum:e.docnum,docdate:e.docdate,pzas:0,lines:[]};
    grp[k].pzas+=Number(e.quantity)||0;
    grp[k].lines.push(e);
  });
  var arr=Object.keys(grp).map(function(k){return grp[k];});
  arr.sort(function(a,b){ return String(b.docdate||'').localeCompare(String(a.docdate||'')); });
  var html='<div class="card" style="margin-top:14px"><div class="ct" style="margin-bottom:10px">🚚 Entregas ('+arr.length+')</div>';
  arr.forEach(function(en){
    var det='';
    en.lines.forEach(function(l){
      var c=(l.itemcode||''); det+='<tr><td style="font-family:monospace;font-size:12px"><span style="color:var(--blue2);cursor:pointer" onclick="verItem(\''+c.replace(/'/g,"\\'")+'\')"><u>'+c+'</u></span></td><td>'+(l.dscription||'—')+'</td><td style="text-align:right">'+fmtN(l.quantity)+'</td></tr>';
    });
    html+='<div style="border:1px solid var(--border);border-radius:var(--r2);margin-bottom:8px;overflow:hidden">'
      +'<div onclick="togEntrega('+en.docnum+')" style="display:flex;justify-content:space-between;align-items:center;gap:10px;padding:11px 13px;cursor:pointer;background:var(--surface2)">'
      +'<span style="font-weight:600">🚚 Entrega #'+en.docnum+'</span>'
      +'<span style="color:var(--text2);font-size:13px">'+fmtD(en.docdate)+' · '+fmtN(en.pzas)+' pzas ▾</span>'
      +'</div>'
      +'<div id="ent-'+en.docnum+'" style="display:none;padding:2px 13px 10px"><table class="tbl"><tr><th>Codigo</th><th>Descripcion</th><th style="text-align:right">Cant.</th></tr>'+det+'</table></div>'
      +'</div>';
  });
  html+='</div>';
  return html;
}
// Muestra 25 y el resto bajo demanda. Se guarda la lista completa para poder
// repintar sin volver a consultar.
function tablFacturas(list){
  if(!list.length) return empty('Sin facturas');
  window._PM_clifac_lista = list;
  window._PM_clifac = function(){
    var c = document.getElementById('cli-fac-tabla');
    if(c) c.innerHTML = tablFacturas(window._PM_clifac_lista);
  };
  var _tot = list.length;
  var _ver = (typeof pmVisibles==='function') ? pmVisibles('clifac') : 25;
  var _list = list.slice(0, _ver);
  return `<table class="tbl"><tr><th>Num.</th><th>Fecha</th><th>Vence</th><th>Cliente</th><th>Total</th><th>Pagado</th><th>Estado</th></tr>${_list.map(f=>`<tr><td><span style="color:#185FA5;cursor:pointer;font-weight:700" onclick="verFactura(${f.docnum})"><u>#${f.docnum}</u></span></td><td>${fmtD(f.docdate)}</td><td>${fmtD(f.docduedate)}</td><td>${f.cardname||''}</td><td>${fmt(f.doctotal)}</td><td>${fmt(f.paidtodate)}</td><td><span class="badge ${f.docstatus==='O'?'b-blue':'b-gray'}">${f.docstatus==='O'?'Abierta':'Cerrada'}</span></td></tr>`).join('')}</table>`
    + ((typeof pmPie==='function') ? pmPie('clifac', _tot) : '');
}

// ── Datos de compra: quién puede verlos ───────────────────────────────────
// El proveedor, los costos FOB/CIF y los importes de la mercancía por llegar
// son información de compras. Un vendedor no debe verlos: con el proveedor y
// el costo, cualquiera puede ir por su cuenta o filtrar el margen fuera.
//
// OJO: esconderlo aquí NO es seguridad de verdad. Quien sepa abrir la consola
// del navegador puede consultar esos campos igual, porque la clave pública va
// en el JavaScript. Lo que protege es el RLS de la base (SQL 43).
function veCompras(){
  var r = String((CU && CU.rol) || '').toLowerCase();
  return r === 'admin' || r === 'compras';
}

// Quien puede ver NOMBRES DE PROVEEDOR. Es mas amplio que veCompras() porque
// gerencia tambien los necesita, pero deja fuera a ventas: con el proveedor a
// la vista, un vendedor puede ir por su cuenta o pasarselo a un cliente.
function veProveedor(){
  var r = String((CU && CU.rol) || '').toLowerCase();
  return r === 'admin' || r === 'administrador' || r === 'compras' || r === 'gerencia';
}
